/*! Stickiply Studio (c) Stickiply 2026. All rights reserved. Proprietary; copying, reuse or reverse engineering is not permitted. https://stickiply.com/policies/terms-of-service */
(function(){
if(customElements.get("bookmark-lab-tool")) return;
/* i18n (P1): stkT reads the stk-i18n islands; English fallback is today's text, so English renders exactly as before.
   Shopify's t filter HTML-escapes non-_html values (measured 22 Sep on /fr: "L'image" arrives as "L&#39;image"),
   so island values are decoded here before use; the English fallback is returned untouched. */
var stkT = (function (g) {
  var M = { "#39": "'", "#039": "'", "#x27": "'", "quot": '"', "#34": '"', "lt": "<", "gt": ">", "amp": "&" };
  function d(s){ return String(s).replace(/&(#39|#039|#x27|quot|#34|lt|gt|amp);/g, function(m, e){ return M[e]; }); }
  return function (k, f) { var s = g ? g(k, f) : f; return s === f ? f : d(s); };
})(window.stkT);
/* i18n: escape translated text before it goes into the innerHTML template (English output is unchanged) */
function stkE(s){ return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }
/* i18n: fill [name] placeholders in one pass; the island passes Liquid variables through as [name] */
function stkF(s, v){ return String(s).replace(/\[(\w+)\]/g, function(m, k){ return Object.prototype.hasOwnProperty.call(v, k) ? String(v[k]) : m; }); }

/* PDF.js is loaded lazily the first time a PDF is dropped. */
var PDFJS_SRC = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
var PDFJS_WORKER = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
var pdfjsLoading = null;
function loadPdfJs(){
  if(window.pdfjsLib){ window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; return Promise.resolve(window.pdfjsLib); }
  if(pdfjsLoading) return pdfjsLoading;
  pdfjsLoading = new Promise(function(res,rej){
    var s=document.createElement("script");
    s.src=PDFJS_SRC;
    s.onload=function(){
      if(window.pdfjsLib){ window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; res(window.pdfjsLib); }
      else rej(new Error("pdfjsLib missing after load"));
    };
    s.onerror=function(){ rej(new Error("pdf.js failed to load")); };
    document.head.appendChild(s);
  });
  return pdfjsLoading;
}

const BM_CSS = "\n:host{\n  --bm-display:\"Sapiens\",sans-serif;\n  display:block;\n  --bg:#ffffff;\n  --panel:#fbfbfc;\n  --line:#e9e9ee;\n  --ink:#1e1e1e;\n  --muted:#7a7a85;\n  --good:#1fab63;\n  --mid:#e09c1f;\n  --bad:#e0484f;\n  --rainbow:linear-gradient(90deg,#f0513c,#f78d28,#ffc707,#5dba68,#4b8dc8,#5f4c9f);\n  --rainbow-loop:linear-gradient(90deg,#f0513c,#f78d28,#ffc707,#5dba68,#4b8dc8,#5f4c9f,#f0513c,#f78d28,#ffc707,#5dba68,#4b8dc8,#5f4c9f,#f0513c);\n}\n*{box-sizing:border-box;margin:0;padding:0}\n:host{font-family:inherit;font-size:15px;line-height:1.45;color:var(--ink)}\n.app{display:flex;flex-direction:column;gap:14px;position:relative}\n.tool::before{content:\"\";position:absolute;left:0;right:0;top:0;height:2.5px;background:var(--rainbow);z-index:2;border-radius:18px 18px 0 0}\n.tool{display:grid;grid-template-columns:1fr 400px;height:calc(100vh - 210px);min-height:560px;max-height:900px;border:1px solid var(--line);border-radius:18px;overflow:hidden;position:relative;background:var(--bg)}\n@media (max-width:900px){.app{height:auto;max-height:none}.tool{grid-template-columns:1fr;height:auto}.panel__body{overflow:visible;display:block;padding:14px 14px 18px}.steppane{overflow:visible;min-height:0;flex:none}.stage{min-height:52vh}}\n.stage{\n  position:relative;display:flex;align-items:center;justify-content:center;\n  padding:36px;\n  background:\n    radial-gradient(circle at 50% 50%, #ececf1 1.2px, transparent 1.7px) 0 0/26px 26px,\n    var(--bg);\n}\n@media (max-width:900px){.stage{padding:14px;min-height:42vh;max-height:52vh}}\n#preview{position:absolute;top:50%;left:50%;transform-origin:center center;filter:drop-shadow(0 14px 34px rgba(26,26,32,.16));touch-action:none;will-change:transform}\n.stage-inner{position:absolute;inset:0;overflow:hidden;display:block;cursor:grab}\n.stage-inner.panning{cursor:grabbing}\n.ruler{position:absolute;z-index:3;pointer-events:none}\n.ruler-h{top:0;left:0}\n.ruler-v{left:0;top:0}\n.zoomctl{position:absolute;bottom:14px;right:14px;z-index:4;display:flex;gap:6px}\n.zoomctl button{width:34px;height:34px;border-radius:10px;border:1.5px solid var(--line);background:rgba(255,255,255,.92);backdrop-filter:blur(3px);cursor:pointer;font-family:var(--bm-display);font-size:16px;color:var(--ink);display:flex;align-items:center;justify-content:center;line-height:1;padding:0}\n.zoomctl button:hover{border-color:#cfcfda}\n#preview.draggable{cursor:grab}\n#preview.dragging{cursor:grabbing}\n#drop{\n  position:relative;z-index:5;\n  border:1.5px dashed var(--line);border-radius:22px;background:var(--bg);\n  padding:54px 44px;text-align:center;cursor:pointer;\n  transition:border-color .15s, box-shadow .15s;max-width:460px;\n}\n#drop:hover,#drop.over{border-color:#c9c9d4;box-shadow:0 10px 30px rgba(26,26,32,.07)}\n#drop h2{font-family:var(--bm-display);font-weight:400;font-size:17px;margin-bottom:10px;letter-spacing:.03em}\n#drop p{color:var(--muted);font-size:13.5px;margin-bottom:4px}\n.panel{border-left:1px solid var(--line);background:var(--panel);display:flex;flex-direction:column;min-height:0;overflow:hidden}\n@media (max-width:900px){.panel{border-left:none;border-top:1px solid var(--line)}}\n.floatprev{position:fixed;right:14px;bottom:14px;z-index:60;width:120px;height:150px;background:#fff;border:1px solid var(--line);border-radius:14px;box-shadow:0 10px 30px rgba(0,0,0,.22);padding:8px;display:none}\n.floatprev canvas{width:100%;height:100%;object-fit:contain;display:block;border-radius:8px}\n.floatprev__close{position:absolute;top:-9px;left:-9px;width:24px;height:24px;border-radius:50%;border:1px solid var(--line);background:#fff;color:var(--ink);font-size:16px;line-height:1;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.15);display:flex;align-items:center;justify-content:center;padding:0}\n.floatprev__re{position:fixed;right:14px;bottom:14px;z-index:60;width:46px;height:46px;border-radius:50%;border:1px solid var(--line);background:#fff;color:var(--ink);box-shadow:0 8px 24px rgba(0,0,0,.22);display:none;align-items:center;justify-content:center;cursor:pointer;padding:0}\n@media (max-width:900px){.floatprev.show{display:block}.floatprev__re.show{display:flex}}\n.panel__body{padding:16px 18px 18px;flex:1;min-height:0;overflow:hidden;display:flex;flex-direction:column}\n#viewBookmark,#viewCard,#viewEditor{flex:1;min-height:0;display:flex;flex-direction:column}\n#viewBookmark.hidden,#viewCard.hidden,#viewEditor.hidden{display:none}\n.layerlist{display:flex;flex-direction:column;gap:7px}\n.layeritem{display:flex;align-items:center;gap:8px;border:1.5px solid var(--line);border-radius:11px;padding:8px 10px;background:var(--bg);transition:border-color .12s}\n.layeritem.on{border-color:transparent;background:linear-gradient(var(--bg),var(--bg)) padding-box,var(--rainbow) border-box}\n.layeritem__name{flex:1;font-size:12.5px;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n.layeritem__ctr{display:flex;gap:4px;flex-shrink:0}\n.layeritem__ctr button{width:26px;height:26px;border-radius:8px;border:1.5px solid var(--line);background:var(--bg);cursor:pointer;color:var(--ink);font-size:13px;line-height:1;display:flex;align-items:center;justify-content:center;padding:0}\n.layeritem__ctr button:hover:not(:disabled){border-color:#cfcfda}\n.layeritem__ctr button:disabled{opacity:.3;cursor:default}\n.layeritem__ctr button.del:hover{border-color:var(--bad);color:var(--bad)}\n.layeritem__rename{flex:1;font-size:12.5px;border:1.5px solid var(--ink);border-radius:8px;padding:4px 7px;font-family:inherit;outline:none;color:var(--ink);min-width:0}\n.addtiles{display:grid;grid-template-columns:1fr 1fr;gap:9px}\n/* MULTI-DESIGN TABS. One tab is one bookmark AND its backing card, as a pair\n   (Thomas, 7 Sep 2026). Ported from the Proof Lab's doc tabs, same class names\n   so the two labs stay one design. No bottom padding on the strip: .doctab has\n   no bottom border and is drawn to sit ON the strip's edge. */\n.stagewrap{display:flex;flex-direction:column;min-height:0;min-width:0}\n.stagewrap .stage{flex:1 1 auto;min-height:0}\n.doctabs{display:flex;gap:6px;padding:10px 12px 0;overflow-x:auto;overflow-y:hidden;flex-shrink:0;background:var(--panel);border-bottom:1px solid var(--line)}\n.doctabs.hidden{display:none}\n.doctabs::-webkit-scrollbar{height:10px}\n.doctabs::-webkit-scrollbar-track{background:#efeff2;border-radius:99px}\n.doctabs::-webkit-scrollbar-thumb{background:var(--brand-y,#ffc63c);border-radius:99px}\n.doctab{display:flex;align-items:center;gap:6px;max-width:150px;padding:8px 10px;border-radius:10px 10px 0 0;border:1.5px solid var(--line);border-bottom:none;background:var(--bg);color:var(--muted);font-family:var(--bm-display);font-size:11px;letter-spacing:.05em;cursor:pointer;flex-shrink:0}\n.doctab:hover{color:var(--ink)}\n.doctab.on{color:var(--ink);border-color:var(--brand-y,#ffc63c);background:var(--bg)}\n.doctab__name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100px}\n.doctab__x{flex-shrink:0;width:16px;height:16px;border-radius:50%;display:flex;align-items:center;justify-content:center;color:var(--muted);font-size:13px;line-height:1}\n.doctab__x:hover{background:var(--line);color:var(--ink)}\n.doctab__add,.doctab__copy{flex-shrink:0;width:32px;height:32px;border-radius:10px 10px 0 0;border:1.5px solid var(--line);border-bottom:none;background:var(--bg);color:var(--muted);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0}\n.doctab__add{font-size:16px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",sans-serif}\n.doctab__copy{margin-left:2px}\n.doctab__copy svg{width:14px;height:14px}\n.doctab__add:hover,.doctab__copy:hover{color:var(--ink);border-color:var(--brand-y,#ffc63c)}\n.app.dark .doctabs{background:#1b1b1f}\n.app.dark .doctab,.app.dark .doctab__add,.app.dark .doctab__copy{background:#232327;border-color:#3a3a41}\n.app.dark .doctab.on{border-color:var(--brand-y,#ffc63c)}\n.app.dark .doctabs::-webkit-scrollbar-track{background:#2e2e34}\n.addtile{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;padding:16px 10px;border:1.5px solid var(--line);border-radius:14px;background:var(--bg);cursor:pointer;transition:border-color .12s,box-shadow .12s,transform .1s}\n.addtile:hover{border-color:#cfcfda;box-shadow:0 4px 14px rgba(26,26,32,.08);transform:translateY(-1px)}\n.addtile__ic{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#f3f1fb,#eaf6ff);color:var(--ink)}\n.addtile__ic svg{width:19px;height:19px}\n.addtile__t{font-family:var(--bm-display);font-size:11.5px;letter-spacing:.04em;color:var(--ink)}\n.nudgebtn{width:30px;height:30px;border-radius:9px;border:1.5px solid var(--line);background:var(--bg);cursor:pointer;color:var(--ink);font-size:14px;line-height:1;display:flex;align-items:center;justify-content:center;padding:0}\n.nudgebtn:hover{border-color:#cfcfda}\n.steptabs{display:flex;gap:6px;margin-bottom:16px}\n.steptab{flex:1;display:flex;align-items:center;justify-content:center;gap:6px;background:var(--bg);border:1.5px solid var(--line);border-radius:11px;padding:9px 6px;font-family:var(--bm-display);font-size:11px;letter-spacing:.05em;color:var(--muted);cursor:pointer;transition:border-color .12s,color .12s}\n.steptab:hover{border-color:#cfcfda}\n.steptab.on{color:var(--ink);border-color:transparent;background:linear-gradient(var(--bg),var(--bg)) padding-box,var(--rainbow) border-box}\n.steptab .step__n{width:18px;height:18px;font-size:10px;background:var(--muted)}\n.steptab.on .step__n{background:var(--ink)}\n.steppane{display:none;flex:1;min-height:0;overflow-y:auto;padding:2px 4px 2px 2px}\n.steppane.on{display:block}\n.dlcard{border:1px solid var(--line);border-radius:18px;background:var(--panel);padding:18px 22px;flex-shrink:0;width:100%}\n.viewtabs{display:grid;grid-template-columns:1fr 1fr 1fr;gap:0;border-bottom:1px solid var(--line);background:var(--panel);z-index:3;flex-shrink:0}\n.viewtab{\n  font-family:var(--bm-display);font-size:11.5px;letter-spacing:.1em;\n  padding:15px 8px;text-align:center;cursor:pointer;color:var(--muted);\n  border-bottom:2.5px solid transparent;transition:color .12s, border-color .12s;\n}\n.viewtab.on{color:var(--ink);border-bottom-color:var(--ink)}\n.group{margin-bottom:24px}\n.group>label,.subgroup>label{\n  display:block;font-family:var(--bm-display);font-size:11px;letter-spacing:.14em;\n  color:var(--muted);margin-bottom:9px;font-weight:400;\n}\n.lbl-sub{display:block;font-family:var(--bm-display);font-size:11px;letter-spacing:.12em;color:var(--muted);margin-bottom:9px;font-weight:400}\n.dpiwrap{margin:2px 0 18px}\n.seg{display:flex;gap:7px;flex-wrap:wrap}\n.seg button{\n  flex:1;min-width:0;background:var(--bg);border:1.5px solid var(--line);color:var(--ink);\n  border-radius:12px;padding:9px 10px 7px;font-size:12px;cursor:pointer;\n  font-family:var(--bm-display);font-weight:400;letter-spacing:.04em;\n  transition:border-color .12s, box-shadow .12s;\n}\n.seg button:hover{border-color:#cfcfda}\n.seg button.on{\n  border-color:transparent;\n  background:linear-gradient(var(--bg),var(--bg)) padding-box, var(--rainbow) border-box;\n  box-shadow:0 2px 8px rgba(26,26,32,.07);\n}\n.chips{display:flex;flex-wrap:wrap;gap:7px}\n.chip{\n  background:var(--bg);border:1.5px solid var(--line);color:var(--ink);\n  border-radius:12px;padding:9px 13px 7px;font-size:12px;cursor:pointer;\n  font-family:var(--bm-display);font-weight:400;letter-spacing:.04em;\n  transition:border-color .12s, box-shadow .12s;\n}\n.chip:hover{border-color:#cfcfda}\n.chip.on{\n  border-color:transparent;\n  background:linear-gradient(var(--bg),var(--bg)) padding-box, var(--rainbow) border-box;\n  box-shadow:0 2px 8px rgba(26,26,32,.07);\n}\n.uprow{display:flex;gap:9px;align-items:stretch}\n.upslot{\n  flex:1;border:1.5px dashed #cfcfda;border-radius:14px;background:var(--bg);\n  padding:20px 14px;text-align:center;cursor:pointer;transition:border-color .14s, background .14s;\n  display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;min-height:128px;\n}\n.upslot:hover,.upslot.over{border-color:#8f7cc4;background:#faf9ff}\n.upslot.filled{border-style:solid;border-color:transparent;background:linear-gradient(var(--bg),var(--bg)) padding-box, var(--rainbow) border-box}\n.upslot.filled .upslot__ic{display:none}\n.upslot__ic{width:46px;height:46px;border-radius:50%;background:#f1f1f6;display:flex;align-items:center;justify-content:center;color:#8a8a95;flex-shrink:0;transition:background .14s,color .14s}\n.upslot:hover .upslot__ic,.upslot.over .upslot__ic{background:#efeaff;color:#5f4c9f}\n.upslot__ic svg{width:21px;height:21px}\n.upslot__thumb{width:50px;height:50px;border-radius:9px;object-fit:contain;background:#f3f3f6}\n.upslot__t{font-family:var(--bm-display);font-size:13px;letter-spacing:.03em;color:var(--ink)}\n.upslot__s{font-size:11px;color:var(--muted);line-height:1.35}\n.upslot__types{font-size:10px;color:var(--muted);letter-spacing:.03em;opacity:.85}\n.row{display:flex;align-items:center;justify-content:space-between;gap:10px}\n.row span.lbl{font-family:var(--bm-display);font-size:12px;letter-spacing:.05em}\n.toggle{position:relative;width:40px;height:23px;border-radius:99px;background:var(--line);cursor:pointer;flex-shrink:0;transition:background .15s}\n.toggle::after{content:\"\";position:absolute;top:2.5px;left:2.5px;width:18px;height:18px;border-radius:50%;background:var(--bg);box-shadow:0 1px 3px rgba(26,26,32,.25);transition:transform .15s}\n.toggle.on{background:var(--ink)}\n.toggle.on::after{transform:translateX(17px)}\ninput[type=range]{-webkit-appearance:none;appearance:none;width:100%;height:4px;border-radius:99px;background:var(--rainbow);outline:none}\ninput[type=range]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:18px;height:18px;border-radius:50%;background:var(--bg);border:2px solid var(--ink);cursor:pointer;box-shadow:0 1px 4px rgba(26,26,32,.25)}\n.range-meta{display:flex;justify-content:space-between;font-size:12px;color:var(--muted);margin-top:6px}\n.ticks{position:relative;height:9px;margin-top:1px;padding:0 9px}\n.tick{position:absolute;top:0;transform:translateX(-50%);cursor:pointer;padding:0 4px}\n.tick i{width:2px;height:7px;background:var(--muted);display:block;border-radius:1px}\n.tick:hover i{background:var(--ink)}\n.swatches{display:flex;flex-wrap:wrap;gap:9px;align-items:center;padding:3px 2px}\n.sub-label{font-family:var(--bm-display);font-size:10px;letter-spacing:.12em;color:var(--muted);margin:11px 0 7px}\n.sub-label:first-child{margin-top:0}\n.hexin{background:var(--bg);border:1.5px solid var(--line);border-radius:10px;padding:6px 10px;font-family:inherit;font-size:13px;width:96px;color:var(--ink);outline:none}\n.hexin:focus{border-color:#cfcfda}\n.sw{width:28px;height:28px;border-radius:50%;cursor:pointer;border:1.5px solid var(--line);transition:transform .1s, box-shadow .1s}\n.sw:hover{transform:scale(1.08)}\n.sw.on{box-shadow:0 0 0 2px var(--bg), 0 0 0 4px var(--ink)}\n.sw.custom{background:conic-gradient(#f0513c,#f78d28,#ffc707,#5dba68,#4b8dc8,#5f4c9f,#f0513c);position:relative;overflow:hidden;flex-shrink:0}\n.sw.custom input{position:absolute;inset:-6px;opacity:0;cursor:pointer}\n#dpi{font-family:var(--bm-display);font-size:13px;letter-spacing:.05em}\n#dpi.ok{color:var(--good)}#dpi.mid{color:var(--mid)}#dpi.bad{color:var(--bad)}\n.hint{font-size:12.5px;color:var(--muted);margin-top:9px}\n.magnet-status{font-size:12.5px;line-height:1.45;padding:9px 11px;border-radius:11px;display:none}\n.magnet-status.show{display:block}\n.magnet-status.ok{background:#eaf7ef;color:#1c7a47;border:1px solid #cdeede}\n.magnet-status.warn{background:#fdede9;color:#b5402f;border:1px solid #f4d2c9}\n.cta{width:100%;border:none;border-radius:14px;padding:13px;background:var(--ink);color:var(--bg);font-family:var(--bm-display);font-size:12.5px;letter-spacing:.06em;cursor:pointer;transition:box-shadow .12s}\n.cta:hover{box-shadow:0 8px 22px rgba(26,26,32,.22)}\n.cta:disabled{opacity:.25;cursor:default;box-shadow:none}\n.cta small{display:block;font-family:inherit;letter-spacing:0;font-weight:400;opacity:.7;font-size:11.5px;margin-top:2px}\n.dl{width:100%;height:100%;text-align:left;border-radius:14px;padding:12px 14px;background:var(--bg);border:1.5px solid var(--line);color:var(--ink);font-family:var(--bm-display);font-size:12.5px;letter-spacing:.05em;cursor:pointer;transition:border-color .12s,box-shadow .12s,background .12s,transform .1s}\n.dl:not(:disabled):hover{box-shadow:0 4px 14px rgba(26,26,32,.1);transform:translateY(-1px)}\n/* PNG files: soft lavender */\n.dl--png{background:#f3f1fb;border-color:#e2ddf3}\n.dl--png:not(:disabled):hover{border-color:#c7bfe9}\n/* SVG cut files: soft teal */\n.dl--svg{background:#ecf6f5;border-color:#d4e8e5}\n.dl--svg:not(:disabled):hover{border-color:#aed7d1}\n/* Proof: primary dark */\n.dl--proof{background:var(--ink);border-color:transparent;color:var(--bg)}\n.dl--proof small{color:rgba(255,255,255,.72)}\n.dl--proof:not(:disabled):hover{box-shadow:0 8px 22px rgba(26,26,32,.22)}\n/* ZIP: full-width rainbow-accented bundle action */\n.dl--zip{width:100%;margin-top:14px;text-align:center;border-color:transparent;background:linear-gradient(var(--bg),var(--bg)) padding-box, var(--rainbow) border-box}\n.dl--zip small{color:var(--muted)}\n.dl--zip:not(:disabled):hover{box-shadow:0 6px 18px rgba(26,26,32,.12)}\n\n.dl:disabled,.ghost:disabled{opacity:.25;cursor:default;box-shadow:none}\n.dl small{display:block;font-family:inherit;letter-spacing:0;font-weight:400;color:var(--muted);font-size:11.5px;margin-top:2px}\n.ghost{width:100%;margin-top:9px;border-radius:14px;padding:11px;background:transparent;border:1.5px solid var(--line);color:var(--muted);font-family:var(--bm-display);font-size:12px;letter-spacing:.05em;cursor:pointer}\n.ghost:hover{border-color:#cfcfda;color:var(--ink)}\n#note{margin-top:14px;font-size:12.5px;color:var(--muted);border-left:2.5px solid;border-image:var(--rainbow) 1;padding-left:10px;display:none}\n#note.show{display:block}\n.hidden{display:none !important}\n.spin{position:absolute;inset:0;display:none;align-items:center;justify-content:center;background:rgba(255,255,255,.65);backdrop-filter:blur(2px);font-family:var(--bm-display);font-size:13px;letter-spacing:.1em;color:var(--ink);z-index:5}\n.spin.show{display:flex}\n.divider{height:1px;background:var(--line);margin:4px 0 22px}\n.step{border:1.5px solid var(--line);border-radius:14px;margin-bottom:12px;overflow:hidden}\n.step__head{display:flex;align-items:center;gap:10px;padding:13px 14px;cursor:pointer;user-select:none}\n.step__n{width:21px;height:21px;border-radius:50%;background:var(--ink);color:var(--bg);font-family:var(--bm-display);font-size:11px;display:flex;align-items:center;justify-content:center;flex-shrink:0}\n.step__t{font-family:var(--bm-display);font-size:14.5px;letter-spacing:.04em;flex:1}\n.step__chev{font-size:18px;color:var(--muted);transform:rotate(90deg);transition:transform .18s}\n.step.collapsed .step__chev{transform:rotate(0deg)}\n.step__body{padding:2px 14px 16px}\n.step.collapsed .step__body{display:none}\n.step .group:last-child{margin-bottom:0}\n.dlcard__head{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:12px}\n.dlcard__col{font-family:var(--bm-display);font-size:13px;letter-spacing:.04em;color:var(--ink)}\n.dlrow{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:10px}\n.dlrow__spacer{}\n.dlcard__foot{display:flex;align-items:center;justify-content:space-between;gap:16px;margin-top:6px}\n.dlcard__foot .ghost{width:auto;margin-top:0;padding:9px 20px}\n@media (max-width:760px){.dlcard__head{grid-template-columns:1fr}.dlrow{grid-template-columns:1fr}.dlrow__spacer{display:none}}\n.canvas-tools{position:absolute;top:14px;left:14px;display:flex;gap:7px;z-index:4}\n.ctool{\n  width:38px;height:38px;border-radius:11px;border:1.5px solid var(--line);\n  background:rgba(255,255,255,.92);backdrop-filter:blur(3px);cursor:pointer;\n  display:flex;align-items:center;justify-content:center;color:var(--ink);\n  transition:border-color .12s, box-shadow .12s, background .12s;\n}\n.ctool:hover{border-color:#cfcfda;box-shadow:0 4px 12px rgba(26,26,32,.1)}\n.ctool.on{border-color:transparent;background:linear-gradient(rgba(255,255,255,.92),rgba(255,255,255,.92)) padding-box, var(--rainbow) border-box}\n.ctool svg{width:18px;height:18px}\n/* clean-up eraser, ported from Sticker Sheet Lab and Proof Lab. Brush size is\n   in mm of the finished bookmark, so it means the same at any zoom. */\n.erase-bar{position:absolute;top:60px;left:14px;z-index:4;display:none;align-items:center;gap:10px;background:rgba(255,255,255,.92);backdrop-filter:blur(3px);border:1.5px solid var(--line);border-radius:11px;padding:7px 12px;font-family:var(--bm-display);font-size:11.5px;letter-spacing:.04em;color:var(--ink)}\n.erase-bar.show{display:flex}\n.erase-bar{white-space:nowrap}\n/* type-in bookmark size, under the bridge controls */\n/* label row: title then the info dot, matching the house rule that jargon and\n   anything non-obvious gets a dot rather than a permanent paragraph */\n.lblrow{display:flex;align-items:center;justify-content:flex-end;gap:7px;margin-bottom:9px}\n.lblrow .lbl-sub{margin-bottom:0}\n.infodot{width:18px;height:18px;flex:none;border-radius:50%;border:1.5px solid var(--line);background:none;color:var(--muted);font-family:ui-serif,Georgia,'Times New Roman',serif;font-style:italic;font-weight:600;font-size:12px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;transition:border-color .12s,background .12s,color .12s}\n.infodot:hover{border-color:#cfcfda;color:var(--ink)}\n.infodot.on{background:var(--ink);color:var(--bg);border-color:transparent}\n/* the two measurements read as a pair, so they sit side by side and centred */\n.sizegrid{display:flex;gap:12px;justify-content:center;align-items:flex-end}\n.sizecell{display:flex;flex-direction:column;align-items:center;gap:6px}\n.sizecap{font-family:var(--bm-display);font-size:10px;letter-spacing:.12em;color:var(--muted)}\n.sizegrid input{width:104px;flex:none;text-align:center;font-family:var(--bm-display);font-size:13px;color:var(--ink);border:1.5px solid var(--line);border-radius:10px;padding:8px 10px;background:var(--bg)}\n.sizegrid input:focus{outline:none;border-color:#cfcfda}\n/* tinted card, same green the order-files card uses elsewhere, so 'this is\n   guidance' reads the same way across the tools */\n.hint--info{display:none;text-align:center;margin-top:11px;font-size:11.5px;line-height:1.5;\n  color:var(--ink);background:#f4fbf7;border:1.5px solid #bfe6d1;border-radius:12px;padding:10px 12px}\n.hint--info.show{display:block}\n.seg--units{flex:none;gap:6px;justify-content:center;margin-top:9px}\n.seg--units button{flex:none;padding:7px 11px 5px;font-size:11px}\n#bmUnitSeg button.on{background:var(--bg);color:var(--ink);box-shadow:inset 0 0 0 2px var(--brand-y)}\n.app.dark .hint--info{background:rgba(48,164,108,.12);border-color:rgba(48,164,108,.4);color:#e8f6ee}\n.erase-bar input[type=range]{width:110px;flex:none}\n.erase-bar button{font:inherit;letter-spacing:inherit;cursor:pointer;color:var(--ink);background:none;border:1.5px solid var(--line);border-radius:8px;padding:3px 9px}\n.erase-bar button:disabled{opacity:.4;cursor:default}\n#preview.erasing{cursor:crosshair}\n.canvas-dims{\n  position:absolute;bottom:14px;left:14px;z-index:4;\n  background:rgba(255,255,255,.92);backdrop-filter:blur(3px);\n  border:1.5px solid var(--line);border-radius:11px;padding:7px 11px 6px;\n  font-family:var(--bm-display);font-size:11.5px;letter-spacing:.04em;color:var(--ink);\n  display:none;\n}\n.canvas-dims.show{display:block}\n.canvas-dims b{color:var(--muted);font-weight:400;font-size:10px;letter-spacing:.1em;display:block;margin-bottom:2px}\n/* download card: order files vs previews */\n.dl-group{border:1.5px solid var(--line);border-radius:16px;padding:14px;margin-bottom:12px}\n.dl-group--order{border-color:#bfe6d1;background:#f4fbf7}\n.dl-group--preview{border-style:dashed;background:#fafafb}\n.dl-group__head{display:flex;align-items:center;gap:9px;margin-bottom:11px;flex-wrap:wrap}\n.dl-badge{font-family:var(--bm-display);font-size:10px;letter-spacing:.12em;padding:5px 10px 4px;border-radius:99px;white-space:nowrap}\n.dl-badge--go{background:var(--good);color:#fff}\n.dl-badge--stop{background:#f1f1f4;color:var(--muted);border:1px solid var(--line)}\n.dl-group__t{font-size:12.5px;color:var(--muted)}\n.dl--zip{width:100%;margin-top:0;text-align:center;border:none;background:var(--good);color:#fff;padding:16px 14px;font-size:14px}\n.dl--zip small{color:rgba(255,255,255,.85)}\n.dl--zip:not(:disabled):hover{box-shadow:0 8px 22px rgba(31,171,99,.35)}\n.dlrow--sub{margin-top:10px}\n.dlrow--sub .dl{padding:9px 12px;font-size:11.5px}\n.dlrow--sub .dl small{font-size:10.5px}\n.dl--proof{background:var(--bg);border:1.5px dashed #d5d5dd;color:var(--muted)}\n.dl--proof small{color:var(--muted)}\n.dl--proof:not(:disabled):hover{box-shadow:none;transform:none;border-color:#bdbdc7;color:var(--ink)}\n/* two top tabs; collapsible section panel */\n.viewtabs{grid-template-columns:1fr 1fr}\n#viewBookmark,#viewCard{display:block;overflow-y:auto;padding-right:2px}\n.step{background:var(--bg)}\n.step__head:hover .step__t{color:var(--ink)}\n@media (max-width:900px){#viewBookmark,#viewCard{overflow:visible}}\n/* orientation buttons with card+bookmark icons */\n#orientSeg button{display:flex;flex-direction:column;align-items:center;gap:6px;padding:11px 10px 8px}\n#orientSeg svg{width:26px;height:26px;display:block;opacity:.85}\n/* permanent slim scrollbar so overlay scrollbars stop covering controls */\n/* classic (non-overlay) scrollbar styled like the sliders: grey track, yellow thumb.\n   NOTE: no scrollbar-width/scrollbar-color here - the standard props would\n   disable the ::-webkit-scrollbar styling in Chrome and bring back the overlay bar */\n#viewBookmark,#viewCard{padding-right:10px}\n#viewBookmark::-webkit-scrollbar,#viewCard::-webkit-scrollbar{width:10px}\n#viewBookmark::-webkit-scrollbar-track,#viewCard::-webkit-scrollbar-track{background:#efeff2;border-radius:99px}\n#viewBookmark::-webkit-scrollbar-thumb,#viewCard::-webkit-scrollbar-thumb{background:var(--brand-y);border-radius:99px}\n#viewBookmark::-webkit-scrollbar-thumb:hover,#viewCard::-webkit-scrollbar-thumb:hover{background:#e9af26}\n/* flat neutral secondary download buttons; the green ZIP is the only colour */\n.dl--png,.dl--svg{background:var(--bg);border-color:var(--line)}\n.dl--png:not(:disabled):hover,.dl--svg:not(:disabled):hover{border-color:#c5c5d0;box-shadow:none;transform:none}\n/* flat swatch grid + hex readout */\n.swfoot{display:flex;align-items:center;gap:9px;margin-top:10px}\n.swfoot__dot{width:20px;height:20px;border-radius:50%;border:1.5px solid var(--line);flex-shrink:0}\n/* flat restyle: borderless surfaces on a soft grey panel, separation by contrast */\n:host{--panel:#f5f5f7;--flat:#f1f1f4;--flat-hover:#e8e8ed}\n.step{border:none;border-radius:16px;box-shadow:0 1px 2px rgba(26,26,32,.05)}\n.seg button{border:1.5px solid transparent;background:var(--flat)}\n.seg button:hover{border-color:transparent;background:var(--flat-hover)}\n.chip{border:1.5px solid transparent;background:var(--flat)}\n.chip:hover{border-color:transparent;background:var(--flat-hover)}\n.addtile{border:none;background:var(--flat)}\n.addtile:hover{background:var(--bg);box-shadow:0 4px 14px rgba(26,26,32,.1)}\n.layeritem{border:1.5px solid transparent;background:var(--flat)}\n.layeritem__ctr button{border:none;background:var(--bg)}\n.nudgebtn{border:none;background:var(--flat)}\n.nudgebtn:hover{background:var(--flat-hover)}\n.hexin{border:none;background:var(--flat);padding:7px 11px}\n.hexin:focus{background:var(--flat-hover)}\n.ghost{border:none;background:var(--flat);color:var(--ink)}\n.ghost:hover{background:var(--flat-hover);color:var(--ink)}\n.ctool{border:1.5px solid transparent;box-shadow:0 1px 4px rgba(26,26,32,.14)}\n.zoomctl button{border:none;box-shadow:0 1px 4px rgba(26,26,32,.14)}\n.canvas-dims{border:none;box-shadow:0 1px 4px rgba(26,26,32,.14)}\n.divider{background:#ececf0}\n.dlcard{border:none;background:var(--panel)}\n.dl-group{border:none}\n.dl-group--order{background:#e9f6ef}\n.dl-group--preview{border:none;background:#ededf1}\n.dl--png,.dl--svg{background:var(--bg);border:none}\n.dl--png:not(:disabled):hover,.dl--svg:not(:disabled):hover{border:none;box-shadow:0 2px 8px rgba(26,26,32,.08)}\n.dl--proof{background:var(--bg);border:1.5px dashed #d5d5dd}\n/* BOLD FLAT OVERHAUL: black selected states, fat sliders, tinted section icons */\n:host{--flat:#eff0f3;--flat-hover:#e5e6ea}\n.tool::before{height:4px;background:linear-gradient(90deg,#f0513c 0 16.66%,#f78d28 0 33.33%,#ffc707 0 50%,#5dba68 0 66.66%,#4b8dc8 0 83.33%,#5f4c9f 0 100%)}\n.seg{gap:8px}\n.seg button{border:none;background:var(--flat);border-radius:12px;padding:12px 12px 10px;font-size:12px}\n.seg button:hover{background:var(--flat-hover)}\n.seg button.on{background:var(--ink);color:var(--bg);box-shadow:none}\n.chip{border:none;background:var(--flat);border-radius:12px;padding:11px 15px 9px}\n.chip:hover{background:var(--flat-hover)}\n.chip.on{background:var(--ink);color:var(--bg);box-shadow:none}\n.upslot.filled{border:2px solid var(--ink);background:var(--bg)}\n.layeritem{border:none}\n.layeritem.on{background:var(--bg);box-shadow:inset 0 0 0 2px var(--ink)}\n.ctool.on{background:var(--ink);color:var(--bg);border-color:transparent}\ninput[type=range]{height:8px;background:#e6e7eb}\ninput[type=range]::-webkit-slider-thumb{width:22px;height:22px;border:2.5px solid var(--ink);box-shadow:0 2px 6px rgba(26,26,32,.25)}\n.swatches{gap:10px}\n.sw{width:32px;height:32px;border:none;box-shadow:inset 0 0 0 1px rgba(26,26,32,.1)}\n.sw.on{box-shadow:inset 0 0 0 1px rgba(26,26,32,.1),0 0 0 3px var(--bg),0 0 0 5.5px var(--ink)}\n.sw.eyedrop{background:var(--flat);display:flex;align-items:center;justify-content:center;color:var(--ink)}\n.sw.eyedrop:hover{background:var(--flat-hover)}\n.sw.eyedrop svg{width:15px;height:15px}\n#note{border-image:none;border-left:3px solid var(--ink)}\n.viewtab.on{border-bottom-width:3px}\n.step__head{gap:11px;padding:15px 16px}\n.step__t{font-size:15px}\n.step__ic{width:32px;height:32px;border-radius:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0}\n.step__ic svg{width:17px;height:17px}\n.step__ic--o{background:#fcebe4;color:#f0513c}\n.step__ic--p{background:#edeaf6;color:#5f4c9f}\n.step__ic--b{background:#e7f0f9;color:#3c78b4}\n.step__ic--g{background:#e7f4eb;color:#35914d}\n.step__ic--y{background:#fdf2d7;color:#c07d00}\n.step__ic--k{background:#ededf1;color:#55555e}\n/* panel section icons in brand colours (downloads keep their own) */\n.step__ic--o,.step__ic--p,.step__ic--b,.step__ic--g,.step__ic--y,.step__ic--k{background:#ececef;color:var(--ink)}\n/* PIXEL-PASTEL MINIMAL NEO-BRUTALIST: white + dark grey, flat ink outlines, 8-bit pastel accents */\n:host{--pastel-r:#f5a69a;--pastel-o:#f8c99b;--pastel-y:#ffe59e;--pastel-g:#b3dcb9;--pastel-b:#b0cce6;--pastel-p:#baaed8;--brand-y:#ffc63c}\n.tool::before{height:5px;background:repeating-linear-gradient(90deg,var(--pastel-r) 0 14px,var(--pastel-o) 14px 28px,var(--pastel-y) 28px 42px,var(--pastel-g) 42px 56px,var(--pastel-b) 56px 70px,var(--pastel-p) 70px 84px)}\n.seg button{background:var(--bg);border:2px solid var(--ink);border-radius:10px;box-shadow:none}\n.seg button:hover{background:var(--flat)}\n.seg button.on{background:var(--ink);color:var(--bg);border-color:var(--ink)}\n.chip{background:var(--bg);border:2px solid var(--ink);border-radius:10px;box-shadow:none}\n.chip:hover{background:var(--flat)}\n.chip.on{background:var(--ink);color:var(--bg)}\n.upslot{border:2px dashed #b9b9c2}\n.upslot:hover,.upslot.over{border-color:var(--ink);background:var(--bg)}\n.upslot.filled{border:2px solid var(--ink);box-shadow:none}\n#drop{border:2px dashed #b9b9c2}\n#drop:hover,#drop.over{border-color:var(--ink);box-shadow:none}\n.hexin{border:2px solid var(--ink);background:var(--bg)}\n.ctool{border:2px solid var(--ink);box-shadow:none;background:var(--bg)}\n.ctool:hover{box-shadow:none;background:var(--flat)}\n.zoomctl button{border:2px solid var(--ink);box-shadow:none;background:var(--bg)}\n.canvas-dims{border:2px solid var(--ink);box-shadow:none}\n.ghost{border:2px solid var(--ink);background:var(--bg);color:var(--ink)}\n.ghost:hover{background:var(--flat);color:var(--ink)}\n.layeritem{border:2px solid var(--ink);background:var(--bg)}\n.layeritem.on{background:var(--ink);box-shadow:none}\n.layeritem.on .layeritem__name{color:var(--bg)}\n/* scrollbar sits at the panel edge, never over controls */\n@media (min-width:901px){.panel__body{padding:16px 9px 18px 18px}#viewBookmark,#viewCard{padding-right:11px}}\n/* flat segmented colour wheel */\n.wheelwrap{padding:4px 0 2px}\n.wheelbox{position:relative;width:210px;margin:8px auto 0}\n.wheel{width:210px;height:210px;display:block}\n.wheel path{cursor:pointer;transition:transform .12s;transform-box:fill-box;transform-origin:center}\n.wheel path:hover{transform:scale(1.06)}\n.wheelcentre{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:flex;gap:7px;align-items:center}\n.wheeldot{width:23px;height:23px;border-radius:50%;cursor:pointer;box-shadow:inset 0 0 0 1.5px rgba(26,26,32,.14);transition:transform .1s;position:relative}\n.wheeldot:hover{transform:scale(1.12)}\n.wheeldot--spec{background:conic-gradient(#f0513c,#f78d28,#ffc707,#5dba68,#4b8dc8,#5f4c9f,#f0513c)}\n/* refinements: 6-stripe bar, pill sliders, soft-green selection, less text */\n.tool::before{background:linear-gradient(90deg,#f0513c 0 16.66%,#f78d28 0 33.33%,#ffc707 0 50%,#5dba68 0 66.66%,#4b8dc8 0 83.33%,#5f4c9f 0 100%)}\n.range-meta{display:none}\n.ticks{display:none}\n#flipHint{display:none}\n.rangebubble{display:none !important}\n.group{margin-bottom:20px}\n.step__body{padding:2px 16px 16px}\n.segslider{display:flex;align-items:center;gap:12px;margin-top:2px}\n.segslider__val{min-width:46px;height:46px;border-radius:50%;background:var(--ink);color:var(--bg);font-family:var(--bm-display);font-size:11.5px;letter-spacing:.02em;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0 5px;white-space:nowrap}\n.segslider__track{position:relative;flex:1;display:flex;gap:7px;align-items:center;height:38px}\n.segbar{flex:1;height:10px;border-radius:99px;background:#e9e9ec;overflow:hidden}\n.segbar__fill{height:100%;background:var(--brand-y);border-radius:99px;width:0%;transition:width .06s linear}\n.segslider__lbl{margin:0 0 4px !important;font-size:9.5px;letter-spacing:.09em;color:var(--muted);text-align:right;line-height:1.2;display:block;max-width:none}\n.segslider__track input[type=range]{position:absolute;inset:0;width:100%;height:100%;opacity:0;margin:0;cursor:pointer}\n.seg button{border:none;background:var(--flat)}\n.seg button:hover{background:var(--flat-hover)}\n.seg button.on{background:var(--brand-y);color:var(--ink);box-shadow:none}\n.chip{border:none;background:var(--flat)}\n.chip.on{background:var(--brand-y);color:var(--ink);box-shadow:none}\n.ctool{border:none;box-shadow:0 1px 3px rgba(26,26,32,.15)}\n.ctool.on{background:#34343a;color:var(--brand-y);box-shadow:0 1px 3px rgba(26,26,32,.15)}\n.zoomctl button{border:none}\n.layeritem{border:none;background:var(--flat)}\n.layeritem.on{background:var(--brand-y);box-shadow:none}\n.layeritem.on .layeritem__name{color:var(--ink)}\n.hexin{border:none;background:var(--flat)}\n.ghost{border:none;background:var(--flat)}\n.canvas-dims{border:none}\n.upslot{border:2px dashed #cfcfda}\n#drop{border:2px dashed #cfcfda}\n#flipSeg button{display:flex;flex-direction:column;align-items:center;gap:5px;padding:10px 10px 8px}\n#flipSeg svg{width:22px;height:22px;opacity:.85}\n#cardPresetSeg button{display:flex;flex-direction:column;align-items:center;gap:5px;padding:10px 8px 8px}\n#cardPresetSeg svg{width:22px;height:22px;opacity:.85}\n/* pill view switcher */\n.viewtabs{display:flex;gap:4px;background:var(--flat);border-radius:99px;padding:4px;margin:12px 14px 4px;border-bottom:0;position:relative}\n.viewtabs__thumb{position:absolute;left:4px;top:4px;bottom:4px;width:calc(50% - 6px);border-radius:99px;background:var(--bg);box-shadow:0 1px 4px rgba(26,26,32,.18);transition:transform .25s cubic-bezier(.4,0,.2,1)}\n.viewtab{flex:1;position:relative;z-index:1;display:flex;align-items:center;justify-content:center;gap:7px;padding:10px 6px;border-bottom:none !important;border-radius:99px}\n.viewtab svg{width:15px;height:15px}\n/* full dark mode */\n.app.dark{--bg:#232327;--panel:#1b1b1f;--line:#3a3a41;--ink:#f1f1f2;--muted:#9a9aa2;--flat:#2e2e34;--flat-hover:#38383f;color:#f1f1f2}\n.app.dark .stage{background:radial-gradient(circle at 50% 50%,#35353c 1.2px,transparent 1.7px) 0 0/26px 26px,#232327}\n.app.dark .seg button.on,.app.dark .chip.on{color:#1e1e1e}\n.app.dark .layeritem.on .layeritem__name{color:#1e1e1e}\n.app.dark .segbar{background:#3a3a41}\n.app.dark .step{box-shadow:none}\n.dial{width:54px;height:54px;border-radius:50%;border:2px solid var(--line);background:var(--bg);position:relative;cursor:pointer;flex-shrink:0;touch-action:none}\n.dial::after{content:\"\";position:absolute;left:50%;top:50%;width:5px;height:5px;margin:-2.5px;border-radius:50%;background:var(--line)}\n.dial__dot{position:absolute;width:12px;height:12px;margin:-6px;border-radius:50%;background:var(--brand-y);box-shadow:0 1px 3px rgba(26,26,32,.25);pointer-events:none}\n.app.dark .dial{background:#232327}\n.app.dark .addtile{background:#232327}\n.app.dark .addtile__ic{background:#2e2e34;color:#f1f1f2}\n.app.dark .addtile:hover{border-color:#4a4a52;box-shadow:none}\n.app.dark .step__ic--o,.app.dark .step__ic--p,.app.dark .step__ic--b,.app.dark .step__ic--g,.app.dark .step__ic--y,.app.dark .step__ic--k{background:#2e2e34;color:#f1f1f2}\n.app.dark .dlcard{background:#1b1b1f}\n.app.dark .dl-group--order,.app.dark .dl-group--preview{background:#232327}\n.app.dark .dl--png,.app.dark .dl--svg{background:#2e2e34;color:#f1f1f2}\n.app.dark .dl--proof{background:#232327;border-color:#4a4a52;color:#9a9aa2}\n.app.dark .dl--svg .dl__ic{background:#233a2b;color:#6ecb8a}\n.app.dark .dl--png .dl__ic{background:#20303f;color:#7fb1e0}\n.app.dark .dl--proof .dl__ic{background:#2e2e34;color:#b9b9c2}\n.app.dark .dl-badge--stop{background:#2e2e34;color:#9a9aa2;border-color:#3a3a41}\n.app.dark .dl small{color:#9a9aa2}\n.app.dark .ctool,.app.dark .zoomctl button,.app.dark .canvas-dims{background:rgba(38,38,44,.94);color:#f1f1f2}\n.app.dark .hexin{color:#f1f1f2}\n.app.dark .toggle{background:#3a3a41}\n.app.dark .toggle::after{background:#f1f1f2}\n.app.dark .toggle.on{background:var(--brand-y)}\n.app.dark .upslot__ic{background:#2e2e34;color:#9a9aa2}\n.app.dark .divider{background:#3a3a41}\n.app.dark .sw{box-shadow:inset 0 0 0 1px rgba(255,255,255,.16)}\n.app.dark .sw.on{box-shadow:inset 0 0 0 1px rgba(255,255,255,.16),0 0 0 3px var(--bg),0 0 0 5.5px #f1f1f2}\n.app.dark #viewBookmark::-webkit-scrollbar-track,.app.dark #viewCard::-webkit-scrollbar-track{background:#2e2e34}\n.app.dark #drop,.app.dark .upslot{background:var(--bg)}\n.app.dark .dl--zip small{color:rgba(255,255,255,.85)}\n/* flat: no hover glows or lifts anywhere */\n.dl:not(:disabled):hover{box-shadow:none;transform:none}\n.dl--png:not(:disabled):hover,.dl--svg:not(:disabled):hover{background:var(--flat-hover)}\n.dl--zip:not(:disabled):hover{box-shadow:none;background:#1c9e5b}\n.addtile:hover{box-shadow:none;transform:none;background:var(--flat-hover)}\n.cta:hover{box-shadow:none}\n/* polish: dark ctool highlight, darker zip hover, flat identical switcher,\n   centred swatches, right-aligned sub-labels, yellow-outline selections */\n.app.dark .ctool.on{background:#141417;color:var(--brand-y)}\n/* rulers sit below the brand stripe, never over it */\n.ruler-h{top:5px}\n.tool::before{z-index:4}\n/* mobile: auto height, taller canvas, compact size tag */\n@media (max-width:900px){\n  .tool{height:auto !important;max-height:none !important;min-height:0 !important}\n  .panel{overflow:visible}\n  .panel__body{overflow:visible}\n  #viewBookmark,#viewCard{overflow:visible;height:auto;padding-right:0}\n  .stage,.stagewrap .stage{min-height:62vh;max-height:none}\n  .canvas-dims{display:none !important}\n  .canvas-tools{flex-direction:column}\n  .zoomctl{flex-direction:column}\n}\n.dl--zip:not(:disabled):hover{background:#178a4f}\n.dl--zip:not(:disabled):active{background:#147a46;box-shadow:none;transform:none}\n.viewtabs__thumb{box-shadow:none}\n.swatches{justify-content:center}\n.swfoot{justify-content:center}\n.lbl-sub,.sub-label{text-align:right}\n#orientSeg button.on,#flipSeg button.on{background:var(--bg);color:var(--ink);box-shadow:inset 0 0 0 2px var(--brand-y)}\n/* download buttons: white cards on grey, file-type icon chips */\n.dlcard{background:#f0f0f3}\n.dl-group--order{background:var(--bg)}\n.dl-group--preview{background:var(--bg)}\n.dl{display:flex;align-items:center;gap:11px;text-align:left}\n.dl--png,.dl--svg,.dl--proof{background:var(--flat);border:none}\n.dl__ic{width:38px;height:38px;border-radius:11px;display:flex;align-items:center;justify-content:center;flex-shrink:0}\n.dl__ic svg{width:19px;height:19px}\n.dl__tx{flex:1;min-width:0}\n.dl--svg .dl__ic{background:#e7f4eb;color:#35914d}\n.dl--png .dl__ic{background:#e7f0f9;color:#3c78b4}\n.dl--proof .dl__ic{background:#ededf1;color:#55555e}\n.dl--proof{border:1.5px dashed #c9c9d2;background:var(--bg)}\n.dl--zip .dl__ic{background:rgba(255,255,255,.25);color:#fff}\n/* compact sliders, tight vertical rhythm */\n.segslider{gap:10px}\n.segslider__val{min-width:44px;background:none;color:var(--ink);font-family:var(--bm-display);font-size:11.5px;letter-spacing:.03em;text-align:left;padding:0;height:auto;border-radius:0;display:block}\n.segslider__track{height:26px;gap:6px}\n.group:has(.segslider){margin-bottom:10px}\n.group:has(.segslider)>label{margin-bottom:4px}\n/* brand: white / 1e1e1e / pastel-bright yellow accent */\n.upslot.filled{border-color:var(--brand-y)}\n.toggle.on{background:var(--brand-y)}\n/* segmented slider + floating value bubble */\ninput[type=range]{height:10px;border-radius:4px}\n.rangebubble{position:fixed;z-index:99;transform:translateX(-50%);background:var(--ink);color:var(--bg);font-family:var(--bm-display);font-size:11.5px;letter-spacing:.04em;padding:5px 9px 4px;border-radius:8px;pointer-events:none;white-space:nowrap}\n.rangebubble::after{content:\"\";position:absolute;left:50%;top:100%;transform:translateX(-50%);border:5px solid transparent;border-top-color:var(--ink)}\n";
const BM_HTML = "<div class=\"app\">\n  <div class=\"tool\">\n    <div class=\"stagewrap\">\n    <div class=\"doctabs hidden\" id=\"docTabs\"></div>\n    <div class=\"stage\" id=\"stage\">\n      <div class=\"erase-bar\" id=\"eraseBar\"><span id=\"eraseLbl\">"+stkE(stkT("stk.labs.bookmark.stage.eraser","Eraser"))+"</span><input type=\"range\" id=\"eraseSize\" min=\"0.5\" max=\"8\" step=\"0.5\" value=\"2\" aria-label=\""+stkE(stkT("stk.labs.bookmark.stage.eraser_size_aria","Eraser size in mm"))+"\"><span id=\"eraseSizeVal\">2.0mm</span><button type=\"button\" id=\"eraseUndo\" disabled>"+stkE(stkT("stk.labs.bookmark.stage.undo","Undo"))+"</button><button type=\"button\" id=\"eraseRedo\" disabled>"+stkE(stkT("stk.labs.sheet.redo","Redo"))+"</button><button type=\"button\" id=\"eraseClear\" disabled>"+stkE(stkT("stk.labs.bookmark.stage.reset","Reset"))+"</button></div>\n      <div class=\"canvas-tools\" id=\"canvasTools\" style=\"display:none\">\n        <div class=\"ctool\" id=\"ctoolErase\" title=\""+stkE(stkT("stk.labs.bookmark.tools.erase","Clean up \u00b7 erase stray pixels"))+"\" aria-pressed=\"false\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.5 20H20\"/><path d=\"m15 5-9.5 9.5a2.1 2.1 0 0 0 0 3l2 2a2.1 2.1 0 0 0 3 0L20 10\"/><path d=\"m11 9 4 4\"/></svg></div>\n        <div class=\"ctool\" id=\"ctoolFill\" title=\""+stkE(stkT("stk.studio.tool.fill_title","Fill brush \u00b7 paint gaps in the border colour"))+"\" aria-pressed=\"false\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08\"/><path d=\"M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z\"/></svg></div>\n        <div class=\"ctool\" id=\"ctoolWand\" title=\""+stkE(stkT("stk.studio.tool.wand_title","Magic wand \u00b7 tap a colour to remove that area, tap again to bring it back"))+"\" aria-pressed=\"false\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M15 4V2\"/><path d=\"M15 16v-2\"/><path d=\"M8 9h2\"/><path d=\"M20 9h2\"/><path d=\"M17.8 11.8 19 13\"/><path d=\"M15 9h.01\"/><path d=\"M17.8 6.2 19 5\"/><path d=\"m3 21 9-9\"/><path d=\"M12.2 6.2 11 5\"/></svg></div>\n        <div class=\"ctool\" id=\"ctoolRuler\" title=\""+stkE(stkT("stk.labs.bookmark.tools.rulers","Toggle rulers"))+"\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 8h18v8H3z\"/><path d=\"M7 8v3\"/><path d=\"M11 8v4\"/><path d=\"M15 8v3\"/><path d=\"M19 8v4\"/></svg></div>\n        <div class=\"ctool\" id=\"ctoolFlip\" title=\""+stkE(stkT("stk.labs.bookmark.tools.flip","Rotate preview 180\u00b0"))+"\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 2v6h-6\"/><path d=\"M3 12a9 9 0 0 1 15-6.7L21 8\"/><path d=\"M3 22v-6h6\"/><path d=\"M21 12a9 9 0 0 1-15 6.7L3 16\"/></svg></div>\n        <div class=\"ctool on\" id=\"ctoolFold\" title=\""+stkE(stkT("stk.labs.bookmark.tools.fold","Toggle fold line"))+"\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 12h18\" stroke-dasharray=\"3 3\"/><path d=\"M7 7l-2 5 2 5\"/><path d=\"M17 7l2 5-2 5\"/></svg></div>\n        <div class=\"ctool on\" id=\"ctoolCut\" title=\""+stkE(stkT("stk.labs.bookmark.tools.cut","Toggle cut line"))+"\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6\" cy=\"6\" r=\"3\"/><circle cx=\"6\" cy=\"18\" r=\"3\"/><path d=\"M20 4 8.12 15.88\"/><path d=\"M14.47 14.48 20 20\"/><path d=\"M8.12 8.12 12 12\"/></svg></div>\n        <div class=\"ctool\" id=\"ctoolStage\" title=\""+stkE(stkT("stk.labs.bookmark.tools.dark_mode","Dark mode"))+"\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"9\"/><path d=\"M12 3a9 9 0 0 1 0 18Z\" fill=\"currentColor\" stroke=\"none\"/></svg></div>\n      </div>\n      <div class=\"canvas-dims\" id=\"canvasDims\"><b>"+stkE(stkT("stk.labs.bookmark.dims.bookmark_size","BOOKMARK SIZE"))+"</b><span id=\"dimText\"></span></div>\n      <div class=\"stage-inner\" id=\"stageInner\">\n        <canvas id=\"preview\" class=\"hidden\"></canvas>\n      </div>\n      <canvas id=\"rulerTop\" class=\"ruler ruler-h hidden\"></canvas>\n      <canvas id=\"rulerLeft\" class=\"ruler ruler-v hidden\"></canvas>\n      <div id=\"drop\">\n        <h2>"+stkE(stkT("stk.labs.bookmark.drop.heading","Build your magnetic bookmark"))+"</h2>\n        <p>"+stkE(stkT("stk.labs.bookmark.drop.body","Drop your artwork here, or use the upload panel."))+"</p>\n        <p>"+stkE(stkT("stk.labs.bookmark.drop.formats","PNG, JPEG, WEBP, PDF or SVG. Transparent PNG works best."))+"</p>\n      </div>\n      <div class=\"zoomctl\" id=\"zoomctl\" style=\"display:none\">\n        <button id=\"zoomOut\" title=\""+stkE(stkT("stk.labs.bookmark.zoom.zoom_out","Zoom out"))+"\">&minus;</button>\n        <button id=\"zoomFit\" title=\""+stkE(stkT("stk.labs.bookmark.zoom.fit","Fit to screen"))+"\"><svg viewBox=\"0 0 24 24\" width=\"15\" height=\"15\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 3H5a2 2 0 0 0-2 2v3\"/><path d=\"M16 3h3a2 2 0 0 1 2 2v3\"/><path d=\"M8 21H5a2 2 0 0 1-2-2v-3\"/><path d=\"M16 21h3a2 2 0 0 0 2-2v-3\"/></svg></button>\n        <button id=\"zoomIn\" title=\""+stkE(stkT("stk.labs.bookmark.zoom.zoom_in","Zoom in"))+"\">+</button>\n      </div>\n      <div class=\"spin\" id=\"spin\">"+stkE(stkT("stk.labs.bookmark.stage.processing","PROCESSING\u2026"))+"</div>\n      <input type=\"file\" id=\"fileMain\" accept=\"image/png,image/jpeg,image/webp,image/svg+xml,application/pdf,.pdf,.svg\" style=\"display:none\">\n      <input type=\"file\" id=\"fileTop\" accept=\"image/png,image/jpeg,image/webp,image/svg+xml,application/pdf,.pdf,.svg\" style=\"display:none\">\n      <input type=\"file\" id=\"fileCard\" accept=\"image/png,image/jpeg,image/webp,image/svg+xml,application/pdf,.pdf,.svg\" style=\"display:none\">\n    </div>\n    </div>\n\n    <div class=\"panel\">\n      <div class=\"viewtabs\"><span class=\"viewtabs__thumb\" id=\"viewThumb\"></span>\n        <div class=\"viewtab on\" id=\"tabBookmark\" data-view=\"bookmark\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 3h10v18l-5-4-5 4Z\"/></svg>"+stkE(stkT("stk.labs.bookmark.tabs.bookmark","BOOKMARK"))+"</div>\n        <div class=\"viewtab\" id=\"tabCard\" data-view=\"card\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"6.5\" width=\"18\" height=\"14\" rx=\"3\"/><rect x=\"5.5\" y=\"9\" width=\"13\" height=\"9\" rx=\"2\" fill=\"currentColor\" stroke=\"none\"/><rect x=\"9.8\" y=\"4.2\" width=\"4.4\" height=\"6\" rx=\"0.8\" fill=\"currentColor\" stroke=\"none\"/></svg>"+stkE(stkT("stk.labs.bookmark.tabs.card","BACKING CARD"))+"</div>\n      </div>\n\n      <div class=\"panel__body\">\n\n      <div id=\"viewBookmark\">\n        <div class=\"step\">\n          <div class=\"step__head\"><span class=\"step__ic step__ic--o\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"3\"/><circle cx=\"9\" cy=\"9\" r=\"2\"/><path d=\"m21 15-5-5L5 21\"/></svg></span><span class=\"step__t\">"+stkE(stkT("stk.labs.bookmark.artwork.heading","Artwork"))+"</span><span class=\"step__chev\">&rsaquo;</span></div>\n          <div class=\"step__body\">\n          <div class=\"upslot\" id=\"slotMain\">\n            <div class=\"upslot__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"/><path d=\"M17 8l-5-5-5 5\"/><path d=\"M12 3v12\"/></svg></div>\n            <div class=\"upslot__t\">"+stkE(stkT("stk.labs.bookmark.artwork.drop_main","Drop your main design here"))+"</div>\n            <div class=\"upslot__s\" id=\"slotMainSub\">"+stkE(stkT("stk.labs.bookmark.artwork.drop_main_sub","or click to browse \u00b7 used for both halves"))+"</div>\n            <div class=\"upslot__types\">"+stkE(stkT("stk.labs.bookmark.ui.formats","PNG, JPEG, WEBP, PDF or SVG"))+"</div>\n          </div>\n          <div class=\"dpiwrap\"><div id=\"dpi\"></div></div>\n          <div class=\"group\" style=\"margin-top:20px\">\n            <div class=\"seg\" id=\"orientSeg\">\n              <button data-v=\"portrait\" class=\"on\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linejoin=\"round\"><rect x=\"5\" y=\"4.5\" width=\"14\" height=\"17\" rx=\"3\"/><rect x=\"7.5\" y=\"7\" width=\"9\" height=\"12\" rx=\"2\" fill=\"currentColor\" stroke=\"none\"/><rect x=\"9.8\" y=\"2.2\" width=\"4.4\" height=\"6\" rx=\"0.8\" fill=\"currentColor\" stroke=\"none\"/></svg>"+stkE(stkT("stk.labs.bookmark.ui.portrait","Portrait"))+"</button>\n              <button data-v=\"landscape\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"6.5\" width=\"18\" height=\"14\" rx=\"3\"/><rect x=\"5.5\" y=\"9\" width=\"13\" height=\"9\" rx=\"2\" fill=\"currentColor\" stroke=\"none\"/><rect x=\"9.8\" y=\"4.2\" width=\"4.4\" height=\"6\" rx=\"0.8\" fill=\"currentColor\" stroke=\"none\"/></svg>"+stkE(stkT("stk.labs.bookmark.ui.landscape","Landscape"))+"</button>\n            </div>\n          </div>\n          <div class=\"group\">\n            <div class=\"seg\" id=\"flipSeg\">\n              <button data-v=\"rotate\" class=\"on\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 2v6h-6\"/><path d=\"M3 12a9 9 0 0 1 15-6.7L21 8\"/><path d=\"M3 22v-6h6\"/><path d=\"M21 12a9 9 0 0 1-15 6.7L3 16\"/></svg>"+stkE(stkT("stk.labs.bookmark.flip.rotate","Rotate 180\u00b0"))+"</button>\n              <button data-v=\"mirror\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 3v18\" stroke-dasharray=\"3 3\"/><path d=\"M8 8 4 12l4 4\"/><path d=\"m16 8 4 4-4 4\"/></svg>"+stkE(stkT("stk.labs.bookmark.flip.mirror","Mirror"))+"</button>\n            </div>\n            <div class=\"hint\" id=\"flipHint\">"+stkE(stkT("stk.labs.bookmark.flip.hint_initial","Rotate: keeps text readable on the fold-over. Switch to Mirror for designs without words."))+"</div>\n          </div>\n          <div class=\"row\" style=\"margin-top:12px\">\n            <span class=\"lbl\">"+stkE(stkT("stk.labs.bookmark.artwork.two_sided","Different design on top half"))+"</span>\n            <div class=\"toggle\" id=\"twoSidedToggle\"></div>\n          </div>\n          <div id=\"topSlotWrap\" style=\"margin-top:12px;display:none\">\n            <div class=\"upslot\" id=\"slotTop\" style=\"position:relative\">\n              <div class=\"upslot__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"/><path d=\"M17 8l-5-5-5 5\"/><path d=\"M12 3v12\"/></svg></div>\n              <div class=\"upslot__t\">"+stkE(stkT("stk.labs.bookmark.artwork.drop_top","Drop your top-half design here"))+"</div>\n              <div class=\"upslot__s\" id=\"slotTopSub\">"+stkE(stkT("stk.labs.bookmark.artwork.drop_top_sub","or click to browse"))+"</div>\n              <div class=\"upslot__types\">"+stkE(stkT("stk.labs.bookmark.ui.formats","PNG, JPEG, WEBP, PDF or SVG"))+"</div>\n            </div>\n          </div>\n          <div class=\"row\" style=\"margin-top:12px\">\n            <span class=\"lbl\">"+stkE(stkT("stk.labs.bookmark.artwork.remove_background","Remove background"))+"</span>\n            <div class=\"toggle\" id=\"rmWhite\"></div>\n          </div>\n          <div class=\"row\" style=\"margin-top:12px\">\n            <span class=\"lbl\">"+stkE(stkT("stk.labs.bookmark.artwork.finished","Finished bookmark (add cut line)"))+"</span>\n            <div class=\"toggle\" id=\"finishedToggle\"></div>\n          </div>\n          <div class=\"hint\" id=\"finishedHint\" style=\"display:none\">"+stkE(stkT("stk.labs.bookmark.artwork.finished_hint","Your upload is the whole unfolded bookmark. We trace the cut around it and place the fold at its narrowest point."))+"</div>\n          <div class=\"group hidden\" id=\"gTol\" style=\"margin-top:14px;margin-bottom:0\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.artwork.removal_strength","Background removal strength"))+"</label>\n            <input type=\"range\" id=\"tol\" min=\"0\" max=\"100\" step=\"1\" value=\"25\">\n            <div class=\"range-meta\"><span>"+stkE(stkT("stk.labs.bookmark.artwork.gentle","Gentle"))+"</span><span id=\"tolVal\">25%</span><span>"+stkE(stkT("stk.labs.bookmark.artwork.aggressive","Aggressive"))+"</span></div>\n            <div class=\"row\" style=\"justify-content:flex-start;gap:9px;margin-top:12px\">\n              <div class=\"sw\" id=\"keySwatch\" title=\""+stkE(stkT("stk.labs.bookmark.artwork.key_colour_title","Colour being removed"))+"\" style=\"cursor:default;background:#ffffff\"></div>\n              <button class=\"ghost\" id=\"keyPick\" style=\"margin:0;width:auto;padding:8px 14px\">"+stkE(stkT("stk.labs.bookmark.artwork.pick_key_colour","Pick colour to remove"))+"</button>\n              <button class=\"ghost\" id=\"keyReset\" style=\"margin:0;width:auto;padding:8px 14px\">"+stkE(stkT("stk.labs.bookmark.ui.white","White"))+"</button>\n              <input type=\"color\" id=\"keyNative\" style=\"display:none\">\n            </div>\n          </div>\n          <div class=\"group\" id=\"savedGroup\" style=\"margin-top:16px;margin-bottom:0\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.saved.heading","Saved designs"))+"</label>\n            <div class=\"row\" style=\"justify-content:center;gap:9px\">\n              <button class=\"ghost\" id=\"saveDesignBtn\" style=\"margin:0;width:auto;padding:9px 16px\">"+stkE(stkT("stk.labs.bookmark.saved.save","Save this design"))+"</button>\n              <button class=\"ghost\" id=\"showDesignsBtn\" style=\"margin:0;width:auto;padding:9px 16px\">"+stkE(stkT("stk.labs.bookmark.saved.show","My designs"))+"</button>\n            </div>\n            <div id=\"savedList\" class=\"layerlist\" style=\"margin-top:10px;display:none\"></div>\n            <div class=\"hint\" id=\"savedHint\"></div>\n          </div>\n          </div>\n        </div>\n\n        <div class=\"step collapsed\">\n          <div class=\"step__head\"><span class=\"step__ic step__ic--p\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 6h9\"/><circle cx=\"17\" cy=\"6\" r=\"2.5\"/><path d=\"M20 12h-9\"/><circle cx=\"7\" cy=\"12\" r=\"2.5\"/><path d=\"M4 18h8\"/><circle cx=\"16\" cy=\"18\" r=\"2.5\"/></svg></span><span class=\"step__t\">"+stkE(stkT("stk.labs.bookmark.ui.design","Design"))+"</span><span class=\"step__chev\">&rsaquo;</span></div>\n          <div class=\"step__body\">\n          <div class=\"row\" style=\"margin-bottom:14px\">\n            <span class=\"lbl\">"+stkE(stkT("stk.labs.bookmark.design.bridge","Bridge"))+"</span>\n            <div class=\"toggle on\" id=\"bridgeToggle\"></div>\n          </div>\n          <div class=\"group\" id=\"gBridge\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.bridge_length","Bridge length"))+"</label>\n            <input type=\"range\" id=\"bridge\" min=\"0\" max=\"50\" step=\"1\" value=\"10\">\n            <div class=\"ticks\" id=\"bridgeTicksRow\"></div>\n            <div class=\"range-meta\"><span>0mm</span><span id=\"bridgeVal\">10mm</span><span>50mm</span></div>\n          </div>\n          <div class=\"group\" id=\"gBridgeW\" style=\"margin-bottom:0\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.design.bridge_width","Bridge width"))+"</label>\n            <input type=\"range\" id=\"bridgeW2\" min=\"15\" max=\"30\" step=\"5\" value=\"20\">\n            <div class=\"range-meta\"><span>15mm</span><span id=\"bridgeWVal\">20mm</span><span>30mm</span></div>\n          </div>\n          <div class=\"group\">\n            <div class=\"lblrow\"><label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.design.art_centre","Artwork centre"))+"</label><button type=\"button\" class=\"ghost\" id=\"artCentreReset\" style=\"margin:0;width:auto;padding:5px 11px;font-size:11px;display:none\">"+stkE(stkT("stk.labs.bookmark.design.art_centre_reset","Reset to auto"))+"</button></div>\n            <input type=\"range\" id=\"artCentre\" min=\"20\" max=\"80\" step=\"1\" value=\"50\" aria-label=\""+stkE(stkT("stk.labs.bookmark.design.art_centre_aria","Where the fold sits across the artwork"))+"\">\n            <div class=\"range-meta\"><span>"+stkE(stkT("stk.labs.bookmark.design.left","Left"))+"</span><span id=\"artCentreVal\">"+stkE(stkT("stk.labs.bookmark.ui.auto","Auto"))+"</span><span>"+stkE(stkT("stk.labs.bookmark.design.right","Right"))+"</span></div>\n          </div>\n          <div class=\"group\">\n            <div class=\"lblrow\"><label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.size.heading","Bookmark size"))+"</label><button type=\"button\" class=\"infodot\" id=\"bmSizeInfo\" aria-expanded=\"false\" aria-label=\""+stkE(stkT("stk.labs.bookmark.size.info_aria","About bookmark size"))+"\">i</button></div>\n            <div class=\"sizegrid\">\n              <div class=\"sizecell\"><span class=\"sizecap\" id=\"bmWCap\">"+stkE(stkF(stkT("stk.labs.bookmark.size.width_caption","Width ([unit])"),{unit:stkT("stk.labs.bookmark.units.cm","cm")}))+"</span><input type=\"number\" id=\"bmW\" step=\"any\" placeholder=\""+stkE(stkT("stk.labs.bookmark.size.placeholder_auto","auto"))+"\" aria-label=\""+stkE(stkT("stk.labs.bookmark.size.width_aria","Bookmark width"))+"\"></div>\n              <div class=\"sizecell\"><span class=\"sizecap\" id=\"bmHCap\">"+stkE(stkF(stkT("stk.labs.bookmark.size.length_caption","Length ([unit])"),{unit:stkT("stk.labs.bookmark.units.cm","cm")}))+"</span><input type=\"number\" id=\"bmH\" step=\"any\" placeholder=\""+stkE(stkT("stk.labs.bookmark.size.placeholder_auto","auto"))+"\" aria-label=\""+stkE(stkT("stk.labs.bookmark.size.length_aria","Bookmark length"))+"\"></div>\n            </div>\n            <div class=\"seg seg--units\" id=\"bmUnitSeg\" role=\"group\" aria-label=\""+stkE(stkT("stk.labs.bookmark.size.units_aria","Units"))+"\"><button type=\"button\" data-u=\"cm\" class=\"on\">"+stkE(stkT("stk.labs.bookmark.units.cm","cm"))+"</button><button type=\"button\" data-u=\"in\">"+stkE(stkT("stk.labs.bookmark.units.inch","in"))+"</button></div>\n            <div class=\"hint hint--info\" id=\"bmSizeHint\"></div>\n          </div>\n          <div class=\"group\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.design.border_width","Border width"))+"</label>\n            <input type=\"range\" id=\"borderW\" min=\"0\" max=\"6\" step=\"0.5\" value=\"2.5\">\n            <div class=\"range-meta\"><span>0mm</span><span id=\"borderVal\">2.5mm</span><span>6mm</span></div>\n          </div>\n          <div class=\"group\" id=\"gCorner\" style=\"display:none\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.corner_radius","Corner radius"))+"</label>\n            <input type=\"range\" id=\"cornerR\" min=\"3.175\" max=\"12\" step=\"0.125\" value=\"6.5\">\n            <div class=\"range-meta\"><span>3.2mm</span><span id=\"cornerVal\">6.5mm</span><span id=\"cornerMaxLbl\">12mm</span></div>\n            <div class=\"hint\" id=\"cornerHint\">"+stkE(stkT("stk.labs.bookmark.corner.rectangle_hint","Your artwork is a rectangle, so it is cut as one: straight edges, and the same radius on all twelve corners. Remove the background instead to cut around the artwork itself."))+"</div>\n          </div>\n          <div class=\"group\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.design.cut_smoothing","Cut smoothing"))+"</label>\n            <input type=\"range\" id=\"smooth\" min=\"0\" max=\"5\" step=\"0.5\" value=\"1\">\n            <div class=\"range-meta\"><span>0mm</span><span id=\"smoothVal\">1.0mm</span><span>5mm</span></div>\n          </div>\n          <div class=\"divider\"></div>\n\n          <div class=\"group\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.colour","Colour"))+"</label>\n            <div class=\"seg\" id=\"bmBgModeSeg\"><button data-v=\"solid\">"+stkE(stkT("stk.labs.bookmark.ui.solid","Solid"))+"</button><button data-v=\"gradient\">"+stkE(stkT("stk.labs.bookmark.ui.gradient","Gradient"))+"</button><button data-v=\"auto\" class=\"on\">"+stkE(stkT("stk.labs.bookmark.ui.auto","Auto"))+"</button></div>\n            <div class=\"hint\" id=\"bmAutoHint\" style=\"display:none;margin-top:8px\">"+stkE(stkT("stk.labs.bookmark.design.auto_bleed_hint","Auto bleed: the border and bleed grow from your artwork's own edges."))+"</div>\n            <div id=\"bmSolidWrap\" style=\"margin-top:10px\"><div id=\"swatchHost\"></div></div>\n            <div id=\"bmGradWrap\" style=\"margin-top:10px;display:none\"><div class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.from","From"))+"</div><div id=\"bmGradFromHost\"></div><div class=\"lbl-sub\" style=\"margin-top:8px\">"+stkE(stkT("stk.labs.bookmark.ui.to","To"))+"</div><div id=\"bmGradToHost\"></div><div class=\"lbl-sub\" style=\"margin-top:8px\">"+stkE(stkT("stk.labs.bookmark.ui.angle","Angle"))+"</div><div class=\"row\" style=\"justify-content:center;gap:14px\"><div class=\"dial\" id=\"bmGradDial\"><div class=\"dial__dot\" id=\"bmGradDialDot\"></div></div><span class=\"lbl\" id=\"bmGradAngleVal\">135&deg;</span></div></div>\n          </div>\n          <div class=\"group\" id=\"foldColourWrap\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.design.fold_line","Fold line"))+"</label>\n            <div id=\"foldSwatchHost\"></div>\n            <div class=\"hint\">"+stkE(stkT("stk.labs.bookmark.design.print_safe_hint","Colours auto-adjust to stay print-safe (CMYK)."))+"</div>\n          </div>\n          </div>\n        </div>\n        <div class=\"step collapsed\">\n          <div class=\"step__head\"><span class=\"step__ic step__ic--k\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/></svg></span><span class=\"step__t\">"+stkE(stkT("stk.labs.bookmark.ui.preview","Preview"))+"</span><span class=\"step__chev\">&rsaquo;</span></div>\n          <div class=\"step__body\">\n          <div class=\"group\" style=\"margin-bottom:0\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.view","View"))+"</label>\n            <div class=\"seg\" id=\"bmViewSeg\">\n              <button data-v=\"full\" class=\"on\">"+stkE(stkT("stk.labs.bookmark.ui.full_length","Full length"))+"</button>\n              <button data-v=\"folded\">"+stkE(stkT("stk.labs.bookmark.ui.folded","Folded"))+"</button>\n            </div>\n            <div class=\"hint\">"+stkE(stkT("stk.labs.bookmark.preview.folded_hint","Folded shows it as it ends up in the hand. The back of the top half is not printed, so it shows white wherever it sits past the front."))+"</div>\n          </div>\n          <div class=\"row\">\n            <span class=\"lbl\">"+stkE(stkT("stk.labs.bookmark.ui.show_magnet_guide","Show magnet guide"))+"</span>\n            <div class=\"toggle\" id=\"magnetToggleBm\"></div>\n          </div>\n          </div>\n        </div>\n      </div>\n\n      <div id=\"viewCard\" class=\"hidden\">\n        <div class=\"step\">\n          <div class=\"step__head\"><span class=\"step__ic step__ic--b\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"6.5\" width=\"18\" height=\"14\" rx=\"3\"/><rect x=\"5.5\" y=\"9\" width=\"13\" height=\"9\" rx=\"2\" fill=\"currentColor\" stroke=\"none\"/><rect x=\"9.8\" y=\"4.2\" width=\"4.4\" height=\"6\" rx=\"0.8\" fill=\"currentColor\" stroke=\"none\"/></svg></span><span class=\"step__t\">"+stkE(stkT("stk.labs.bookmark.card.heading","Card"))+"</span><span class=\"step__chev\">&rsaquo;</span></div>\n          <div class=\"step__body\">\n          <div class=\"group\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.card.backing_card","Backing card"))+"</label>\n            <div class=\"seg\" id=\"cardPresetSeg\">\n              <button data-v=\"grid\" class=\"on\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3.5\" y=\"5\" width=\"17\" height=\"14\" rx=\"2.5\"/><path d=\"M3.5 12h17\"/><path d=\"M9 5v14\"/><path d=\"M15 5v14\"/></svg>"+stkE(stkT("stk.labs.bookmark.card.preset_default","Default"))+"</button>\n              <button data-v=\"upload\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"/><path d=\"M17 8l-5-5-5 5\"/><path d=\"M12 3v12\"/></svg>"+stkE(stkT("stk.labs.bookmark.card.preset_upload","Upload"))+"</button>\n              <button data-v=\"design\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 20h9\"/><path d=\"M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z\"/></svg>"+stkE(stkT("stk.labs.bookmark.ui.design","Design"))+"</button>\n            </div>\n            <div class=\"hint\" id=\"cardPresetHint\">"+stkE(stkT("stk.labs.bookmark.card.preset_hint","Use our default unbranded card, upload your own, or design one right here. 8.7 \u00d7 6.7cm, 6.5mm rounded corners."))+"</div>\n          </div>\n          <div class=\"row\" id=\"showOnCardRow\" style=\"margin-top:16px\">\n            <span class=\"lbl\">"+stkE(stkT("stk.labs.bookmark.card.show_bookmark","Show bookmark on card"))+"</span>\n            <div class=\"toggle on\" id=\"showOnCard\"></div>\n          </div>\n          <div class=\"group\" style=\"margin-top:20px\">\n            <div class=\"seg\" id=\"orientSegCard\">\n              <button data-v=\"portrait\" class=\"on\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linejoin=\"round\"><rect x=\"5\" y=\"4.5\" width=\"14\" height=\"17\" rx=\"3\"/><rect x=\"7.5\" y=\"7\" width=\"9\" height=\"12\" rx=\"2\" fill=\"currentColor\" stroke=\"none\"/><rect x=\"9.8\" y=\"2.2\" width=\"4.4\" height=\"6\" rx=\"0.8\" fill=\"currentColor\" stroke=\"none\"/></svg>"+stkE(stkT("stk.labs.bookmark.ui.portrait","Portrait"))+"</button>\n              <button data-v=\"landscape\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"6.5\" width=\"18\" height=\"14\" rx=\"3\"/><rect x=\"5.5\" y=\"9\" width=\"13\" height=\"9\" rx=\"2\" fill=\"currentColor\" stroke=\"none\"/><rect x=\"9.8\" y=\"4.2\" width=\"4.4\" height=\"6\" rx=\"0.8\" fill=\"currentColor\" stroke=\"none\"/></svg>"+stkE(stkT("stk.labs.bookmark.ui.landscape","Landscape"))+"</button>\n            </div>\n          </div>\n          <div id=\"cardUploadWrap\" style=\"margin-top:14px\">\n            <div class=\"upslot\" id=\"slotCard\">\n              <div class=\"upslot__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"/><path d=\"M17 8l-5-5-5 5\"/><path d=\"M12 3v12\"/></svg></div>\n              <div class=\"upslot__t\">"+stkE(stkT("stk.labs.bookmark.card.drop","Drop your card design here"))+"</div>\n              <div class=\"upslot__s\" id=\"slotCardSub\">"+stkE(stkT("stk.labs.bookmark.card.drop_sub","or click to browse \u00b7 8.7 \u00d7 6.7cm"))+"</div>\n              <div class=\"upslot__types\">"+stkE(stkT("stk.labs.bookmark.ui.formats","PNG, JPEG, WEBP, PDF or SVG"))+"</div>\n            </div>\n          </div>\n          <div class=\"group\" id=\"cardBgGroup\" style=\"margin-top:16px;margin-bottom:0\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.card.bg_heading","Card background & bleed colour"))+"</label>\n            <div class=\"seg\" id=\"cardBgModeSeg\"><button data-v=\"auto\" class=\"on\">"+stkE(stkT("stk.labs.bookmark.ui.auto","Auto"))+"</button><button data-v=\"solid\">"+stkE(stkT("stk.labs.bookmark.ui.solid","Solid"))+"</button></div>\n            <div id=\"cardSwatchHost\"></div>\n            <div class=\"hint\">"+stkE(stkT("stk.labs.bookmark.card.bg_hint","Fills the card and the 1.5mm bleed, shown as the tint around the edge."))+"</div>\n          </div>\n          </div>\n        </div>\n\n        <div class=\"step\" id=\"designSection\" style=\"display:none\">\n          <div class=\"step__head\"><span class=\"step__ic step__ic--g\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 20h9\"/><path d=\"M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z\"/></svg></span><span class=\"step__t\">"+stkE(stkT("stk.labs.bookmark.card_design.heading","Card design"))+"</span><span class=\"step__chev\">&rsaquo;</span></div>\n          <div class=\"step__body\">\n          <div class=\"group\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.background","Background"))+"</label>\n            <div class=\"seg\" id=\"edBgType\">\n              <button data-v=\"solid\" class=\"on\">"+stkE(stkT("stk.labs.bookmark.ui.solid","Solid"))+"</button>\n              <button data-v=\"gradient\">"+stkE(stkT("stk.labs.bookmark.ui.gradient","Gradient"))+"</button>\n            </div>\n            <div id=\"edSolidWrap\" style=\"margin-top:10px\"><div id=\"edBgHost\"></div></div>\n            <div id=\"edGradWrap\" style=\"margin-top:10px;display:none\">\n              <div class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.from","From"))+"</div><div id=\"edGradFromHost\"></div>\n              <div class=\"lbl-sub\" style=\"margin-top:8px\">"+stkE(stkT("stk.labs.bookmark.ui.to","To"))+"</div><div id=\"edGradToHost\"></div>\n              <div class=\"lbl-sub\" style=\"margin-top:8px\">"+stkE(stkT("stk.labs.bookmark.ui.angle","Angle"))+"</div>\n              <input type=\"range\" id=\"edGradAngle\" min=\"0\" max=\"360\" step=\"15\" value=\"135\">\n              <div class=\"range-meta\"><span>0&deg;</span><span id=\"edGradAngleVal\">135&deg;</span><span>360&deg;</span></div>\n            </div>\n          </div>\n          <div class=\"row\" style=\"margin-top:4px\">\n            <span class=\"lbl\">"+stkE(stkT("stk.labs.bookmark.card_design.grid_lines","Grid lines"))+"</span>\n            <div class=\"toggle\" id=\"edGridToggle\"></div>\n          </div>\n          <div id=\"edGridOpts\" style=\"display:none;margin-top:12px\">\n            <div class=\"group\" style=\"margin-bottom:14px\">\n              <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.card_design.spacing","Spacing"))+"</label>\n              <input type=\"range\" id=\"edGridSpacing\" min=\"3\" max=\"20\" step=\"0.5\" value=\"7\">\n              <div class=\"range-meta\"><span>3mm</span><span id=\"edGridSpacingVal\">7mm</span><span>20mm</span></div>\n            </div>\n            <div class=\"group\" style=\"margin-bottom:14px\">\n              <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.card_design.line_thickness","Line thickness"))+"</label>\n              <input type=\"range\" id=\"edGridThick\" min=\"0.1\" max=\"1\" step=\"0.05\" value=\"0.2\">\n              <div class=\"range-meta\"><span>"+stkE(stkT("stk.labs.bookmark.card_design.fine","fine"))+"</span><span id=\"edGridThickVal\">0.20mm</span><span>"+stkE(stkT("stk.labs.bookmark.card_design.bold","bold"))+"</span></div>\n            </div>\n            <div class=\"group\" style=\"margin-bottom:14px\">\n              <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.card_design.margin_inset","Margin inset"))+"</label>\n              <input type=\"range\" id=\"edGridInset\" min=\"0\" max=\"15\" step=\"0.5\" value=\"0\">\n              <div class=\"range-meta\"><span>0mm</span><span id=\"edGridInsetVal\">0mm</span><span>15mm</span></div>\n              <div class=\"hint\">"+stkE(stkT("stk.labs.bookmark.card_design.margin_hint","Keeps the grid off the edges, like a printed panel."))+"</div>\n            </div>\n            <div class=\"group\" style=\"margin-bottom:14px\">\n              <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.card_design.clear_top","Clear space at top"))+"</label>\n              <input type=\"range\" id=\"edGridTop\" min=\"0\" max=\"60\" step=\"1\" value=\"0\">\n              <div class=\"range-meta\"><span>0mm</span><span id=\"edGridTopVal\">0mm</span><span>60mm</span></div>\n            </div>\n            <div class=\"group\" style=\"margin-bottom:14px\">\n              <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.card_design.clear_bottom","Clear space at bottom"))+"</label>\n              <input type=\"range\" id=\"edGridBottom\" min=\"0\" max=\"60\" step=\"1\" value=\"0\">\n              <div class=\"range-meta\"><span>0mm</span><span id=\"edGridBottomVal\">0mm</span><span>60mm</span></div>\n              <div class=\"hint\">"+stkE(stkT("stk.labs.bookmark.card_design.clear_hint","Stop the grid short to leave white space for your printed text, like a panel."))+"</div>\n            </div>\n            <div class=\"group\" style=\"margin-bottom:0\">\n              <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.line_colour","Line colour"))+"</label>\n              <div id=\"edGridColourHost\"></div>\n            </div>\n          </div>\n          <div class=\"group\" style=\"margin-top:18px\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.card_design.add_heading","Add to card"))+"</label>\n            <div class=\"addtiles\" id=\"edAddTiles\">\n              <button class=\"addtile\" id=\"edAddText\">\n                <span class=\"addtile__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 7V5h16v2\"/><path d=\"M12 5v14\"/><path d=\"M9 19h6\"/></svg></span>\n                <span class=\"addtile__t\">"+stkE(stkT("stk.labs.bookmark.card_design.add_text","Text"))+"</span>\n              </button>\n              <button class=\"addtile\" id=\"edAddLogo\">\n                <span class=\"addtile__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><circle cx=\"8.5\" cy=\"8.5\" r=\"1.5\"/><path d=\"M21 15l-5-5L5 21\"/></svg></span>\n                <span class=\"addtile__t\">"+stkE(stkT("stk.labs.bookmark.card_design.add_logo","Logo"))+"</span>\n              </button>\n              <button class=\"addtile\" id=\"edAddQR\">\n                <span class=\"addtile__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"7\" height=\"7\" rx=\"1\"/><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" rx=\"1\"/><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" rx=\"1\"/><path d=\"M14 14h3v3\"/><path d=\"M21 14v7h-7\"/><path d=\"M17 21v.01\"/></svg></span>\n                <span class=\"addtile__t\">"+stkE(stkT("stk.labs.bookmark.card_design.add_qr","QR code"))+"</span>\n              </button>\n              <button class=\"addtile\" id=\"edAddShape\">\n                <span class=\"addtile__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"8\" height=\"8\" rx=\"1\"/><circle cx=\"17\" cy=\"7\" r=\"4\"/><path d=\"M7 14l-4 7h8z\"/><rect x=\"13\" y=\"14\" width=\"8\" height=\"7\" rx=\"1\"/></svg></span>\n                <span class=\"addtile__t\">"+stkE(stkT("stk.labs.bookmark.ui.shape","Shape"))+"</span>\n              </button>\n            </div>\n            <div class=\"hint\">"+stkE(stkT("stk.labs.bookmark.card_design.add_hint","Tap to add, then drag on the card to position."))+"</div>\n          </div>\n          <div id=\"edLayerPanel\" style=\"display:none\"></div>\n          <input type=\"file\" id=\"edLogoFile\" accept=\"image/png,image/jpeg,image/webp,image/svg+xml\" style=\"display:none\">\n          <div class=\"group\" style=\"margin-top:18px\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.card_design.layers","Layers"))+"</label>\n            <div id=\"edLayerList\" class=\"layerlist\"></div>\n            <div class=\"hint\" id=\"edLayerEmpty\">"+stkE(stkT("stk.labs.bookmark.card_design.layers_empty","No objects yet. Add text, a logo or a QR code above."))+"</div>\n          </div>\n          </div>\n        </div>\n\n        <div class=\"step collapsed\">\n          <div class=\"step__head\"><span class=\"step__ic step__ic--y\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 3h10v18l-5-4-5 4Z\"/></svg></span><span class=\"step__t\">"+stkE(stkT("stk.labs.bookmark.on_card.heading","Bookmark on card"))+"</span><span class=\"step__chev\">&rsaquo;</span></div>\n          <div class=\"step__body\">\n          <div class=\"group\" id=\"cardWidthGroup\" style=\"margin-top:14px;margin-bottom:0\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.on_card.width","Bookmark width on card"))+"</label>\n            <input type=\"range\" id=\"cardWidth\" min=\"30\" max=\"65\" step=\"0.5\" value=\"65\">\n            <div class=\"range-meta\"><span id=\"cardWidthMin\">3.0cm</span><span id=\"cardWidthVal\">6.5cm</span><span id=\"cardWidthMax\">6.5cm</span></div>\n            <div class=\"hint\">"+stkE(stkT("stk.labs.bookmark.on_card.width_hint","Shrink the bookmark so it doesn't cover the card's printed text."))+"</div>\n          </div>\n          <div class=\"group\" id=\"bridgeCardGroup\" style=\"margin-top:14px;margin-bottom:0\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.bridge_length","Bridge length"))+"</label>\n            <input type=\"range\" id=\"bridgeCard\" min=\"0\" max=\"50\" step=\"1\" value=\"10\">\n            <div class=\"range-meta\"><span>0mm</span><span id=\"bridgeCardVal\">10mm</span><span>50mm</span></div>\n          </div>\n          </div>\n        </div>\n\n        <div class=\"step collapsed\">\n          <div class=\"step__head\"><span class=\"step__ic step__ic--k\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/></svg></span><span class=\"step__t\">"+stkE(stkT("stk.labs.bookmark.ui.preview","Preview"))+"</span><span class=\"step__chev\">&rsaquo;</span></div>\n          <div class=\"step__body\">\n          <div class=\"group\">\n            <label class=\"lbl-sub\">"+stkE(stkT("stk.labs.bookmark.ui.view","View"))+"</label>\n            <div class=\"seg\" id=\"cardViewSeg\">\n              <button data-v=\"front\" class=\"on\">"+stkE(stkT("stk.labs.bookmark.ui.folded","Folded"))+"</button>\n              <button data-v=\"full\">"+stkE(stkT("stk.labs.bookmark.ui.full_length","Full length"))+"</button>\n            </div>\n            <div class=\"seg\" id=\"cardSideSeg\" style=\"margin-top:7px\">\n              <button data-v=\"front\" class=\"on\">"+stkE(stkT("stk.labs.bookmark.on_card.front","Front side"))+"</button>\n              <button data-v=\"back\">"+stkE(stkT("stk.labs.bookmark.on_card.back","Back side"))+"</button>\n            </div>\n          </div>\n          <div class=\"row\">\n            <span class=\"lbl\">"+stkE(stkT("stk.labs.bookmark.ui.show_magnet_guide","Show magnet guide"))+"</span>\n            <div class=\"toggle\" id=\"magnetToggle\"></div>\n          </div>\n          <div class=\"magnet-status\" id=\"magnetStatus\" style=\"margin-top:11px;margin-bottom:0\"></div>\n          </div>\n        </div>\n      </div>\n\n      </div>\n    </div>\n  </div>\n\n  <div class=\"dlcard\">\n    <div class=\"dl-group dl-group--order\">\n      <div class=\"dl-group__head\"><span class=\"dl-badge dl-badge--go\">"+stkE(stkT("stk.labs.bookmark.downloads.order_tag","FOR YOUR ORDER"))+"</span><span class=\"dl-group__t\">"+stkE(stkT("stk.labs.bookmark.downloads.order_sub","This is the file to upload when you order"))+"</span></div>\n      <button class=\"dl dl--zip\" id=\"dlZip\" disabled><span class=\"dl__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M4 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4l2 2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2Z\"/><path d=\"M14 10v1\"/><path d=\"M14 13v1\"/><path d=\"M14 16v1\"/></svg></span><span class=\"dl__tx\">"+stkE(stkT("stk.labs.bookmark.downloads.zip","Download order files (ZIP)"))+"<small>"+stkE(stkT("stk.labs.bookmark.downloads.zip_sub","Print PNGs + cut SVGs at your exact size \u00b7 upload this one file with your order"))+"</small></span></button>\n      <div class=\"dlrow dlrow--sub\">\n        <button class=\"dl dl--svg\" id=\"dlCut\" disabled><span class=\"dl__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6\" cy=\"6\" r=\"3\"/><circle cx=\"6\" cy=\"18\" r=\"3\"/><path d=\"M20 4 8.12 15.88\"/><path d=\"M14.47 14.48 20 20\"/><path d=\"M8.12 8.12 12 12\"/></svg></span><span class=\"dl__tx\">"+stkE(stkT("stk.labs.bookmark.downloads.bm_cut","Bookmark cut file SVG"))+"<small>"+stkE(stkT("stk.labs.bookmark.downloads.bm_cut_sub","Already in the ZIP \u00b7 cut path, fold + 1.5mm bleed"))+"</small></span></button>\n        <button class=\"dl dl--svg\" id=\"dlCardCut\" disabled><span class=\"dl__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"6\" cy=\"6\" r=\"3\"/><circle cx=\"6\" cy=\"18\" r=\"3\"/><path d=\"M20 4 8.12 15.88\"/><path d=\"M14.47 14.48 20 20\"/><path d=\"M8.12 8.12 12 12\"/></svg></span><span class=\"dl__tx\">"+stkE(stkT("stk.labs.bookmark.downloads.card_cut","Card cut file SVG"))+"<small>"+stkE(stkT("stk.labs.bookmark.downloads.card_cut_sub","Already in the ZIP \u00b7 card cut path + 1.5mm bleed"))+"</small></span></button>\n      </div>\n      <div class=\"dlrow dlrow--sub\" style=\"margin-bottom:0\">\n        <button class=\"dl dl--png\" id=\"dlPrint\" disabled><span class=\"dl__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"3\"/><circle cx=\"9\" cy=\"9\" r=\"2\"/><path d=\"m21 15-5-5L5 21\"/></svg></span><span class=\"dl__tx\">"+stkE(stkT("stk.labs.bookmark.downloads.bm_print","Bookmark print PNG \u00b7 300 DPI"))+"<small>"+stkE(stkT("stk.labs.bookmark.downloads.bm_print_sub","Already in the ZIP \u00b7 flattened artwork"))+"</small></span></button>\n        <button class=\"dl dl--png\" id=\"dlCardPrint\" disabled><span class=\"dl__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"3\"/><circle cx=\"9\" cy=\"9\" r=\"2\"/><path d=\"m21 15-5-5L5 21\"/></svg></span><span class=\"dl__tx\">"+stkE(stkT("stk.labs.bookmark.downloads.card_print","Card print PNG \u00b7 300 DPI"))+"<small>"+stkE(stkT("stk.labs.bookmark.downloads.card_print_sub","Already in the ZIP \u00b7 card artwork"))+"</small></span></button>\n      </div>\n    </div>\n    <div class=\"dl-group dl-group--preview\">\n      <div class=\"dl-group__head\"><span class=\"dl-badge dl-badge--stop\">"+stkE(stkT("stk.labs.bookmark.downloads.preview_tag","PREVIEW ONLY"))+"</span><span class=\"dl-group__t\">"+stkE(stkT("stk.labs.bookmark.downloads.preview_sub","Just for checking your design - please don't upload this with your order"))+"</span></div>\n      <button class=\"dl dl--proof\" id=\"dlCardProof\" disabled><span class=\"dl__ic\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/></svg></span><span class=\"dl__tx\">"+stkE(stkT("stk.labs.bookmark.downloads.preview_png","Preview PNG"))+"<small>"+stkE(stkT("stk.labs.bookmark.downloads.preview_png_sub","Your bookmark shown on its backing card \u00b7 not a print file"))+"</small></span></button>\n    </div>\n    <div class=\"dlcard__foot\">\n      <button class=\"ghost\" id=\"resetBtn\">"+stkE(stkT("stk.labs.bookmark.downloads.clear_all","Clear all"))+"</button>\n    </div>\n    <div id=\"note\"></div>\n  </div>\n  <button class=\"floatprev__re\" id=\"floatReopen\" title=\""+stkE(stkT("stk.labs.bookmark.float.show","Show live preview"))+"\"><svg viewBox=\"0 0 24 24\" width=\"20\" height=\"20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/></svg></button>\n  <div class=\"floatprev\" id=\"floatPrev\">\n    <canvas id=\"floatCanvas\"></canvas>\n    <button class=\"floatprev__close\" id=\"floatClose\" title=\""+stkE(stkT("stk.labs.bookmark.float.hide","Hide preview"))+"\">&times;</button>\n  </div>\n</div>";

function bmInit(root){

/* ---------- constants ---------- */
const PRINT_DPI = 300;         // floor: never export below this
/* Export at whatever resolution the artwork actually carries, not a fixed 300.
   A vector upload rasterises far above 300dpi at bookmark size and the old cap
   resampled it down until line art printed blocky. Thomas, 26 Aug 2026. */
const EXPORT_DPI_MAX = 900, EXPORT_PX_MAX = 120e6;
function bmExportDpi(wPx, hPx, mmpp){
  const src = mmpp>0 ? 25.4/mmpp : PRINT_DPI;
  let dpi = Math.max(PRINT_DPI, Math.min(EXPORT_DPI_MAX, src));
  const px = (wPx*mmpp/25.4*dpi) * (hPx*mmpp/25.4*dpi);
  if(px > EXPORT_PX_MAX) dpi *= Math.sqrt(EXPORT_PX_MAX/px);
  return dpi;
}
const BLEED_MM = 1.5;
const CUT_COLOUR = "#FF00FF";              // 100% magenta cut
const FOLD_COLOUR_DEFAULT = "#B8B8C0";     // light grey score line; user-colourable
const CUT_PT = 1, PT_TO_MM = 25.4/72;
const CUT_STROKE_MM = (CUT_PT*PT_TO_MM).toFixed(4);
const FOLD_PT = 2;                                    // fold line weight
const FOLD_STROKE_MM = (FOLD_PT*PT_TO_MM).toFixed(4); // 2pt solid fold line
const MIN_CORNER_MM = 3;                   // bookmark corners are softer than stickers
const VEC_TARGET = 2000;
const WORK = (window.matchMedia&&matchMedia("(max-width:760px)").matches)?1500:2000;

/* unfolded bookmark envelope (max artwork box) per card orientation, in mm.
   The whole folded piece = topHalf + bridge + bottomHalf must fit this height. */
const TEMPLATES = {
  portrait:  { w:55, h:150, cardW:67, cardH:87 },
  landscape: { w:65, h:130, cardW:87, cardH:67 }
};
/* magnet: a 20mm round magnet sits on each half; folded, the two must meet.
   The artwork must cover the magnet (20mm) plus 5mm clearance all the way
   around it, so a 30mm-diameter safe zone of artwork at the magnet position.
   If the bookmark is scaled narrower than 30mm, the magnet can't be placed
   with proper coverage and the checker warns. */
const MAGNET_DIA_MM = 20;
const MAGNET_CLEARANCE_MM = 5;                          // ring around the magnet
const MAGNET_SAFE_MM = MAGNET_DIA_MM + 2*MAGNET_CLEARANCE_MM;   // 30mm safe diameter
const CARD_CORNER_MM = 6.5;
/* The magnet must sit at least this far below the fold. Folded, a magnet any
   closer is fighting the bend instead of lying flat, which is what makes a
   short bridge fold badly. Thomas, 25 Aug 2026. */
const MAGNET_FOLD_CLEAR_MM = 6;
// how far proud of the card's top edge the folded bookmark actually rides.
// 1.5mm sat too high against the real thing; halved on Thomas's eye, 25 Aug 2026.
const FOLD_RISE_MM = 0.75;

const opts = {
  bmView:"full",   // "full" = flat, as printed. "folded" = as it ends up in the hand.
  orient:"portrait", flip:"rotate", sizeWmm:null, bridgeMm:10, bridgeWmm:20, smoothMm:1, finished:false, cornerMm:3.175 /* = BM_CORNER_MIN_MM, written out because that const is declared further down and would hoist as undefined here, which fell back to 6.5 */, bridgeOn:true,
  // null = measured optical centre. A number 0..1 = the customer moved the
  // Artwork Centre slider and theirs wins from then until they reset it.
  artCentre:null,
  previewFlip:false,
  /* AUTO, not solid white. Thomas set this rule for Proof Lab on 8 Sep -
     "auto is default, customers can change it" - and it was never carried
     across, so the Bookmark Creator kept bleeding white behind artwork that
     has its own colour to the edge (9 Sep). Auto grows the bleed from the
     artwork's own edges, which is what that navy bookmark wanted.
     SUPERSEDED 30 Sep 2026 (Thomas, on an empty bridge: "it is on auto but
     shouldnt be"): the bookmark starts on SOLID. Auto grows the edges only a few
     mm, so the bridge between the halves stayed unprinted. Auto is still offered
     when there is no bridge (bmHasBridge). */
  bg:"#ffffff", bgMode:"solid", bgFrom:"#ffc63c", bgTo:"#f15a24", bgAngle:135,
  border:true, borderMm:2.5,
  fold:true, foldColour:FOLD_COLOUR_DEFAULT, cut:true, rulers:false,
  removeWhite:false, removeTol:25, removeKey:"#ffffff", removeInner:false,
  view:"bookmark",
  cardBg:"#ffffff", cardBgMode:"auto", showOnCard:true, cardView:"front", cardSide:"front",
  cardWidthMm:null,        // bookmark width on the card (null = full/true width)
  cardPreset:"grid",       // "grid" (default unbranded card) | "upload"
  showMagnet:false,        // magnet guide off by default (opt-in)
  magnetOffX:0, magnetOffY:null,   // magnet centre offset from default (mm); null Y = auto
  cardBmOffXmm:0,   // slide the bookmark across the card to check the fit (card mm)
  cardDesign:{ bg:{type:"solid", colour:"#ffffff", from:"#5f4c9f", to:"#4b8dc8", angle:135}, grid:{on:false, spacingMm:7, thicknessMm:0.2, colour:"#c8c8d0", insetMm:0, topMm:0, bottomMm:0}, layers:[] },
  selLayer:null            // id of selected design layer
};

/* per-artwork processed record: {art, mask0, palette, srcW, isVector} */
let main=null, top=null, card=null;
let activeTarget="main";          // which slot a drop/processSource feeds
/* Clean-up eraser state. Strokes are held per slot in `raw` coordinates and
   replayed in finishIngest, so changing the removal key or tolerance after
   erasing does not resurrect what was erased. AI/LAB-RULES.md rule 3. */
let erasing=false, curErase=null, lastTrimOff={x:0,y:0}, lastGeo=null;
/* Size boxes display in cm or inches; the stored width is always mm. Switching
   units rewrites the boxes, never the bookmark. */
let bmUnit="cm";
const BM_UNIT_PER_MM={cm:0.1, in:1/25.4};
const bmFromMm=mm=>mm*BM_UNIT_PER_MM[bmUnit];
const bmToMm=v=>v/BM_UNIT_PER_MM[bmUnit];
const bmDp=()=>bmUnit==="in"?2:1;
let palette=[], paletteLight=[];
let baseScene=null, cutPath=null, foldPath=null, sceneMm=null;
let bmCutSegs=null;   // exact outline segments when the artwork is rectangular
let bmCornerCapMm=0, bmCornerUsedMm=0;   // what the geometry allowed, for the slider
let cardScene=null, animRaf=0;
let zoom=1, panX=0, panY=0, fitted=false;

const BASICS = ["#ffffff","#1a1a20"];

/* Stickiply's own unbranded grid backing cards, offered when a customer
   doesn't upload their own. Hosted on the Shopify CDN. */
const DEFAULT_CARDS = {
  portrait:  "https://cdn.shopify.com/s/files/1/0809/5219/7414/files/Magnetic_Bookmark_Backing_Card_Unbranded_New.png?v=1781919108",
  landscape: "https://cdn.shopify.com/s/files/1/0809/5219/7414/files/Magnetic_Bookmark_Backing_Card_Landscape_Unbranded_New.png?v=1781919108"
};
let defaultCardImg={ portrait:null, landscape:null };   // cached loaded images

const $ = id => root.getElementById(id);
const mk = (w,h) => { const c=document.createElement("canvas"); c.width=Math.max(1,Math.round(w)); c.height=Math.max(1,Math.round(h)); return c; };

/* ---------- load & rasterise (shared with sticker lab) ---------- */
function baseName(raw){
  let n=(raw||"").replace(/\.[^.]+$/,"");
  n=n.replace(/[^\w\- ]+/g,"").trim().replace(/\s+/g,"-");
  n=n.replace(/-+/g,"-").slice(0,60);
  return n || "stickiply-bookmark";
}
let outBase="stickiply-bookmark";
function loadFile(file, target){
  if(!file) return;
  activeTarget=target||"main";
  if(activeTarget==="main") outBase=baseName(file.name);
  const name=(file.name||"").toLowerCase();
  const type=file.type||"";
  if(type==="application/pdf" || name.endsWith(".pdf")){ loadPdf(file); return; }
  if(type==="image/svg+xml" || name.endsWith(".svg")){ loadSvg(file); return; }
  if(/^image\//.test(type)){ loadRaster(file); return; }
  showError(stkT("stk.labs.bookmark.error.unsupported_type","That file type is not supported. Use PNG, JPEG, WEBP, SVG or PDF."));
}
/* THE PAGE IS NOT THE ARTWORK (Thomas, 22 Oct 2026, order 9955; the sticker Studio's plArtBounds, word for word).
   ingest() scales the WHOLE upload to WORK px on its longest edge and only then trims the empty border, so a small design
   on an A4 page keeps a fraction of its pixels and the export upsamples it. The artwork's own bounds are found first:
   a high-quality probe (<= 1024 px) gives a first box, then EVERY source pixel outside it is read in row strips and any
   ink there widens the box, so nothing can be cut away (LAB-RULES rules 3 and 5). "Ink" is any alpha, or with a
   reference colour (a PDF's white page) any pixel that differs from it. null = the artwork fills the page; leave it. */
const ART_PAGE_SHARE = 0.92;
function plArtBounds(src, w, h, ref){
  if(!(w>0 && h>0)) return null;
  const tol = ref ? (ref.tol||1) : 0;
  const on = ref
    ? (d,i)=> d[i+3]>10 && (Math.abs(d[i]-ref.rgb[0])>tol || Math.abs(d[i+1]-ref.rgb[1])>tol || Math.abs(d[i+2]-ref.rgb[2])>tol)
    : (d,i)=> d[i+3]>10;
  const P=1024, s=Math.min(1, P/Math.max(w,h)), pw=Math.max(1,Math.round(w*s)), ph=Math.max(1,Math.round(h*s));
  let x0=w, y0=h, x1=-1, y1=-1;
  const c=mk(pw,ph), x=c.getContext("2d",{willReadFrequently:true});
  try{
    x.imageSmoothingEnabled=true; x.imageSmoothingQuality="high";
    x.drawImage(src,0,0,pw,ph);
    const d=x.getImageData(0,0,pw,ph).data;
    for(let yy=0;yy<ph;yy++) for(let xx=0;xx<pw;xx++){
      if(!on(d,(yy*pw+xx)*4)) continue;
      if(xx<x0) x0=xx; if(xx>x1) x1=xx; if(yy<y0) y0=yy; if(yy>y1) y1=yy;
    }
  }catch(e){ c.width=0; c.height=0; return null; }
  c.width=0; c.height=0;
  if(x1<0) return null;
  const LIMIT=ART_PAGE_SHARE*Math.max(w,h);
  let X0=Math.max(0,Math.floor(x0/s)-1), Y0=Math.max(0,Math.floor(y0/s)-1);
  let X1=Math.min(w,Math.ceil((x1+1)/s)+1), Y1=Math.min(h,Math.ceil((y1+1)/s)+1);
  if(Math.max(X1-X0, Y1-Y0) > LIMIT) return null;
  try{
    const ROWS=256, sc=mk(1,1), sx=sc.getContext("2d",{willReadFrequently:true});
    const scan=(rx,ry,rw,rh)=>{
      for(let yy=ry; yy<ry+rh; yy+=ROWS){
        const hh=Math.min(ROWS, ry+rh-yy); if(rw<=0||hh<=0) continue;
        sc.width=rw; sc.height=hh; sx.imageSmoothingEnabled=false;   /* a resize clears the context's state */
        sx.drawImage(src, rx,yy,rw,hh, 0,0,rw,hh);
        const d=sx.getImageData(0,0,rw,hh).data;
        for(let j=0;j<hh;j++) for(let i=0;i<rw;i++){
          if(!on(d,(j*rw+i)*4)) continue;
          const ax=rx+i, ay=yy+j;
          if(ax<X0) X0=ax; if(ax+1>X1) X1=ax+1; if(ay<Y0) Y0=ay; if(ay+1>Y1) Y1=ay+1;
        }
        if(Math.max(X1-X0, Y1-Y0) > LIMIT) throw 0;   /* too big to crop: stop reading */
      }
    };
    const bx0=X0, by0=Y0, bx1=X1, by1=Y1;
    scan(0,0,w,by0); scan(0,by1,w,h-by1); scan(0,by0,bx0,by1-by0); scan(bx1,by0,w-bx1,by1-by0);
    sc.width=0; sc.height=0;
  }catch(e){ return null; }
  const pad=10;
  X0=Math.max(0,X0-pad); Y0=Math.max(0,Y0-pad); X1=Math.min(w,X1+pad); Y1=Math.min(h,Y1+pad);
  if(Math.max(X1-X0, Y1-Y0) > LIMIT) return null;
  return {x:X0, y:Y0, w:X1-X0, h:Y1-Y0};
}
function plPaperPage(w,h){
  const P=[[297,420],[210,297],[148,210],[215.9,279.4],[215.9,355.6]].map(p=>p.map(v=>v/25.4*72));
  const near=(a,b)=>Math.abs(a-b)<=0.04*b;   /* 4%: a page with 3 mm bleed still counts */
  return P.some(([pw,ph])=>(near(w,pw)&&near(h,ph))||(near(w,ph)&&near(h,pw)));
}
function loadRaster(file){
  const url=URL.createObjectURL(file);
  const img=new Image();
  img.onload=()=>{ URL.revokeObjectURL(url);
    $("spin").classList.add("show");
    setTimeout(()=>{   /* behind the spinner: a big page is read in full */
      try{
        /* the page is not the artwork; never for the card slot, where the file IS the card and its margins are the customer's placement */
        const W0=img.naturalWidth||0, H0=img.naturalHeight||0, crop=activeTarget==="card" ? null : plArtBounds(img,W0,H0,null);
        if(!crop){ ingest(img,false); return; }
        const s=Math.min(1,3200/Math.max(crop.w,crop.h)), c=mk(Math.round(crop.w*s),Math.round(crop.h*s)), x=c.getContext("2d");   /* capped like the sticker Studio's source: a phone's canvas limit */
        x.imageSmoothingQuality="high"; x.drawImage(img,crop.x,crop.y,crop.w,crop.h,0,0,c.width,c.height);
        const im=new Image(); im.onload=()=>{ c.width=0; c.height=0; ingest(im,false); }; im.onerror=()=>{ ingest(img,false); }; im.src=c.toDataURL("image/png");
      }catch(e){ ingest(img,false); }
    },0); };
  img.onerror=()=>{ URL.revokeObjectURL(url); showError(stkT("stk.labs.bookmark.error.image_unreadable","That image could not be read.")); };
  img.src=url;
}
/* A VECTOR FILE'S BACKGROUND LAYER (21 Oct 2026, Thomas: a design traced in SVG Lab came back with a white halo once flattened): an
   SVG whose first shapes include one covering the artboard (a background layer) is drawn without it OUTSIDE the artwork - the
   background colour is drawn again only inside the outer outline of the other shapes, under them - so the outer edge antialiases
   against the clear outside (no halo) while white seen through the design's holes stays white. The sticker Studio's code
   (lab-cart/drawer-2026-10-21/src/pl_svgcols.js), here without its colour row. */
function bmsvgRgb(h){ const m=/^#?([0-9a-f]{6})$/i.exec(h||""); if(!m) return [0,0,0]; const n=parseInt(m[1],16); return [(n>>16)&255,(n>>8)&255,n&255]; }
const BMSVG_NS="http://www.w3.org/2000/svg", BMSVG_SHAPES="path,rect,circle,ellipse,polygon,polyline,line,text";
const BMSVG_NAMED={ white:"#ffffff", black:"#000000", red:"#ff0000", green:"#008000", blue:"#0000ff", yellow:"#ffff00", gray:"#808080", grey:"#808080", orange:"#ffa500", purple:"#800080", pink:"#ffc0cb" };
function bmsvgHex(v){
  if(v==null) return null; v=String(v).trim().toLowerCase();
  if(!v || v==="none" || v==="transparent" || v.startsWith("url(")) return null;
  if(BMSVG_NAMED[v]) return BMSVG_NAMED[v];
  let m=/^#([0-9a-f]{3})$/.exec(v); if(m) return "#"+m[1].split("").map(c=>c+c).join("");
  m=/^#([0-9a-f]{6})/.exec(v); if(m) return "#"+m[1];
  m=/^rgba?\(\s*([\d.]+)%?\s*,\s*([\d.]+)%?\s*,\s*([\d.]+)%?/.exec(v); if(m) return "#"+[m[1],m[2],m[3]].map(n=>Math.max(0,Math.min(255,Math.round(+n)))).map(n=>n.toString(16).padStart(2,"0")).join("");
  return null;
}
function bmsvgRules(doc){
  const out={};
  doc.querySelectorAll("style").forEach(st=>{ const t=st.textContent||""; let m; const re=/([^{}]+)\{([^}]*)\}/g;
    while((m=re.exec(t))){ const decl={}; m[2].split(";").forEach(kv=>{ const i=kv.indexOf(":"); if(i<0) return; decl[kv.slice(0,i).trim().toLowerCase()]=kv.slice(i+1).trim(); });
      m[1].split(",").forEach(sel=>{ const s=sel.trim(); const c=/^\.([\w-]+)$/.exec(s); if(c) out["."+c[1]]=Object.assign(out["."+c[1]]||{}, decl); else if(/^[a-z]+$/i.test(s)) out[s.toLowerCase()]=Object.assign(out[s.toLowerCase()]||{}, decl); }); } });
  return out;
}
function bmsvgPaint(el, prop, rules){
  for(let e=el; e && e.nodeType===1; e=e.parentNode){
    const st=e.getAttribute && e.getAttribute("style");
    if(st){ const m=new RegExp("(?:^|;)\\s*"+prop+"\\s*:\\s*([^;]+)","i").exec(st); if(m) return m[1].trim(); }
    const cls=(e.getAttribute && e.getAttribute("class")||"").split(/\s+/).filter(Boolean);
    for(let i=cls.length-1;i>=0;i--){ const r=rules["."+cls[i]]; if(r && r[prop]!=null) return r[prop]; }
    const a=e.getAttribute && e.getAttribute(prop); if(a!=null && a!=="inherit") return a;
    const tr=rules[(e.nodeName||"").toLowerCase()]; if(tr && tr[prop]!=null) return tr[prop];
  }
  return prop==="fill" ? "#000000" : null;
}
function bmsvgShapes(root){ return [...root.querySelectorAll(BMSVG_SHAPES)].filter(el=>!el.closest("defs,clipPath,mask,pattern,symbol,marker")); }
function bmsvgViewBox(root){
  const vb=(root.getAttribute("viewBox")||"").trim().split(/[\s,]+/).map(Number);
  if(vb.length===4 && vb.every(isFinite) && vb[2]>0 && vb[3]>0) return vb;
  const w=parseFloat(root.getAttribute("width")), h=parseFloat(root.getAttribute("height"));
  return (w>0 && h>0) ? [0,0,w,h] : null;
}
function bmsvgTransformed(el, root){ for(let e=el; e && e!==root; e=e.parentNode){ if(e.getAttribute && e.getAttribute("transform")) return true; } return false; }
/* the artboard-covering shape: a rect, or a path of straight segments only, whose box is at least 98% of the viewBox */
function bmsvgIsBackground(el, vb, root){
  if(!vb || bmsvgTransformed(el, root)) return false;
  const tag=el.nodeName.toLowerCase(); let x0,y0,x1,y1;
  if(tag==="rect"){ const g=k=>parseFloat(el.getAttribute(k)||"0"); x0=g("x"); y0=g("y"); x1=x0+g("width"); y1=y0+g("height"); }
  else if(tag==="path"){ const d=el.getAttribute("d")||""; if(/[a-zCcSsQqTtAa]/.test(d.replace(/[eE][-+]?\d/g,""))) return false;   /* absolute straight segments only */
    const n=(d.match(/-?\d*\.?\d+(?:e[-+]?\d+)?/gi)||[]).map(Number); if(n.length<6 || n.length>40) return false;
    const xs=n.filter((_,i)=>i%2===0), ys=n.filter((_,i)=>i%2===1); x0=Math.min(...xs); x1=Math.max(...xs); y0=Math.min(...ys); y1=Math.max(...ys); }
  else return false;
  const ix=Math.max(0, Math.min(x1, vb[0]+vb[2])-Math.max(x0, vb[0])), iy=Math.max(0, Math.min(y1, vb[1]+vb[3])-Math.max(y0, vb[1]));
  return ix*iy >= 0.98*vb[2]*vb[3];
}
function bmsvgAnalyse(txt){
  let doc; try{ doc=new DOMParser().parseFromString(txt,"image/svg+xml"); }catch(e){ return null; }
  const root=doc && doc.documentElement; if(!root || root.nodeName.toLowerCase()!=="svg" || doc.getElementsByTagName("parsererror").length) return null;
  const rules=bmsvgRules(doc), vb=bmsvgViewBox(root), shapes=bmsvgShapes(root); if(!shapes.length) return null;
  const cols=[]; const add=hex=>{ if(!hex) return null; for(const c of cols){ const a=bmsvgRgb(c.hex), b=bmsvgRgb(hex); if(Math.abs(a[0]-b[0])+Math.abs(a[1]-b[1])+Math.abs(a[2]-b[2])<=12) return c.hex; } cols.push({hex, area:0}); return hex; };
  let bgIdx=-1, bgHex=null;
  shapes.forEach((el,i)=>{ const f=add(bmsvgHex(bmsvgPaint(el,"fill",rules))); add(bmsvgHex(bmsvgPaint(el,"stroke",rules)));
    if(bgIdx<0 && f && bmsvgIsBackground(el, vb, root)){ bgIdx=i; bgHex=f; } });
  if(!cols.length) return null;
  return { vb, cols, bgIdx, bgHex, group:hex=>{ if(!hex) return null; for(const c of cols){ const a=bmsvgRgb(c.hex), b=bmsvgRgb(hex); if(Math.abs(a[0]-b[0])+Math.abs(a[1]-b[1])+Math.abs(a[2]-b[2])<=12) return c.hex; } return hex; } };
}
/* the outer outline of a path: its subpaths that lie inside no other of its subpaths (absolute commands only; else the whole path) */
function bmsvgOuterD(d){
  if(/[a-z]/.test(d.replace(/[eE][-+]?\d/g,""))) return d;
  const subs=d.split(/(?=M)/).map(s=>s.trim()).filter(Boolean); if(subs.length<2) return d;
  const cx=mk(1,1).getContext("2d"), P=subs.map(s=>{ try{ return new Path2D(s); }catch(e){ return null; } });
  const keep=subs.filter((s,i)=>{ const m=/^M\s*(-?[\d.eE+-]+)[\s,]+(-?[\d.eE+-]+)/.exec(s); if(!m) return true; const x=+m[1], y=+m[2];
    for(let j=0;j<subs.length;j++){ if(j!==i && P[j] && cx.isPointInPath(P[j], x, y, "nonzero")) return false; } return true; });
  return keep.join(" ");
}
function bmsvgTransformChain(el, root){ const t=[]; for(let e=el.parentNode; e && e!==root; e=e.parentNode){ const a=e.getAttribute && e.getAttribute("transform"); if(a) t.unshift(a); } return t.join(" "); }
/* the file as it is drawn with colours off: off = hexes not drawn; inside = hexes cleared inside the artwork too */
function bmsvgRenderText(txt, off, inside){
  const doc=new DOMParser().parseFromString(txt,"image/svg+xml"), root=doc.documentElement, info=bmsvgAnalyse(txt);
  if(!info) return txt;
  const rules=bmsvgRules(doc), shapes=bmsvgShapes(root), grp=info.group, OFF=new Set((off||[]).map(grp)), IN=new Set((inside||[]).map(grp));
  const bgEl=info.bgIdx>=0 ? shapes[info.bgIdx] : null, bgHex=info.bgHex;
  const kept=[];
  shapes.forEach(el=>{
    const f=grp(bmsvgHex(bmsvgPaint(el,"fill",rules))), s=grp(bmsvgHex(bmsvgPaint(el,"stroke",rules)));
    const st=el.getAttribute("style")||"";
    /* the background colour removed from OUTSIDE only: other shapes in that colour are inside the design and stay */
    const fOff = f && OFF.has(f) && !(f===bgHex && el!==bgEl && !IN.has(bgHex));
    if(fOff) el.setAttribute("style", st+";fill:none");
    if(s && OFF.has(s)) el.setAttribute("style", (el.getAttribute("style")||"")+";stroke:none");
    if(el!==bgEl && f && !fOff) kept.push(el);
  });
  if(bgEl && OFF.has(bgHex) && !IN.has(bgHex) && kept.length){
    const g=doc.createElementNS(BMSVG_NS,"g"); g.setAttribute("id","stk-inner-fill");
    kept.forEach(el=>{
      const c=el.cloneNode(false); c.removeAttribute("class"); c.removeAttribute("id"); c.removeAttribute("style"); c.removeAttribute("stroke");
      if(c.nodeName.toLowerCase()==="path") c.setAttribute("d", bmsvgOuterD(el.getAttribute("d")||""));
      c.setAttribute("fill", bgHex); c.setAttribute("fill-rule","nonzero"); c.setAttribute("stroke","none");
      const chain=bmsvgTransformChain(el, root); if(chain){ const w=doc.createElementNS(BMSVG_NS,"g"); w.setAttribute("transform", chain); w.appendChild(c); g.appendChild(w); } else g.appendChild(c);
    });
    let top=bgEl; while(top.parentNode && top.parentNode!==root) top=top.parentNode;
    root.insertBefore(g, top.nextSibling);
  }
  return new XMLSerializer().serializeToString(doc);
}
function loadSvg(file){
  $("spin").classList.add("show");
  const reader=new FileReader();
  reader.onload=()=>{
    let txt=reader.result;
    if(!/xmlns=/.test(txt)) txt=txt.replace(/<svg/i,'<svg xmlns="http://www.w3.org/2000/svg"');
    try{ const inf=bmsvgAnalyse(txt); if(inf && inf.bgHex) txt=bmsvgRenderText(txt, [inf.bgHex], []); }catch(e){}   /* the background layer leaves the outside (21 Oct 2026) */
    const blob=new Blob([txt],{type:"image/svg+xml"});
    const url=URL.createObjectURL(blob);
    const img=new Image();
    img.onload=()=>{
      URL.revokeObjectURL(url);
      let w=img.naturalWidth||img.width||0, h=img.naturalHeight||img.height||0;
      if(!w||!h){ w=VEC_TARGET; h=VEC_TARGET; }
      const s=VEC_TARGET/Math.max(w,h);
      const c=mk(w*s,h*s);
      c.getContext("2d").drawImage(img,0,0,c.width,c.height);
      const svgRoot=(/<svg\b[^>]*>/i.exec(txt)||[""])[0], vbm=/\sviewBox\s*=\s*["']([^"']*)["']/.exec(svgRoot), vbv=vbm ? vbm[1].trim().split(/[\s,]+/).map(Number) : [];
      const NUM=(a)=>new RegExp("\\s"+a+"\\s*=\\s*[\"']\\s*(?:\\d+(?:\\.\\d+)?|\\.\\d+)(?:px|pt|pc|mm|cm|in)?\\s*[\"']").test(svgRoot);   /* no space before the unit: "100 mm" is invalid, so no size */
      const svgSized=((vbv.length===4 && vbv.every(isFinite) && vbv[2]>0 && vbv[3]>0) || (NUM("width") && NUM("height")))
        && !/\d(?:\.\d+)?(?:[sld]?v(?:w|h|i|b|min|max)|cq(?:w|h|i|b|min|max))\b/i.test(txt.replace(/<!--[\s\S]*?-->/g,"").replace(/<(i:pgf|metadata)\b(?:[^>]*\/>|[^>]*>[\s\S]*?<\/\1\s*>)/gi,"").replace(/\bdata:[^"')]*/gi,""));   /* a real viewBox, or a numeric width AND height; no viewport units (tested with data: URIs out). XML attributes are case-sensitive */   /* the ROOT tag has a viewBox or a numeric width: only then does the content scale with the redraw */
      const b=(activeTarget!=="card" && svgSized) ? plArtBounds(c,c.width,c.height,null) : null;   /* the page is not the artwork; never for the card slot (the file IS the card) */
      if(b){
        const k=VEC_TARGET/Math.max(b.w,b.h), c2=mk(Math.round(b.w*k),Math.round(b.h*k));
        c2.getContext("2d").drawImage(img,-b.x*k,-b.y*k,c.width*k,c.height*k);
        c.width=0; c.height=0; ingestCanvas(c2); return;
      }
      ingestCanvas(c);
    };
    img.onerror=()=>{ URL.revokeObjectURL(url); $("spin").classList.remove("show"); showError(stkT("stk.labs.bookmark.error.svg_render","That SVG could not be rendered. Flatten it to PNG and try again.")); };
    img.src=url;
  };
  reader.onerror=()=>{ $("spin").classList.remove("show"); showError(stkT("stk.labs.bookmark.error.svg_unreadable","That SVG could not be read.")); };
  reader.readAsText(file);
}
function loadPdf(file){
  $("spin").classList.add("show");
  loadPdfJs().then(function(pdfjsLib){
    const reader=new FileReader();
    reader.onload=function(){
      const data=new Uint8Array(reader.result);
      pdfjsLib.getDocument({data:data, isEvalSupported:false}).promise.then(function(pdf){ return pdf.getPage(1); })
      .then(function(page){
        const vp1=page.getViewport({scale:1});
        const scale=VEC_TARGET/Math.max(vp1.width,vp1.height);
        const vp=page.getViewport({scale:scale});
        const c=mk(vp.width,vp.height);
        const ctx=c.getContext("2d");
        ctx.fillStyle="#ffffff"; ctx.fillRect(0,0,c.width,c.height);
        return page.render({canvasContext:ctx,viewport:vp,intent:"print"}).promise.then(function(){ return {c:c, page:page, vp:vp, vp1:vp1}; });
      }).then(function(r){
        /* the page is not the artwork, when the page is a sheet of paper (pdf.js paints it white) */
        const c=r.c, b=(activeTarget!=="card" && plPaperPage(r.vp1.width,r.vp1.height)) ? plArtBounds(c,c.width,c.height,{rgb:[255,255,255],tol:1}) : null;   /* never for the card slot: the file IS the card, in any format */
        if(!b){ ingestCanvas(c); return; }
        const k=VEC_TARGET/Math.max(b.w,b.h), vp2=r.page.getViewport({scale:r.vp.scale*k, offsetX:-b.x*k, offsetY:-b.y*k});
        const c2=mk(Math.round(b.w*k),Math.round(b.h*k)), x2=c2.getContext("2d");
        x2.fillStyle="#ffffff"; x2.fillRect(0,0,c2.width,c2.height);
        return r.page.render({canvasContext:x2,viewport:vp2,intent:"print"}).promise.then(function(){ c.width=0; c.height=0; ingestCanvas(c2); }, function(){ ingestCanvas(c); });
      })
      .catch(function(err){ console.error(err); $("spin").classList.remove("show"); showError(stkT("stk.labs.bookmark.error.pdf_render","That PDF could not be rendered. Export it as PNG and try again.")); });
    };
    reader.onerror=function(){ $("spin").classList.remove("show"); showError(stkT("stk.labs.bookmark.error.pdf_unreadable","That PDF could not be read.")); };
    reader.readAsArrayBuffer(file);
  }).catch(function(err){ console.error(err); $("spin").classList.remove("show"); showError(stkT("stk.labs.bookmark.error.pdf_reader","The PDF reader could not load. Check your connection and try again.")); });
}
function ingestCanvas(c){
  const img=new Image();
  img.onload=()=>{ ingest(img,true); };
  img.onerror=()=>{ $("spin").classList.remove("show"); showError(stkT("stk.labs.bookmark.error.prepare_failed","Could not prepare that file.")); };
  img.src=c.toDataURL("image/png");
}
function showError(msg){ const n=$("note"); n.textContent=msg; n.classList.add("show"); }
/* Is there room for the magnet to sit its full clearance below the fold?
   Returns null when fine, or a sentence saying what is wrong. The magnet is
   clamped to the clearance while dragging, so the only way to fail is that the
   front half is too short to hold it at all. */
function magnetProblem(){
  if(!baseScene || !sceneMm || opts.finished) return null;
  const ppm=sceneMm.ppm;
  const frontHmm=(baseScene.height - sceneMm.foldYpx)/ppm;
  const needed=MAGNET_FOLD_CLEAR_MM + MAGNET_DIA_MM;
  if(frontHmm + 0.5 >= needed) return null;
  return stkF(stkT("stk.labs.bookmark.magnet.no_fit","Magnet does not fit: the front half is [front_mm]mm below the fold, and the magnet needs [needed_mm]mm ([clear_mm]mm clear of the fold plus the [magnet_mm]mm magnet). Any closer to the fold and it fights the bend instead of lying flat, which is what makes a bookmark fold badly. Change the bridge length or the bookmark size before ordering."),{front_mm:frontHmm.toFixed(1),needed_mm:needed,clear_mm:MAGNET_FOLD_CLEAR_MM,magnet_mm:MAGNET_DIA_MM});
}

/* ---------- ingest into a slot ---------- */
function ingest(img, isVector){
  $("spin").classList.add("show");
  setTimeout(()=>{
    const s=Math.min(1, WORK/Math.max(img.width,img.height));
    const raw=mk(img.width*s, img.height*s);
    const rcx=raw.getContext("2d");
    rcx.imageSmoothingQuality="high";
    rcx.drawImage(img,0,0,raw.width,raw.height);
    finishIngest(raw, img.width*s, isVector);
  },30);
}
/* ================= EXACT BOOKMARK OUTLINE =================
   A rectangular artwork should be cut as a rectangle, not traced round its
   pixels. Thomas, 8 Sep 2026: "it should be a proper box with 6.5mm curved
   corners, and then where the artwork connects to the bridge, curves from the
   square straight edge to the bridge straight edge. all 12 corners outer and
   inner should all be curved at the same rate with all side edges straight."

   So the folded outline is built as geometry: two rectangles joined by a
   bridge, 8 convex corners and 4 concave ones where the bridge meets each
   half, every corner the same radius, every edge dead straight. One
   description drives both the on-screen path and the cut file, so they cannot
   drift apart.

   Only used when the artwork really is rectangular - detectRect measures the
   fit and refuses anything organic, so a die-cut bookmark still traces. */
/* THE LAMINATE DECIDES THE MINIMUM. Thomas, 8 Sep 2026: "there must be a
   minimum because the material doesnt work like paper, the laminate will lift
   if a sharp edge is available." So the corner radius is a customer setting
   with a floor, never zero, and the geometry can only ever clamp it DOWN to
   what the bridge leaves room for - it can never take it below the floor. */
var BM_CORNER_MM = 6.5;          // the default
var BM_CORNER_MIN_MM = 3.175;    // 1/8 inch, the laminate floor. Thomas's own
                                 // manual file uses 9pt = 3.175mm and he set
                                 // this as the minimum on 8 Sep 2026.
var BM_CORNER_MAX_MM = 12;
/* corner radius, as a share of the short side, from which a design counts as ROUNDED (bmArtIsRect) */
var BM_ROUNDED_ART = 0.05;
/* the four concave curves where the halves meet the bridge. Thomas, 9 Oct 2026, on a shortest bridge where
   two 3.175mm curves left 0.6mm of straight between them: "the middle part here can be slightly tighter so
   its a straight line across the top of the bookmark going to a curve corner into the straight bridge".
   The outer corners keep their radius and the bridge keeps its length; only these four tighten. */
var BM_FILLET_MM = 2.0;
/* The shortest bridge that still leaves room for two floor-radius fillets on
   each side, given that the border grows the halves inward across the gap. */
function bridgeMinMm(){
  /* + 0.3mm: the border and the bridge are both rounded to whole pixels when the
     outline is built (2.5mm becomes 30px = 2.54mm at 300dpi), and that rounding
     alone left the gap 0.07mm short of two floor-radius fillets (17 Sep 2026). */
  return 2*BM_CORNER_MIN_MM + 2*Math.max(opts.borderMm||0,0) + 0.3;
}
function convexHull(pts){
  const p=pts.slice().sort((a,b)=>a[0]-b[0]||a[1]-b[1]);
  if(p.length<3) return p;
  const cr=(o,a,b)=>(a[0]-o[0])*(b[1]-o[1])-(a[1]-o[1])*(b[0]-o[0]);
  const lo=[],up=[];
  for(const q of p){ while(lo.length>=2&&cr(lo[lo.length-2],lo[lo.length-1],q)<=0) lo.pop(); lo.push(q); }
  for(let i=p.length-1;i>=0;i--){ const q=p[i]; while(up.length>=2&&cr(up[up.length-2],up[up.length-1],q)<=0) up.pop(); up.push(q); }
  lo.pop(); up.pop(); return lo.concat(up);
}
function polyAreaBm(p){ let a=0; for(let i=0;i<p.length;i++){ const b=p[(i+1)%p.length]; a+=p[i][0]*b[1]-b[0]*p[i][1]; } return Math.abs(a)/2; }
function minAreaRect(h){
  let best=null;
  for(let i=0;i<h.length;i++){
    const a=h[i], b=h[(i+1)%h.length];
    const ang=Math.atan2(b[1]-a[1], b[0]-a[0]);
    const c=Math.cos(-ang), s2=Math.sin(-ang);
    let x0=1e18,y0=1e18,x1=-1e18,y1=-1e18;
    for(const p of h){ const x=p[0]*c-p[1]*s2, y=p[0]*s2+p[1]*c;
      if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; }
    const w=x1-x0, ht=y1-y0, area=w*ht;
    if(!best||area<best.area){ const mx=(x0+x1)/2, my=(y0+y1)/2;
      best={area,ang,w,h:ht,cx:mx*c+my*s2,cy:-mx*s2+my*c}; }
  }
  return best;
}
function sdRoundBox(u,v,a,b,r){
  const qx=Math.abs(u)-(a-r), qy=Math.abs(v)-(b-r);
  return Math.hypot(Math.max(qx,0),Math.max(qy,0))+Math.min(Math.max(qx,qy),0)-r;
}
function detectRect(pts){
  if(pts.length<4) return null;
  const h=convexHull(pts); if(h.length<4) return null;
  const R=minAreaRect(h); if(!R||R.w<8||R.h<8) return null;
  if(polyAreaBm(pts)/R.area < 0.90) return null;      // a circle is 0.785
  const a=R.w/2, b=R.h/2, mn=Math.min(R.w,R.h);
  const c=Math.cos(-R.ang), s2=Math.sin(-R.ang);
  const loc=pts.map(p=>{ const dx=p[0]-R.cx, dy=p[1]-R.cy; return [dx*c-dy*s2, dx*s2+dy*c]; });
  let bestR=0,bestDev=Infinity;
  for(let i=0;i<=48;i++){
    const r=i/48*Math.min(a,b); let dev=0;
    for(let j=0;j<loc.length;j++){ const d=Math.abs(sdRoundBox(loc[j][0],loc[j][1],a,b,r));
      if(d>dev){ dev=d; if(dev>=bestDev) break; } }
    if(dev<bestDev){ bestDev=dev; bestR=r; }
  }
  if(bestDev > Math.max(2.5, 0.018*mn)) return null;
  return {cx:R.cx,cy:R.cy,w:R.w,h:R.h,ang:R.ang,r:bestR,dev:bestDev};
}
/* The artwork's own corner radius, in mask pixels. detectRect's fitted r is a
   best-fit under a max-deviation norm and reads a phone-style rounded corner
   far too small (IMG_2649, 17 Sep 2026: 0.078 of the width against a true
   0.19). This measures it the way a ruler would: how far in from the bounding
   box each edge starts, at a fixed depth d, solved for the circle that gives
   that inset - r = (x+d) + sqrt(2xd). Eight readings, the median wins. */
function bmMeasureCorner(mask){
  const W=mask.width,H=mask.height; let d;
  try{ d=mask.getContext("2d").getImageData(0,0,W,H).data; }catch(e){ return null; }
  const on=(x,y)=>x>=0&&y>=0&&x<W&&y<H&&d[(y*W+x)*4+3]>128;
  let x0=W,x1=-1,y0=H,y1=-1;
  for(let y=0;y<H;y++) for(let x=0;x<W;x++) if(d[(y*W+x)*4+3]>128){ if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; }
  if(x1<x0) return null;
  const bw=x1-x0+1, bh=y1-y0+1, side=Math.min(bw,bh);
  /* shallow depth on purpose: a phone-style "continuous" corner is flatter than
     a circle, so the deeper the reading the smaller the radius it implies
     (IMG_2649: 0.19 of the width at 2px, 0.08 at 4%). The eye reads the corner
     from where the edge starts to turn, so that is where it is measured. */
  const dep=Math.max(2, Math.round(side*0.004));
  const rs=[];
  const solve=x=> x<=0 ? 0 : (x+dep)+Math.sqrt(2*x*dep);
  const scan=(fx,fy,sx,sy)=>{ let k=0; while(k<side/2 && !on(fx+sx*k, fy+sy*k)) k++; return k; };
  // along the top and bottom edges, in from each side
  rs.push(solve(scan(x0,y0+dep, 1,0)), solve(scan(x1,y0+dep,-1,0)), solve(scan(x0,y1-dep, 1,0)), solve(scan(x1,y1-dep,-1,0)));
  // along the left and right edges, in from top and bottom
  rs.push(solve(scan(x0+dep,y0,0, 1)), solve(scan(x1-dep,y0,0, 1)), solve(scan(x0+dep,y1,0,-1)), solve(scan(x1-dep,y1,0,-1)));
  rs.sort((a,b)=>a-b);
  const rEdge=(rs[3]+rs[4])/2;
  /* ...and once more along each diagonal, where the corner is deepest: the gap
     from the box corner to the artwork is r(sqrt2-1). The two readings bracket
     a continuous corner; their mean sits where Thomas set it by eye (9.2mm on
     a 50mm bookmark, 0.184 of the width). */
  const dg=[scan(x0,y0,1,1),scan(x1,y0,-1,1),scan(x0,y1,1,-1),scan(x1,y1,-1,-1)].sort((a,b)=>a-b);
  const rDiag=((dg[1]+dg[2])/2)*Math.SQRT2/(Math.SQRT2-1);
  const r=(rEdge>0&&rDiag>0) ? (rEdge+rDiag)/2 : Math.max(rEdge,rDiag);
  return { r: Math.min(r, side/2), side };
}
/* ARTWORK THAT BRINGS ITS OWN WHITE BORDER (18 Oct 2026, the owner on the Bookmark Studio: "this design has a
   white border thats not being followed etc, its come up as square"). A rounded square that already carries a
   white edge was cut as a rectangle round the whole image, plus a second 2.5mm border. bmOwnEdge reads the
   artwork once per upload.
     alpha  - a shape on transparency whose outer band is near-white all round, at least BM_OWN_RING_MIN of
              its short side deep, with real artwork inside the band. Its alpha edge already IS the outer edge
              of that white, so the geometry stays; only the added border goes (0, the customer can add one).
     opaque - a file flattened on white. White running in from the canvas edge (near-white only) must reach
              all four corners, stay in the frame band and the corner pockets, and leave the artwork the same
              distance d from all four sides. The outer edge is then the artwork grown by d (a uniform ring:
              the design's own corner radius plus d); the white corners beyond it are cleared, so the file is
              cut like the same design on transparency. d under the minimum means only the corners are white
              (a rounded design on a white square): the design is its own edge and the border stays.
   Anything else - a full-bleed rectangle, a die-cut with no white band, white padding of unequal widths, white
   that runs into the design - returns null and is cut exactly as before. */
var BM_OWN_RING_MIN = 0.02;   // white band depth, as a share of the short side, from which it is the artwork's own border
var BM_OWN_RING_MAX = 0.15;   // deeper than this it is padding, not a border
/* exact squared distance from every pixel to the nearest pixel where inside[] is 0 (Felzenszwalb-Huttenlocher) */
function bmEdt(inside, W, H){
  const INF=1e20, N=W*H, D=new Float64Array(N);
  for(let i=0;i<N;i++) D[i]=inside[i]?INF:0;
  const n=Math.max(W,H), f=new Float64Array(n), o=new Float64Array(n), v=new Int32Array(n), z=new Float64Array(n+1);
  const pass=len=>{
    let k=0; v[0]=0; z[0]=-INF; z[1]=INF;
    for(let q=1;q<len;q++){
      let s=((f[q]+q*q)-(f[v[k]]+v[k]*v[k]))/(2*q-2*v[k]);
      while(s<=z[k]){ k--; s=((f[q]+q*q)-(f[v[k]]+v[k]*v[k]))/(2*q-2*v[k]); }
      k++; v[k]=q; z[k]=s; z[k+1]=INF;
    }
    k=0;
    for(let q=0;q<len;q++){ while(z[k+1]<q) k++; o[q]=(q-v[k])*(q-v[k])+f[v[k]]; }
  };
  for(let x=0;x<W;x++){ for(let y=0;y<H;y++) f[y]=D[y*W+x]; pass(H); for(let y=0;y<H;y++) D[y*W+x]=o[y]; }
  for(let y=0;y<H;y++){ for(let x=0;x<W;x++) f[x]=D[y*W+x]; pass(W); for(let x=0;x<W;x++) D[y*W+x]=o[x]; }
  return D;
}
function bmOwnEdge(art){
  const W=art.width, H=art.height, N=W*H;
  if(W<16 || H<16) return null;
  const px=art.getContext("2d").getImageData(0,0,W,H).data;
  const ink=new Uint8Array(N);
  let x0=W,x1=-1,y0=H,y1=-1;
  for(let i=0;i<N;i++) if(px[i*4+3]>=128){ ink[i]=1; const x=i%W, y=(i/W)|0; if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; }
  if(x1<x0) return null;
  const bw=x1-x0+1, bh=y1-y0+1, side=Math.min(bw,bh);
  const white=i=>{ const r=px[i*4],g=px[i*4+1],b=px[i*4+2], mx=Math.max(r,g,b), mn=Math.min(r,g,b); return px[i*4+3]>=128 && mx>=225 && mx-mn<=28; };
  const ringMin=Math.max(3, BM_OWN_RING_MIN*side), ringMax=BM_OWN_RING_MAX*side;
  let inBox=0; for(let y=y0;y<=y1;y++) for(let x=x0;x<=x1;x++) inBox+=ink[y*W+x];
  const corners=[y0*W+x0, y0*W+x1, y1*W+x0, y1*W+x1];
  const st=new Int32Array(N);
  if(!(inBox>=0.995*bw*bh && corners.every(i=>ink[i]))){
    /* ALPHA: the outline with its holes filled, then the share of near-white pixels at each depth in from it */
    const out=new Uint8Array(N); let sp=0;
    const push=i=>{ if(!out[i] && !ink[i]){ out[i]=1; st[sp++]=i; } };
    for(let x=0;x<W;x++){ push(x); push((H-1)*W+x); }
    for(let y=0;y<H;y++){ push(y*W); push(y*W+W-1); }
    while(sp){ const i=st[--sp], x=i%W; if(x>0) push(i-1); if(x<W-1) push(i+1); if(i>=W) push(i-W); if(i<N-W) push(i+W); }
    const solid=new Uint8Array(N); let area=0;
    for(let i=0;i<N;i++){ if(!out[i]){ solid[i]=1; area++; } }
    const D=bmEdt(solid,W,H), J=Math.ceil(ringMax)+3, tot=new Float64Array(J+1), wh=new Float64Array(J+1);
    for(let i=0;i<N;i++){ if(!solid[i]) continue; const j=Math.max(1,Math.round(Math.sqrt(D[i]))); if(j<=J){ tot[j]++; if(white(i)) wh[j]++; } }
    let d=0;   /* depth 1 is the antialiased rim; the band counts from 2 */
    for(let j=2;j<=J;j++){ if(tot[j]>0 && wh[j]>=0.9*tot[j]) d=j; else break; }
    if(d<ringMin || d>=ringMax) return null;   /* too thin to be a border, or white all the way in (white artwork) */
    let near=0, nw=0; for(let j=1;j<=d;j++){ near+=tot[j]; nw+=wh[j]; }
    if(nw<0.93*near) return null;
    let inner=area; for(let j=1;j<=Math.min(J,d+2);j++) inner-=tot[j];
    if(inner<0.3*area) return null;            /* the band must surround a design, not be it */
    return { kind:"alpha", ring:d, own:true, shape:null, side };
  }
  /* OPAQUE: white running in from the canvas edge */
  const bg=new Uint8Array(N); let sp=0;
  const push=i=>{ if(!bg[i] && white(i)){ bg[i]=1; st[sp++]=i; } };
  for(let x=x0;x<=x1;x++){ push(y0*W+x); push(y1*W+x); }
  for(let y=y0;y<=y1;y++){ push(y*W+x0); push(y*W+x1); }
  while(sp){ const i=st[--sp], x=i%W, y=(i/W)|0; if(x>x0) push(i-1); if(x<x1) push(i+1); if(y>y0) push(i-W); if(y<y1) push(i+W); }
  if(!corners.every(i=>bg[i])) return null;    /* a full-bleed design: the corners are not white */
  let cx0=W,cx1=-1,cy0=H,cy1=-1,cArea=0;
  for(let y=y0;y<=y1;y++) for(let x=x0;x<=x1;x++){ if(!bg[y*W+x]){ cArea++; if(x<cx0)cx0=x; if(x>cx1)cx1=x; if(y<cy0)cy0=y; if(y>cy1)cy1=y; } }
  if(cx1<cx0 || cArea<0.3*bw*bh) return null;
  const ins=[cx0-x0, cy0-y0, x1-cx1, y1-cy1], iMax=Math.max(...ins), iMin=Math.min(...ins);
  if(iMax-iMin > Math.max(3, 0.006*side, 0.15*iMax)) return null;   /* unequal padding: a background, not a border */
  const d=(ins[0]+ins[1]+ins[2]+ins[3])/4;
  if(d>ringMax) return null;
  const pocket=d+0.3*side; let stray=0;
  for(let y=y0;y<=y1;y++) for(let x=x0;x<=x1;x++){
    if(!bg[y*W+x]) continue;
    const ex=Math.min(x-x0,x1-x), ey=Math.min(y-y0,y1-y);
    if(Math.min(ex,ey)<=d+2 || (ex<=pocket && ey<=pocket)) continue;
    stray++;
  }
  if(stray>0.002*bw*bh) return null;           /* white running into the design: it is part of it */
  /* the outer edge = the design grown by d; what lies beyond it is only ever this white (bg), never the design */
  const notC=new Uint8Array(N);
  for(let i=0;i<N;i++) notC[i]=1;
  for(let y=y0;y<=y1;y++) for(let x=x0;x<=x1;x++){ const i=y*W+x; if(!bg[i]) notC[i]=0; }
  const D=bmEdt(notC,W,H), lim=(d+0.5)*(d+0.5), clear=[];
  for(let y=y0;y<=y1;y++) for(let x=x0;x<=x1;x++){ const i=y*W+x; if(bg[i] && D[i]>lim) clear.push(i); }
  return { kind:"opaque", ring:d, own:d>=ringMin, clear, side };
}
/* the pixels of an artwork as an identity, so a border decided for it is not decided again when the same
   artwork comes back (a saved design reopening, a rebuild) - the value saved with it stands */
function bmArtKey(art){
  try{
    const W=art.width, H=art.height, d=art.getContext("2d").getImageData(0,0,W,H).data;
    let h=2166136261>>>0; const step=Math.max(1,Math.floor(W*H/4096));
    for(let i=0;i<W*H;i+=step){ h^=(d[i*4]|(d[i*4+1]<<8)|(d[i*4+2]<<16))^(d[i*4+3]<<24); h=Math.imul(h,16777619)>>>0; }
    return W+"x"+H+":"+h.toString(36);
  }catch(e){ return null; }
}
/* Called on every slot ingest. Two sources can set the border, so the rule is explicit: this sets it to 0
   only for an artwork it has not seen (by its pixels) that has its own white edge, remembers the value it
   replaced, and puts that value back when a new artwork, a back half, or the same file after Remove Background
   or erasing has no white edge of its own. Once the customer moves the slider the value is theirs (opts.borderMm
   is no longer the 0 this set); a saved design reopens with its saved border; Finished keeps its own rule. */
function bmApplyOwnEdge(rec, target){
  let own=null;
  try{ own=bmOwnEdge(rec.art); }catch(e){ own=null; }
  rec.own=own;
  if(own && own.clear && own.clear.length){
    /* A flattened file: the white corners outside its own edge become clear, as Remove Background would make
       them, and the geometry copy is taken again. Only pixels the flood fill proved near-white, joined to the
       canvas edge and outside the design grown by its ring, change - no ink is lost (LAB-RULES 3: the cut itself
       is still traced from mask0, a copy) - and a coloured border or bleed then shows its colour in those
       corners instead of a white square. */
    try{
      const x=rec.art.getContext("2d"), im=x.getImageData(0,0,rec.art.width,rec.art.height), a=im.data;
      for(const i of own.clear) a[i*4+3]=0;
      x.putImageData(im,0,0);
      rec.mask0=hardenAlpha(silhouette(rec.art,"#fff"));
    }catch(e){}
  }
  if(own) own.clear=null;
  const key=bmArtKey(rec.art), slot = target==="top" ? "ownEdgeTopKey" : "ownEdgeKey";
  if(key && opts[slot]===key) return;
  opts[slot]=key;
  if(opts.finished) return;
  const hasOwn=!!(own && own.own);
  const ours=!!opts.ownEdgeZeroed && opts.borderMm===0;
  const setB=mm=>{
    opts.borderMm=mm;
    const w=$("borderW"), l=$("borderVal");
    if(w) w.value=mm; if(l) l.textContent=(+mm).toFixed(1)+"mm";
    try{ paintAllRanges(); }catch(e){}
  };
  const back=()=>{ setB(opts.ownEdgePrevMm==null?2.5:opts.ownEdgePrevMm); opts.ownEdgeZeroed=false; };
  if(target==="top"){ if(ours && !hasOwn) back(); return; }
  const topOwn = !top || !!(top.own && top.own.own);
  if(hasOwn && topOwn){
    if(!ours) opts.ownEdgePrevMm=opts.borderMm;
    setB(0); opts.ownEdgeZeroed=true;
  } else if(ours) back();
}
/* is the loaded artwork a rectangle? both halves must be, when two-sided */
function bmArtIsRect(){
  const check=rec=>{
    if(!rec||!rec.mask0) return false;
    if(rec.__rectMask===rec.mask0) return rec.__isRect;
    let v=false;
    /* 18 Oct 2026 (customer "Page Unresponsive"): a contour three times the canvas perimeter is not a
       rectangle (a rectangle traces to about 2(w+h)); a noisy photo mask is skipped before rdp runs on it */
    try{ const c=traceContour(rec.mask0); v=c.length<=6*(rec.mask0.width+rec.mask0.height) && !!detectRect(rdp(c,1.6)); }catch(e){ v=false; }
    rec.__rectMask=rec.mask0; rec.__isRect=v;
    return v;
  };
  /* A ROUNDED DESIGN IS NOT A RECTANGLE (Thomas, 9 Oct 2026, a customer's two ChatGPT halves with their
     own rounded corners: "its saying your artwork is rectangle, but its not", "this should be die cut").
     On two halves the 12-corner template squeezed every corner down to the bridge fillets (3.98mm against
     her 4.8mm design corner, plus the border, so the cut ran inside the border at each corner), and one
     radius cannot follow two designs whose corners differ (0.165 and 0.119 of the width). Rounded art is
     traced like any other shape: the cut runs a border's width outside the design all round. Square-
     cornered art (a full-bleed photo reads 0 to 0.01) keeps the template and its laminate-floor corners.
     A FINISHED piece keeps the template with its measured radius (17 Sep). */
  const rounded=rec=>{
    if(rec.__roundMask===rec.mask0) return rec.__rounded;
    let v=false;
    try{ const M=bmMeasureCorner(rec.mask0); v=!!(M && M.side>0 && M.r/M.side>=BM_ROUNDED_ART); }catch(e){ v=false; }
    rec.__roundMask=rec.mask0; rec.__rounded=v;
    return v;
  };
  if(!check(main)) return false;
  if(top && !check(top)) return false;
  if(!opts.finished && (rounded(main) || (top && rounded(top)))) return false;
  return true;
}
/* The 12-corner outline, in the OUTLINE canvas's own pixels. B is the border
   growth already baked into that canvas, so the geometry is the half boxes
   grown by it. Returns segments, so one description can be emitted as a
   Path2D for the screen and as an SVG d for the cut file. */
function bmOutlineSegs(geo, ppm, B){
  /* EACH HALF'S OWN BOX (9 Oct 2026). Two designs of different proportions do not fill the same box:
     the customer's top half was 9% wider for its height, came out 5.9mm short inside its slot, and the
     cut drawn round the whole slot ran 2.9mm past the artwork and off the top of the file. tBox/bBox are
     the halves' measured ink boxes (buildSilhouette); an edge within 2px of its slot is the slot. */
  const onePiece0 = (geo.topY === geo.bottomY) && geo.fullH > 0;
  const hH0 = onePiece0 ? geo.fullH : geo.halfH;
  const snapBox=(b)=>{
    if(onePiece0 || !b) return {x0:0, x1:geo.halfW, y0:0, y1:hH0};
    const e0x=b.x<=2?0:b.x, e1x=(geo.halfW-(b.x+b.w))<=2?geo.halfW:b.x+b.w;
    const e0y=b.y<=2?0:b.y, e1y=(hH0-(b.y+b.h))<=2?hH0:b.y+b.h;
    return {x0:e0x, x1:e1x, y0:e0y, y1:e1y};
  };
  const tb=snapBox(geo.tBox), ub=snapBox(geo.bBox);
  const x0=geo.pad+tb.x0-B, x1=geo.pad+tb.x1+B;      // top half
  const u0=geo.pad+ub.x0-B, u1=geo.pad+ub.x1+B;      // bottom half
  /* A FINISHED bookmark is ONE piece, not two halves. buildSilhouette sets
     topY === bottomY there and carries the real height in fullH, so measuring
     both halves with halfH made them the SAME box - running from the top of the
     artwork to its middle. That is why a finished upload came back cut down one
     side only (Thomas, 8 and 9 Sep). Every other reader of the finished geo
     already uses fullH. */
  const onePiece = (geo.topY === geo.bottomY) && geo.fullH > 0;
  const hH = onePiece ? geo.fullH : geo.halfH;
  const tY0=geo.topY+tb.y0-B, tY1=geo.topY+tb.y1+B;
  const bY0=geo.bottomY+ub.y0-B, bY1=geo.bottomY+ub.y1+B;
  const gap=bY0-tY1;
  const bx0=geo.pad+(geo.halfW-geo.bridgeW)/2-B, bx1=bx0+geo.bridgeW+2*B;
  const step=Math.min(bx0-x0, x1-bx1, bx0-u0, u1-bx1);   // how far the bridge is inset
  /* A RECTANGULAR ARTWORK BRINGS ITS OWN CORNERS (Thomas, 17 Sep 2026: a
     finished bookmark "didnt put the cut line round the object instead asked me
     to decide corner radius"). detectRect already measures the radius that best
     fits the artwork's outline; it was only used as a yes/no. On a new file the
     slider now STARTS at that measured radius, scaled to the finished size, so
     the straightened cut follows the object. The slider still overrides. */
  if(opts.cornerFromArt){
    opts.cornerFromArt=false;
    try{
      const M=main&&main.mask0 ? bmMeasureCorner(main.mask0) : null;
      /* kept as a PROPORTION of the width, not as millimetres: the same file is
         27mm wide as a two-half bookmark and 55mm wide once Finished is on, and
         a radius fixed at the first size came out half what the artwork shows */
      opts.cornerRatio = (M && M.r>0) ? M.r/M.side : null;
      opts.cornerAuto  = !!opts.cornerRatio;
    }catch(e){ opts.cornerAuto=false; }
  }
  if(opts.cornerAuto && opts.cornerRatio){
    /* + the border (18 Oct 2026, "this design has a white border thats not being followed"): the cut runs B
       outside the artwork, so its corner is the artwork's own radius grown by B - concentric, the border as
       wide round the corner as along the sides. With the artwork's own white edge B is 0 and the cut takes
       the artwork's radius exactly. */
    const rMm=opts.cornerRatio*geo.halfW/ppm + B/ppm;
    opts.cornerMm=Math.max(BM_CORNER_MIN_MM, Math.min(BM_CORNER_MAX_MM, Math.round(rMm*10)/10));
  }
  const wantMm=(opts.cornerMm==null?BM_CORNER_MM:opts.cornerMm);
  /* The outer box always has room; only the four inner fillets are squeezed by
     the gap between the halves, which the border eats from both sides. */
  let capPx=Math.min((x1-x0)/2,(u1-u0)/2,(tY1-tY0)/2,(bY1-bY0)/2);
  /* Since 9 Oct the four bridge curves have their own radius (BM_FILLET_MM), so the gap limits only them; an
     outer corner needs room along the half's inner edge for itself and one bridge curve, nothing more. The
     gap/2 cap left from the twelve-equal-corners outline held a concentric corner at 3.5mm on a 12mm bridge
     with a 2.5mm border (18 Oct 2026). */
  if(gap>0.5) capPx=Math.min(capPx, Math.max(0, step-Math.min(BM_FILLET_MM*ppm, gap/2)));
  bmCornerCapMm=capPx/ppm;
  /* HARD STOP. The radius never drops below the laminate floor - a sharper
     corner lifts, so it is not an option to fall into. bridgeMinMm() keeps the
     bridge long enough that this floor always fits, and the bridge can be
     switched off entirely, which removes the inner fillets and the limit. */
  let r=Math.min(wantMm*ppm, capPx);
  r=Math.max(r, BM_CORNER_MIN_MM*ppm);
  r=Math.min(r,(x1-x0)/2,(u1-u0)/2,(tY1-tY0)/2,(bY1-bY0)/2);
  if(!(r>0)) r=0;
  bmCornerUsedMm=r/ppm;
  const S=[];
  const M=(x,y)=>S.push({t:"M",x,y});
  const L=(x,y)=>S.push({t:"L",x,y});
  const A=(x,y,sw,rr)=>S.push({t:"A",x,y,r:(rr==null?r:rr),sw});
  const rIn=Math.min(r, BM_FILLET_MM*ppm, gap>0.5?gap/2:Infinity);       // the bridge curves (BM_FILLET_MM), never more than the gap holds
  if(gap<=0.5){                                  // the halves have merged: one box
    const m0=Math.min(x0,u0), m1=Math.max(x1,u1);
    M(m0+r,tY0); L(m1-r,tY0); A(m1,tY0+r,1);
    L(m1,bY1-r); A(m1-r,bY1,1);
    L(m0+r,bY1); A(m0,bY1-r,1);
    L(m0,tY0+r); A(m0+r,tY0,1);
    return {segs:S,r};
  }
  M(x0+r,tY0);
  L(x1-r,tY0);        A(x1,tY0+r,1);            // 1 top-right
  L(x1,tY1-r);        A(x1-r,tY1,1);            // 2 top half, bottom-right
  L(bx1+rIn,tY1);     A(bx1,tY1+rIn,0,rIn);     // 3 CONCAVE into the bridge
  L(bx1,bY0-rIn);     A(bx1+rIn,bY0,0,rIn);     // 4 CONCAVE out of the bridge
  L(u1-r,bY0);        A(u1,bY0+r,1);            // 5 bottom half, top-right
  L(u1,bY1-r);        A(u1-r,bY1,1);            // 6 bottom-right
  L(u0+r,bY1);        A(u0,bY1-r,1);            // 7 bottom-left
  L(u0,bY0+r);        A(u0+r,bY0,1);            // 8 bottom half, top-left
  L(bx0-rIn,bY0);     A(bx0,bY0-rIn,0,rIn);     // 9 CONCAVE
  L(bx0,tY1+rIn);     A(bx0-rIn,tY1,0,rIn);     // 10 CONCAVE
  L(x0+r,tY1);        A(x0,tY1-r,1);            // 11 top half, bottom-left
  L(x0,tY0+r);        A(x0+r,tY0,1);            // 12 top-left
  return {segs:S,r};
}
/* Path2D's constructor parses SVG path data, so ONE emitter serves both the
   screen path and the cut file. No second implementation to drift. */
/* Does the upload carry real transparency? Sampled on a small copy - a
   die-cut PNG has large clear areas, so a coarse read is enough, and this runs
   on every upload. A flattened JPEG or a full-bleed design returns false. */
function bmArtHasAlpha(c){
  try{
    const W=Math.max(1,Math.min(160,c.width)), H=Math.max(1,Math.min(160,c.height));
    const t=mk(W,H), x=t.getContext("2d");
    x.drawImage(c,0,0,W,H);
    const d=x.getImageData(0,0,W,H).data;
    let clear=0;
    for(let i=3;i<d.length;i+=4) if(d[i]<200) clear++;
    return clear > (W*H)*0.02;      // 2% of the frame genuinely see-through
  }catch(e){ return false; }
}
function bmSegsToPath2D(segs){ return new Path2D(bmSegsToD(segs, v=>v.toFixed(3))); }
function bmSegsToD(segs, f){
  let d="";
  for(const g of segs){
    if(g.t==="M") d+="M"+f(g.x)+" "+f(g.y);
    else if(g.t==="L") d+="L"+f(g.x)+" "+f(g.y);
    else d+="A"+f(g.r)+" "+f(g.r)+" 0 0 "+g.sw+" "+f(g.x)+" "+f(g.y);
  }
  return d+"Z";
}
/* ================= MULTI-DESIGN DOCUMENTS =================
   One document = one bookmark AND its backing card, as a pair (Thomas,
   7 Sep 2026). The module globals are always the ACTIVE document's state;
   docs[] holds every other document's saved copy. Switching captures the
   outgoing document, copies the incoming one back into the globals, then
   RE-SYNCS THE DOM.

   The DOM re-sync is not optional. Some per-document truth lives only in an
   element's class: the two-sided toggle is read as authority at the handler
   for it, and nulls `top` when it is off. Restore the variables without
   restoring the controls and the incoming document loses its second artwork.
   syncControlsFromOpts() sets that toggle from `!!top`, which is why every
   activation goes through it.

   Nothing here re-runs finishIngest(). The processed canvases are carried
   across live, exactly as the Proof Lab does it. */
let docs=[], activeIdx=-1, docSeq=0;

/* A shallow {...opts} would share cardDesign between every tab: bg, grid and
   layers[] are nested mutable objects, so one card edit would change them all.
   Layers hold a live Image in .img and a QR .matrix - copy those by reference
   (they are never mutated in place), clone the layer objects around them. */
function cloneCardDesign(D){
  if(!D) return D;
  const c=Object.assign({},D);
  if(D.bg) c.bg=Object.assign({},D.bg);
  if(D.grid) c.grid=Object.assign({},D.grid);
  c.layers=(D.layers||[]).map(L=>Object.assign({},L));
  return c;
}
function cloneBmOpts(o){
  const c=Object.assign({},o);
  c.cardDesign=cloneCardDesign(o.cardDesign);
  return c;
}
function captureDoc(){
  if(activeIdx<0 || !docs[activeIdx]) return;
  const d=docs[activeIdx];
  d.main=main; d.top=top; d.card=card;
  d.palette=palette; d.paletteLight=paletteLight;
  d.baseScene=baseScene; d.cutPath=cutPath; d.foldPath=foldPath; d.sceneMm=sceneMm;
  d.cardScene=cardScene; d.outBase=outBase;
  d.opts=cloneBmOpts(opts);
  d.name=docName(d);
}
function loadDocGlobals(d){
  /* the card's picture rides across every tab with its settings (one per order): a tab keeps the card on screen; a
     tab restored with a card of its own brings it only when none is loaded */
  main=d.main; top=d.top; if(!card && d.card) card=d.card; d.card=card;
  palette=d.palette||[]; paletteLight=d.paletteLight||[];
  baseScene=d.baseScene; cutPath=d.cutPath; foldPath=d.foldPath; sceneMm=d.sceneMm;
  cardScene=d.cardScene; outBase=d.outBase||"stickiply-bookmark";
  /* opts is a const object, so it is assigned into, never rebound - the same
     shape restoreDesign() uses. Clone on the way in too, so the stored copy
     cannot be mutated through the live opts. */
  /* THE CARD IS ONE THING PER ORDER, NOT ONE PER TAB (Thomas, 11 Sep 2026).
     Every option was saved per artwork tab, so setting the card to Landscape
     on the second tab left the first tab's bookmark on the Portrait template:
     the screen said 4.2 x 12.9cm, the exported cut file was 4.6 x 15.0cm.
     Card-level settings ride across every tab; only the bookmark's own
     options stay per tab. */
  const CARD_SHARED=["orient","cardBg","cardBgMode","cardPreset","showOnCard","cardView","cardSide","cardWidthMm","cardBmOffXmm","cardDesign","cardCustomW","cardCustomH","cardOrient"];
  const keep={}; for(const k of CARD_SHARED) if(k in opts) keep[k]=opts[k];
  Object.assign(opts, cloneBmOpts(d.opts)); bmHist=[]; bmRedo=[];
  Object.assign(opts, keep);
  /* Derived state is rebuilt by rendering, never copied. Transient interaction
     state is reset: a switch mid-stroke would otherwise write the outgoing
     document's erase strokes while the incoming one is on screen. */
  invalidateCardDesign(); magnetCircle=null; lastGeo=null; lastTrimOff={x:0,y:0}; bmCutSegs=null;
  curErase=null; if(erasing) setEraseMode(false);
  draggingMagnet=false; draggingBmOnCard=false; draggingLayer=null; activeGuides={v:false,h:false};
  if(animRaf){ cancelAnimationFrame(animRaf); animRaf=0; }
  activeTarget="main"; fitted=false;
}
function docName(d){
  const o=(d&&d.opts)||opts;
  return (d&&d.outBase) || outBase || "bookmark";
}
function newDoc(from){
  const d={ id:++docSeq, name:"bookmark", main:null, top:null, card:null,
            palette:[], paletteLight:[], baseScene:null, cutPath:null, foldPath:null,
            sceneMm:null, cardScene:null, outBase:"stickiply-bookmark", opts:cloneBmOpts(opts) };
  if(from){
    /* A duplicate shares the processed canvases - they are never drawn into
       again, only read - but NOT the slot record itself: rec.eraseStrokes is a
       live array, so erasing on the copy would rub out the original's artwork
       too. Copy the record, give it its own strokes. */
    d.main=copyRec(from.main); d.top=copyRec(from.top); d.card=copyRec(from.card);
    d.palette=(from.palette||[]).slice(); d.paletteLight=(from.paletteLight||[]).slice();
    d.outBase=from.outBase; d.opts=cloneBmOpts(from.opts);
  }
  return d;
}
function copyRec(r){
  if(!r) return r;
  const c=Object.assign({},r);
  c.eraseStrokes=(r.eraseStrokes||[]).map(g=>g.slice());
  if(r.trimOff) c.trimOff=Object.assign({},r.trimOff);
  return c;
}
/* Called from finishIngest when a genuinely NEW main artwork arrives and one is
   already loaded. A card or a top-half upload joins the CURRENT document,
   because a document is the pair. */
function beginDocForNewMain(){
  if(activeIdx<0){                       // first ever upload: make it document 1
    docs=[newDoc()]; activeIdx=0; return;
  }
  /* loadFile() sets the global outBase from the NEW file's name before ingest
     runs, so capturing now would relabel the outgoing tab with the incoming
     file's name - both tabs came out "TWO" in testing. Its own name was stored
     by the captureDoc at the end of its own ingest, so put it back. */
  const prevName=docs[activeIdx].outBase;
  captureDoc();
  if(prevName) docs[activeIdx].outBase=prevName;
  docs.push(newDoc());
  activeIdx=docs.length-1;
  /* the new document keeps the settings of the one before it, which is what
     dropping a second design onto the tool already did, but starts with no
     artwork of its own */
  const d=docs[activeIdx];
  /* the backing card is one per order (20 Oct 2026, Thomas: a new design wiped the uploaded card while its tile still
     showed it): the new document takes the card along; only the bookmark's own artwork starts empty */
  d.main=null; d.top=null; d.card=card; d.palette=[]; d.paletteLight=[];
  main=null; top=null; palette=[]; paletteLight=[];
  baseScene=null; cutPath=null; foldPath=null; cardScene=null;
  invalidateCardDesign(); magnetCircle=null;
}
function activateDoc(i){
  if(i===activeIdx || !docs[i]) return;
  captureDoc();
  activeIdx=i;
  loadDocGlobals(docs[i]);
  syncPresetSeg(); applyCardPreset();
  syncControlsFromOpts();               // the DOM is the second state store
  renderSwatches(); refreshSlots(); refreshCardSlot();
  $("drop").classList.toggle("hidden", !!main);
  $("preview").classList.toggle("hidden", !main);
  $("zoomctl").style.display = main ? "flex" : "none";
  enableDownloads();
  buildAndRender(); syncBmSize(); updateDpi();
  renderDocTabs();
}
function duplicateDoc(i){
  const src=docs[i]; if(!src) return;
  if(i===activeIdx) captureDoc();
  docs.push(newDoc(docs[i]));
  activeIdx=docs.length-1;
  loadDocGlobals(docs[activeIdx]);
  syncPresetSeg(); applyCardPreset();
  syncControlsFromOpts();
  renderSwatches(); refreshSlots(); refreshCardSlot();
  enableDownloads(); buildAndRender(); syncBmSize(); updateDpi();
  renderDocTabs();
}
function closeDoc(i){
  if(!docs[i]) return;
  if(docs.length===1){ docs=[]; activeIdx=-1; clearAllBm(); renderDocTabs(); return; }
  const wasActive = i===activeIdx;
  if(!wasActive) captureDoc();
  docs.splice(i,1);
  if(wasActive){
    activeIdx=Math.min(i, docs.length-1);
    loadDocGlobals(docs[activeIdx]);
    syncPresetSeg(); applyCardPreset();
    syncControlsFromOpts();
    renderSwatches(); refreshSlots(); refreshCardSlot();
    $("drop").classList.toggle("hidden", !!main);
    $("preview").classList.toggle("hidden", !main);
    enableDownloads(); buildAndRender(); syncBmSize(); updateDpi();
  } else if(i<activeIdx){ activeIdx--; }
  renderDocTabs();
}
function renderDocTabs(){
  const host=$("docTabs"); if(!host) return;
  if(docs.length<1){ host.classList.add("hidden"); host.innerHTML=""; return; }
  host.classList.remove("hidden");
  host.innerHTML="";
  docs.forEach((d,i)=>{
    const nm = (i===activeIdx ? outBase : d.outBase) || "bookmark";
    const t=document.createElement("div");
    t.className="doctab"+(i===activeIdx?" on":"");
    const n=document.createElement("span"); n.className="doctab__name"; n.textContent=nm; n.title=nm;
    const x=document.createElement("span"); x.className="doctab__x"; x.textContent="×"; x.title=stkT("stk.labs.bookmark.tabs.close","Close");
    t.appendChild(n); t.appendChild(x);
    t.addEventListener("click",e=>{ if(e.target===x) return; activateDoc(i); });
    x.addEventListener("click",e=>{ e.stopPropagation(); closeDoc(i); });
    host.appendChild(t);
  });
  const add=document.createElement("button");
  add.type="button"; add.className="doctab__add"; add.title=stkT("stk.labs.bookmark.tabs.add_design","Add another design");
  add.setAttribute("aria-label",stkT("stk.labs.bookmark.tabs.add_design","Add another design")); add.textContent="+";
  add.addEventListener("click",()=>{ activeTarget="main"; $("fileMain").click(); });
  host.appendChild(add);
  const cp=document.createElement("button");
  cp.type="button"; cp.className="doctab__copy"; cp.title=stkT("stk.labs.bookmark.tabs.duplicate_design","Duplicate this design");
  cp.setAttribute("aria-label",stkT("stk.labs.bookmark.tabs.duplicate_design","Duplicate this design"));
  cp.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>';
  cp.addEventListener("click",()=>duplicateDoc(activeIdx));
  host.appendChild(cp);
}
/* process a raw (un-keyed) source canvas into the active slot */
function finishIngest(raw, srcW, isVector, keepStrokes){
    const c=copyCanvas(raw);
    /* reprocessAll rebuilds each slot from `raw`, which would drop the erase
       strokes along with the old record - carry them across explicitly. A
       genuinely new upload passes keepStrokes falsy, so its strokes start empty. */
    const prevRec = activeTarget==="top" ? top : activeTarget==="card" ? card : main;
    const strokes = (keepStrokes && prevRec && prevRec.eraseStrokes) ? prevRec.eraseStrokes : [];
    if(activeTarget!=="card" && opts.removeWhite) removeWhiteBg(c, opts.removeTol, opts.removeKey);

    if(activeTarget==="card"){
      card={ art:c, raw, srcW, isVector:!!isVector };
      opts.cardPreset="upload";
      // reflect the preset selection in the segmented control
      const seg=$("cardPresetSeg");
      if(seg){ [...seg.children].forEach(b=>b.classList.toggle("on", b.dataset.v==="upload")); }
      applyCardPreset();
      $("note").classList.remove("show");
      refreshCardSlot();
      enableDownloads();
      buildAndRender();
      if(activeIdx>=0 && docs[activeIdx]) captureDoc();
      renderDocTabs();
      $("spin").classList.remove("show");
      return;
    }

    // Only clean up alpha WE created. A customer file that already has transparency
    // keeps its separated elements - signature, dotted i, full stop - and the
    // clean-up eraser handles anything they want gone. AI/LAB-RULES.md rule 3.
    /* A NEW main artwork is a NEW document. keepStrokes is set only by
       reprocessAll rebuilding the slots in place, which must not spawn a tab. */
    if(activeTarget==="main" && !keepStrokes) beginDocForNewMain();
    if(activeTarget!=="card" && opts.removeWhite) despeckle(c);
    /* replay BEFORE the trim, so erasing a stray in the corner actually shrinks
       the artwork rather than leaving dead space where it used to be */
    const bmEd=bmApplyEdits(c, strokes);   /* FILL BRUSH + MAGIC WAND (21 Oct 2026): the eraser's list, in order */
    const art=trim(c);
    const mask0=hardenAlpha(silhouette(art,"#fff")); /* geometry copy hardened (>=96 alpha counts as ink) - a faint baked-in glow must not drag the cut line out; measured 27 Aug 2026 on order 8885, 8.7mm border at a 2.0mm setting before this */
    const rec={ art, mask0, raw, srcW, isVector:!!isVector, trimRatio:art.width/c.width,
                eraseStrokes:strokes, trimOff:{x:lastTrimOff.x, y:lastTrimOff.y} };
    bmApplyOwnEdge(rec, activeTarget);   /* artwork with its own white edge: cut on that edge, no added border */
    rec.artDraw=bmDrawnCopy(rec, bmEd); rec.wandMap=bmEd.map; rec.edW=bmEd.w; rec.edH=bmEd.h;   /* FILL BRUSH + MAGIC WAND (21 Oct 2026) */
    if(opts.removeWhite || (strokes||[]).some(g=>g && g[0] && (g[0].w || g[0].f))){ try{ bmDecontaminate(rec, raw); }catch(e){} }   /* the halo (21 Oct 2026): the drawn edge of what was removed */
    if(activeTarget==="top") top=rec; else { main=rec; opts.cornerFromArt=true; }   // new artwork: measure its own corners once

    if(activeTarget==="main"){
      palette=extractPalette(bmInk(rec)||art);   /* the colours that print (not the fill brush's grey) */
      paletteLight=palette.map(lighten);
      /* AUTO ONLY SUITS FULL-BLEED ARTWORK.
         Auto grows the bleed out of the artwork's own edge pixels. That is right
         for a design that runs to the edge, and wrong for a transparent PNG,
         where the edge IS the die-cut shape - it smears the artwork outwards in
         streaks (Thomas, 9 Sep, on a purple octopus). A transparent upload wants
         a plain white border behind it, which is what a die-cut sticker or
         bookmark has. Decided per upload, and only ever as the STARTING mode -
         the Colour buttons still override it. */
      /* 30 Sep 2026: every upload starts on Solid white (Thomas: "it is on auto
         but shouldnt be") - Auto left the bridge between the halves unprinted. */
      opts.bgMode = "solid";
      opts.bg="#ffffff";
    }
    $("note").classList.remove("show");
    $("drop").classList.add("hidden");
    $("preview").classList.remove("hidden");
    if(activeTarget==="main"){ fitted=false; opts.magnetOffX=0; opts.magnetOffY=null; opts.cardBmOffXmm=0; }     // re-fit + reset magnet to default
    $("zoomctl").style.display="flex";
    renderSwatches();
    refreshSlots();
    enableDownloads();
    buildAndRender();
    /* new artwork = new proportions, so the size pair is restated from the
       piece that actually came out rather than the previous artwork's numbers */
    syncBmSize();
    updateDpi();
    if(activeIdx>=0 && docs[activeIdx]) captureDoc();
    renderDocTabs();
    $("spin").classList.remove("show");
}
function removeWhiteBg(c, tol, keyHex){
  /* keyed background removal. White key uses brightness+chroma (kind to
     anti-aliased text); any other key colour uses RGB distance. The floor is
     deliberately strict so "Gentle" removes only near-exact matches. */
  const t=Math.max(0,Math.min(100, tol==null?25:tol))/100;
  const m=/^#?([0-9a-f]{6})$/i.exec(keyHex||"#ffffff");
  const kn=m?parseInt(m[1],16):0xffffff;
  const kr=(kn>>16)&255, kg=(kn>>8)&255, kb=kn&255;
  const whiteKey = kr>250 && kg>250 && kb>250;
  const brightCut = 254 - t*94;
  const chromaCut = 4 + t*56;
  const distCut = 22 + t*150;
  const ctx=c.getContext("2d");
  const {width:w,height:h}=c;
  const d=ctx.getImageData(0,0,w,h);
  const px=d.data;
  const seen=new Uint8Array(w*h);
  const isWhite=i=>{
    const r=px[i*4],g=px[i*4+1],b=px[i*4+2],a=px[i*4+3];
    if(a<10) return true;
    if(whiteKey){
      const mx=Math.max(r,g,b), mn=Math.min(r,g,b);
      return mx>brightCut && (mx-mn)<chromaCut;
    }
    const dr=r-kr, dg=g-kg, db=b-kb;
    return (dr*dr+dg*dg+db*db) < distCut*distCut;
  };
  const stack=[];
  for(let x=0;x<w;x++){ stack.push(x,(h-1)*w+x); }
  for(let y=0;y<h;y++){ stack.push(y*w,y*w+w-1); }
  while(stack.length){
    const i=stack.pop();
    if(i<0||i>=w*h||seen[i]) continue;
    seen[i]=1;
    if(!isWhite(i)) continue;
    px[i*4+3]=0;
    const x=i%w;
    stack.push(i-w,i+w);
    if(x>0) stack.push(i-1);
    if(x<w-1) stack.push(i+1);
  }
  ctx.putImageData(d,0,0);
}
/* ================= FILL BRUSH + MAGIC WAND (21 Oct 2026) =================
   Thomas, on his Proof Lab (a black-and-white figure on a chair): "a brush next to the eraser that works in the same way but
   instead of removing pixels it fills the area with the background colour", and "some white needs to stay, other needs to go,
   so maybe a magic wand style toggle" (it replaces the Remove inner white switch of the same day). Both are edits in each
   slot's eraser list (rec.eraseStrokes, raw px), replayed in order in finishIngest, kept by a saved design, undone and redone
   by the bar's Undo / Redo:
   - a fill stroke, stamps {x,y,r,f:1}: the discs join the artwork that shapes the bookmark (rec.art, in a neutral grey that
     no measurement reads as white or ink colour), so the outline and the cut close over a gap; the DRAWN copy (rec.artDraw)
     is clear there, so the bookmark's own background shows (solid, gradient or auto) and follows a later colour change;
   - a wand tap, one stamp {x,y,r:1,w:1}: the near-white region joined to that pixel (Remove background's strength, its white
     test) goes. Enclosed, it leaves the drawn copy only, so the outline, its auto centre and the size stay exactly as they
     were; touching the outside, it goes like removed background. A tap on a region the wand took brings it back. */
var bmTool="erase", bmHist=[], bmRedo=[];
const BM_FILL_GEO="#7f7f7f";
function bmDisc(cnv,x,y,r,col){ const c2=cnv.getContext("2d"); c2.save(); c2.globalCompositeOperation="source-over"; c2.fillStyle=col; c2.beginPath(); c2.arc(x,y,r,0,Math.PI*2); c2.fill(); c2.restore(); }
function bmEdPt(p){ const o={x:p.x,y:p.y,r:p.r}; if(p.f) o.f=1; if(p.w) o.w=1; return o; }
function bmWhiteTest(tol){
  const t=Math.max(0,Math.min(100, tol==null?25:tol))/100, brightCut=254-t*94, chromaCut=4+t*56;
  return (px,i)=>{ if(px[i*4+3]<10) return false; const r=px[i*4],g=px[i*4+1],b=px[i*4+2], mx=Math.max(r,g,b), mn=Math.min(r,g,b); return mx>brightCut && (mx-mn)<chromaCut; };
}
/* THE TRUE MAGIC WAND (21 Oct 2026, Thomas: "magic wand seems to only work on white"): the region of the TAPPED pixel's
   colour as Remove background measures it - white by its white test (exactly as before), any other colour by the RGB
   distance a picked key colour uses (22 + strength x 150); a see-through pixel or the fill brush's paint is never taken */
function bmWandTest(px,seed,tol,skip){
  if(px[seed*4+3]<10 || (skip && skip[seed*4+3])) return null;
  const isW=bmWhiteTest(tol);
  if(isW(px,seed)) return (p,i)=>isW(p,i) && !(skip && skip[i*4+3]);
  const t=Math.max(0,Math.min(100, tol==null?25:tol))/100, cut=22+t*150, c2=cut*cut, r0=px[seed*4], g0=px[seed*4+1], b0=px[seed*4+2];
  return (p,i)=>{ if(p[i*4+3]<10 || (skip && skip[i*4+3])) return false; const dr=p[i*4]-r0, dg=p[i*4+1]-g0, db=p[i*4+2]-b0; return dr*dr+dg*dg+db*db < c2; };
}
function bmRegion(px,w,h,seed,isW){
  if(seed<0||seed>=w*h||!isW || !isW(px,seed)) return null;
  const seen=new Uint8Array(w*h), out=[seed], st=[seed]; seen[seed]=1;
  while(st.length){
    const i=st.pop(), x=i%w;
    if(x>0 && !seen[i-1] && isW(px,i-1)){ seen[i-1]=1; st.push(i-1); out.push(i-1); }
    if(x<w-1 && !seen[i+1] && isW(px,i+1)){ seen[i+1]=1; st.push(i+1); out.push(i+1); }
    if(i>=w && !seen[i-w] && isW(px,i-w)){ seen[i-w]=1; st.push(i-w); out.push(i-w); }
    if(i<w*h-w && !seen[i+w] && isW(px,i+w)){ seen[i+w]=1; st.push(i+w); out.push(i+w); }
  }
  return out;
}
/* see-through pixels joined to the canvas edge: the outside */
function bmOutside(px,w,h){
  const out=new Uint8Array(w*h), st=[];
  for(let x=0;x<w;x++){ st.push(x,(h-1)*w+x); }
  for(let y=0;y<h;y++){ st.push(y*w,y*w+w-1); }
  while(st.length){ const i=st.pop(); if(i<0||i>=w*h||out[i]||px[i*4+3]>=10) continue; out[i]=1; const x=i%w; st.push(i-w,i+w); if(x>0) st.push(i-1); if(x<w-1) st.push(i+1); }
  return out;
}
/* the slot's edit list on the raw-size canvas c, in order; returns what the drawn copy loses and the wand's region map */
function bmApplyEdits(c, strokes){
  const w=c.width, h=c.height; let draw=null, map=null, paint=null;
  (strokes||[]).forEach((grp,gi)=>{
    const s0=grp && grp[0]; if(!s0) return;
    if(s0.w){
      const ctx=c.getContext("2d"), d=ctx.getImageData(0,0,w,h), px=d.data;
      const seed=Math.round(s0.y)*w+Math.round(s0.x), skip=paint ? paint.getContext("2d").getImageData(0,0,w,h).data : null;
      const reg=(seed>=0 && seed<w*h) ? bmRegion(px,w,h,seed,bmWandTest(px,seed,opts.removeTol,skip)) : null; if(!reg) return;
      const out=bmOutside(px,w,h); let open=false;
      for(let k=0;k<reg.length && !open;k++){ const i=reg[k], x=i%w, y=(i-x)/w;
        if(x===0||y===0||x===w-1||y===h-1 || (x>0&&out[i-1]) || (x<w-1&&out[i+1]) || (y>0&&out[i-w]) || (y<h-1&&out[i+w])) open=true; }
      if(!map) map=new Int32Array(w*h);
      if(open){ for(let k=0;k<reg.length;k++){ px[reg[k]*4+3]=0; map[reg[k]]=gi+1; } ctx.putImageData(d,0,0); }
      else { if(!draw) draw=mk(w,h); const dx=draw.getContext("2d"), dd=dx.getImageData(0,0,w,h); for(let k=0;k<reg.length;k++){ dd.data[reg[k]*4+3]=255; map[reg[k]]=gi+1; } dx.putImageData(dd,0,0); }
      return;
    }
    if(s0.f){ if(!draw) draw=mk(w,h); if(!paint) paint=mk(w,h); for(const st of grp){ bmDisc(c,st.x,st.y,st.r,BM_FILL_GEO); bmDisc(draw,st.x,st.y,st.r,"#000"); bmDisc(paint,st.x,st.y,st.r,"#000"); } return; }
    for(const st of grp){ punch(c,st.x,st.y,st.r); if(paint) punch(paint,st.x,st.y,st.r); }
  });
  return {draw, map, w, h};
}
/* the drawn copy: the trimmed artwork less the fill and the enclosed wand regions (null = draw the artwork itself) */
function bmDrawnCopy(rec, ed){
  if(!ed || !ed.draw) return null;
  const o=mkLike(rec.art), x=o.getContext("2d"); x.drawImage(rec.art,0,0);
  const off=rec.trimOff||{x:0,y:0}; x.globalCompositeOperation="destination-out"; x.drawImage(ed.draw,-off.x,-off.y);
  return o;
}
/* what the halves DRAW: the drawn copy when there is one, else the artwork */
function bmInk(rec){ return rec ? (rec.artDraw || rec.art) : null; }
/* one brush stamp in a slot's own art space; true = a fill stamp */
function bmStampEdit(hit,r){
  const rec=hit.rec;
  if(bmTool==="fill"){
    if(!rec.artDraw) rec.artDraw=bmDrawnCopy(rec,{draw:mk(1,1)});
    bmDisc(rec.art,hit.x,hit.y,r,BM_FILL_GEO);
    if(rec.mask0) bmDisc(rec.mask0,hit.x,hit.y,r,"#fff");
    punch(rec.artDraw,hit.x,hit.y,r);
    return true;
  }
  punch(rec.art,hit.x,hit.y,r);
  if(rec.mask0) punch(rec.mask0,hit.x,hit.y,r);
  if(rec.artDraw) punch(rec.artDraw,hit.x,hit.y,r);
  return false;
}
/* tools: one at a time, a second tap on the active one puts it away */
function bmToolPick(t){
  if(!main) return;
  if(erasing && bmTool===t){ setEraseMode(false); return; }
  bmTool=t; setEraseMode(true);
}
function bmSyncTool(){
  if(!bmTool) bmTool="erase";
  [["ctoolErase","erase"],["ctoolFill","fill"],["ctoolWand","wand"]].forEach(([id,t])=>{ const b=$(id); if(!b) return; const on=erasing && bmTool===t; b.classList.toggle("on",on); b.setAttribute("aria-pressed",String(on)); });
  const lbl=$("eraseLbl"); if(lbl) lbl.textContent = bmTool==="fill" ? stkT("stk.studio.tool.fill_brush","Fill brush") : bmTool==="wand" ? stkT("stk.studio.tool.wand","Magic wand") : stkT("stk.labs.bookmark.stage.eraser","Eraser");
  const sz=$("eraseSize");
  if(sz){ const sw=(sz.closest && sz.closest(".segslider")) || sz; sw.style.display = bmTool==="wand" ? "none" : ""; sz.disabled=false; sz.style.opacity=""; sz.setAttribute("aria-label", bmTool==="erase" ? stkT("stk.labs.bookmark.stage.eraser_size_aria","Eraser size in mm") : stkT("stk.studio.tool.brush_size_aria","Brush size in mm")); }
  const sv=$("eraseSizeVal"); if(sv){ sv.style.opacity=""; sv.style.display = bmTool==="wand" ? "none" : ""; }
  { const bar=$("eraseBar"); if(bar) bar.style.justifyContent = bmTool==="wand" ? "center" : ""; }
  requestAnimationFrame(()=>{ try{ bmColsLayout(); }catch(e){} });
  /* a long tool name (fr "Pinceau de remplissage") must not push the bar past the canvas: the name gives way, the lit tile says which tool */
  if(lbl){ lbl.style.display=""; try{ const bar=$("eraseBar"), st=$("stage"); if(bar && st && erasing){ const br=bar.getBoundingClientRect(), sr=st.getBoundingClientRect(); if(br.width && br.right>sr.right-6) lbl.style.display="none"; } }catch(e){} }
}
window.addEventListener("resize",()=>{ try{ if(erasing) bmSyncTool(); }catch(e){} });
/* history over the slots' lists (each op holds the list itself: a reprocess rebuilds the slot record, not its list) */
function bmApplyOp(op,fwd){
  if(op.t==="reset"){ op.prev.forEach(p=>{ p.L.length=0; if(!fwd) p.list.forEach(g=>p.L.push(g)); }); return; }
  const L=op.L, ins=()=>L.splice(Math.min(op.i,L.length),0,op.g), del=()=>{ const k=L.indexOf(op.g); if(k>=0) L.splice(k,1); };
  if(op.t==="add") (fwd?ins:del)(); else (fwd?del:ins)();
}
function bmDo(op){ if(!bmHist) bmHist=[]; bmApplyOp(op,true); bmHist.push(op); bmRedo=[]; }
function bmUndo(){
  if(bmHist && bmHist.length){ const op=bmHist.pop(); bmApplyOp(op,false); (bmRedo=bmRedo||[]).push(op); return true; }
  const rec=(top&&top.eraseStrokes&&top.eraseStrokes.length)?top:main;   /* edits from a saved design */
  if(rec&&rec.eraseStrokes&&rec.eraseStrokes.length){ const L=rec.eraseStrokes, g=L.pop(); (bmRedo=bmRedo||[]).push({t:"add",L,g,i:L.length}); return true; }
  return false;
}
function bmRedoOne(){ if(!bmRedo || !bmRedo.length) return false; const op=bmRedo.pop(); bmApplyOp(op,true); bmHist.push(op); return true; }
/* a wand tap: inside a region the wand took -> it comes back; on near-white -> it goes */
function bmWandTap(pt){
  const hit=sceneToSlot(pt.x,pt.y); if(!hit) return;
  const rec=hit.rec, off=rec.trimOff||{x:0,y:0}, x=Math.round(hit.x+off.x), y=Math.round(hit.y+off.y);
  const L=rec.eraseStrokes=rec.eraseStrokes||[];
  if(rec.wandMap && x>=0 && y>=0 && x<rec.edW && y<rec.edH){
    const gi=rec.wandMap[y*rec.edW+x];
    if(gi && L[gi-1]){ bmDo({t:"del",L,g:L[gi-1],i:gi-1}); replayErase(); return; }
  }
  const src=bmInk(rec), ax=Math.round(hit.x), ay=Math.round(hit.y);
  if(!src || ax<0 || ay<0 || ax>=src.width || ay>=src.height) return;
  const d=src.getContext("2d").getImageData(ax,ay,1,1).data;
  if(d[3]<10) return;   /* a see-through pixel: nothing for the wand to take */
  bmDo({t:"add",L,g:[{x,y,r:1,w:1}],i:L.length}); replayErase();
}
/* THE STAGE COLUMNS (21 Oct 2026, Thomas on live iPhone): on a phone the tool column (left) and the zoom column (right) are each
   centred in the canvas area that is free on its side: below a button in that top corner (the designs grid, top right; his crop
   had "-" on it), above the edit bar when one shows (the bar sits on the canvas bottom, clear of the sheet's rounded top), and
   their tiles shrink together until they fit, so nothing overlaps at any snap or canvas height. Desktop keeps its rows. */
function bmColsLayout(){
  try{
    const ce=$("ctoolErase"), ct=ce && ce.parentElement, zc=$("zoomctl"), st=(zc && zc.parentElement) || (ct && ct.parentElement) || $("stage"); if(!st) return;
    const cols=[ct,zc].filter(Boolean), bar=$("eraseBar");
    cols.forEach(c=>{ c.style.removeProperty("top"); c.style.removeProperty("bottom"); c.style.removeProperty("row-gap"); [...c.children].forEach(t=>{ if(t.style && t.style.zoom) t.style.zoom=""; }); });
    if(!(window.matchMedia && window.matchMedia("(max-width:767px)").matches)) return;
    const S=st.getBoundingClientRect(); if(!S.height) return;
    const hd=root.host.dataset, sheet=(hd.plHead||hd.bmsHead)==="1", base=sheet?30:10;
    const barOn=!!(bar && erasing && bar.getClientRects().length), bh=barOn ? (Math.round(bar.getBoundingClientRect().height)||38) : 0;
    const bottom=base+(barOn?bh+8:0);
    /* the buttons over the canvas's top corners: the designs grid (in the canvas), the Studio's back and light / dark (over it) */
    const cand=[...st.querySelectorAll(".gridbtn")];
    try{ document.querySelectorAll(".plx-back,.plx-theme").forEach(e=>cand.push(e)); }catch(e){}
    [...st.children].forEach(e=>{ if(cols.includes(e) || e===bar || !e.getClientRects().length || getComputedStyle(e).position!=="absolute") return; const r=e.getBoundingClientRect(); if(r.height<=80 && r.width<=120 && r.top-S.top<=60) cand.push(e); });
    const corner=right=>{ let b=-1; cand.forEach(e=>{ if(!e.getClientRects().length) return; const r=e.getBoundingClientRect(); if(r.bottom<=S.top || r.top>S.top+80 || r.right<=S.left || r.left>=S.right) return; if((r.left+r.width/2>S.left+S.width/2)===right) b=Math.max(b, r.bottom-S.top); }); return b; };
    cols.forEach(c=>{ const cr=c.getBoundingClientRect(), right=cr.left+cr.width/2>S.left+S.width/2, cb=corner(right);
      c.style.setProperty("top", (cb<0 ? 10 : Math.ceil(cb+8))+"px", "important"); c.style.setProperty("bottom", bottom+"px", "important"); });
    cols.forEach(c=>{ const cs=getComputedStyle(c); if(cs.flexDirection!=="column") return; const tiles=[...c.children].filter(t=>t!==bar && t.offsetWidth>0 && t.getClientRects().length); if(!tiles.length) return;
      const gap0=parseFloat(cs.rowGap)||0, H=c.clientHeight, need=tiles.reduce((n,t)=>n+t.offsetWidth,0)+gap0*(tiles.length-1);   /* square tiles: width = their own height */
      if(H>0 && need>H+0.5){ const k=Math.max(0.42, Math.floor(H/need*100)/100); tiles.forEach(t=>t.style.zoom=String(k)); c.style.setProperty("row-gap", (gap0*k).toFixed(1)+"px", "important"); } });
    if(barOn && typeof placeEraseBar==="function") placeEraseBar();
  }catch(e){}
}
setTimeout(()=>{ try{ const zc=$("zoomctl"), st=(zc && zc.parentElement) || $("stage"); if(st && window.ResizeObserver) new ResizeObserver(()=>requestAnimationFrame(bmColsLayout)).observe(st); }catch(e){} }, 0);
window.addEventListener("resize",()=>requestAnimationFrame(bmColsLayout));

/* EDGE DECONTAMINATION (21 Oct 2026, a customer's black heart "witchling" on white: after Remove background and the magic wand a
   thin white line stayed round the black, printing as a light halo on her red border). An antialiased edge pixel is part ink,
   part the colour that was removed; that removed share stays in it as white. For every kept pixel within `band` px of a region
   WE removed (by colour: background removal, the magic wand, a fill brush's cleared area - never the customer's own see-through
   areas): C = the removed colour next to it (the removed pixels' original colours within 2 px), F = the solid colour just inside
   (the nearest kept pixel deeper than the band, reached through the band); its share of ink a is where it sits on the line from C
   to F; it becomes F at a times its alpha, so the edge fades from ink straight into whatever is behind (the border colour).
   Guards: a pixel more than `band` from a removed region is never touched (white kept inside the design stays white); deeper
   band pixels only follow a shallower neighbour that is at least as removed-coloured (a white stroke behind a black outline is
   not an antialias step and is kept); an ink colour within 40 of C has nothing to separate (kept); a hairline with no solid
   colour behind it within the band is kept as it is. px is changed in place; returns the number of pixels changed. */
function decontaminateEdges(px, orig, removed, w, h, band){
  const N=w*h; band=band||3;
  const dist=new Int16Array(N).fill(-1), q=new Int32Array(N); let qh=0, qt=0;
  for(let i=0;i<N;i++) if(removed[i]){ dist[i]=0; q[qt++]=i; }
  if(!qt) return 0;
  while(qh<qt){
    const i=q[qh++], d=dist[i]; if(d>=band+3) continue; const x=i%w;
    const nb0=x>0?i-1:-1, nb1=x<w-1?i+1:-1, nb2=i>=w?i-w:-1, nb3=i<N-w?i+w:-1;
    for(const k of [nb0,nb1,nb2,nb3]){ if(k<0 || dist[k]>=0 || removed[k] || px[k*4+3]<10) continue; dist[k]=d+1; q[qt++]=k; }
  }
  /* the solid colour behind the edge: from the kept pixels just deeper than the band, spread into the band through the band */
  const near=new Int32Array(N).fill(-1); qh=0; qt=0;
  for(let i=0;i<N;i++) if(dist[i]>band && px[i*4+3]>=250){ near[i]=i; q[qt++]=i; }
  while(qh<qt){
    const i=q[qh++], x=i%w;
    const nb0=x>0?i-1:-1, nb1=x<w-1?i+1:-1, nb2=i>=w?i-w:-1, nb3=i<N-w?i+w:-1;
    for(const k of [nb0,nb1,nb2,nb3]){ if(k<0 || near[k]>=0 || dist[k]<1 || dist[k]>band) continue; near[k]=near[i]; q[qt++]=k; }
  }
  const aOf=new Float32Array(N).fill(-1);   /* each band pixel's removed-colour share, for the deeper ones to follow */
  let changed=0;
  for(let d=1; d<=band; d++){
    for(let i=0;i<N;i++){
      if(dist[i]!==d || near[i]<0) continue;
      const o=i*4; if(px[o+3]<10) continue;
      const x=i%w, y=(i-x)/w, R=d+1;
      let cr=0,cg=0,cb=0,cn=0;
      for(let yy=Math.max(0,y-R); yy<=Math.min(h-1,y+R); yy++) for(let xx=Math.max(0,x-R); xx<=Math.min(w-1,x+R); xx++){ const k=yy*w+xx; if(!removed[k]) continue; cr+=orig[k*4]; cg+=orig[k*4+1]; cb+=orig[k*4+2]; cn++; }
      if(!cn) continue;
      cr/=cn; cg/=cn; cb/=cn;
      const f=near[i]*4, fr=px[f], fg=px[f+1], fb=px[f+2];
      const dr=fr-cr, dg=fg-cg, db=fb-cb, L2=dr*dr+dg*dg+db*db;
      if(L2<1600) continue;
      let a=((px[o]-cr)*dr+(px[o+1]-cg)*dg+(px[o+2]-cb)*db)/L2; a=Math.max(0,Math.min(1,a));
      if(d>1){   /* deeper than the first ring: only as the continuation of a shallower antialias step */
        let ok=false; const nb=[x>0?i-1:-1, x<w-1?i+1:-1, i>=w?i-w:-1, i<N-w?i+w:-1];
        for(const k of nb){ if(k>=0 && dist[k]===d-1 && aOf[k]>=0 && aOf[k]<=a+0.05){ ok=true; break; } }
        if(!ok) continue;
      }
      aOf[i]=a;
      if(a>=0.985) continue;   /* already ink */
      px[o]=fr; px[o+1]=fg; px[o+2]=fb; px[o+3]=Math.round(px[o+3]*a); changed++;
    }
  }
  return changed;
}
/* the bookmark's use of it: on the DRAWN copy only (the outline is traced from rec.art and stays exactly as it was), against the
   untouched source (raw) */
function bmDecontaminate(rec, raw){
  if(!rec || !rec.art || !raw) return 0;
  const drawn=rec.artDraw || bmDrawnCopy(rec,{draw:mk(1,1)}); const w=drawn.width, h=drawn.height, ctx=drawn.getContext("2d"), d=ctx.getImageData(0,0,w,h), px=d.data;
  const rw=raw.width, rh=raw.height, r0=raw.getContext("2d").getImageData(0,0,rw,rh).data, off=rec.trimOff||{x:0,y:0};
  const orig=new Uint8ClampedArray(w*h*4), removed=new Uint8Array(w*h);
  for(let y=0;y<h;y++){ const ry=y+off.y; if(ry<0||ry>=rh) continue; for(let x=0;x<w;x++){ const rx=x+off.x; if(rx<0||rx>=rw) continue; const j=y*w+x, k=ry*rw+rx;
    orig[j*4]=r0[k*4]; orig[j*4+1]=r0[k*4+1]; orig[j*4+2]=r0[k*4+2]; orig[j*4+3]=r0[k*4+3]; if(r0[k*4+3]>=10 && px[j*4+3]<10) removed[j]=1; } }
  const n=decontaminateEdges(px, orig, removed, w, h, 3);
  if(n){ ctx.putImageData(d,0,0); rec.artDraw=drawn; }
  return n;
}
function despeckle(c){
  const ctx=c.getContext("2d");
  const {width:w,height:h}=c;
  const d=ctx.getImageData(0,0,w,h);
  const a=d.data;
  const lab=new Int32Array(w*h);
  // Speck threshold: only true dust. The old 0.04%-of-area rule scaled to
  // hundreds of px on a normal upload and silently deleted small text.
  // Matched to sticker-sheet-lab.liquid. See AI/LAB-RULES.md rule 3.
  const minKeep=Math.max(6, w*h*0.00001);
  let n=0;
  for(let i=0;i<w*h;i++){
    if(a[i*4+3]>10 && !lab[i]){
      n++; const members=[]; const st=[i];
      while(st.length){
        const j=st.pop();
        if(j<0||j>=w*h||lab[j]||a[j*4+3]<=10) continue;
        lab[j]=n; members.push(j);
        const xx=j%w;
        st.push(j-w,j+w);
        if(xx>0) st.push(j-1);
        if(xx<w-1) st.push(j+1);
      }
      if(members.length<minKeep){ for(const j of members) a[j*4+3]=0; }
    }
  }
  ctx.putImageData(d,0,0);
}
function trim(c){
  const ctx=c.getContext("2d");
  const {width:w,height:h}=c;
  const a=ctx.getImageData(0,0,w,h).data;
  let x0=w,y0=h,x1=0,y1=0,found=false;
  for(let y=0;y<h;y++)for(let x=0;x<w;x++){
    if(a[(y*w+x)*4+3]>10){ found=true; if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; }
  }
  if(!found){ lastTrimOff={x:0,y:0}; return c; }
  /* Erase strokes are stored against `raw` (the un-keyed source), not `art`,
     because art is re-trimmed whenever removal settings change. Record the
     crop so art pixels can be converted back to raw pixels. */
  const p=2, out=mk(x1-x0+1+2*p, y1-y0+1+2*p);
  out.getContext("2d").drawImage(c, x0,y0,x1-x0+1,y1-y0+1, p,p,x1-x0+1,y1-y0+1);
  lastTrimOff={x:x0-2, y:y0-2};
  return out;
}
function silhouette(srcCanvas,color){
  const c=mk(srcCanvas.width,srcCanvas.height), x=c.getContext("2d");
  x.drawImage(srcCanvas,0,0);
  x.globalCompositeOperation="source-in";
  x.fillStyle=color; x.fillRect(0,0,c.width,c.height);
  return c;
}

/* ---------- morphology (shared) ---------- */
function mkLike(src){ return mk(src.width,src.height); }
function dilateCanvas(src,R){
  const c=mkLike(src), x=c.getContext("2d");
  x.drawImage(src,0,0);
  let remaining=Math.max(0,Math.round(R));
  while(remaining>0){
    const s=Math.min(remaining,6);
    const snap=mkLike(c); snap.getContext("2d").drawImage(c,0,0);
    for(let k=0;k<16;k++){ const a=(k/16)*Math.PI*2; x.drawImage(snap, Math.cos(a)*s, Math.sin(a)*s); }
    remaining-=s;
  }
  x.globalCompositeOperation="source-in";
  x.fillStyle="#fff"; x.fillRect(0,0,c.width,c.height);
  return c;   // NOT hardened here - see hardenAlpha, it must run ONCE at the end
}
/* Dilation stamps are drawn at FRACTIONAL offsets, so each is bilinear-resampled and
   its edge lands half-transparent. Sixteen stacked, repeatedly, leave a multi-pixel
   partial-alpha ramp instead of an edge. Filled with the border colour that is
   white-at-partial-alpha, which over a darker page reads as a grey rim. Harden it.
   AI/LAB-RULES.md rule 2. */
function hardenAlpha(c, cut){
  cut = cut==null ? 96 : cut;
  const x=c.getContext("2d");
  const d=x.getImageData(0,0,c.width,c.height), a=d.data;
  for(let i=3;i<a.length;i+=4) a[i] = a[i]>=cut ? 255 : 0;
  x.putImageData(d,0,0);
  return c;
}
function invert(src){
  const c=mkLike(src), x=c.getContext("2d");
  x.fillStyle="#fff"; x.fillRect(0,0,c.width,c.height);
  x.globalCompositeOperation="destination-out";
  x.drawImage(src,0,0);
  return c;
}
function padCanvas(src,p){ const c=mk(src.width+2*p,src.height+2*p); c.getContext("2d").drawImage(src,p,p); return c; }
function cropCanvas(src,p,w,h){ const c=mk(w,h); c.getContext("2d").drawImage(src,-p,-p); return c; }
function fillHoles(c){
  const x=c.getContext("2d");
  const {width:w,height:h}=c;
  const d=x.getImageData(0,0,w,h);
  const a=d.data;
  const outside=new Uint8Array(w*h);
  const stack=[];
  for(let i=0;i<w;i++){ stack.push(i,(h-1)*w+i); }
  for(let i=0;i<h;i++){ stack.push(i*w,i*w+w-1); }
  while(stack.length){
    const i=stack.pop();
    if(i<0||i>=w*h||outside[i]) continue;
    if(a[i*4+3]>120) continue;
    outside[i]=1;
    const xx=i%w;
    stack.push(i-w,i+w);
    if(xx>0) stack.push(i-1);
    if(xx<w-1) stack.push(i+1);
  }
  for(let i=0;i<w*h;i++){ if(!outside[i]){ a[i*4]=255;a[i*4+1]=255;a[i*4+2]=255;a[i*4+3]=255; } }
  x.putImageData(d,0,0);
}
function boxPassH(src,dst,w,h,r){
  const win=2*r+1;
  for(let y=0;y<h;y++){
    const row=y*w; let sum=0;
    for(let x=-r;x<=r;x++) sum+=x>=0&&x<w? src[row+x]:0;
    for(let x=0;x<w;x++){ dst[row+x]=sum/win; const add=x+r+1, sub=x-r; sum+=(add<w?src[row+add]:0)-(sub>=0?src[row+sub]:0); }
  }
}
function boxPassV(src,dst,w,h,r){
  const win=2*r+1;
  for(let x=0;x<w;x++){
    let sum=0;
    for(let y=-r;y<=r;y++) sum+=y>=0&&y<h? src[y*w+x]:0;
    for(let y=0;y<h;y++){ dst[y*w+x]=sum/win; const add=y+r+1, sub=y-r; sum+=(add<h?src[add*w+x]:0)-(sub>=0?src[sub*w+x]:0); }
  }
}
function smoothMask(c,K){
  K=Math.round(K);
  if(K<1) return c;
  const p=K+6;
  const padded=padCanvas(c,p);
  const {width:w,height:h}=padded;
  const px=padded.getContext("2d").getImageData(0,0,w,h);
  let a=new Float32Array(w*h), b=new Float32Array(w*h);
  for(let i=0;i<w*h;i++) a[i]=px.data[i*4+3];
  const r=Math.max(1,Math.round(K/2));
  for(let t=0;t<3;t++){ boxPassH(a,b,w,h,r); boxPassV(b,a,w,h,r); }
  const out=mk(w,h);
  const od=out.getContext("2d").createImageData(w,h);
  for(let i=0;i<w*h;i++){ if(a[i]>=128){ od.data[i*4]=255;od.data[i*4+1]=255;od.data[i*4+2]=255;od.data[i*4+3]=255; } }
  out.getContext("2d").putImageData(od,0,0);
  return cropCanvas(out,p,c.width,c.height);
}
function recolour(maskCanvas,color){
  const c=mkLike(maskCanvas), x=c.getContext("2d");
  x.drawImage(maskCanvas,0,0);
  x.globalCompositeOperation="source-in";
  x.fillStyle=color; x.fillRect(0,0,c.width,c.height);
  return c;
}
/* ---------- contour + simplify (shared) ---------- */
/* ---------- SIMPLIFY (P136, 17 Sep 2026) ----------
   Illustrator's Simplify for traced cut lines: keep the shape, keep only the
   nodes that are needed, and join them with CURVES, not straight lines. The
   old path (rdp then chaikin) joined nodes with straight segments, so curves
   came out as flat sides ("octagon", Thomas 17 Sep), and chaikin rounds real
   corners. Fitted to the RAW trace, never to an already-thinned polyline.
   Measured on his fish artwork through this lab's own mask+trace:
   92 straight nodes -> 25 curve nodes, within 0.15mm (Adobe: 15-33).
   v2, 17 Sep: straight edges are found first and emitted as exact lines, and the corner
   between two edges is a true circular arc sized to the trace ("any 90 degree angle ...
   a perfectly smooth corner radius, fit to size", Thomas). Test shape: 19 nodes with
   curves bowing 0.18mm off a circle -> 9 nodes, 3 exact arcs, edges dead straight.
   Shared verbatim by Sticker Sheet Lab, Proof Lab and Bookmark Lab. */
const SIMPLIFY_SMOOTH_MM = 0.3;   /* moving average over the trace: removes pixel noise, not shape */
const SIMPLIFY_TOL_MM    = 0.15;  /* max distance from the traced outline; blade is 0.25mm */
const smpSub=(a,b)=>[a[0]-b[0],a[1]-b[1]], smpAdd=(a,b)=>[a[0]+b[0],a[1]+b[1]],
      smpScl=(a,s)=>[a[0]*s,a[1]*s], smpDot=(a,b)=>a[0]*b[0]+a[1]*b[1],
      smpLen=a=>Math.hypot(a[0],a[1]),
      smpNorm=a=>{ const l=smpLen(a); return l>1e-12?[a[0]/l,a[1]/l]:[0,0]; };
const smpBez=(ctrl,t)=>{ let p=ctrl.map(q=>q.slice()); while(p.length>1){ const n=[]; for(let i=0;i<p.length-1;i++) n.push([p[i][0]+(p[i+1][0]-p[i][0])*t, p[i][1]+(p[i+1][1]-p[i][1])*t]); p=n; } return p[0]; };
function smpFitOpen(pts, err, tStart, tEnd){
  /* open polyline -> cubic segments [p0,c1,c2,p3]; err = max deviation, mm */
  const p=[];
  for(const q of pts) if(!p.length||q[0]!==p[p.length-1][0]||q[1]!==p[p.length-1][1]) p.push(q);
  if(p.length<2) return [];
  const errSq=err*err, iterSq=errSq*4, out=[];
  const chordParam=(a,b)=>{
    const u=[0];
    for(let i=a+1;i<=b;i++) u.push(u[i-a-1]+smpLen(smpSub(p[i],p[i-1])));
    const tot=u[u.length-1]||1;
    return u.map(v=>v/tot);
  };
  const genBezier=(a,b,u,t1,t2)=>{
    /* least-squares alphas along the fixed end tangents */
    let c00=0,c01=0,c11=0,x0=0,x1=0;
    for(let i=a;i<=b;i++){
      const t=u[i-a], w=1-t;
      const A0=smpScl(t1,3*t*w*w), A1=smpScl(t2,3*t*t*w);
      c00+=smpDot(A0,A0); c01+=smpDot(A0,A1); c11+=smpDot(A1,A1);
      const tmp=smpSub(p[i],smpAdd(smpScl(p[a],w*w*w+3*t*w*w),smpScl(p[b],t*t*t+3*t*t*w)));
      x0+=smpDot(A0,tmp); x1+=smpDot(A1,tmp);
    }
    const det=c00*c11-c01*c01, chord=smpLen(smpSub(p[b],p[a]));
    let a1=det?(x0*c11-x1*c01)/det:0, a2=det?(c00*x1-c01*x0)/det:0;
    /* degenerate least squares: fall back to the Wu-Barsky heuristic */
    if(!isFinite(a1)||!isFinite(a2)||a1<1e-6*chord||a2<1e-6*chord||a1>chord*3||a2>chord*3) a1=a2=chord/3;
    return [p[a],smpAdd(p[a],smpScl(t1,a1)),smpAdd(p[b],smpScl(t2,a2)),p[b]];
  };
  const maxErr=(a,b,bz,u)=>{
    let m=0, split=(a+b)>>1;
    for(let i=a+1;i<b;i++){
      const e=smpSub(smpBez(bz,u[i-a]),p[i]), d2=smpDot(e,e);
      if(d2>m){ m=d2; split=i; }
    }
    return [m,split];
  };
  const reparam=(a,b,u,bz)=>{
    /* one newton-raphson step per point toward the closest curve parameter */
    const d1=[0,1,2].map(i=>smpScl(smpSub(bz[i+1],bz[i]),3));
    const d2=[0,1].map(i=>smpScl(smpSub(d1[i+1],d1[i]),2));
    return u.map((t,i)=>{
      const diff=smpSub(smpBez(bz,t),p[a+i]);
      const q1=smpBez(d1,t), q2=smpBez(d2,t);
      const den=smpDot(q1,q1)+smpDot(diff,q2);
      return den?Math.max(0,Math.min(1,t-smpDot(diff,q1)/den)):t;
    });
  };
  let spacing=0;
  const fit=(a,b,t1,t2,depth)=>{
    if(b-a===1){
      const d3=smpLen(smpSub(p[b],p[a]))/3;
      out.push([p[a],smpAdd(p[a],smpScl(t1,d3)),smpAdd(p[b],smpScl(t2,d3)),p[b]]);
      return;
    }
    let u=chordParam(a,b);
    let bz=genBezier(a,b,u,t1,t2);
    let [e,split]=maxErr(a,b,bz,u);
    if(e<=errSq){ out.push(bz); return; }
    if(e<=iterSq){ /* close enough that reparameterising may rescue one cubic */
      for(let i=0;i<4;i++){
        u=reparam(a,b,u,bz);
        bz=genBezier(a,b,u,t1,t2);
        [e,split]=maxErr(a,b,bz,u);
        if(e<=errSq){ out.push(bz); return; }
      }
    }
    if(depth>40){ out.push(bz); return; }
    /* split at the worst point; tangent there from its neighbours */
    /* tangent at the split from about 0.4mm either side, not the immediate
       neighbours: on a dense trace one-point tangents are noise, and noisy
       tangents are what made straight edges wander (Thomas, 17 Sep) */
    const kw=Math.max(1,Math.min(split-a,b-split,Math.round(0.4/(spacing||0.4))));
    const tc=smpNorm(smpSub(p[split-kw],p[split+kw]));
    fit(a,split,t1,tc,depth+1);
    fit(split,b,smpScl(tc,-1),t2,depth+1);
  };
  for(let i=1;i<p.length;i++) spacing+=smpLen(smpSub(p[i],p[i-1])); spacing/=Math.max(1,p.length-1);
  fit(0,p.length-1, tStart||smpNorm(smpSub(p[1],p[0])), tEnd||smpNorm(smpSub(p[p.length-2],p[p.length-1])), 0);
  return out;
}
function smpFitClosed(pts, err){
  /* closed ring (start not repeated) -> closed loop of cubic segments */
  const p=[];
  for(const q of pts) if(!p.length||q[0]!==p[p.length-1][0]||q[1]!==p[p.length-1][1]) p.push(q);
  while(p.length>1&&p[0][0]===p[p.length-1][0]&&p[0][1]===p[p.length-1][1]) p.pop();
  const n=p.length;
  if(n<3) return [];
  /* turn angle measured two points out so single-pixel jitter can't fake a corner */
  const turn=i=>{
    const a=smpNorm(smpSub(p[i],p[(i-2+n)%n])), b=smpNorm(smpSub(p[(i+2)%n],p[i]));
    return Math.acos(Math.max(-1,Math.min(1,smpDot(a,b))));
  };
  const SHARP=Math.PI/3;
  /* a pixel trace smears one corner over a few points: cluster neighbouring
     hits and keep the sharpest of each cluster */
  const corners=[];
  for(let i=0;i<n;i++){
    const a=turn(i);
    if(a<=SHARP) continue;
    const last=corners[corners.length-1];
    if(last&&i-last[0]<=2){ if(a>last[1]){ last[0]=i; last[1]=a; } }
    else corners.push([i,a]);
  }
  if(corners.length>1){
    const f=corners[0], l=corners[corners.length-1];
    if(f[0]+n-l[0]<=2){ if(l[1]>f[1]){ f[0]=l[0]; f[1]=l[1]; } corners.pop(); }
  }
  if(!corners.length){
    /* no true corner: seam anywhere - the end tangents agree, so the join stays smooth */
    return smpFitOpen(p.concat([p[0]]),err);
  }
  /* seam at the sharpest corner, split at every corner: corners stay corners */
  const rot=corners.reduce((m,c)=>c[1]>m[1]?c:m)[0];
  const q=p.slice(rot).concat(p.slice(0,rot));
  const idxs=corners.map(c=>(c[0]-rot+n)%n).sort((x,y)=>x-y);
  const out=[];
  for(let k=0;k<idxs.length;k++){
    const a=idxs[k], b=k+1<idxs.length?idxs[k+1]:n;
    const run=[];
    for(let i=a;i<=b;i++) run.push(q[i%n]);
    out.push(...smpFitOpen(run,err));
  }
  return out;
}


const SIMPLIFY_LINE_MIN_MM = 5;     /* shortest run treated as a straight edge. Shorter "straight" pieces are
                                       usually chords of a gentle curve: at 1.5mm a 25mm-radius curve became a
                                       chain of flats (50 nodes, octagon again). Short real edges fit fine as curves */
const SIMPLIFY_LINE_TOL_MM = 0.04;  /* how far a point may sit off that edge */
const SIMPLIFY_LINE_BOW_MM = 0.012; /* mean signed offset: a real edge scatters both sides, a curve bows one way */
function smpFillet(A1,d1,A2,B2,d2,pts,err){
  /* A perfect circular corner between two straight edges, radius fitted to the
     traced corner - "treated like we treat labels, a perfectly smooth corner
     radius, fit to size" (Thomas, 17 Sep). Growing a border around a straight-
     edged shape makes exactly this: edges joined by circular arcs. Returns
     {T1,T2,seg} or null when no arc fits within err (then a free curve is used). */
  const cr=d1[0]*d2[1]-d1[1]*d2[0], dt=Math.max(-1,Math.min(1,smpDot(d1,d2)));
  const th=Math.acos(dt);
  if(Math.abs(cr)<1e-6 || th<15*Math.PI/180 || th>150*Math.PI/180) return null;
  /* V = where the two edge lines meet */
  const w=smpSub(A2,A1), s1=(w[0]*d2[1]-w[1]*d2[0])/cr, V=smpAdd(A1,smpScl(d1,s1));
  const side=cr>0?1:-1, n1=[-d1[1]*side, d1[0]*side];
  const tanH=Math.tan(th/2);
  const shape=r=>{ const tl=r*tanH, T1=smpSub(V,smpScl(d1,tl)), T2=smpAdd(V,smpScl(d2,tl)), C=smpAdd(T1,smpScl(n1,r)); return {tl,T1,T2,C}; };
  const dev=(r)=>{ const {T1,T2,C}=shape(r); let m=0;
    for(const p of pts){
      const s1p=smpDot(smpSub(p,T1),d1), s2p=smpDot(smpSub(p,T2),d2);
      let d;
      if(s1p<=0){ const v=smpSub(p,T1); d=Math.abs(v[0]*d1[1]-v[1]*d1[0]); }
      else if(s2p>=0){ const v=smpSub(p,T2); d=Math.abs(v[0]*d2[1]-v[1]*d2[0]); }
      else d=Math.abs(smpLen(smpSub(p,C))-r);
      if(d>m) m=d; }
    return m; };
  /* the radius can't run past either edge's own start */
  /* the arc may not run back past either edge's far end */
  const rLim=Math.max(0,Math.min(smpDot(smpSub(V,A1),d1), smpDot(smpSub(B2,V),d2)))/tanH;
  if(!(rLim>0)) return null;
  let lo=0, hi=rLim;
  for(let k=0;k<60;k++){ const m1=lo+(hi-lo)/3, m2=hi-(hi-lo)/3; if(dev(m1)<=dev(m2)) hi=m2; else lo=m1; }
  const r=(lo+hi)/2, e=dev(r);
  if(!(e<=err) || !(r>1e-4)) return null;
  const {T1,T2}=shape(r), h=(4/3)*Math.tan(th/4)*r;
  return {T1,T2,r,dev:e,seg:[T1, smpAdd(T1,smpScl(d1,h)), smpSub(T2,smpScl(d2,h)), T2]};
}
function smpFitClosedLines(P, err){
  /* STRAIGHT EDGES FIRST, CORNERS AS TRUE ARCS (Thomas, 17 Sep: "look at these
     edges"; "any 90 degree angle ... a perfectly smooth corner radius, fit to
     size"). Curves had been fitted straight across the join between an edge and
     its corner, so edges wandered 0.1mm and corners bowed. Now: find every
     straight run and emit it as an exact line; between two runs try a circular
     fillet tangent to both; only if no arc fits, fit free curves with their end
     tangents pinned to the edges. */
  const n=P.length;
  if(n<16) return smpFitClosed(P,err);
  let per=0; for(let i=0;i<n;i++) per+=smpLen(smpSub(P[(i+1)%n],P[i]));
  const sp=per/n, w=Math.max(2,Math.round(0.5/sp));
  let r0=0, best=-1;
  for(let i=0;i<n;i++){
    const a=smpNorm(smpSub(P[i],P[(i-w+n)%n])), b=smpNorm(smpSub(P[(i+w)%n],P[i]));
    const t=1-smpDot(a,b); if(t>best){ best=t; r0=i; }
  }
  const Q=P.slice(r0).concat(P.slice(0,r0));
  const offLine=(i,j)=>{
    const A=Q[i], D=smpSub(Q[j],A), L=smpLen(D); if(L<1e-9) return 0;
    let m=0, sum=0; for(let k=i+1;k<j;k++){ const v=smpSub(Q[k],A), sd=(v[0]*D[1]-v[1]*D[0])/L; sum+=sd; m=Math.max(m,Math.abs(sd)); }
    const bow=j-i>1?Math.abs(sum/(j-i-1)):0;
    return bow>SIMPLIFY_LINE_BOW_MM ? Infinity : m;
  };
  const runs=[];
  const minPts=Math.max(4,Math.round(SIMPLIFY_LINE_MIN_MM/sp));
  let i=0;
  while(i<n-minPts){
    let j=i+minPts;
    if(offLine(i,j)>SIMPLIFY_LINE_TOL_MM){ i++; continue; }
    let step=minPts;
    while(step>=1){ const t=j+step; if(t<n && offLine(i,t)<=SIMPLIFY_LINE_TOL_MM) j=t; else step>>=1; }
    runs.push([i,j]); i=j+1;
  }
  for(let k=runs.length-1;k>0;k--){
    const a=runs[k-1], b=runs[k];
    if(b[0]-a[1]<=Math.max(3,Math.round(0.3/sp)) && offLine(a[0],b[1])<=SIMPLIFY_LINE_TOL_MM){ a[1]=b[1]; runs.splice(k,1); }
  }
  if(!runs.length) return smpFitClosed(P,err);
  const R=runs.length;
  const dir=r=>smpNorm(smpSub(Q[r[1]],Q[r[0]]));
  const curvePts=k=>{ const r=runs[k], nx=runs[(k+1)%R], to=(k+1<R)?nx[0]:nx[0]+n, c=[]; for(let q=r[1];q<=to;q++) c.push(Q[q%n]); return c; };
  /* decide every corner first, because a fillet moves the ends of both edges */
  const corner=[];
  for(let k=0;k<R;k++){
    const r=runs[k], nx=runs[(k+1)%R];
    corner.push(smpFillet(Q[r[0]],dir(r),Q[nx[0]],Q[nx[1]],dir(nx),curvePts(k),err));
  }
  /* an edge must still have positive length after both its corners trim it */
  for(let k=0;k<R;k++){
    const pv=corner[(k-1+R)%R], cu=corner[k], r=runs[k], d=dir(r), A=Q[r[0]];
    const s0=pv?smpDot(smpSub(pv.T2,A),d):0, s1=cu?smpDot(smpSub(cu.T1,A),d):smpDot(smpSub(Q[r[1]],A),d);
    if(s1-s0<0.05){ if(cu&&(!pv||cu.r>=pv.r)) corner[k]=null; else corner[(k-1+R)%R]=null; }
  }
  const out=[];
  for(let k=0;k<R;k++){
    const r=runs[k], nx=runs[(k+1)%R], pv=corner[(k-1+R)%R], cu=corner[k], d=dir(r);
    const S=pv?pv.T2:Q[r[0]], E=cu?cu.T1:Q[r[1]], L=smpLen(smpSub(E,S));
    out.push([S, smpAdd(S,smpScl(d,L/3)), smpSub(E,smpScl(d,L/3)), E]);
    if(cu){ out.push(cu.seg); continue; }
    const cur=curvePts(k);
    if(cur.length<2) continue;
    if(cur.length===2){ const a=cur[0], b=cur[1], dd=smpLen(smpSub(b,a))/3;
      out.push([a, smpAdd(a,smpScl(d,dd)), smpSub(b,smpScl(dir(nx),dd)), b]); continue; }
    for(const sg of smpFitOpen(cur, err, d, smpScl(dir(nx),-1))) out.push(sg);
  }
  return out;
}
function simplifyTrace(ptsPx, pxPerMm){
  /* closed traced contour in pixels -> cubic segments [[p0,c1,c2,p3],...] in pixels */
  const n=ptsPx.length;
  if(n<8) return null;
  /* a zero or non-finite scale makes the smoothing window infinite and the loop never ends */
  if(!(pxPerMm>0) || !isFinite(pxPerMm)) return null;
  const mm=ptsPx.map(p=>[p[0]/pxPerMm,p[1]/pxPerMm]);
  let per=0; for(let i=1;i<n;i++) per+=smpLen(smpSub(mm[i],mm[i-1]));
  const h=Math.max(1,Math.round(SIMPLIFY_SMOOTH_MM/(per/n)/2));
  const sm=mm.map((_,i)=>{ let x=0,y=0; for(let k=-h;k<=h;k++){ const q=mm[(i+k+n)%n]; x+=q[0]; y+=q[1]; } return [x/(2*h+1),y/(2*h+1)]; });
  const segs=smpFitClosedLines(sm,SIMPLIFY_TOL_MM);
  if(!segs||!segs.length) return null;
  return segs.map(s=>s.map(p=>[p[0]*pxPerMm,p[1]*pxPerMm]));
}
function simplifyPathD(segs, map, dp){
  /* map: [x,y] px -> [X,Y] output units; dp: decimals */
  const f=v=>v.toFixed(dp==null?2:dp);
  const P=p=>{ const q=map(p); return f(q[0])+" "+f(q[1]); };
  let d="M"+P(segs[0][0]);
  for(const s of segs) d+=" C"+P(s[1])+" "+P(s[2])+" "+P(s[3]);
  return d+" Z";
}
/* ---------- /SIMPLIFY ---------- */
function traceContour(maskCanvas){
  const {width:w,height:h}=maskCanvas;
  const a=maskCanvas.getContext("2d").getImageData(0,0,w,h).data;
  const solid=(x,y)=> x>=0&&y>=0&&x<w&&y<h&&a[(y*w+x)*4+3]>128;
  let sx=-1,sy=-1;
  outer: for(let y=0;y<h;y++)for(let x=0;x<w;x++){ if(solid(x,y)){ sx=x; sy=y; break outer; } }
  if(sx<0) return [];
  const dirs=[[-1,0],[-1,-1],[0,-1],[1,-1],[1,0],[1,1],[0,1],[-1,1]];
  const pts=[]; let cx=sx, cy=sy, bi=0;
  const maxSteps=Math.min(w*h*4, 4000000);   /* 18 Oct 2026: a boundary past 4M points on a 2000px canvas is noise; bounds memory */
  for(let step=0;step<maxSteps;step++){
    pts.push([cx,cy]); let found=false;
    for(let k=1;k<=8;k++){
      const di=(bi+k)%8; const nx=cx+dirs[di][0], ny=cy+dirs[di][1];
      if(solid(nx,ny)){ bi=(di+6)%8; cx=nx; cy=ny; found=true; break; }
    }
    if(!found) break;
    if(cx===sx&&cy===sy&&pts.length>2) break;
  }
  return pts;
}
/* 18 Oct 2026 (customer "Page Unresponsive" on the Creator; measured in Chromium: 90 s and counting inside
   rdp() under bmArtIsRect, on a phone photo with Remove background at 25%). A noisy mask traces to a
   contour of hundreds of thousands of points and rdp's split-and-scan grows past n squared. The work is now
   bounded: a contour over RDP_MAX points is thinned evenly first, and a split that still runs past
   RDP_BUDGET point checks falls back to an even thinning. A normal design (a few thousand points) reaches
   neither bound, so its outline is byte for byte what it was. */
const RDP_MAX=60000, RDP_BUDGET=30000000;
function rdpThin(pts,n){ const k=Math.max(1,Math.ceil(pts.length/n)); if(k===1) return pts; const o=[]; for(let i=0;i<pts.length;i+=k) o.push(pts[i]); return o; }
function rdp(pts,eps){
  if(pts.length<3) return pts;
  if(pts.length>RDP_MAX) pts=rdpThin(pts,RDP_MAX);
  const keep=new Uint8Array(pts.length);
  keep[0]=keep[pts.length-1]=1;
  const stack=[[0,pts.length-1]];
  let work=0;
  while(stack.length){
    const [i,j]=stack.pop();
    if((work+=j-i)>RDP_BUDGET) return rdpThin(pts,4000);
    const [x1,y1]=pts[i],[x2,y2]=pts[j];
    const dx=x2-x1, dy=y2-y1;
    const len=Math.hypot(dx,dy)||1e-9;
    let mi=-1, md=0;
    for(let k=i+1;k<j;k++){
      const d=Math.abs(dy*pts[k][0]-dx*pts[k][1]+x2*y1-y2*x1)/len;
      if(d>md){ md=d; mi=k; }
    }
    if(md>eps){ keep[mi]=1; stack.push([i,mi],[mi,j]); }
  }
  return pts.filter((_,i)=>keep[i]);
}
function chaikin(pts,iter){
  let p=pts;
  for(let t=0;t<iter;t++){
    const q=[];
    for(let i=0;i<p.length;i++){
      const A=p[i], B=p[(i+1)%p.length];
      q.push([A[0]*0.75+B[0]*0.25, A[1]*0.75+B[1]*0.25]);
      q.push([A[0]*0.25+B[0]*0.75, A[1]*0.25+B[1]*0.75]);
    }
    p=q;
  }
  return p;
}
function maskBBox(maskCanvas){
  const {width:w,height:h}=maskCanvas;
  const a=maskCanvas.getContext("2d").getImageData(0,0,w,h).data;
  let x0=w,x1=-1,y0=h,y1=-1;
  for(let y=0;y<h;y++)for(let x=0;x<w;x++){
    if(a[(y*w+x)*4+3]>128){ if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; }
  }
  if(x1<x0) return {x:0,y:0,w:w,h:h};
  return {x:x0,y:y0,w:x1-x0+1,h:y1-y0+1};
}
/* ---------- palette ---------- */
function extractPalette(c){
  const x=c.getContext("2d");
  const {width:w,height:h}=c;
  const a=x.getImageData(0,0,w,h).data;
  const bins={};
  const step=Math.max(1,Math.floor(Math.sqrt(w*h/18000)));
  for(let y=0;y<h;y+=step)for(let xx=0;xx<w;xx+=step){
    const i=(y*w+xx)*4;
    if(a[i+3]<200) continue;
    const key=(a[i]>>4)<<8 | (a[i+1]>>4)<<4 | (a[i+2]>>4);
    let b=bins[key]; if(!b){b=bins[key]=[0,0,0,0];}
    b[0]+=a[i]; b[1]+=a[i+1]; b[2]+=a[i+2]; b[3]++;
  }
  const hex=n=>n.toString(16).padStart(2,"0");
  return Object.values(bins).sort((p,q)=>q[3]-p[3]).slice(0,6)
    .map(b=>"#"+hex(Math.round(b[0]/b[3]))+hex(Math.round(b[1]/b[3]))+hex(Math.round(b[2]/b[3])));
}
function lighten(hex){
  const m=/^#?([0-9a-f]{6})$/i.exec(hex); if(!m) return hex;
  const n=parseInt(m[1],16);
  let r=((n>>16)&255)/255, g=((n>>8)&255)/255, b=(n&255)/255;
  const mx=Math.max(r,g,b), mn=Math.min(r,g,b), d=mx-mn;
  let h=0, s=0, l=(mx+mn)/2;
  if(d>0){
    s = l>0.5 ? d/(2-mx-mn) : d/(mx+mn);
    if(mx===r) h=((g-b)/d+(g<b?6:0));
    else if(mx===g) h=(b-r)/d+2;
    else h=(r-g)/d+4;
    h/=6;
  }
  // raise lightness toward a pastel, keep most of the saturation
  l = l + (1-l)*0.75;
  s = Math.min(1, s*1.5);   /* 27 Sep 2026: unclamped, the tints overflowed to 7-char hex the canvas ignored (Proof Lab found it) */
  const hue=(p,q,t)=>{ if(t<0)t+=1; if(t>1)t-=1; if(t<1/6)return p+(q-p)*6*t; if(t<1/2)return q; if(t<2/3)return p+(q-p)*(2/3-t)*6; return p; };
  let R,G,B;
  if(s===0){ R=G=B=l; }
  else{
    const q=l<0.5?l*(1+s):l+s-l*s, p=2*l-q;
    R=hue(p,q,h+1/3); G=hue(p,q,h); B=hue(p,q,h-1/3);
  }
  const h2=v=>Math.max(0,Math.min(255,Math.round(v*255))).toString(16).padStart(2,"0");
  return "#"+h2(R)+h2(G)+h2(B);
}

/* ================= BOOKMARK COMPOSITION =================
   Layout (top to bottom): TOP half (flipped) | BRIDGE | BOTTOM half (upright).
   Everything is laid out in a working pixel space scaled so the unfolded
   piece fits the template's max box. One conjoined silhouette is built from
   both halves plus a bridge rectangle, then dilated for the border and
   traced for the cut. The fold line sits at the centre of the bridge.
======================================================== */

/* scale (px per mm) chosen so the unfolded artwork fits the template box.
   Half height in mm is derived from the artwork aspect ratio and the
   template width, then doubled plus bridge to check against template height. */
const CUT_MAX = {
  portrait:  { w:55, h:150 },
  landscape: { w:65, h:135 }
};
function layoutMm(){
  if(!main) return null;
  const t=TEMPLATES[opts.orient];
  if(opts.finished){
    /* ready-made unfolded bookmark: fit the whole piece in the template box */
    const lim=CUT_MAX[opts.orient];
    const inset=(opts.border ? opts.borderMm : 0);
    const cap=sizeCaps();
    const maxArtW=Math.max(10, Math.min(lim.w,cap.w)-2*inset), maxArtH=Math.max(10, Math.min(lim.h,cap.h)-2*inset);
    let w=Math.min(t.w,maxArtW), h=w*(main.art.height/main.art.width);
    if(h>maxArtH){ w*=maxArtH/h; h=maxArtH; }
    return { halfWmm:w, halfHmm:h/2, bridgeMm:0, totalWmm:w, totalHmm:h, t };
  }
  const a=main.art;
  /* Width measured symmetrically about the optical centre. halfWmm is pinned to
     the template width, so a wider effective artwork does NOT make the bookmark
     wider - it makes it shorter, and the BOOKMARK SIZE readout follows on its
     own. bookcalling.png: 14.2cm -> 12.9cm, which is the price of the fold
     sitting on the phone instead of 2.7mm to its left. */
  const _c=centreFrac(), _M=Math.max(_c, 1-_c);
  const aw=a.width*2*_M, ah=a.height;

  // The cut line = artwork dilated by the BORDER only. The bleed sits OUTSIDE
  // the cut, on the canvas, so it must NOT be subtracted from the artwork cap
  // or the finished cut lands short of the limit.
  const inset = (opts.border ? opts.borderMm : 0);
  const lim = CUT_MAX[opts.orient];
  /* A typed size narrows these caps. Width is a TARGET - the piece comes out at
     the width asked for. Length is a MAXIMUM: the cut line follows the artwork's
     own outline, so the height it produces is set by the artwork's proportions
     and can be limited but not dictated without distorting the design. The
     BOOKMARK SIZE readout reports what actually resulted. */
  const cap = sizeCaps();
  const maxArtW = Math.max(10, Math.min(lim.w, cap.w) - 2*inset);
  const maxArtH = Math.max(10, Math.min(lim.h, cap.h) - 2*inset);

  // size each half from the width cap; height follows the artwork proportion
  let halfWmm = Math.min(t.w, maxArtW);
  let halfHmm = halfWmm*(ah/aw);

  // the bridge ADDS to the total. Only shrink if halves + bridge exceed the
  // height cap, and shrink as little as possible (cap the bridge first if it
  // alone would overflow, otherwise scale the halves down to make room).
  /* Bridge off: the halves join directly, so the outline is one rectangle with
     four corners and no inner fillets - which is what removes the corner-radius
     constraint altogether (Thomas, 8 Sep 2026). */
  let bridge = (opts.bridgeOn===false) ? 0 : opts.bridgeMm;
  /* THE BRIDGE FLOOR IS GEOMETRY, NOT JUST A SLIDER LIMIT (Thomas, 17 Sep 2026:
     "incorrect cut line" on BUYMEBOOKS). Rectangular artwork gets two fillets of
     at least 3.175mm on each side of the bridge, so the gap between the halves
     must hold 2 x 3.175mm after the border has grown into it. bridgeMinMm() said
     so, but only the slider obeyed it: with the border at 2.5mm the slider read
     11.5mm while opts.bridgeMm was still the 10mm default, the gap came out
     4.9mm, and the two 3.17mm curves overlapped - the cut ran backwards for
     1.4mm at each side of the bridge. */
  let _minBridge=0;
  /* the same half-millimetre rounding the slider's minimum uses, and written
     back, so the number on the slider is the number in the file */
  if(bridge>0){ try{ if(bmArtIsRect()) _minBridge=Math.ceil(bridgeMinMm()*2)/2; }catch(e){} }
  if(bridge<_minBridge){ bridge=_minBridge; opts.bridgeMm=_minBridge; }
  let totalH = 2*halfHmm + bridge;

  if(totalH > maxArtH){
    // try keeping the halves and trimming nothing unless we must.
    // available height for the two halves after the bridge:
    const halvesBudget = maxArtH - bridge;
    if(halvesBudget < 2*10){
      // bridge so long the halves would be tiny: cap the bridge instead
      bridge = Math.max(_minBridge, maxArtH - 2*halfHmm);
      if(2*halfHmm + bridge > maxArtH){        // the floor won: the halves give instead
        const sc=(maxArtH-bridge)/(2*halfHmm); halfWmm*=sc; halfHmm*=sc;
      }
      totalH = 2*halfHmm + bridge;
    } else {
      const scale = halvesBudget/(2*halfHmm);
      halfWmm*=scale; halfHmm*=scale;
      totalH = 2*halfHmm + bridge;
    }
  }

  return { halfWmm, halfHmm, bridgeMm:bridge, totalWmm:halfWmm, totalHmm:totalH, t };
}
function pxPerMm(){
  const L=layoutMm(); if(!L) return 8;
  // resolution: enough for 300dpi at the largest dimension, capped for perf
  const longestMm=Math.max(L.totalWmm,L.totalHmm);
  const dpiPx=longestMm/25.4*PRINT_DPI;
  const capped=Math.min(dpiPx, 2600);     // keep canvas under ~2600 on long edge
  return capped/longestMm;
}
/* flip the top half: mirror = horizontal flip, rotate = 180 rotation.
   Both leave it "upside down" relative to the bottom when later placed,
   because we additionally rotate the whole top half 180 for the fold.
   Implementation: bottom is drawn upright; top is the SAME art rotated 180
   (rotate mode) OR mirrored horizontally then flipped vertically (mirror
   mode equals a horizontal mirror after the 180 that the fold needs). */
function makeTopArt(srcArt){
  const c=mkLike(srcArt), x=c.getContext("2d");
  x.save();
  x.translate(c.width/2,c.height/2);
  x.rotate(Math.PI);                 // 180 so it reads right when folded over
  if(opts.flip==="mirror") x.scale(-1,1);   // mirror handedness for perfect fold overlap
  x.drawImage(srcArt,-srcArt.width/2,-srcArt.height/2);
  x.restore();
  return c;
}

/* narrowest solid row within the middle band of a finished piece = the fold.
   22 Sep 2026 (order 9329, Magnetlesezeichen_Vivi): the bridge strip tapered by
   0.45mm, so the single narrowest row was the chest-to-tail join under the top
   fox and the fold landed there. Rows within tolPx of the narrowest now count
   as the neck, and the fold sits at the middle of the LONGEST such run - the
   bridge - not between the first and last narrow row anywhere in the band. */
function findWaistY(maskC, y0, Hpx, tolPx){
  const w=maskC.width;
  const a=maskC.getContext("2d").getImageData(0,0,w,maskC.height).data;
  const from=y0+Math.round(Hpx*0.3), to=y0+Math.round(Hpx*0.7);
  const counts=[];
  let bestW=Infinity;
  for(let y=from;y<=to;y++){
    let cnt=0;
    for(let x=0;x<w;x++){ if(a[(y*w+x)*4+3]>128) cnt++; }
    counts.push(cnt);
    if(cnt>0 && cnt<bestW) bestW=cnt;
  }
  if(bestW===Infinity) return y0+Math.round(Hpx/2);
  const tol=Math.max(2, tolPx||0);
  let bestS=-1, bestE=-1, runS=-1;
  counts.forEach((cnt,i)=>{
    const narrow = cnt>0 && cnt<=bestW+tol;
    if(narrow){ if(runS<0) runS=i; if(i-runS > bestE-bestS){ bestS=runS; bestE=i; } }
    else runS=-1;
  });
  return from+Math.round((bestS+bestE)/2);
}
/* build the conjoined silhouette mask in working px.
   Returns {mask, layout, ppm, geo} where geo holds half/bridge px boxes. */
function buildSilhouette(){
  const L=layoutMm(); if(!L) return null;
  const ppm=pxPerMm();
  if(opts.finished){
    const W=Math.round(L.totalWmm*ppm), H=Math.round(L.totalHmm*ppm);
    const pad=Math.round(Math.max(opts.borderMm,0)*ppm)+Math.round(BLEED_MM*ppm)+8;
    const mask=mk(W+2*pad, H+2*pad);
    mask.getContext("2d").drawImage(scaledSilhouette(centredCanvas(main.art,centreFrac()),W,H,ppm), pad, pad);
    const merged=closeMask(mask, Math.round(Math.max(2, ppm*2)));
    const foldY=findWaistY(merged, pad, H, Math.round(ppm*1.0));   // 1mm: a hand-drawn strip is never ruler straight
    const geo={ pad, halfW:W, halfH:Math.round(H/2), fullH:H, bridgeH:0, bridgeW:W,
                topY:pad, bottomY:pad, W:mask.width, H:mask.height, foldY };
    return { mask:merged, layout:L, ppm, geo, topFlipped:null };
  }
  const halfW=Math.round(L.halfWmm*ppm);
  const halfH=Math.round(L.halfHmm*ppm);
  const bridgeH=Math.round(L.bridgeMm*ppm);
  const pad=Math.round(Math.max(opts.borderMm,0)*ppm)+Math.round(BLEED_MM*ppm)+8;

  const W=halfW+2*pad;
  const H=halfH+bridgeH+halfH+2*pad;
  const mask=mk(W,H);
  const mx=mask.getContext("2d");

  // place bottom (upright) and top (flipped) art silhouettes, scaled to halfW x halfH
  const bottomArt=main.art;
  const topArt = top ? top.art : main.art;
  const topFlipped=makeTopArt(topArt);

  // silhouettes scaled into the half boxes
  /* Bottom sits on its own optical centre; the top half is flipped, so ITS
     optical centre is the mirror of the bottom's. Centring each on its own
     value is what makes the two bodies line up back-to-front when folded. */
  const _cf=centreFrac();
  const sBottom=scaledSilhouette(centredCanvas(bottomArt,_cf), halfW, halfH, ppm, 0);
  const sTop=scaledSilhouette(centredCanvas(topFlipped,topCentreFrac(topFlipped)), halfW, halfH, ppm, 1);

  const topY=pad;
  const bottomY=pad+halfH+bridgeH;
  mx.drawImage(sTop, pad, topY);
  mx.drawImage(sBottom, pad, bottomY);

  /* Bridge: a solid neck that overlaps DEEP into both halves so the union
     reads as one continuous shape, not a thin strip pinched between two
     blobs. Overlap ~30% of half height into each side. Width is either the
     user's chosen mm, or an auto default of half the artwork width clamped
     to a sensible range. When bridge length is 0 the halves join directly. */
const overlap=Math.round(halfH*0.42);
  const autoWmm=Math.min(Math.max(L.halfWmm*0.5, 16), 26);
  const bridgeWmm = opts.bridgeWmm>0 ? opts.bridgeWmm : autoWmm;
  const bridgeW=Math.round(Math.min(bridgeWmm, L.halfWmm)*ppm);   // never wider than the half
  mx.fillStyle="#fff";
  const bx=pad+(halfW-bridgeW)/2;
  const by=topY+halfH-overlap;
  const bh=bridgeH+2*overlap;
  roundRectPath(mx, bx, by, bridgeW, bh, Math.min(bridgeW*0.12, ppm*2));
  mx.fill();

  // close concave notches where the neck meets each half
  let merged=closeMask(mask, Math.round(Math.max(2, ppm*2)));

  let tBox=null, bBox=null;
  try{ if(bmArtIsRect()){ tBox=maskBBox(sTop); bBox=maskBBox(sBottom); } }catch(e){}
  const geo={ pad, halfW, halfH, bridgeH, bridgeW, topY, bottomY, W, H, tBox, bBox,
              foldY: topY+halfH+bridgeH/2 };
  return { mask:merged, layout:L, ppm, geo, topFlipped };
}
/* lowest (max y) solid alpha pixel within an x-band and y-range, or null */
function lowestSolidInBand(canvas, x0, x1, y0, y1){
  const {width:w,height:h}=canvas;
  x0=Math.max(0,x0); x1=Math.min(w,x1); y0=Math.max(0,y0); y1=Math.min(h,y1);
  if(x1<=x0||y1<=y0) return null;
  const d=canvas.getContext("2d").getImageData(x0,y0,x1-x0,y1-y0).data;
  const bw=x1-x0;
  for(let yy=(y1-y0)-1; yy>=0; yy--){
    for(let xx=0; xx<bw; xx++){ if(d[(yy*bw+xx)*4+3]>40) return y0+yy; }
  }
  return null;
}
/* highest (min y) solid alpha pixel within an x-band and y-range, or null */
function highestSolidInBand(canvas, x0, x1, y0, y1){
  const {width:w,height:h}=canvas;
  x0=Math.max(0,x0); x1=Math.min(w,x1); y0=Math.max(0,y0); y1=Math.min(h,y1);
  if(x1<=x0||y1<=y0) return null;
  const d=canvas.getContext("2d").getImageData(x0,y0,x1-x0,y1-y0).data;
  const bw=x1-x0;
  for(let yy=0; yy<(y1-y0); yy++){
    for(let xx=0; xx<bw; xx++){ if(d[(yy*bw+xx)*4+3]>40) return y0+yy; }
  }
  return null;
}
/* morphological closing: dilate then erode, fills small concave gaps and
   notches without changing overall size much. */
function closeMask(src,K){
  K=Math.max(1,Math.round(K));
  const p=K+4;
  let c=padCanvas(src,p);
  c=dilateCanvas(c,K);
  c=invert(dilateCanvas(invert(c),K));   // erode = invert-dilate-invert
  fillHoles(c);
  return cropCanvas(c,p,src.width,src.height);
}
/* AUTO card background.
   The card and its 1.5mm bleed were always filled with whatever flat colour was
   picked, defaulting to white, and there was no auto option at all (Thomas,
   8 Sep 2026). Auto reads the artwork's own outer ring - the pixels that
   actually meet the trim - and uses the MEDIAN of them, so one bright element
   in a corner cannot drag the bleed off. Median for the same reason inkCentre
   uses one: a tail should not move the answer. Falls back to white when there
   is no card artwork to read. */
const _autoCardBg = new WeakMap();
function autoCardBgFor(art){
  if(!art) return "#ffffff";
  if(_autoCardBg.has(art)) return _autoCardBg.get(art);
  const W=Math.max(1,Math.min(240,art.width)), H=Math.max(1,Math.min(240,art.height));
  const c=mk(W,H), x=c.getContext("2d");
  x.drawImage(art,0,0,W,H);
  let d; try{ d=x.getImageData(0,0,W,H).data; }catch(e){ return "#ffffff"; }
  const ring=Math.max(1,Math.round(Math.min(W,H)*0.06));
  const R=[],G=[],B=[];
  for(let y=0;y<H;y++) for(let px=0;px<W;px++){
    if(px>=ring && px<W-ring && y>=ring && y<H-ring) continue;   // interior
    const i=(y*W+px)*4;
    if(d[i+3]<128) continue;                                      // transparent
    R.push(d[i]); G.push(d[i+1]); B.push(d[i+2]);
  }
  if(!R.length){ _autoCardBg.set(art,"#ffffff"); return "#ffffff"; }
  const med=a=>{ a.sort((m,n)=>m-n); return a[a.length>>1]; };
  const hex="#"+[med(R),med(G),med(B)].map(v=>v.toString(16).padStart(2,"0")).join("");
  _autoCardBg.set(art,hex);
  return hex;
}
/* One reader for the card fill, so preview and export can never disagree. */
function cardBgNow(){
  if(opts.cardBgMode!=="auto") return opts.cardBg;
  return autoCardBgFor(card && card.art);
}
/* the uploaded card picture with its bleed (hotfix 1, 18 Oct 2026): the picture covers the trim box exactly; Auto
   stretches each edge row / column 1.5 mm outward and fills each corner from its corner pixel, Solid paints the band
   the card colour. The card colour goes down first (LAB-RULES rule 1), so a transparent picture is never on white. */
const _cardUpBleed=new WeakMap();
function cardUploadBleed(a,cw,ch,b){
  const bg=cardBgNow(), key=cw+"x"+ch+":"+b+":"+opts.cardBgMode+":"+bg;
  const hit=_cardUpBleed.get(a); if(hit && hit.key===key) return hit.c;
  const face=mk(cw,ch), fx=face.getContext("2d");
  fx.fillStyle=bg; fx.fillRect(0,0,cw,ch);
  const sc=Math.max(cw/a.width, ch/a.height), dw=a.width*sc, dh=a.height*sc;
  fx.imageSmoothingQuality="high"; fx.drawImage(a,(cw-dw)/2,(ch-dh)/2,dw,dh);
  const c=mk(cw+2*b, ch+2*b), x=c.getContext("2d");
  if(b>0){
    if(opts.cardBgMode==="auto"){
      x.imageSmoothingEnabled=false;
      x.drawImage(face,0,0,cw,1, b,0,cw,b);              /* top row up */
      x.drawImage(face,0,ch-1,cw,1, b,b+ch,cw,b);        /* bottom row down */
      x.drawImage(face,0,0,1,ch, 0,b,b,ch);              /* left column out */
      x.drawImage(face,cw-1,0,1,ch, b+cw,b,b,ch);        /* right column out */
      x.drawImage(face,0,0,1,1, 0,0,b,b);                /* corners: the corner pixel */
      x.drawImage(face,cw-1,0,1,1, b+cw,0,b,b);
      x.drawImage(face,0,ch-1,1,1, 0,b+ch,b,b);
      x.drawImage(face,cw-1,ch-1,1,1, b+cw,b+ch,b,b);
      x.imageSmoothingEnabled=true;
    } else { x.fillStyle=opts.cardBg; x.fillRect(0,0,c.width,c.height); }
  }
  x.drawImage(face,b,b);
  _cardUpBleed.set(a,{key,c});
  return c;
}
/* ---------- optical centre ----------
   The bounding-box centre is NOT the centre of a design. One thin appendage - a
   telephone wire, a trailing ribbon, a stray sparkle - drags the box sideways
   while the mass of the artwork stays put, and the fold then lands off the body.
   Measured on a real order 25 Aug 2026 (bookcalling.png, a phone on a book
   stack with a curly wire): the bbox centre and the optical centre are 5.3% of
   the artwork width apart - 2.7mm on a 55mm bookmark, and plainly visible.
   MEDIAN of the column ink mass, not the mean: a long thin tail barely moves a
   median. Measured three ways on that file - centroid +4.7%, median +5.3%,
   eroded core +5.0% - so the choice of measure is not what matters; using the
   bbox is. Cached per canvas; the artwork only changes on upload. */
const _inkCentre = new WeakMap();
function inkCentreFrac(art){
  if(!art) return 0.5;
  if(_inkCentre.has(art)) return _inkCentre.get(art);
  let f = 0.5;
  try{
    const W = Math.min(400, art.width);
    const H = Math.max(1, Math.round(art.height * W / art.width));
    const c = mk(W, H), x = c.getContext("2d");
    x.drawImage(art, 0, 0, W, H);
    const d = x.getImageData(0, 0, W, H).data;
    const col = new Float64Array(W);
    let tot = 0;
    for(let y=0; y<H; y++) for(let px=0; px<W; px++){
      const a = d[(y*W+px)*4+3];
      if(a > 25){ col[px] += a; tot += a; }
    }
    if(tot > 0){
      let run = 0;
      for(let px=0; px<W; px++){ run += col[px]; if(run >= tot/2){ f = (px+0.5)/W; break; } }
    }
  }catch(e){ console.warn("ink centre fallback:", e); }
  _inkCentre.set(art, f);
  return f;
}
/* The centre the fold should sit on: measured unless the customer has moved the
   Artwork Centre slider, in which case theirs wins. One value, one owner. */
function centreFrac(){
  /* A FINISHED bookmark is laid out by its designer - both halves, the bridge
     and the fold are already where they belong - so there is no optical centre
     to find. Centring it anyway padded the artwork out to a symmetric box and
     then fitted THAT to the size limit: the asymmetric boot (IMG_2651, 17 Sep
     2026) came out 3.3cm wide inside a 4.3cm allowance, and the width-on-card
     slider read 6.5cm against a bookmark half that size. */
  if(opts.finished) return 0.5;
  return (opts.artCentre == null) ? inkCentreFrac(main && main.art)
                                  : Math.min(0.95, Math.max(0.05, opts.artCentre));
}
/* Where the TOP half's optical centre lands. makeTopArt rotates 180, which
   mirrors x to 1-c - but in mirror mode it also applies scale(-1,1), and the two
   x-flips cancel, leaving the centre at c. Assuming 1-c in both modes centred
   mirror the wrong way: auto-centre looked like it simply did not fire when you
   switched to Mirror. Thomas, 25 Aug 2026. When the measurement owns the value
   the top canvas is measured directly, so any future transform is handled by
   construction rather than by another assumption. */
function topCentreFrac(topCanvas){
  if(opts.artCentre == null) return inkCentreFrac(topCanvas);
  const v=centreFrac();
  return (opts.flip==="mirror") ? v : (1-v);
}
/* The artwork on a canvas that is SYMMETRIC about `frac`, so anything that fits
   it into a box lands that point at the box centre. Nothing is ever cropped -
   the canvas grows on the short side instead, which is why the finished
   bookmark comes out shorter rather than clipped. */
function centredCanvas(art, frac){
  const c = (frac == null) ? 0.5 : frac;
  const M = Math.max(c, 1-c);
  const W = Math.round(art.width * 2 * M);
  if(W <= art.width + 1) return art;      // already symmetric: nothing to do
  const out = mk(W, art.height);
  out.getContext("2d").drawImage(art, Math.round((M - c) * art.width), 0);
  return out;
}
/* ay places a design shorter than its slot: 0.5 centres it, 1 sits it at the slot's foot, 0 at its head.
   The halves pass the FOLD side (top half 1, bottom half 0), so two designs of different proportions both
   meet the bridge and the shorter one simply ends sooner. Centred, the customer's 5.9mm-short top half sat
   2.9mm further from the fold than the bottom half, so the folded halves did not line up (9 Oct 2026). */
function scaledSilhouette(art, w, h, ppm, ay){
  // contain the art into w x h, then make a white silhouette of it
  const c=mk(w,h), x=c.getContext("2d");
  const sc=Math.min(w/art.width, h/art.height);
  const dw=art.width*sc, dh=art.height*sc;
  x.imageSmoothingQuality="high";
  x.drawImage(art, (w-dw)/2, (h-dh)*(ay==null?0.5:ay), dw, dh);
  x.globalCompositeOperation="source-in";
  x.fillStyle="#fff"; x.fillRect(0,0,w,h);
  /* hardened like Proof Lab's mask0 (>=96 alpha is ink). Unhardened, faint
     specks stack to solid under the border dilation: order 9329's moon file
     carries ~38k pixels at alpha 1-95, two faint lines down the canvas edges,
     and with a 2mm border the finished piece closed into a rectangle. */
  return dropSpecks(hardenAlpha(c), ppm);
}
/* Specks are not part of the piece. The same moon file has hardened fragments
   of those edge lines (a 6mm sliver, a dozen dots) well clear of the artwork;
   grown by the border they became floating blobs and chunks bolted onto the
   outline, and the fold line ran out to one of them. Any separate island under
   0.5% of the biggest one leaves the SILHOUETTE only - the artwork layer is
   never touched (AI/_rules/LAB-RULES.md rule 3), so a speck the customer really
   wants stays printed, it just does not steer the cut. */
function dropSpecks(maskC, ppm){
  /* v11.7 (26 Sep 2026, customer fault): the 0.5%-of-the-biggest-island rule from v11.6 also dropped every
     detached letter and star of a bookmark (words above and below a cat, sparkles round it), so the cut ran
     through them while the print kept them. A speck is now judged by its PHYSICAL size, not by the body:
       tiny      under 0.6 mm2 (a dot);
       hairline  narrower than 0.35 mm on its short side AND clear of everything substantial by more than
                 3 mm (order 9329's hardened edge-line fragments: a 6 x 0.15 mm sliver at the canvas edge).
     A letter, however thin, sits within a word, so it stays; a star of any size stays; an "i" dot that is
     dropped still lands inside the cut because the border grows from the stem next to it. Without a scale
     (no ppm) only islands under 0.05% of the biggest one go. The artwork layer is never touched (LAB-RULES 3). */
  try{
    const w=maskC.width, h=maskC.height, x=maskC.getContext("2d");
    const img=x.getImageData(0,0,w,h), a=img.data, n=w*h;
    const lab=new Int32Array(n), st=new Int32Array(n), isl=[null];
    let id=0;
    for(let i=0;i<n;i++){
      if(lab[i] || a[i*4+3]<128) continue;
      id++; let sp=0, cnt=0, x0=w, x1=0, y0=h, y1=0; st[sp++]=i; lab[i]=id;
      while(sp){
        const p=st[--sp]; cnt++;
        const px=p%w, py=(p/w)|0;
        if(px<x0) x0=px; if(px>x1) x1=px; if(py<y0) y0=py; if(py>y1) y1=py;
        if(px>0   && !lab[p-1] && a[(p-1)*4+3]>=128){ lab[p-1]=id; st[sp++]=p-1; }
        if(px<w-1 && !lab[p+1] && a[(p+1)*4+3]>=128){ lab[p+1]=id; st[sp++]=p+1; }
        if(p>=w   && !lab[p-w] && a[(p-w)*4+3]>=128){ lab[p-w]=id; st[sp++]=p-w; }
        if(p<n-w  && !lab[p+w] && a[(p+w)*4+3]>=128){ lab[p+w]=id; st[sp++]=p+w; }
      }
      isl.push({ n:cnt, x0, x1, y0, y1 });
    }
    if(id<2) return maskC;
    const drop=new Uint8Array(id+1);
    const px=(ppm>0 && isFinite(ppm)) ? ppm : 0;
    if(px){
      const tiny=0.6*px*px, hair=0.35*px, near=3*px, solid=1.5*px*px, thick=0.8*px;
      const big=[]; for(let k=1;k<=id;k++){ const s=isl[k]; if(s.n>=solid || Math.min(s.x1-s.x0+1,s.y1-s.y0+1)>=thick) big.push(s); }
      const gap=(s,t)=>Math.max(0, t.x0-s.x1-1, s.x0-t.x1-1) + Math.max(0, t.y0-s.y1-1, s.y0-t.y1-1);
      for(let k=1;k<=id;k++){
        const s=isl[k], side=Math.min(s.x1-s.x0+1, s.y1-s.y0+1);
        if(s.n<tiny){ drop[k]=1; continue; }
        if(side<hair){ let close=false; for(const t of big){ if(t!==s && gap(s,t)<=near){ close=true; break; } } if(!close) drop[k]=1; }
      }
    } else {
      let biggest=0; for(let k=1;k<=id;k++) if(isl[k].n>biggest) biggest=isl[k].n;
      const floor=biggest*0.0005;
      for(let k=1;k<=id;k++) if(isl[k].n<floor) drop[k]=1;
    }
    let dropped=0;
    for(let i=0;i<n;i++){ const L=lab[i]; if(L && drop[L]){ a[i*4+3]=0; dropped++; } }
    if(dropped) x.putImageData(img,0,0);
    return maskC;
  }catch(e){ console.warn("speck filter skipped:", e); return maskC; }
}
function scaledArt(art, w, h, ay){
  const c=mk(w,h), x=c.getContext("2d");
  const sc=Math.min(w/art.width, h/art.height);
  const dw=art.width*sc, dh=art.height*sc;
  x.imageSmoothingQuality="high";
  x.drawImage(art, (w-dw)/2, (h-dh)*(ay==null?0.5:ay), dw, dh);
  return c;
}

/* islands of a mask (alpha over 128): how many, and the box round all of them (v11.7) */
let bmIslandFallback=false;
function islandBox(c){
  const w=c.width, h=c.height, a=c.getContext("2d").getImageData(0,0,w,h).data, n=w*h;
  const lab=new Uint8Array(n), st=new Int32Array(n);
  let count=0, x0=w, y0=h, x1=-1, y1=-1;
  for(let i=0;i<n;i++){
    if(lab[i] || a[i*4+3]<=128) continue;
    count++; let sp=0; st[sp++]=i; lab[i]=1;
    while(sp){
      const p=st[--sp], px=p%w, py=(p/w)|0;
      if(px<x0) x0=px; if(px>x1) x1=px; if(py<y0) y0=py; if(py>y1) y1=py;
      if(px>0   && !lab[p-1] && a[(p-1)*4+3]>128){ lab[p-1]=1; st[sp++]=p-1; }
      if(px<w-1 && !lab[p+1] && a[(p+1)*4+3]>128){ lab[p+1]=1; st[sp++]=p+1; }
      if(p>=w   && !lab[p-w] && a[(p-w)*4+3]>128){ lab[p-w]=1; st[sp++]=p-w; }
      if(p<n-w  && !lab[p+w] && a[(p+w)*4+3]>128){ lab[p+w]=1; st[sp++]=p+w; }
    }
  }
  return { count, x0, y0, x1, y1 };
}
/* v11.7 (26 Sep 2026): traceContour follows the FIRST island it meets scanning from the top, so a piece whose
   border left anything detached (a star or a word clear of the body) was cut as that island alone: the
   customer's cut file held one 10 mm ring and no bookmark. The agreed rule (TASKS P09, close then fall back)
   applies here: if the 2 mm closing and the border still leave more than one island, the cut becomes the
   rectangle round everything, so the piece is one and nothing printed is cut through. Runs on the preview
   outline AND the export outline (buildBookmarkExport rebuilds its own), so the cut file matches the screen. */
function closeIslands(outline){
  const ib=islandBox(outline);
  if(ib.count>1){ const ox=outline.getContext("2d"); ox.fillStyle="#fff"; ox.fillRect(ib.x0,ib.y0,ib.x1-ib.x0+1,ib.y1-ib.y0+1); }
  return ib.count;
}
/* ---------- build the full bookmark scene ---------- */
function buildBookmark(){
  const S=buildSilhouette(); if(!S) return null;
  const { mask, ppm, geo } = S;
  const R = (opts.border && opts.borderMm>0) ? Math.max(2,Math.round(opts.borderMm*ppm)) : 0;
  const sPx = Math.round(opts.smoothMm*ppm);

  // dilate the conjoined mask for the border, fill holes, smooth
  let outline = R>0 ? dilateCanvas(mask,R) : copyCanvas(mask);
  fillHoles(outline);
  if(sPx>0){ outline=smoothMask(outline,sPx); fillHoles(outline); }
  bmIslandFallback=closeIslands(outline)>1;   // v11.7: one piece, see closeIslands

  // halves assembled once, so the auto-bleed base can dilate exactly what is drawn
  const halves=mk(outline.width,outline.height);
  {
    const hx=halves.getContext("2d");
    if(opts.finished){
      hx.drawImage(scaledArt(centredCanvas(bmInk(main),centreFrac()), geo.halfW, geo.fullH), geo.pad, geo.topY);
    } else {
      const topArtSrc = top ? top.art : main.art;
      const topFlipped = makeTopArt(topArtSrc);
      /* REMOVE INNER WHITE (21 Oct 2026): drawn without it, placed by the artwork with it (same centre either way) */
      const topInk = bmInk(top||main)!==topArtSrc ? makeTopArt(bmInk(top||main)) : topFlipped;
      hx.drawImage(scaledArt(centredCanvas(topInk,topCentreFrac(topFlipped)), geo.halfW, geo.halfH, 1), geo.pad, geo.topY);
      hx.drawImage(scaledArt(centredCanvas(bmInk(main),centreFrac()), geo.halfW, geo.halfH, 0), geo.pad, geo.bottomY);
    }
  }
  // coloured base = outline filled with bg (or the artwork's own dilated edges), halves on top
  const scene=mk(outline.width,outline.height);
  const x=scene.getContext("2d");
  if(opts.bgMode==="auto" && !bmHasBridge())
    x.drawImage(autoBleedAssembled(halves, outline, R+Math.round(BLEED_MM*ppm)+4),0,0);
  else
    x.drawImage(recolourBg(outline),0,0);
  x.drawImage(defringeArt(halves),0,0);

  /* A rectangular artwork gets the exact 12-corner outline; anything else is
     traced as before. bmCutSegs is kept so the cut FILE emits the identical
     geometry instead of tracing the same pixels a second time. */
  let cut=null; bmCutSegs=null;
  if(bmArtIsRect()){
    const B=Math.round(Math.max(opts.borderMm,0)*ppm);
    const g=bmOutlineSegs(geo, ppm, B);
    bmCutSegs=g.segs;
    cut=bmSegsToPath2D(g.segs);
  } else {
    let pts=traceContour(outline);
    if(pts.length>2){
      /* v11.7: chaikin cuts every corner at a quarter of the edge, so a 5-point rectangle (the island
         fallback) lost 37 mm of its long sides on screen while the export stayed square; smooth only traces
         with enough points that the cut is a fraction of a millimetre, as it is on organic shapes */
      pts=rdp(pts,1.6); if(pts.length>=16) pts=chaikin(pts,2);
      cut=new Path2D();
      cut.moveTo(pts[0][0],pts[0][1]);
      for(let i=1;i<pts.length;i++) cut.lineTo(pts[i][0],pts[i][1]);
      cut.closePath();
    }
  }
  // fold line: horizontal across the bridge centre, spanning the outline width there
  const fold=new Path2D();
  const fy=geo.foldY;
  // find left/right extent of the outline at fy
  const ext=rowExtent(outline, Math.round(fy));
  fold.moveTo(ext[0], fy);
  fold.lineTo(ext[1], fy);

  baseScene=scene; cutPath=cut; foldPath=fold; lastGeo=geo;
  try{ syncCornerUI(); syncBridgeUI(); }catch(e){}
  // sceneMm: how many mm the scene spans, for sizing exports.
  // The cut bbox longest edge maps to the layout's longest finished dimension.
  const bb=maskBBox(outline);
  sceneMm={ ppm, mmPerPx: 1/ppm, cutBB:bb, foldYpx:fy,
            cutWmm: bb.w/ppm, cutHmm: bb.h/ppm, geo };
  return scene;
}
/* The bookmark as it ends up in the hand: folded through the fold line, front
   artwork facing you, and behind it the reverse of the top half. That reverse is
   not printed, so it is plain white, and wherever the two halves disagree it
   shows past the front. Mirror in y about the fold, never a rotation. */
function buildFoldedScene(){
  if(!baseScene || !sceneMm) return null;
  const fy=Math.round(sceneMm.foldYpx||0);
  const W=baseScene.width, h=baseScene.height-fy;
  if(!(fy>0 && h>0)) return null;
  const backH=Math.min(fy, h);
  const r=Math.max(1, Math.round(W*0.0026));       // outline weight
  const blur=Math.max(4, W*0.020);
  const pad=Math.ceil(blur*1.6 + r + 2);           // room for shadow + outline
  const GREY="#d9d9e0";
  /* A solid-colour copy of a region's alpha - the silhouette of that part of the
     piece. Used for both the outline and the shadow caster, so the shadow
     follows the real shape rather than a rectangle. */
  const tint=(sx,sy,sw,sh,flip,col)=>{
    const t=mk(sw,sh), tc=t.getContext("2d");
    if(flip){ tc.translate(0,sh); tc.scale(1,-1); }
    tc.drawImage(trimmedScene(), sx, sy, sw, sh, 0, 0, sw, sh);
    tc.setTransform(1,0,0,1,0,0);
    tc.globalCompositeOperation="source-in";
    tc.fillStyle=col; tc.fillRect(0,0,sw,sh);
    return t;
  };
  const outline=(x,shape)=>{
    for(let k=0;k<16;k++){
      const a=(k/16)*Math.PI*2;
      x.drawImage(shape, pad+Math.cos(a)*r, pad+Math.sin(a)*r);
    }
  };
  const c=mk(W+2*pad, h+2*pad), x=c.getContext("2d");

  /* BACK: the reverse of the top half, mirrored through the fold. Not printed,
     so plain white - it needs both a shadow and its own outline or it vanishes
     into a white front on a white stage. */
  const backWhite=tint(0, fy-backH, W, backH, true, "#ffffff");
  const backGrey =tint(0, fy-backH, W, backH, true, GREY);
  x.save();
  x.shadowColor="rgba(26,26,32,.20)"; x.shadowBlur=blur; x.shadowOffsetY=blur*0.30;
  x.drawImage(backWhite, pad, pad);
  x.restore();
  outline(x, backGrey);
  x.drawImage(backWhite, pad, pad);

  /* FRONT: the printed half, with its own outline and shadow so it reads as
     lying ON the back rather than beside it. */
  const frontGrey=tint(0, fy, W, h, false, GREY);
  x.save();
  x.shadowColor="rgba(26,26,32,.26)"; x.shadowBlur=blur; x.shadowOffsetY=blur*0.30;
  x.drawImage(frontGrey, pad, pad);
  x.restore();
  outline(x, frontGrey);
  x.drawImage(trimmedScene(), 0, fy, W, h, pad, pad, W, h);

  /* Magnet guide over the folded piece. Same geometry the coverage check uses -
     front half, just below the fold, following the customer's drag - but in
     baseScene pixels, because here there is no card and no card scale. */
  if(opts.showMagnet){
    const ppm=sceneMm.ppm;
    const ringR=(MAGNET_SAFE_MM/2)*ppm, rr=(MAGNET_DIA_MM/2)*ppm;
    const cx=pad + W/2 + (opts.magnetOffX||0)*ppm;
    const cy=pad + ringR + 2*ppm + (opts.magnetOffY==null?0:opts.magnetOffY)*ppm;
    x.save();
    x.setLineDash([4,4]);
    x.strokeStyle="rgba(123,107,255,.95)"; x.lineWidth=Math.max(1.2, ppm*0.28);
    x.beginPath(); x.arc(cx,cy,rr,0,Math.PI*2); x.stroke();
    x.setLineDash([2,3]);
    x.strokeStyle="rgba(123,107,255,.5)";
    x.beginPath(); x.arc(cx,cy,ringR,0,Math.PI*2); x.stroke();
    x.setLineDash([]);
    x.fillStyle="rgba(123,107,255,.95)";
    x.beginPath(); x.arc(cx,cy,Math.max(2,ppm*0.6),0,Math.PI*2); x.fill();
    x.restore();
    // publish it in THIS canvas's coords so the drag can find it here too -
    // without this the pointer fell through to the stage pan
    magnetCircle={ cx, cy, r:rr, ringR, f:1, headroom:0 };
  }
  return c;
}
function copyCanvas(src){ const c=mkLike(src); c.getContext("2d").drawImage(src,0,0); return c; }
function rowExtent(canvas,y){
  const {width:w,height:h}=canvas;
  y=Math.max(0,Math.min(h-1,y));
  const a=canvas.getContext("2d").getImageData(0,y,w,1).data;
  let x0=-1,x1=-1;
  for(let x=0;x<w;x++){ if(a[x*4+3]>128){ if(x0<0)x0=x; x1=x; } }
  if(x0<0) return [0,w];
  return [x0,x1];
}

/* ---------- backing card scene ---------- */
/* Render the customer-designed card art to a canvas at the card's true size.
   Layer coordinates are stored in mm from the card's top-left trim corner, so
   the design is resolution-independent. This canvas becomes the card "art". */
/* DEAD, kept only so the nine invalidateCardDesign() call sites still read as
   intent. cardDesignCache is written at the end of buildCardDesignArt() and
   nulled here, but NOTHING EVER READS IT - verified 7 Sep 2026 by grepping
   every reference. It is not a cache, it is a variable that looks like one,
   and it cost a wrong bug report before that was checked. If a real cache is
   ever wanted here it must be keyed to the document, or it becomes the
   cross-document leak that put the wrong silhouette into four live cut files
   in August. */
let cardDesignCache=null;
function invalidateCardDesign(){ cardDesignCache=null; }
/* The designed card is authored at TRIM size, but print needs ink out to the
   bleed. Scaling the whole design up to cover the bleed is what cropped words
   off the edges: everything moved outward by ~1.5mm and the outer 1.5mm was
   cut away. Instead keep the design at its exact size and position, and fill
   ONLY the bleed band underneath it with a scaled copy - the band carries the
   right background colour/gradient and no authored element shifts.
   AI/LAB-RULES.md rule 5: the customer's dimensions are the customer's. */
function cardDesignArtBleed(){
  const inner=buildCardDesignArt();
  const bleedPx=Math.round(BLEED_MM*pxPerMm());
  if(bleedPx<=0) return inner;
  const c=mk(inner.width+2*bleedPx, inner.height+2*bleedPx), x=c.getContext("2d");
  const sc=Math.max(c.width/inner.width, c.height/inner.height);
  const dw=inner.width*sc, dh=inner.height*sc;
  x.drawImage(inner,(c.width-dw)/2,(c.height-dh)/2,dw,dh);   // under-layer fills the band
  x.drawImage(inner,bleedPx,bleedPx);                        // the design, exact size and place
  return c;
}
function buildCardDesignArt(){
  const t=TEMPLATES[opts.orient];
  const ppm=pxPerMm();
  const W=Math.round(t.cardW*ppm), H=Math.round(t.cardH*ppm);
  const c=mk(W,H), x=c.getContext("2d");
  const D=opts.cardDesign;
  // background
  if(D.bg.type==="gradient"){
    const a=(D.bg.angle||0)*Math.PI/180;
    const dx=Math.cos(a), dy=Math.sin(a);
    const x0=W/2 - dx*W/2, y0=H/2 - dy*H/2, x1=W/2 + dx*W/2, y1=H/2 + dy*H/2;
    const g=x.createLinearGradient(x0,y0,x1,y1);
    g.addColorStop(0, D.bg.from); g.addColorStop(1, D.bg.to);
    x.fillStyle=g;
  } else {
    x.fillStyle=D.bg.colour||"#ffffff";
  }
  x.fillRect(0,0,W,H);
  // grid lines: customer-controlled spacing, thickness, colour and margin inset.
  // The inset keeps the grid off the very edge so it reads like a printed panel
  // rather than running into the bleed.
  const G = D.grid;
  if(G && G.on){
    const step=Math.max(1, G.spacingMm)*ppm;
    const inset=Math.max(0, G.insetMm||0)*ppm;
    const topGap=Math.max(0, G.topMm||0)*ppm;
    const botGap=Math.max(0, G.bottomMm||0)*ppm;
    const x0=inset, x1=W-inset;
    const y0=inset+topGap, y1=H-inset-botGap;
    if(y1>y0+1 && x1>x0+1){
      x.save();
      x.beginPath(); x.rect(x0,y0,x1-x0,y1-y0); x.clip();   // grid only inside its area
      x.strokeStyle=G.colour||"#c8c8d0";
      x.lineWidth=Math.max(0.4, (G.thicknessMm||0.2)*ppm);
      x.beginPath();
      for(let gx=x0+step; gx<x1; gx+=step){ x.moveTo(gx,y0); x.lineTo(gx,y1); }
      for(let gy=y0+step; gy<y1; gy+=step){ x.moveTo(x0,gy); x.lineTo(x1,gy); }
      // also draw the bounding edges of the grid panel so it reads as a framed area
      x.rect(x0,y0,x1-x0,y1-y0);
      x.stroke();
      x.restore();
    }
  }
  // layers, in array order (later = on top)
  for(const L of D.layers){ drawDesignLayer(x, L, ppm); }
  cardDesignCache={ canvas:c, w:W, h:H };
  return c;
}
/* unit-agnostic path for star/heart, centred on 0,0 in a w-by-h box */
function shapePathD(shape,w,h){
  if(shape==="star"){
    const R=w/2, r=w*0.21, ry=h/w;
    let d="";
    for(let i=0;i<10;i++){
      const rad=(i%2===0)?R:r;
      const a=-Math.PI/2 + i*Math.PI/5;
      d+=(i===0?"M":"L")+(rad*Math.cos(a)).toFixed(3)+" "+(rad*Math.sin(a)*ry).toFixed(3);
    }
    return d+"Z";
  }
  if(shape==="heart"){
    const sx=w/24, sy=h/22;
    const f=(px,py)=>((px-12)*sx).toFixed(3)+" "+((py-11)*sy).toFixed(3);
    return "M"+f(12,21)+"C"+f(5,16)+" "+f(2,12)+" "+f(2,8.5)+"C"+f(2,5.4)+" "+f(4.4,3)+" "+f(7.5,3)+"C"+f(9.4,3)+" "+f(11.1,4)+" "+f(12,5.6)+"C"+f(12.9,4)+" "+f(14.6,3)+" "+f(16.5,3)+"C"+f(19.6,3)+" "+f(22,5.4)+" "+f(22,8.5)+"C"+f(22,12)+" "+f(19,16)+" "+f(12,21)+"Z";
  }
  return null;
}
function drawDesignLayer(x, L, ppm){
  x.save();
  if(L.opacity!=null) x.globalAlpha=Math.max(0,Math.min(1,L.opacity));
  const px=L.x*ppm, py=L.y*ppm;
  if(L.type==="text"){
    const size=Math.max(1,L.sizeMm*ppm);
    x.font=`${L.weight||"600"} ${size}px ${L.font||"sans-serif"}`;
    if(L.spacingMm) x.letterSpacing=(L.spacingMm*ppm)+"px";
    x.fillStyle=L.colour||"#1a1a20";
    x.textAlign=L.align||"center"; x.textBaseline="middle";
    x.translate(px,py); if(L.rot) x.rotate(L.rot*Math.PI/180);
    (L.text||"").split("\n").forEach((line,i,arr)=>{
      x.fillText(line, 0, (i-(arr.length-1)/2)*size*1.15);
    });
  } else if(L.type==="shape"){
    const w=L.wMm*ppm, h=L.hMm*ppm;
    x.translate(px,py); if(L.rot) x.rotate(L.rot*Math.PI/180);
    const hasFill=L.fill && L.fill!=="none";
    const hasStroke=L.stroke && L.stroke!=="none" && L.strokeMm>0;
    if(hasFill) x.fillStyle=L.fill;
    if(hasStroke){ x.strokeStyle=L.stroke; x.lineWidth=Math.max(0.5,L.strokeMm*ppm); }
    if(L.shape==="rect"){
      const r=Math.min((L.radiusMm||0)*ppm, w/2, h/2);
      roundRectPath(x, -w/2, -h/2, w, h, r);
      if(hasFill) x.fill();
      if(hasStroke) x.stroke();
    } else if(L.shape==="circle"){
      x.beginPath(); x.ellipse(0,0,w/2,h/2,0,0,Math.PI*2);
      if(hasFill) x.fill();
      if(hasStroke) x.stroke();
    } else if(L.shape==="star" || L.shape==="heart"){
      const p2=new Path2D(shapePathD(L.shape,w,h));
      if(hasFill) x.fill(p2);
      if(hasStroke) x.stroke(p2);
    } else if(L.shape==="line"){
      x.beginPath(); x.moveTo(-w/2,0); x.lineTo(w/2,0);
      x.strokeStyle = hasStroke ? L.stroke : (L.fill||"#1a1a20");
      x.lineWidth = Math.max(0.5,(L.strokeMm||1)*ppm);
      x.lineCap="round"; x.stroke();
    }
  } else if(L.type==="logo" && L.img){
    const w=L.wMm*ppm, h=w*(L.img.height/L.img.width);
    x.translate(px,py); if(L.rot) x.rotate(L.rot*Math.PI/180);
    x.drawImage(L.img, -w/2, -h/2, w, h);
} else if(L.type==="qr" && L.matrix){
    const size=L.sizeMm*ppm, n=L.matrix.length, cell=size/n;
    const style=L.dotStyle||"square";
    const fg=L.fg||"#000000", bg=L.bg||"#ffffff", eye=L.eye||fg;
    const transparent = bg==="transparent";
    // render the QR to its own canvas so transparency (erased gaps) works
    // regardless of what's on the destination. Then blit it onto the card.
    const pad=Math.ceil(cell);
    const qc=mk(Math.ceil(size)+2*pad, Math.ceil(size)+2*pad);
    const qx=qc.getContext("2d");
    qx.translate(pad,pad);
    // background / quiet zone
    if(!transparent){ qx.fillStyle=bg; qx.fillRect(-cell,-cell,size+2*cell,size+2*cell); }
    const isEye=(r,c)=> (r<8&&c<8) || (r<8&&c>=n-8) || (r>=n-8&&c<8);
    const isTiming=(r,c)=> (r===6 || c===6);
    qx.fillStyle=fg;
    const mtx=L.matrix;
    const dark=(r,c)=> r>=0&&c>=0&&r<n&&c<n&&mtx[r][c]&&!isEye(r,c);
    for(let r=0;r<n;r++) for(let cc=0;cc<n;cc++){
      if(!mtx[r][cc] || isEye(r,cc)) continue;
      const dx=cc*cell, dy=r*cell;
      if(style==="square" || isTiming(r,cc)){ qx.fillRect(dx,dy,cell+0.6,cell+0.6); continue; }
      const up=dark(r-1,cc), dn=dark(r+1,cc), lf=dark(r,cc-1), rt=dark(r,cc+1);
      const rad=style==="dots"?cell*0.5:cell*0.34;
      const tl=(!up&&!lf)?rad:0, tr=(!up&&!rt)?rad:0, br=(!dn&&!rt)?rad:0, bl=(!dn&&!lf)?rad:0;
      roundRectPathVar(qx, dx-0.3, dy-0.3, cell+0.6, cell+0.6, tl,tr,br,bl); qx.fill();
    }
    drawQrEye(qx, 0, 0, cell, eye, bg, style, transparent);
    drawQrEye(qx, (n-7)*cell, 0, cell, eye, bg, style, transparent);
    drawQrEye(qx, 0, (n-7)*cell, cell, eye, bg, style, transparent);
    // blit the finished QR onto the card at the layer position
    x.translate(px, py); if(L.rot) x.rotate(L.rot*Math.PI/180);
    x.drawImage(qc, -size/2 - pad, -size/2 - pad);
  }
  x.restore();
}
/* draw a 7x7 finder eye at (ox,oy) in canvas px: outer ring, gap, inner 3x3.
   When transparent, the gap is erased so the card shows through instead of a
   white ring. roundRectPath already calls beginPath, so each shape is its own
   clean subpath. */
function drawQrEye(x, ox, oy, cell, colour, bg, style, transparent){
  const r = (style==="square") ? 0 : cell*0.16;
  const sq=(bx,by,s,rr)=>{ if(rr>0){ roundRectPath(x,bx,by,s,s,rr); } else { x.beginPath(); x.rect(bx,by,s,s); } };
  // outer square, solid eye colour
  x.save(); x.fillStyle=colour; sq(ox,oy,cell*7,r); x.fill(); x.restore();
  // gap ring: erase to transparent, or paint the background colour
  if(transparent){
    x.save();
    x.globalCompositeOperation="destination-out";
    sq(ox+cell,oy+cell,cell*5,Math.max(0,r-cell*0.04));
    x.fill();
    x.restore();
  } else {
    x.save(); x.fillStyle=bg; sq(ox+cell,oy+cell,cell*5,Math.max(0,r-cell*0.04)); x.fill(); x.restore();
  }
  // centre dot, solid eye colour
  x.save(); x.fillStyle=colour; sq(ox+cell*2,oy+cell*2,cell*3,Math.max(0,r-cell*0.06)); x.fill(); x.restore();
}
function buildCard(){
  const t=TEMPLATES[opts.orient];
  const ppm=pxPerMm();
  const cardW=Math.round(t.cardW*ppm), cardH=Math.round(t.cardH*ppm);
  const rPx=Math.round(CARD_CORNER_MM*ppm);
  const bleedPx=Math.round(BLEED_MM*ppm);
  // canvas includes the bleed band around the card so it's visible on screen
  const W=cardW+2*bleedPx, H=cardH+2*bleedPx;
  const c=mk(W,H), x=c.getContext("2d");

  // the artwork shown on the card front: a customer design, an uploaded image,
  // the default grid card, or nothing (plain colour).
  let cardArt=null;
  if(opts.cardPreset==="design"){ cardArt=cardDesignArtBleed(); }
  else if(opts.cardPreset==="grid"){ cardArt=defaultCardImg[opts.orient]||null; }
  else if(card){ cardArt=card.art; }

  // 1) bleed band: card colour at reduced opacity, filling the whole area out
  //    to the bleed edge, so users SEE where the background colour bleeds to.
  //    An uploaded picture shows its own bleed here (hotfix 1: Auto = its edges stretched out, Solid = the colour).
  const upB=(opts.cardPreset!=="design" && opts.cardPreset!=="grid" && card && card.art && opts.cardSide!=="back") ? cardUploadBleed(card.art,cardW,cardH,bleedPx) : null;
  x.save();
  x.globalAlpha=0.45;
  if(upB){ roundRectPath(x,0,0,W,H,rPx+bleedPx); x.clip(); x.drawImage(upB,0,0); }
  else { x.fillStyle=cardBgNow(); roundRectPath(x,0,0,W,H,rPx+bleedPx); x.fill(); }
  x.restore();

  // 2) the actual card, inset by the bleed, at full opacity
  x.save();
  roundRectPath(x,bleedPx,bleedPx,cardW,cardH,rPx);
  x.clip();
  x.fillStyle=cardBgNow(); x.fillRect(bleedPx,bleedPx,cardW,cardH);
  if(upB){ x.drawImage(upB,0,0); cardArt=null; }
  if(cardArt && opts.cardSide!=="back"){
    /* Cover the FULL bleed extent and centre on the whole canvas - identical to
       buildCardExport. Framing to the trim box here while the export framed to
       trim+bleed made the print ~4.5% more zoomed than the preview and lost
       about 1.5mm off every edge. What is on screen is now what is cut. */
    const a=cardArt;
    const sc=Math.max(W/a.width, H/a.height);
    const dw=a.width*sc, dh=a.height*sc;
    x.drawImage(a, (W-dw)/2, (H-dh)/2, dw, dh);
  }
  x.restore();

  // a hairline on the true cut edge so the card boundary is clear vs bleed
  x.save();
  x.strokeStyle="rgba(26,26,32,.18)"; x.lineWidth=Math.max(1,ppm*0.15);
  roundRectPath(x,bleedPx,bleedPx,cardW,cardH,rPx);
  x.stroke();
  x.restore();

  cardScene={ canvas:c, cardW:W, cardH:H, innerW:cardW, innerH:cardH, bleedPx, rPx, ppm,
              cardTopPx:bleedPx };
  return c;
}
function roundRectPath(x,px,py,w,h,r){
  r=Math.min(r,w/2,h/2);
  x.beginPath();
  x.moveTo(px+r,py);
  x.arcTo(px+w,py,px+w,py+h,r);
  x.arcTo(px+w,py+h,px,py+h,r);
  x.arcTo(px,py+h,px,py,r);
  x.arcTo(px,py,px+w,py,r);
  x.closePath();
}
/* rounded rect with independent corner radii (top-left, top-right, bottom-right,
   bottom-left). Used for neighbour-aware QR modules so connected edges stay
   square and only exposed corners round off. */
function roundRectPathVar(x,px,py,w,h,tl,tr,br,bl){
  const m=Math.min(w/2,h/2);
  tl=Math.min(tl,m); tr=Math.min(tr,m); br=Math.min(br,m); bl=Math.min(bl,m);
  x.beginPath();
  x.moveTo(px+tl,py);
  x.lineTo(px+w-tr,py);
  if(tr) x.arcTo(px+w,py,px+w,py+tr,tr); else x.lineTo(px+w,py);
  x.lineTo(px+w,py+h-br);
  if(br) x.arcTo(px+w,py+h,px+w-br,py+h,br); else x.lineTo(px+w,py+h);
  x.lineTo(px+bl,py+h);
  if(bl) x.arcTo(px,py+h,px,py+h-bl,bl); else x.lineTo(px,py+h);
  x.lineTo(px,py+tl);
  if(tl) x.arcTo(px,py,px+tl,py,tl); else x.lineTo(px,py);
  x.closePath();
}

/* ---------- rendering ---------- */
const RAINBOW=["#f0513c","#f78d28","#ffc707","#5dba68","#4b8dc8","#5f4c9f","#f0513c"];
function rainbowConic(ctx,w,h,angle){
  if(ctx.createConicGradient){
    const g=ctx.createConicGradient(angle-Math.PI/2,w/2,h/2);
    RAINBOW.forEach((c,i)=>g.addColorStop(i/(RAINBOW.length-1),c));
    return g;
  }
  const g=ctx.createLinearGradient(0,0,w,h);
  RAINBOW.forEach((c,i)=>g.addColorStop(i/(RAINBOW.length-1),c));
  return g;
}
function buildAndRender(){
  if(opts.view==="editor"){
    // editor designs the card; show the card with the design, bookmark hidden so
    // layers are freely editable. Force folded front so the full card is visible.
    invalidateCardDesign();
    buildCard();
    $("drop").classList.add("hidden"); $("preview").classList.remove("hidden");
    syncCanvasChrome();
    render();
    return;
  }
  if(opts.view==="card"){
    if(main) buildBookmark();
    buildCard();
    if(card || main){ $("drop").classList.add("hidden"); $("preview").classList.remove("hidden"); }
    syncCanvasChrome();
    render();
    return;
  }
  if(!main){ return; }
  buildBookmark();
  updateDims();
  syncCanvasChrome();
  render();
}
/* show/hide canvas tools + dims depending on state and view */
function syncCanvasChrome(){
  /* the toolbar shows in both views; flip/fold/cut only apply to the bookmark */
  const canvasUp = !$("preview").classList.contains("hidden");
  $("canvasTools").style.display = canvasUp ? "flex" : "none";
  const bmTools = !!main && opts.view==="bookmark";
  ["ctoolFlip","ctoolFold","ctoolCut"].forEach(id=>{ $(id).style.display = bmTools ? "" : "none"; });
  // zoom/fit controls should be available whenever there's something on the
  // canvas: a bookmark, the backing card, or the editor design.
  const canvasVisible = !$("preview").classList.contains("hidden");
  $("zoomctl").style.display = canvasVisible ? "flex" : "none";
  if(opts.view==="bookmark"){
    if(main) updateDims(); else $("canvasDims").classList.remove("show");
  } else {
    updateCardDims();
  }
}
/* card-view readout: card true size + bookmark true size */
function updateCardDims(){
  const dimsEl=$("canvasDims"), txt=$("dimText");
  const t=TEMPLATES[opts.orient];
  let s=stkF(stkT("stk.labs.bookmark.dims.card","Card [w]cm \u00d7 [h]cm"),{w:(t.cardW/10).toFixed(1),h:(t.cardH/10).toFixed(1)});
  if(main && sceneMm){
    const ppm=sceneMm.ppm;
    const f=cardScaleFactor();
    const trueWcm=(sceneMm.cutBB.w/ppm)/10*f;
    const trueHcm=(sceneMm.cutBB.h/ppm)/10*f;
    s+="  \u00b7  "+stkF(stkT("stk.labs.bookmark.dims.card_bookmark","Bookmark [w] \u00d7 [h]cm"),{w:trueWcm.toFixed(1),h:trueHcm.toFixed(1)});
  }
  txt.textContent=s;
  dimsEl.querySelector("b").textContent=stkT("stk.labs.bookmark.dims.true_size","TRUE SIZE");
  dimsEl.classList.add("show");
  checkMagnet();
}
/* the uniform scale applied to the bookmark when placed on the card */
function cardScaleFactor(){
  if(!baseScene || !sceneMm) return 1;
  const ppm = (cardScene?cardScene.ppm:sceneMm.ppm);
  const trueWmm = baseScene.width/ppm;
  if(opts.cardWidthMm==null) return 1;
  return Math.min(1, opts.cardWidthMm/trueWmm);
}
/* Check the magnet can be placed: the artwork must have a 30mm opaque safe disc
   on the front half at the magnet position. Scaling the bookmark narrower
   shrinks the physical artwork, so a too-narrow bookmark fails the check. */
function checkMagnet(){
  const el=$("magnetStatus");
  if(!el) return;
  if(!main || !sceneMm || !baseScene || opts.view!=="card"){ el.classList.remove("show"); return; }
  const ppm=sceneMm.ppm;
  const f=cardScaleFactor();
  // physical bookmark width after scaling
  const bookmarkWmm=(sceneMm.cutBB.w/ppm)*f;
  // magnet centre in baseScene px: default just below the fold on the front half,
  // shifted by the user's drag offset (offsets stored in mm of artwork space).
  const ringRpx=(MAGNET_SAFE_MM/2)*ppm;            // unscaled artwork px
  const cx=Math.round(baseScene.width/2 + (opts.magnetOffX||0)*ppm);
  const cy=Math.round(sceneMm.foldYpx + ringRpx + 2*ppm + (opts.magnetOffY==null?0:opts.magnetOffY)*ppm);
  // sample alpha over the safe disc
  let total=0, opaque=0;
  try{
    const sctx=baseScene.getContext("2d");
    const r=Math.round(ringRpx);
    const x0=Math.max(0,cx-r), y0=Math.max(0,cy-r);
    const w=Math.min(baseScene.width-x0, 2*r), h=Math.min(baseScene.height-y0, 2*r);
    if(w>0 && h>0){
      const data=sctx.getImageData(x0,y0,w,h).data;
      for(let yy=0; yy<h; yy++){
        for(let xx=0; xx<w; xx++){
          const dx=(x0+xx)-cx, dy=(y0+yy)-cy;
          if(dx*dx+dy*dy<=r*r){
            total++;
            if(data[(yy*w+xx)*4+3]>40) opaque++;
          }
        }
      }
    }
  }catch(e){ el.classList.remove("show"); return; }
  const cover = total? opaque/total : 0;
  // need the bookmark physically wide enough for the 30mm safe zone, and the
  // artwork actually filling that disc
  const wideEnough = bookmarkWmm >= MAGNET_SAFE_MM - 0.5;
  const filled = cover >= 0.92;
  el.classList.remove("ok","warn");
  if(wideEnough && filled){
    el.classList.add("show","ok");
    el.textContent=stkT("stk.labs.bookmark.magnet.fits","Magnet fits: the 20mm magnet has full artwork coverage with 5mm clearance.");
  } else if(!wideEnough){
    el.classList.add("show","warn");
    el.textContent=stkF(stkT("stk.labs.bookmark.magnet.too_narrow","Too narrow for the magnet. The bookmark is [width_cm]cm wide here; it needs at least 3.0cm of artwork so the 20mm magnet has 5mm clearance. Widen the bookmark."),{width_cm:(bookmarkWmm/10).toFixed(1)});
  } else {
    el.classList.add("show","warn");
    el.textContent=stkT("stk.labs.bookmark.magnet.not_covered","The magnet area isn't fully covered by artwork. Move or enlarge the design so the magnet spot (just below the fold) is solid, or the magnets won't bond well.");
  }
}
function render(){
  const cv=$("preview");
  if(opts.view==="editor"){
    if(!cardScene) buildCard();
    composeCardView(cv, {hideBookmark:true, forceFront:true});
    if(!fitted) fitView(); else applyTransform();
    syncRulers(); syncFloatPreview();
    return;
  }
  if(opts.view==="card"){
    if(!cardScene) buildCard();
    composeCardView(cv);
    if(!fitted) fitView(); else applyTransform();
    syncRulers(); syncFloatPreview();
    return;
  }
  if(!baseScene){ syncRulers(); return; }
  if(opts.bmView==="folded"){
    const fs=buildFoldedScene();
    if(fs){
      if(animRaf){ cancelAnimationFrame(animRaf); animRaf=0; }
      cv.width=fs.width; cv.height=fs.height;
      const fx=cv.getContext("2d");
      fx.clearRect(0,0,cv.width,cv.height);
      fx.drawImage(fs,0,0);
      if(!fitted) fitView(); else applyTransform();
      syncRulers(); syncFloatPreview();
      return;
    }
  }
  cv.width=baseScene.width; cv.height=baseScene.height;
  if(animRaf) cancelAnimationFrame(animRaf);
  const loop=ts=>{ drawBookmarkFrame(cv,ts); if(opts.cut && !document.hidden){ animRaf=requestAnimationFrame(loop);} else animRaf=0; };
  if(opts.cut) animRaf=requestAnimationFrame(loop); else drawBookmarkFrame(cv,0);
  if(!fitted) fitView(); else applyTransform();
  syncFloatPreview();
}
/* Mobile-only floating live preview. Mirrors the main canvas into a small
   pinned thumbnail so colour and option changes are visible while the controls
   are scrolled into view, instead of scrolling up and down. */
let floatDismissed=false;
function syncFloatPreview(){
  const fp=$("floatPrev"), fc=$("floatCanvas"), src=$("preview");
  if(!fp||!fc||!src||!src.width||!src.height) return;
  const maxW=220, maxH=270;   // backing store cap; CSS scales the display size
  const sc=Math.min(maxW/src.width, maxH/src.height, 1);
  const w=Math.max(1,Math.round(src.width*sc)), h=Math.max(1,Math.round(src.height*sc));
  if(fc.width!==w) fc.width=w;
  if(fc.height!==h) fc.height=h;
  const fx=fc.getContext("2d");
  fx.clearRect(0,0,w,h);
  fx.imageSmoothingQuality="high";
  try{ fx.drawImage(src,0,0,w,h); }catch(e){}
}
/* Decide whether the floating preview should be shown: only on small screens,
   only when there's something rendered, and only once the main canvas has been
   scrolled mostly out of view. */
function updateFloatPreviewVisibility(){
  // Floating preview removed: it didn't update reliably. Keep hidden always.
  const fp=$("floatPrev"), re=$("floatReopen");
  if(fp) fp.classList.remove("show");
  if(re) re.classList.remove("show");
}
function stageBox(){ return $("stageInner").getBoundingClientRect(); }
function baseFitScale(){
  const cv=$("preview"); const box=stageBox();
  if(!cv.width||!cv.height||!box.width) return 1;
  const pad=0.88;   // leave a little margin
  return Math.min(box.width/cv.width, box.height/cv.height)*pad;
}
function fitView(){
  const cv=$("preview");
  if(!cv.width||!cv.height) return;
  zoom=1; panX=0; panY=0; fitted=true;
  applyTransform();
}
function applyTransform(){
  const cv=$("preview");
  const s=baseFitScale()*zoom;
  /* 21 Oct 2026 (the drawer drag): the same fit is not written again - an unchanged canvas is not touched */
  { const t=`translate(-50%,-50%) translate(${panX}px,${panY}px) scale(${s})`; if(cv.__bmT!==t){ cv.__bmT=t; cv.style.transform=t; } }
  syncRulers();
}
function zoomBy(factor, cx, cy){
  const prev=zoom;
  zoom=Math.max(0.4, Math.min(6, zoom*factor));
  // keep the point under the cursor stable (cx,cy relative to stage centre)
  if(cx!=null){
    const box=stageBox();
    const ox=cx-(box.left+box.width/2), oy=cy-(box.top+box.height/2);
    const r=zoom/prev;
    panX=ox-(ox-panX)*r;
    panY=oy-(oy-panY)*r;
  }
  applyTransform();
}
function drawBookmarkFrame(target,tMs){
  const x=target.getContext("2d");
  x.clearRect(0,0,target.width,target.height);
  x.save();
  if(opts.previewFlip){ x.translate(target.width/2,target.height/2); x.rotate(Math.PI); x.translate(-target.width/2,-target.height/2); }
  x.drawImage(baseScene,0,0);
  const ref=Math.max(target.width,target.height);
  if(opts.fold && foldPath){
    x.strokeStyle=opts.foldColour;
    x.lineWidth=Math.max(3,ref/300);
    x.setLineDash([]);
    x.stroke(foldPath);
  }
  if(opts.cut && cutPath){
    const angle=(tMs%6000)/6000*Math.PI*2;
    x.strokeStyle=rainbowConic(x,target.width,target.height,angle);
    x.lineWidth=Math.max(2.5,ref/300);
    const on=ref/55, off=ref/75;
    x.setLineDash([on,off]);
    x.lineDashOffset=-(tMs%100000)/1000*(on+off);
    x.stroke(cutPath);
    x.setLineDash([]); x.lineDashOffset=0;
  }
  if(opts.showMagnet) drawFlatMagnetGuide(x);
  x.restore();
}
/* P21, Thomas 12 Sep 2026: the magnet guide used to be drawn only on the folded
   preview. On the FLAT sheet the one magnet lands in TWO places - where it sits
   on the front half, and the mirrored position on the top half, because that
   half folds over through the fold line and meets it. Both are drawn so the
   customer sees what the magnet has to cover on the printed sheet.
   Geometry is the same expression checkMagnet() uses, in baseScene px, so the
   guide and the coverage warning can never disagree.
   ON SCREEN ONLY: drawBookmarkFrame is called from render() and nowhere else;
   buildBookmarkExport / buildBookmarkCutSVG / buildCardExport / buildCardCutSVG
   build their own canvases and never call this, and buildCardProofCanvas turns
   opts.showMagnet off around the mockup. Keep it that way - a guide in a cut
   file cuts. */
function drawFlatMagnetGuide(x){
  if(!baseScene || !sceneMm) return;
  const ppm=sceneMm.ppm;
  const fy=sceneMm.foldYpx||0;
  const ringR=(MAGNET_SAFE_MM/2)*ppm, rr=(MAGNET_DIA_MM/2)*ppm;
  const cx=baseScene.width/2 + (opts.magnetOffX||0)*ppm;
  const cyFront=fy + ringR + 2*ppm + (opts.magnetOffY==null?0:opts.magnetOffY)*ppm;
  const cyFold=2*fy - cyFront;                     // mirrored through the fold
  const lw=Math.max(1.2, ppm*0.28);
  x.save();
  for(const cy of [cyFront, cyFold]){
    x.setLineDash([4,4]);
    x.strokeStyle="rgba(123,107,255,.95)"; x.lineWidth=lw;
    x.beginPath(); x.arc(cx,cy,rr,0,Math.PI*2); x.stroke();
    x.setLineDash([2,3]);
    x.strokeStyle="rgba(123,107,255,.5)";
    x.beginPath(); x.arc(cx,cy,ringR,0,Math.PI*2); x.stroke();
    x.setLineDash([]);
    x.fillStyle="rgba(123,107,255,.95)";
    x.beginPath(); x.arc(cx,cy,Math.max(2,ppm*0.6),0,Math.PI*2); x.fill();
  }
  x.restore();
}
function composeCardView(cv, optsArg){
  const o=optsArg||{};
  const { canvas:cardC, cardW, cardH, innerH, cardTopPx } = cardScene;
  const showBookmark = !o.hideBookmark && opts.showOnCard && baseScene && sceneMm;
  const viewMode = o.forceFront ? "front" : opts.cardView;
  // In full-length the top half hangs above the card; add headroom above.
  // Back side and folded both sit within the card, so no headroom needed there.
  let headroom=0;
  if(viewMode==="full" && opts.cardSide!=="back" && showBookmark){
    const foldOnCardAbs = Math.max(0, cardTopPx - Math.round(FOLD_RISE_MM*cardScene.ppm));
    const aboveFold = sceneMm.foldYpx;               // true-size px above the fold
    headroom = Math.max(0, aboveFold - foldOnCardAbs) + innerH*0.03;
  }
  const cw=cardW, ch=cardH+headroom;
  // the whole scene is translated down by this below, so the hit test for
  // dragging the bookmark has to know about it
  cardScene.headroom=headroom;
  cv.width=cw; cv.height=ch;
  cv.classList.remove("draggable");
  if(animRaf) cancelAnimationFrame(animRaf);
  const loop=ts=>{
    const x=cv.getContext("2d");
    x.clearRect(0,0,cw,ch);
    x.save();
    x.translate(0, headroom);
    x.drawImage(cardC,0,0);
    if(opts.cardPreset==="upload") drawCardBleedGuide(x);
    if(showBookmark) drawBookmarkOnCard(x,ts,cardW,cardH);
    // alignment guides while dragging a design layer (editor / design view)
    if(draggingLayer && (activeGuides.v||activeGuides.h)){
      const bleedPx=cardScene.bleedPx;
      x.save();
      x.strokeStyle="rgba(224,93,255,.9)"; x.lineWidth=Math.max(1,cardScene.ppm*0.18); x.setLineDash([6,5]);
      if(activeGuides.v){ const cx=cardW/2; x.beginPath(); x.moveTo(cx,0); x.lineTo(cx,cardH); x.stroke(); }
      if(activeGuides.h){ const cy=cardH/2; x.beginPath(); x.moveTo(0,cy); x.lineTo(cardW,cy); x.stroke(); }
      x.restore();
    }
    x.restore();
    if(magnetCircle) magnetCircle.headroom=headroom;   // for drag hit-testing
    if(!document.hidden) animRaf=requestAnimationFrame(loop); else animRaf=0;
  };
  animRaf=requestAnimationFrame(loop);
}
/* bleed guide for uploaded cards: shows the trim edge (card boundary) and the
   safe margin inside it, so customers keep key content away from the cut and
   extend backgrounds into the bleed. Drawn in the preview only, not exported. */
function drawCardBleedGuide(x){
  const { innerW, innerH, bleedPx, rPx, ppm } = cardScene;
  const fullW=innerW+2*bleedPx, fullH=innerH+2*bleedPx;
  const safeMm=3;                                  // keep text 3mm inside the trim
  const safePx=safeMm*ppm;
  x.save();
  // safe area - dashed inside the trim (blue)
  x.setLineDash([6,5]);
  x.lineWidth=Math.max(1, ppm*0.18);
  x.strokeStyle="rgba(77,198,255,.9)";
  roundRectPath(x, bleedPx+safePx, bleedPx+safePx, innerW-2*safePx, innerH-2*safePx, Math.max(0,rPx-safePx));
  x.stroke();
  // bleed edge - dashed outside the trim (magenta)
  x.strokeStyle="rgba(224,93,255,.75)";
  x.setLineDash([4,4]);
  roundRectPath(x, 0, 0, fullW, fullH, rPx+bleedPx);
  x.stroke();
  x.restore();
}
/* Place the bookmark on the card at TRUE real-world scale (bookmark scene and
   card share the same px-per-mm, so 1:1 pixels). Fold pinned to the card's
   top edge. No free scaling or dragging: what you see is true size.
   Bridge length (set on this screen too) changes the overall height. */
function drawBookmarkOnCard(x,tMs,cardW,cardH){
  const fy=sceneMm.foldYpx;
  const srcWfull=baseScene.width;
  const ppm=cardScene.ppm;
  // uniform scale so the bookmark's on-card width matches the slider (cm).
  // true width in mm = srcWfull/ppm; target = opts.cardWidthMm (null => full).
  const trueWmm=srcWfull/ppm;
  const targetWmm = opts.cardWidthMm==null ? trueWmm : Math.min(opts.cardWidthMm, trueWmm);
  const f = targetWmm/trueWmm;
  const srcW=srcWfull;                          // source pixels unchanged
  const drawW=srcWfull*f;                       // scaled draw width
  /* Centred by default, but draggable: the customer needs to slide the
     bookmark out to the card's edge to judge the fit (Thomas, 8 Sep 2026).
     Card millimetres, so the travel does not change when the bookmark-width
     slider does. Every drawing path goes through here, so the mockup export
     cannot disagree with what is on screen. */
  const bx=(cardW-drawW)/2 + (opts.cardBmOffXmm||0)*ppm;
  const cardTopPx=cardScene.cardTopPx||0;
  /* The fold does not sit ON the card's top edge - it wraps OVER it, so in the
     hand the bookmark rides about 1-2mm proud of the card. Thomas measured it on
     real stock, 25 Aug 2026; his observation, not a model. Card millimetres, so
     it does not scale with the bookmark-width slider: the gap is a property of
     the card and the fold, not of how big the artwork is drawn. Clamped so a
     card with little headroom cannot push the fold off the canvas. */
  const foldRisePx = Math.round(FOLD_RISE_MM * cardScene.ppm);
  const foldOnCard = Math.max(0, cardTopPx - foldRisePx);

  if(opts.cardSide==="back"){
    const srcH=Math.max(1, Math.min(fy, baseScene.height));
    const drawH=srcH*f;
    x.save();
    const cx0=bx+drawW/2, cy0=foldOnCard+drawH/2;
    x.translate(cx0,cy0); x.rotate(Math.PI); x.translate(-cx0,-cy0);
    drawWithShadow(x,trimmedScene(),0,0,srcW,srcH,bx,foldOnCard,drawW,drawH,cardW);
    x.restore();
    if(opts.showMagnet) drawMagnetGuide(x,bx,foldOnCard,drawW,drawH,f,true);
    return;
  }
  if(opts.cardView==="full"){
    const drawH=baseScene.height*f;
    const by=foldOnCard - fy*f;
    drawWithShadow(x,trimmedScene(),0,0,srcW,baseScene.height,bx,by,drawW,drawH,cardW);
    if(opts.showMagnet) drawMagnetGuide(x,bx,foldOnCard,drawW,fy*f,f,false);
    return;
  }
  /* The folded-over back sits BEHIND the card in the hand, so it is not drawn
     here - only the front half shows. The folded piece on its own has its own
     Preview in the Bookmark section. Thomas, 25 Aug 2026. */
  const srcY=Math.max(0, fy);
  const srcH=baseScene.height-srcY;
  const drawH=srcH*f;
  drawWithShadow(x,trimmedScene(),0,srcY,srcW,srcH,bx,foldOnCard,drawW,drawH,cardW);
  if(opts.showMagnet) drawMagnetGuide(x,bx,foldOnCard,drawW,drawH,f,false);
}
/* the magnet centre in COMPOSED canvas coords (the coord space drawBookmarkOnCard
   draws in). Shared by the guide, the coverage check, and drag hit-testing.
   Default sits just below the fold on the front half; offsets move it. */
let magnetCircle=null;   // {cx,cy,r,ringR} in composed coords, for hit-testing
function magnetCentre(bx, foldY, drawW, f){
  const ppm=cardScene.ppm;
  const ringR=(MAGNET_SAFE_MM/2)*ppm*f;
  const baseCx=bx+drawW/2;
  const baseCy=foldY + ringR + 2*ppm*f;          // default: just below the fold
  const offX=(opts.magnetOffX||0)*ppm*f;
  const offY=(opts.magnetOffY==null?0:opts.magnetOffY)*ppm*f;
  return { cx:baseCx+offX, cy:baseCy+offY, r:(MAGNET_DIA_MM/2)*ppm*f, ringR };
}
function drawMagnetGuide(x, bx, foldY, drawW, drawH, f, isBack){
  const m=magnetCentre(bx, foldY, drawW, f);
  magnetCircle={ ...m, f };
  x.save();
  x.setLineDash([4*f,4*f]);
  x.strokeStyle="rgba(123,107,255,.95)"; x.lineWidth=Math.max(1.2, cardScene.ppm*f*0.28);
  x.beginPath(); x.arc(m.cx,m.cy,m.r,0,Math.PI*2); x.stroke();
  x.setLineDash([2*f,3*f]);
  x.strokeStyle="rgba(123,107,255,.5)";
  x.beginPath(); x.arc(m.cx,m.cy,m.ringR,0,Math.PI*2); x.stroke();
  // small centre dot + grip hint
  x.setLineDash([]);
  x.fillStyle="rgba(123,107,255,.95)";
  x.beginPath(); x.arc(m.cx,m.cy,Math.max(2,cardScene.ppm*f*0.6),0,Math.PI*2); x.fill();
  x.restore();
}
/* THE PIECE AS IT COMES OFF THE CUTTER: the scene clipped to the cut path.
   The scene runs rectangular artwork out to square corners under a rounded cut
   (that is the bleed), and the card view, Preview PNG and folded view drew it
   as-is (Thomas, 30 Sep 2026: "cut line not showing correctly on proof"). */
let _trim={s:null,c:null,v:null};
function trimmedScene(){
  if(!baseScene || !cutPath) return baseScene;
  if(_trim.v && _trim.s===baseScene && _trim.c===cutPath) return _trim.v;
  const t=mk(baseScene.width, baseScene.height), tx=t.getContext("2d");
  tx.clip(cutPath); tx.drawImage(baseScene,0,0);
  _trim={s:baseScene,c:cutPath,v:t};
  return t;
}
function drawWithShadow(x,img,sx,sy,sw,sh,dx,dy,dw,dh,cardW){
  x.save();
  x.shadowColor="rgba(26,26,32,.22)";
  x.shadowBlur=cardW*0.025; x.shadowOffsetY=cardW*0.01;
  x.drawImage(img,sx,sy,sw,sh,dx,dy,dw,dh);
  x.restore();
}
/* on-screen rulers in cm around the preview, toggled by the ruler button */
function syncRulers(){
  const rt=$("rulerTop"), rl=$("rulerLeft"), cv=$("preview");
  const show = opts.rulers && !cv.classList.contains("hidden");
  rt.classList.toggle("hidden", !show);
  rl.classList.toggle("hidden", !show);
  if(!show) return;
  const stageRect=$("stage").getBoundingClientRect();
  const cvRect=cv.getBoundingClientRect();
  if(!cvRect.width) return;
  const ppm = (opts.view==="card" && cardScene) ? cardScene.ppm : (sceneMm?sceneMm.ppm:8);
  const mmPerCssPx = (cv.width/cvRect.width)/ppm;     // mm per on-screen px
  const originX = cvRect.left - stageRect.left;
  const originY = cvRect.top - stageRect.top;
  drawRuler(rt, stageRect.width, true, mmPerCssPx, originX);
  drawRuler(rl, stageRect.height, false, mmPerCssPx, originY);
}
function drawRuler(canvas, lengthCss, horizontal, mmPerCssPx, originCss){
  const thick=18, dpr=window.devicePixelRatio||1;
  canvas.style.width = (horizontal?lengthCss:thick)+"px";
  canvas.style.height = (horizontal?thick:lengthCss)+"px";
  canvas.width = Math.round((horizontal?lengthCss:thick)*dpr);
  canvas.height = Math.round((horizontal?thick:lengthCss)*dpr);
  const x=canvas.getContext("2d");
  x.scale(dpr,dpr);
  x.clearRect(0,0,canvas.width,canvas.height);
  x.fillStyle=darkMode?"rgba(35,35,40,.94)":"rgba(255,255,255,.92)";
  x.fillRect(0,0,horizontal?lengthCss:thick, horizontal?thick:lengthCss);
  x.fillStyle=darkMode?"#9a9aa2":"#7a7a85"; x.strokeStyle=darkMode?"#4a4a52":"#c9c9d4";
  x.font="8px "+getComputedStyle(canvas).fontFamily;
  x.textBaseline="middle"; x.textAlign="center";
  // draw cm marks measured from the artwork origin, both directions
  const span=lengthCss;
  for(let cm=-99; cm<=99; cm++){
    const pos = originCss + (cm*10)/mmPerCssPx;
    if(pos<0||pos>span) continue;
    x.beginPath();
    if(horizontal){ x.moveTo(pos, thick); x.lineTo(pos, thick-7); }
    else { x.moveTo(thick, pos); x.lineTo(thick-7, pos); }
    x.stroke();
    const half=originCss+(cm*10+5)/mmPerCssPx;
    if(half>=0&&half<=span){
      x.beginPath();
      if(horizontal){ x.moveTo(half, thick); x.lineTo(half, thick-4); }
      else { x.moveTo(thick, half); x.lineTo(thick-4, half); }
      x.stroke();
    }
    if(cm!==0){
      if(horizontal) x.fillText(String(cm), pos, 5);
      else { x.save(); x.translate(6,pos); x.rotate(-Math.PI/2); x.fillText(String(cm),0,0); x.restore(); }
    }
  }
}
document.addEventListener("visibilitychange",()=>{ if(!document.hidden && main) render(); });

/* ---------- downloads ---------- */
function saveBlob(blob,name){
  const a=document.createElement("a");
  a.href=URL.createObjectURL(blob);
  a.download=name; a.click();
  setTimeout(()=>URL.revokeObjectURL(a.href),3000);
}
function outName(suffix){ return outBase+"-"+suffix; }

/* bookmark export scene: same as baseScene but bg bleeds BLEED_MM past the cut */
function buildBookmarkExport(){
  const S=buildSilhouette(); if(!S) return null;
  const { mask, ppm, geo } = S;
  const R = (opts.border && opts.borderMm>0) ? Math.max(2,Math.round(opts.borderMm*ppm)) : 0;
  const sPx = Math.round(opts.smoothMm*ppm);
  let outline = R>0 ? dilateCanvas(mask,R) : copyCanvas(mask);
  fillHoles(outline);
  if(sPx>0){ outline=smoothMask(outline,sPx); fillHoles(outline); }
  closeIslands(outline);   // v11.7: the cut file gets the same one-piece outline as the preview
  /* "Bookmark width on card" shrinks the physical bookmark, so exports must
     match the TRUE SIZE readout: divide ppm by the same cardScaleFactor().
     Bleed is dilated wider pre-scale so it stays a true 1.5mm on the doc. */
  const cf=cardScaleFactor();
  const bleedPx=Math.round(BLEED_MM*ppm/cf);
  const bleedM=dilateCanvas(outline,bleedPx);
  /* Crop everything to the bleed extent. The working canvas carries padding
     (border + bleed + slop) on every side; exporting it uncropped made the
     files measure larger than the bookmark. Cropped, the document is exactly
     cut size + 1.5mm bleed per side. */
  const bb=maskBBox(bleedM);
  // halves assembled uncropped, so auto bleed can dilate exactly what is drawn
  const halves=mkLike(bleedM);
  {
    const hx=halves.getContext("2d");
    if(opts.finished){
      hx.drawImage(scaledArt(centredCanvas(bmInk(main),centreFrac()), geo.halfW, geo.fullH), geo.pad, geo.topY);
    } else {
      const topArtSrc = top ? top.art : main.art;
      const topFlipped = makeTopArt(topArtSrc);
      /* REMOVE INNER WHITE (21 Oct 2026): drawn without it, placed by the artwork with it (same centre either way) */
      const topInk = bmInk(top||main)!==topArtSrc ? makeTopArt(bmInk(top||main)) : topFlipped;
      hx.drawImage(scaledArt(centredCanvas(topInk,topCentreFrac(topFlipped)), geo.halfW, geo.halfH, 1), geo.pad, geo.topY);
      hx.drawImage(scaledArt(centredCanvas(bmInk(main),centreFrac()), geo.halfW, geo.halfH, 0), geo.pad, geo.bottomY);
    }
  }
  const scene=mk(bb.w,bb.h);
  const x=scene.getContext("2d");
  if(opts.bgMode==="auto" && !bmHasBridge())
    x.drawImage(autoBleedAssembled(halves, bleedM, R+bleedPx+4),-bb.x,-bb.y);
  else
    x.drawImage(recolourBg(bleedM),-bb.x,-bb.y);
  x.drawImage(defringeArt(halves),-bb.x,-bb.y);
  const outlineCrop=mk(bb.w,bb.h);
  outlineCrop.getContext("2d").drawImage(outline,-bb.x,-bb.y);
  return { scene, outline:outlineCrop, ppm:ppm/cf, geo, foldY:geo.foldY-bb.y, off:{x:bb.x,y:bb.y} };
}
/* The single customer preview is the card proof (bookmark on its backing
   card, built by buildCardProofCanvas) - one file, one purpose. */
function dlPrint(){
  const E=buildBookmarkExport(); if(!E) return;
  const mmpp=1/E.ppm;
  const _d=bmExportDpi(E.scene.width,E.scene.height,mmpp);
  const targetW=Math.round(E.scene.width*mmpp/25.4*_d);
  const targetH=Math.round(E.scene.height*mmpp/25.4*_d);
  const out=mk(targetW,targetH);
  const x=out.getContext("2d"); x.imageSmoothingQuality="high";
  x.drawImage(E.scene,0,0,targetW,targetH);
  out.toBlob(b=>saveBlob(b,outName("bookmark-print-300dpi")+".png"),"image/png");
}
function svgPathFromMask(maskCanvas,mmpp,off){
  /* the same geometry the screen is showing, when the artwork is a rectangle.
     bmCutSegs are in the UNCROPPED silhouette frame; the export crops the
     artwork, the outline and the fold to the bleed box, so the segments have
     to move by the same amount. They did not: IMG_2649 (17 Sep 2026) came out
     with the cut 0.70mm right and down of its own artwork and fold line, which
     is why the fold sat off-centre in the file but centred on screen. */
  if(bmCutSegs){
    const ox=off?off.x:0, oy=off?off.y:0, f=v=>(v*mmpp).toFixed(2);
    let d="";
    for(const g of bmCutSegs){
      if(g.t==="M") d+="M"+f(g.x-ox)+" "+f(g.y-oy);
      else if(g.t==="L") d+="L"+f(g.x-ox)+" "+f(g.y-oy);
      else d+="A"+f(g.r)+" "+f(g.r)+" 0 0 "+g.sw+" "+f(g.x-ox)+" "+f(g.y-oy);
    }
    return d+"Z";
  }
  let pts=traceContour(maskCanvas);
  if(pts.length<3) return "";
  /* SIMPLIFY (P136): curves fitted to the RAW trace, before rdp/chaikin.
     mmpp is mm per px, so px per mm is 1/mmpp. Same v*mmpp mapping and
     2 decimals as the straight-line writer below, which stays as fallback. */
  const segs=simplifyTrace(pts, 1/mmpp);
  if(segs) return simplifyPathD(segs, p=>[p[0]*mmpp,p[1]*mmpp], 2);
  pts=rdp(pts,1.6); if(pts.length>=16) pts=chaikin(pts,2);   // v11.7: same corner guard as the preview
  const f=v=>(v*mmpp).toFixed(2);
  let d="M"+f(pts[0][0])+" "+f(pts[0][1]);
  for(let i=1;i<pts.length;i++) d+="L"+f(pts[i][0])+" "+f(pts[i][1]);
  return d+"Z";
}
function buildBookmarkCutSVG(E){
  const ppm=E.ppm, mmpp=1/ppm;
  const _d=bmExportDpi(E.scene.width,E.scene.height,mmpp);
  const targetW=Math.round(E.scene.width*mmpp/25.4*_d);
  const targetH=Math.round(E.scene.height*mmpp/25.4*_d);
  const out=mk(targetW,targetH);
  const ox=out.getContext("2d"); ox.imageSmoothingQuality="high";
  ox.drawImage(E.scene,0,0,targetW,targetH);
  const png=out.toDataURL("image/png");
  const W=(E.scene.width*mmpp).toFixed(2), H=(E.scene.height*mmpp).toFixed(2);
  const cutD=svgPathFromMask(E.outline,mmpp,E.off);
  const fy=E.foldY;
  const ext=rowExtent(E.outline, Math.round(fy));
  const fx0=(ext[0]*mmpp).toFixed(2), fx1=(ext[1]*mmpp).toFixed(2), fyMm=(fy*mmpp).toFixed(2);
  const foldEl = opts.fold
    ? `<line id="FoldLine" x1="${fx0}" y1="${fyMm}" x2="${fx1}" y2="${fyMm}" stroke="${opts.foldColour}" stroke-width="${FOLD_STROKE_MM}" style="stroke:${opts.foldColour}"/>`
    : "";
  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${W}mm" height="${H}mm" viewBox="0 0 ${W} ${H}">
  <g id="Artwork"><image xlink:href="${png}" href="${png}" x="0" y="0" width="${W}" height="${H}"/></g>
  <g id="Fold">${foldEl}</g>
  <g id="Cut"><path id="CutContour" d="${cutD}" fill="none" stroke="${CUT_COLOUR}" stroke-width="${CUT_STROKE_MM}" style="stroke:${CUT_COLOUR}"/></g>
</svg>`;
}
function dlCut(){
  $("spin").classList.add("show");
  setTimeout(()=>{
    const E=buildBookmarkExport(); if(!E){ $("spin").classList.remove("show"); return; }
    saveBlob(new Blob([buildBookmarkCutSVG(E)],{type:"image/svg+xml"}),outName("bookmark-cutfile")+".svg");
    $("spin").classList.remove("show");
  },30);
}
/* ---------- card downloads ---------- */
function buildCardExport(){
  const t=TEMPLATES[opts.orient];
  const ppm=pxPerMm();
  const bleedPx=Math.round(BLEED_MM*ppm);
  const cardW=Math.round(t.cardW*ppm), cardH=Math.round(t.cardH*ppm);
  const rPx=Math.round(CARD_CORNER_MM*ppm);
  const fullW=cardW+2*bleedPx, fullH=cardH+2*bleedPx;
  const c=mk(fullW,fullH), x=c.getContext("2d");
  // bleed: fill whole area with bg/card art, cut path is the rounded rect inset
  x.fillStyle=cardBgNow(); x.fillRect(0,0,fullW,fullH);
  const artImg = opts.cardPreset==="design" ? cardDesignArtBleed()
               : opts.cardPreset==="grid" ? defaultCardImg[opts.orient]
               : (card?card.art:null);
  if(artImg && opts.cardPreset!=="design" && opts.cardPreset!=="grid"){ x.drawImage(cardUploadBleed(artImg,cardW,cardH,bleedPx),0,0); }
  else if(artImg){
    const a=artImg;
    const sc=Math.max(fullW/a.width, fullH/a.height);
    const dw=a.width*sc, dh=a.height*sc;
    x.drawImage(a,(fullW-dw)/2,(fullH-dh)/2,dw,dh);
  }
  return { canvas:c, ppm, bleedPx, cardW, cardH, rPx, fullW, fullH };
}
function dlCardPrint(){
  const E=buildCardExport();
  const mmpp=1/E.ppm;
  // export only the trimmed card (no bleed) for the print PNG
  const t=TEMPLATES[opts.orient];
  const _cd=bmExportDpi(t.cardW*E.ppm, t.cardH*E.ppm, mmpp);
  const targetW=Math.round(t.cardW/25.4*_cd);
  const targetH=Math.round(t.cardH/25.4*_cd);
  const out=mk(targetW,targetH);
  const x=out.getContext("2d"); x.imageSmoothingQuality="high";
  const rPx=Math.round(CARD_CORNER_MM/25.4*_cd);
  roundRectPath(x,0,0,targetW,targetH,rPx); x.save(); x.clip();
  x.drawImage(E.canvas, E.bleedPx,E.bleedPx,E.cardW,E.cardH, 0,0,targetW,targetH);
  x.restore();
  out.toBlob(b=>saveBlob(b,outName("card-print-300dpi")+".png"),"image/png");
}
/* escape text for XML */
function xmlEsc(s){ return (s==null?"":String(s)).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }
/* Build a backing card SVG that keeps each design element as its own editable
   layer (<g>) instead of one flattened image. Background, grid, shapes and text
   are emitted as native SVG; logos and QR codes are embedded as images inside
   their own group (they can't be cleanly vectorised). Coordinates are in mm,
   offset by the bleed so the artwork lines up inside the trimmed card. */
function buildLayeredCardSVG(){
  const t=TEMPLATES[opts.orient];
  const bleed=BLEED_MM;                       // mm
  const cardW=t.cardW, cardH=t.cardH;
  const fullW=cardW+2*bleed, fullH=cardH+2*bleed;
  const ppm=pxPerMm();                          // for rasterising qr/logo images
  const D=opts.cardDesign;
  const ox=bleed, oy=bleed;                     // design origin inside the bleed
  const f2=v=>(+v).toFixed(2);
  let groups="";

  // --- background group ---
  let bgEl="";
  if(D.bg.type==="gradient"){
    const a=(D.bg.angle||0)*Math.PI/180;
    const dx=Math.cos(a)/2, dy=Math.sin(a)/2;
    const x1=f2(50-dx*100), y1=f2(50-dy*100), x2=f2(50+dx*100), y2=f2(50+dy*100);
    bgEl=`<defs><linearGradient id="cardBgGrad" x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%">`+
         `<stop offset="0%" stop-color="${xmlEsc(D.bg.from)}"/><stop offset="100%" stop-color="${xmlEsc(D.bg.to)}"/>`+
         `</linearGradient></defs>`+
         `<rect x="0" y="0" width="${f2(fullW)}" height="${f2(fullH)}" fill="url(#cardBgGrad)"/>`;
  } else {
    bgEl=`<rect x="0" y="0" width="${f2(fullW)}" height="${f2(fullH)}" fill="${xmlEsc(D.bg.colour||"#ffffff")}"/>`;
  }
  groups+=`  <g id="Background">${bgEl}</g>\n`;

  // --- grid group ---
  const G=D.grid;
  if(G && G.on){
    const step=Math.max(1,G.spacingMm), inset=Math.max(0,G.insetMm||0);
    const topGap=Math.max(0,G.topMm||0), botGap=Math.max(0,G.bottomMm||0);
    const gx0=ox+inset, gy0=oy+inset+topGap, gx1=ox+cardW-inset, gy1=oy+cardH-inset-botGap;
    if(gy1>gy0 && gx1>gx0){
      let lines="";
      for(let x=gx0+step; x<gx1; x+=step){ lines+=`<line x1="${f2(x)}" y1="${f2(gy0)}" x2="${f2(x)}" y2="${f2(gy1)}"/>`; }
      for(let y=gy0+step; y<gy1; y+=step){ lines+=`<line x1="${f2(gx0)}" y1="${f2(y)}" x2="${f2(gx1)}" y2="${f2(y)}"/>`; }
      lines+=`<rect x="${f2(gx0)}" y="${f2(gy0)}" width="${f2(gx1-gx0)}" height="${f2(gy1-gy0)}" fill="none"/>`;
      groups+=`  <g id="Grid" stroke="${xmlEsc(G.colour||"#c8c8d0")}" stroke-width="${f2(G.thicknessMm||0.2)}" fill="none">${lines}</g>\n`;
    }
  }

  // --- one group per design layer ---
  D.layers.forEach((L,idx)=>{
    const lx=ox+(L.x||0), ly=oy+(L.y||0);
    const op = (L.opacity==null?1:L.opacity);
    const rot = L.rot ? ` rotate(${f2(L.rot)})` : "";
    const gid = "Layer_"+(idx+1)+"_"+(L.name?L.name.replace(/[^\w]+/g,"_"):L.type);
    const tf = `translate(${f2(lx)} ${f2(ly)})${rot}`;
    let inner="";
    if(L.type==="text"){
      const size=L.sizeMm;
      const lines=(L.text||"").split("\n");
      const total=lines.length;
      inner=lines.map((ln,i)=>{
        const dy=(i-(total-1)/2)*size*1.15;
        return `<text x="0" y="${f2(dy)}" font-family="${xmlEsc((L.font||'sans-serif').replace(/'/g,''))}" font-size="${f2(size)}" font-weight="${L.weight||600}" letter-spacing="${f2(L.spacingMm||0)}" fill="${xmlEsc(L.colour||'#1a1a20')}" text-anchor="middle" dominant-baseline="central">${xmlEsc(ln)}</text>`;
      }).join("");
    } else if(L.type==="shape"){
      const w=L.wMm, h=L.hMm;
      const hasFill=L.fill && L.fill!=="none";
      const hasStroke=L.stroke && L.stroke!=="none" && L.strokeMm>0;
      const fillA = hasFill?`fill="${xmlEsc(L.fill)}"`:`fill="none"`;
      const strokeA = hasStroke?`stroke="${xmlEsc(L.stroke)}" stroke-width="${f2(L.strokeMm)}"`:"";
      if(L.shape==="rect"){
        inner=`<rect x="${f2(-w/2)}" y="${f2(-h/2)}" width="${f2(w)}" height="${f2(h)}" rx="${f2(L.radiusMm||0)}" ${fillA} ${strokeA}/>`;
      } else if(L.shape==="circle"){
        inner=`<ellipse cx="0" cy="0" rx="${f2(w/2)}" ry="${f2(h/2)}" ${fillA} ${strokeA}/>`;
      } else if(L.shape==="star" || L.shape==="heart"){
        inner=`<path d="${shapePathD(L.shape,w,h)}" ${fillA} ${strokeA}/>`;
      } else {
        const col = hasStroke?L.stroke:(L.fill||"#1a1a20");
        inner=`<line x1="${f2(-w/2)}" y1="0" x2="${f2(w/2)}" y2="0" stroke="${xmlEsc(col)}" stroke-width="${f2(L.strokeMm||1)}" stroke-linecap="round"/>`;
      }
    } else if(L.type==="logo" && L.img){
      // rasterise the logo to a PNG and embed
      const w=L.wMm, h=w*(L.img.height/L.img.width);
      const pxW=Math.round(w*ppm), pxH=Math.round(h*ppm);
      const lc=mk(pxW,pxH); lc.getContext("2d").drawImage(L.img,0,0,pxW,pxH);
      inner=`<image xlink:href="${lc.toDataURL('image/png')}" href="${lc.toDataURL('image/png')}" x="${f2(-w/2)}" y="${f2(-h/2)}" width="${f2(w)}" height="${f2(h)}"/>`;
    } else if(L.type==="qr" && L.matrix){
      // render the styled QR to a PNG at high res and embed, centred
      const size=L.sizeMm;
      const pxS=Math.round(size*ppm);
      const qc=mk(pxS,pxS); const qx=qc.getContext("2d");
      // draw using the same routine but at origin
      drawDesignLayer(qx, Object.assign({},L,{x:size/2, y:size/2, rot:0}), ppm);
      inner=`<image xlink:href="${qc.toDataURL('image/png')}" href="${qc.toDataURL('image/png')}" x="${f2(-size/2)}" y="${f2(-size/2)}" width="${f2(size)}" height="${f2(size)}"/>`;
    }
    groups+=`  <g id="${xmlEsc(gid)}" opacity="${f2(op)}" transform="${tf}">${inner}</g>\n`;
  });

  // cut + bleed rect
  const r=CARD_CORNER_MM;
  const cut=`  <g id="Cut"><rect x="${f2(bleed)}" y="${f2(bleed)}" width="${f2(cardW)}" height="${f2(cardH)}" rx="${f2(r)}" fill="none" stroke="${CUT_COLOUR}" stroke-width="${CUT_STROKE_MM}" style="stroke:${CUT_COLOUR}"/></g>\n`;

  return `<?xml version="1.0" encoding="UTF-8"?>\n`+
    `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${f2(fullW)}mm" height="${f2(fullH)}mm" viewBox="0 0 ${f2(fullW)} ${f2(fullH)}">\n`+
    groups+cut+`</svg>`;
}
function buildCardCutSVG(E){
  const mmpp=1/E.ppm;
  const W=(E.fullW*mmpp).toFixed(2), H=(E.fullH*mmpp).toFixed(2);
  const _cd=bmExportDpi(E.fullW, E.fullH, mmpp);
  const targetW=Math.round(E.fullW*mmpp/25.4*_cd);
  const targetH=Math.round(E.fullH*mmpp/25.4*_cd);
  const out=mk(targetW,targetH);
  const ox=out.getContext("2d"); ox.imageSmoothingQuality="high";
  ox.drawImage(E.canvas,0,0,targetW,targetH);
  const png=out.toDataURL("image/png");
  const bx=(E.bleedPx*mmpp).toFixed(2), by=(E.bleedPx*mmpp).toFixed(2);
  const cw=(E.cardW*mmpp).toFixed(2), ch=(E.cardH*mmpp).toFixed(2);
  const r=(E.rPx*mmpp).toFixed(2);
  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${W}mm" height="${H}mm" viewBox="0 0 ${W} ${H}">
  <g id="Artwork"><image xlink:href="${png}" href="${png}" x="0" y="0" width="${W}" height="${H}"/></g>
  <g id="Cut"><rect id="CutContour" x="${bx}" y="${by}" width="${cw}" height="${ch}" rx="${r}" fill="none" stroke="${CUT_COLOUR}" stroke-width="${CUT_STROKE_MM}" style="stroke:${CUT_COLOUR}"/></g>
</svg>`;
}
function dlCardCut(){
  if(opts.cardPreset==="design"){
    saveBlob(new Blob([buildLayeredCardSVG()],{type:"image/svg+xml"}),outName("card-cutfile")+".svg");
    return;
  }
  const E=buildCardExport();
  saveBlob(new Blob([buildCardCutSVG(E)],{type:"image/svg+xml"}),outName("card-cutfile")+".svg");
}
/* Composited proof: the bookmark placed on the backing card, exactly as shown
   in the Preview, rendered at print resolution. This is the "what you'll get"
   image for the customer. */
function buildCardProofCanvas(){
  if(!cardScene) buildCard();
  const E=buildCardExport();
  const ppm=E.ppm, mmpp=1/ppm;
  // The proof is the canonical product shot: folded, front side, as it sits in
  // the cello bag. Render that regardless of the current preview toggles, so the
  // download is always the same recognisable image.
  const savedView=opts.cardView, savedSide=opts.cardSide, savedMag=opts.showMagnet;
  opts.cardView="front"; opts.cardSide="front"; opts.showMagnet=false;
  buildCard();                       // rebuild card art for the front side
  const scale = (mmpp/25.4*PRINT_DPI);
  const showBookmark = opts.showOnCard && baseScene && sceneMm;
  // folded view has no headroom (bookmark sits within the card)
  const outW=Math.round(E.fullW*scale);
  const outH=Math.round(E.fullH*scale);
  const out=mk(outW,outH);
  const x=out.getContext("2d"); x.imageSmoothingQuality="high";
  x.save();
  x.scale(scale,scale);
  x.drawImage(cardScene.canvas,0,0);
  if(showBookmark){
    drawBookmarkOnCard(x,0,cardScene.cardW,cardScene.cardH);
  }
  x.restore();
  opts.cardView=savedView; opts.cardSide=savedSide; opts.showMagnet=savedMag;
  buildCard();                       // restore the live card scene
  return out;
}
function dlCardProof(){
  $("spin").classList.add("show");
  setTimeout(()=>{
    const c=buildCardProofCanvas();
    c.toBlob(b=>{ saveBlob(b,outName("PREVIEW-ONLY")+".png"); $("spin").classList.remove("show"); },"image/png");
  },30);
}

/* ---------- ZIP (store-only; PNG/SVG already compressed) ---------- */
function crc32(bytes){
  let c, crc=0xFFFFFFFF;
  for(let i=0;i<bytes.length;i++){
    c=(crc^bytes[i])&0xFF;
    for(let k=0;k<8;k++) c = c&1 ? (c>>>1)^0xEDB88320 : c>>>1;
    crc=(crc>>>8)^c;
  }
  return (crc^0xFFFFFFFF)>>>0;
}
function makeZip(files){
  // files: [{name, bytes:Uint8Array}]
  const enc=new TextEncoder();
  const chunks=[]; const central=[]; let offset=0;
  const u16=v=>new Uint8Array([v&255,(v>>8)&255]);
  const u32=v=>new Uint8Array([v&255,(v>>8)&255,(v>>16)&255,(v>>24)&255]);
  for(const f of files){
    const nameB=enc.encode(f.name);
    const crc=crc32(f.bytes), sz=f.bytes.length;
    const local=[].concat(
      [...u32(0x04034b50)],[...u16(20)],[...u16(0)],[...u16(0)],
      [...u16(0)],[...u16(0)],            // time/date
      [...u32(crc)],[...u32(sz)],[...u32(sz)],
      [...u16(nameB.length)],[...u16(0)]
    );
    const localHead=new Uint8Array(local);
    chunks.push(localHead, nameB, f.bytes);
    const cen=[].concat(
      [...u32(0x02014b50)],[...u16(20)],[...u16(20)],[...u16(0)],[...u16(0)],
      [...u16(0)],[...u16(0)],
      [...u32(crc)],[...u32(sz)],[...u32(sz)],
      [...u16(nameB.length)],[...u16(0)],[...u16(0)],
      [...u16(0)],[...u16(0)],[...u32(0)],
      [...u32(offset)]
    );
    central.push({head:new Uint8Array(cen), name:nameB});
    offset += localHead.length + nameB.length + f.bytes.length;
  }
  const cstart=offset; let csize=0;
  for(const c of central){ chunks.push(c.head, c.name); csize+=c.head.length+c.name.length; }
  const end=[].concat(
    [...u32(0x06054b50)],[...u16(0)],[...u16(0)],
    [...u16(central.length)],[...u16(central.length)],
    [...u32(csize)],[...u32(cstart)],[...u16(0)]
  );
  chunks.push(new Uint8Array(end));
  return new Blob(chunks,{type:"application/zip"});
}
function canvasToBytes(c){
  return new Promise(res=>{
    c.toBlob(b=>b.arrayBuffer().then(ab=>res(new Uint8Array(ab))),"image/png");
  });
}
async function dlZip(){
  /* Show the problem rather than describe it: turn the magnet guide on, switch
     to the folded view where the clearance is visible, then ask. Thomas, 25 Aug
     2026 - the point is to stop unfoldable files being ordered. */
  const mp=magnetProblem();
  if(mp){
    opts.showMagnet=true; opts.bmView="folded";
    if(typeof syncMagnetToggles==="function") syncMagnetToggles();
    const seg=$("bmViewSeg");
    if(seg) [...seg.children].forEach(b=>b.classList.toggle("on", b.dataset.v==="folded"));
    fitted=false; render();
    showError(mp);
    if(!window.confirm(mp+"\n\n"+stkT("stk.labs.bookmark.zip.download_anyway","Download anyway?"))) return;
  }
  $("spin").classList.add("show");
  try{
    const files=[];
    const push=(name,bytes)=>files.push({name,bytes});
    const enc=new TextEncoder();

    push("READ-ME.txt", enc.encode(
      /* i18n: READ-ME lines come from the locale; file names and the underline stay fixed */
      stkT("stk.labs.bookmark.zip.readme_title","STICKIPLY ORDER FILES")+"\r\n"+
      "=====================\r\n\r\n"+
      stkT("stk.labs.bookmark.zip.readme_upload","UPLOAD WITH YOUR ORDER (or simply upload this whole ZIP):")+"\r\n"+
      "  - "+stkF(stkT("stk.labs.bookmark.zip.readme_bm_print","[file]  (bookmark artwork)"),{file:outName("bookmark-print-300dpi")+".png"})+"\r\n"+
      "  - "+stkF(stkT("stk.labs.bookmark.zip.readme_bm_cut","[file]  (bookmark cut line, exact size)"),{file:outName("bookmark-cutfile")+".svg"})+"\r\n"+
      "  - "+stkF(stkT("stk.labs.bookmark.zip.readme_card_print","[file]  (backing card artwork)"),{file:outName("card-print-300dpi")+".png"})+"\r\n"+
      "  - "+stkF(stkT("stk.labs.bookmark.zip.readme_card_cut","[file]  (backing card cut line)"),{file:outName("card-cutfile")+".svg"})+"\r\n\r\n"+
      stkT("stk.labs.bookmark.zip.readme_preview","PREVIEW ONLY - please don't send these as artwork:")+"\r\n"+
      "  - "+stkF(stkT("stk.labs.bookmark.zip.readme_preview_files","any file starting with [prefix]"),{prefix:"PREVIEW-ONLY"})+"\r\n\r\n"+
      stkT("stk.labs.bookmark.zip.readme_sizing","Sizing note: the print and cut files include a 1.5mm bleed on every\nside, so they measure 3mm larger than the finished cut size shown\nin the tool. That's intentional and normal for print.").replace(/\r?\n/g,"\r\n")+"\r\n"));

    // bookmark print PNG
    const E=buildBookmarkExport();
    if(E){
      const mmpp=1/E.ppm;
      const _d=bmExportDpi(E.scene.width,E.scene.height,mmpp);
      const tw=Math.round(E.scene.width*mmpp/25.4*_d), th=Math.round(E.scene.height*mmpp/25.4*_d);
      const o=mk(tw,th); o.getContext("2d").drawImage(E.scene,0,0,tw,th);
      push(outName("bookmark-print-300dpi")+".png", await canvasToBytes(o));
      // bookmark cut SVG
      push(outName("bookmark-cutfile")+".svg", enc.encode(buildBookmarkCutSVG(E)));
    }
    // card files
    const CE=buildCardExport();
    const t=TEMPLATES[opts.orient];
    const _cd2=bmExportDpi(t.cardW*CE.ppm, t.cardH*CE.ppm, 1/CE.ppm);
    const ctw=Math.round(t.cardW/25.4*_cd2), cth=Math.round(t.cardH/25.4*_cd2);
    const co=mk(ctw,cth); const cx=co.getContext("2d");
    const crPx=Math.round(CARD_CORNER_MM/25.4*_cd2);
    roundRectPath(cx,0,0,ctw,cth,crPx); cx.save(); cx.clip();
    cx.drawImage(CE.canvas, CE.bleedPx,CE.bleedPx,CE.cardW,CE.cardH, 0,0,ctw,cth); cx.restore();
    push(outName("card-print-300dpi")+".png", await canvasToBytes(co));
    push(outName("card-cutfile")+".svg", enc.encode(opts.cardPreset==="design" ? buildLayeredCardSVG() : buildCardCutSVG(CE)));
    // card proof (bookmark on card)
    if(baseScene && sceneMm){
      push(outName("PREVIEW-ONLY")+".png", await canvasToBytes(buildCardProofCanvas()));
    }

    const zip=makeZip(files);
    saveBlob(zip, outBase+"-ORDER-FILES.zip");
  }catch(e){
    $("note").textContent=stkF(stkT("stk.labs.bookmark.zip.build_error","Couldn't build the ZIP: [error]"),{error:(e.message||e)}); $("note").classList.add("show");
  }
  $("spin").classList.remove("show");
}

/* ---------- UI: swatches ---------- */
function subLabel(t){ const l=document.createElement("div"); l.className="sub-label"; l.textContent=t; return l; }
function swatchRow(colours, current, onpick){
  const row=document.createElement("div"); row.className="swatches";
  colours.forEach(col=>{
    const s=document.createElement("div");
    s.className="sw"+(col.toLowerCase()===current.toLowerCase()?" on":"");
    s.style.background=col; s.onclick=()=>onpick(col);
    row.appendChild(s);
  });
  return row;
}
function hslToHex(h,sat,l){
  sat/=100; l/=100;
  const k=n=>(n+h/30)%12;
  const a=sat*Math.min(l,1-l);
  const f=n=>l-a*Math.max(-1,Math.min(k(n)-3,Math.min(9-k(n),1)));
  const to=v=>Math.max(0,Math.min(255,Math.round(v*255))).toString(16).padStart(2,"0");
  return "#"+to(f(0))+to(f(8))+to(f(4));
}
function hexToHsl(hex){
  const m=/^#?([0-9a-f]{6})$/i.exec(hex); if(!m) return null;
  const n=parseInt(m[1],16);
  const r=((n>>16)&255)/255, g=((n>>8)&255)/255, b=(n&255)/255;
  const mx=Math.max(r,g,b), mn=Math.min(r,g,b), d=mx-mn;
  let h=0, sv=0; const l=(mx+mn)/2;
  if(d>0){
    sv = l>0.5 ? d/(2-mx-mn) : d/(mx+mn);
    if(mx===r) h=((g-b)/d+(g<b?6:0)); else if(mx===g) h=(b-r)/d+2; else h=(r-g)/d+4;
    h*=60;
  }
  return {h, s:sv*100, l:l*100};
}
/* clamp any picked colour into a printable (CMYK-friendly) gamut: cap
   saturation so neon RGB greens/cyans can't be chosen; leave neutrals alone */
function printSafe(hex){
  const c=hexToHsl(hex); if(!c) return hex;
  if(c.s<5) return hex.toLowerCase();
  const sat=Math.min(c.s,78), l=Math.max(16,Math.min(93,c.l));
  if(sat===c.s && l===c.l) return hex.toLowerCase();
  return hslToHex(c.h,sat,l);
}
/* vivid 12-segment colour wheel, contiguous segments with playfully varied
   outer radii (hand-made feel). Centre: black, full-spectrum picker, white. */
function buildColourWheel(onpick){
  const wrap=document.createElement("div"); wrap.className="wheelbox";
  const NS="http://www.w3.org/2000/svg";
  const svg=document.createElementNS(NS,"svg");
  svg.setAttribute("viewBox","-56 -56 112 112");
  svg.setAttribute("class","wheel");
  const COLS=["#ffc40c","#f7941d","#f15a24","#d64541","#f4907e","#a463f2","#6c3ce0","#2c5aa0","#17839c","#0f9d58","#a9dcc0","#b8e061"];
  const OUTER=[52,47,50,46,51,47,49,46,52,47,50,46];
  const R0=31;
  const segPath=(r0,r1,a0,a1)=>{
    const p=(r,a)=>[r*Math.cos(a),r*Math.sin(a)];
    const [x0,y0]=p(r1,a0),[x1,y1]=p(r1,a1),[x2,y2]=p(r0,a1),[x3,y3]=p(r0,a0);
    return `M${x0.toFixed(2)} ${y0.toFixed(2)}A${r1} ${r1} 0 0 1 ${x1.toFixed(2)} ${y1.toFixed(2)}L${x2.toFixed(2)} ${y2.toFixed(2)}A${r0} ${r0} 0 0 0 ${x3.toFixed(2)} ${y3.toFixed(2)}Z`;
  };
  COLS.forEach((raw,i)=>{
    const col=printSafe(raw);
    const a0=(i*30-90)*Math.PI/180, a1=((i+1)*30-90)*Math.PI/180;
    const path=document.createElementNS(NS,"path");
    path.setAttribute("d",segPath(R0,OUTER[i],a0,a1));
    path.setAttribute("fill",col);
    path.addEventListener("click",()=>onpick(col));
    svg.appendChild(path);
  });
  wrap.appendChild(svg);
  const centre=document.createElement("div"); centre.className="wheelcentre";
  const dot=(bg,title,fn,cls)=>{
    const d=document.createElement("div");
    d.className="wheeldot"+(cls?" "+cls:""); d.title=title;
    if(bg) d.style.background=bg;
    d.onclick=fn; return d;
  };
  centre.appendChild(dot("#1a1a20",stkT("stk.labs.bookmark.colour.black","Black"),()=>onpick("#1a1a20")));
  const nat=document.createElement("input"); nat.type="color";
  nat.style.cssText="position:absolute;opacity:0;width:1px;height:1px;pointer-events:none";
  nat.oninput=()=>onpick(nat.value);
  const spec=dot(null,stkT("stk.labs.bookmark.colour.all","All colours"),()=>nat.click(),"wheeldot--spec");
  spec.appendChild(nat);
  centre.appendChild(spec);
  centre.appendChild(dot("#ffffff",stkT("stk.labs.bookmark.ui.white","White"),()=>onpick("#ffffff")));
  wrap.appendChild(centre);
  return wrap;
}
const openWheels=new Set();   // host ids whose wheel stays open across re-renders
/* screen eyedropper swatch (Chromium EyeDropper API); null where unsupported */
function eyedropSwatch(onpick){
  if(!window.EyeDropper) return null;
  const d=document.createElement("div");
  d.className="sw eyedrop"; d.title=stkT("stk.labs.bookmark.colour.eyedropper","Pick a colour from anywhere on screen");
  d.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2 22 1-1h3l9-9"/><path d="M3 21v-3l9-9"/><path d="m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z"/></svg>';
  d.onclick=()=>{ new EyeDropper().open().then(r=>onpick(r.sRGBHex)).catch(()=>{}); };
  return d;
}
function buildSwatchHost(host, current, onpick, withArtwork){
  const rawpick=onpick; onpick=c=>rawpick(printSafe(c));
  host.innerHTML="";
  /* one flat grid: basics, then artwork colours, then their tints - no sub-labels.
     Last circle opens the full colour picker; a hex readout sits below. */
  let cols=[...BASICS];
  if(withArtwork && palette.length) cols=cols.concat(palette, paletteLight);
  const seen=new Set();
  cols=cols.filter(c=>{ const k=c.toLowerCase(); if(seen.has(k)) return false; seen.add(k); return true; });
  const row=document.createElement("div"); row.className="swatches";
  cols.forEach(col=>{
    const s=document.createElement("div");
    s.className="sw"+(col.toLowerCase()===current.toLowerCase()?" on":"");
    s.style.background=col; s.onclick=()=>onpick(col);
    row.appendChild(s);
  });
  const wheelWrap=document.createElement("div"); wheelWrap.className="wheelwrap";
  wheelWrap.style.display = openWheels.has(host.id) ? "" : "none";
  wheelWrap.appendChild(buildColourWheel(onpick));
  const cust=document.createElement("div"); cust.className="sw custom"; cust.title=stkT("stk.labs.bookmark.colour.wheel","Colour wheel");
  cust.onclick=()=>{
    const open=wheelWrap.style.display==="none";
    wheelWrap.style.display=open?"":"none";
    if(open) openWheels.add(host.id); else openWheels.delete(host.id);
  };
  row.appendChild(cust);
  const eye=eyedropSwatch(onpick); if(eye) row.appendChild(eye);
  host.appendChild(row);
  host.appendChild(wheelWrap);
  const foot=document.createElement("div"); foot.className="swfoot";
  const dot=document.createElement("span"); dot.className="swfoot__dot"; dot.style.background=current;
  const hex=document.createElement("input");
  hex.className="hexin"; hex.value=current; hex.placeholder="#FFFFFF"; hex.maxLength=7; hex.spellcheck=false;
  hex.addEventListener("change",()=>{
    let v=hex.value.trim(); if(!v.startsWith("#")) v="#"+v;
    if(/^#[0-9a-fA-F]{6}$/.test(v)) onpick(v.toLowerCase()); else hex.value=current;
  });
  foot.appendChild(dot); foot.appendChild(hex);
  host.appendChild(foot);
}
/* bookmark body fill: solid colour or a print-safe 2-stop gradient anchored
   to the cut mask's bounding box (matches the Proof Lab's gradient) */
function bmBgFill(x,bb){
  const a=(opts.bgAngle-90)*Math.PI/180;
  const cx=bb.x+bb.w/2, cy=bb.y+bb.h/2;
  const L=Math.max(1,(Math.abs(bb.w*Math.cos(a))+Math.abs(bb.h*Math.sin(a)))/2);
  const g=x.createLinearGradient(cx-Math.cos(a)*L, cy-Math.sin(a)*L, cx+Math.cos(a)*L, cy+Math.sin(a)*L);
  g.addColorStop(0, printSafe(opts.bgFrom));
  g.addColorStop(1, printSafe(opts.bgTo));
  return g;
}
/* AUTO BLEED. Border and bleed grown from the artwork's own edge colours by
   colour dilation of the ASSEMBLED halves - the same feature as Proof Lab and
   Sticker Sheet Lab, keep the three in step (AI/_rules/LAB-RULES.md rule 6). */
function autoBleedAssembled(halves, maskCanvas, Rpx){
  Rpx=Math.min(300,Math.max(2,Math.round(Rpx)));
  const c=mkLike(halves), x=c.getContext("2d");
  /* Dilate from a HARDENED copy - semi-transparent antialiased edge pixels
     stack into black smears otherwise. Only solid ink grows outward. */
  const hardSrc=mkLike(halves);
  hardSrc.getContext("2d").drawImage(halves,0,0);
  try{ hardenAlpha(hardSrc,200); }catch(e){}
  x.drawImage(hardSrc,0,0);
  let rem=Rpx;
  while(rem>0){
    const st=Math.min(rem,6);
    const snap=mkLike(c); snap.getContext("2d").drawImage(c,0,0);
    x.globalCompositeOperation="destination-over";
    for(let k=0;k<16;k++){const a=k/16*Math.PI*2; x.drawImage(snap,Math.cos(a)*st,Math.sin(a)*st);}
    rem-=st;
  }
  x.globalCompositeOperation="destination-in";
  x.drawImage(maskCanvas,0,0);
  x.globalCompositeOperation="source-over";
  return c;
}
/* DEFRINGE (replaces the 17 Sep seam cover the same day). Thomas, 17 Sep 2026,
   on the first fix: "whats going on here in bookmark creator?" - the seam cover
   repainted the outer 0.3mm of the artwork from the colours inside it, which on
   die-cut art IS the black outline: the outline was eaten and the fill smeared
   past it. The grey line on client-made bookmarks comes from one thing only:
   the antialiased rim pixels carry a greyed COLOUR (the design tool blended
   them toward grey) at partial alpha. So nothing solid is ever touched. A rim
   pixel - partly transparent, within 3px of solid ink AND of empty space - keeps
   its own alpha and takes the colour of the nearest solid ink. A black outline
   stays a black outline with the same soft edge; a pink bookmark's grey rim
   becomes pink. Glows and shadows are wide, so they fail the two-sided test
   and are left alone. Returns a new canvas; the input is not modified. */
function defringeArt(halves){
  try{
    const W=halves.width, H=halves.height;
    const src=halves.getContext("2d").getImageData(0,0,W,H), d=src.data;
    const solid=mk(W,H), clear=mk(W,H), part=mk(W,H);
    const sx=solid.getContext("2d"), cx=clear.getContext("2d"), px=part.getContext("2d");
    const sI=sx.createImageData(W,H), cI=cx.createImageData(W,H), pI=px.createImageData(W,H);
    let any=false;
    for(let i=0;i<d.length;i+=4){
      const a=d[i+3];
      if(a>=250){ sI.data[i]=d[i]; sI.data[i+1]=d[i+1]; sI.data[i+2]=d[i+2]; sI.data[i+3]=255; }
      else if(a<=8){ cI.data[i+3]=255; }
      else { pI.data[i+3]=255; any=true; }
    }
    sx.putImageData(sI,0,0); cx.putImageData(cI,0,0); px.putImageData(pI,0,0);
    /* WHITE RIM (22 Sep 2026, order 9329: the fox and the moon bookmarks both
       showed a seam down the bridge). The design tool left a 1px near-white line
       along the strip at alpha 110-253, so after scaling most of it is SOLID and
       the partial-pixel pass below never saw it (measured: a 1px line 5 to 7
       levels lighter than both neighbours, 59 px in the middle of the fox's
       bridge). A solid pixel within 2px of the edge is recoloured only when the
       colour 2px inside it matches the colour 5px inside (a flat fill, not
       shading) and the pixel is that fill blended toward white. A black outline
       is darker, a real white border is white 2px in, and fur or shading fails
       the flat test, so none of them change. Alpha is never touched. */
    let rimFixed=0;
    try{
      const nonSolid=mk(W,H), nx=nonSolid.getContext("2d");
      nx.drawImage(clear,0,0); nx.drawImage(part,0,0);
      const nearA=dilateCanvas(nonSolid,2), nearB=dilateCanvas(nonSolid,5);
      const cut=(m)=>{ const c=mk(W,H), x=c.getContext("2d"); x.drawImage(solid,0,0); x.globalCompositeOperation="destination-out"; x.drawImage(m,0,0); return c; };
      const rimM=mk(W,H), rx=rimM.getContext("2d");
      rx.drawImage(solid,0,0); rx.globalCompositeOperation="destination-in"; rx.drawImage(nearA,0,0);
      const inA=autoBleedAssembled(cut(nearA), rimM, 4).getContext("2d").getImageData(0,0,W,H).data;
      const inB=autoBleedAssembled(cut(nearB), rimM, 7).getContext("2d").getImageData(0,0,W,H).data;
      const rm=rx.getImageData(0,0,W,H).data;
      for(let i=0;i<d.length;i+=4){
        if(rm[i+3]<250 || inA[i+3]===0 || inB[i+3]===0) continue;
        if(Math.abs(inA[i]-inB[i])+Math.abs(inA[i+1]-inB[i+1])+Math.abs(inA[i+2]-inB[i+2])>12) continue;
        /* a white halo is the fill blended toward white: every channel sits
           the same fraction t of the way from the fill to 255. Darker (an
           outline) gives t<0 and is left alone. */
        let ok=true, tMin=1, tMax=0, tN=0;
        for(let k=0;k<3;k++){
          const inn=inA[i+k], v=d[i+k], room=255-inn;
          if(room<8){ if(Math.abs(v-inn)>6){ ok=false; break; } continue; }
          const t=(v-inn)/room;
          if(t<-0.04){ ok=false; break; }
          tMin=Math.min(tMin,t); tMax=Math.max(tMax,t); tN++;
        }
        if(!ok || !tN || tMax<0.03 || tMax-tMin>0.3) continue;   // 0.03: the moon's rim sat only 6 levels (t 0.065) above its fill
        d[i]=sI.data[i]=inA[i]; d[i+1]=sI.data[i+1]=inA[i+1]; d[i+2]=sI.data[i+2]=inA[i+2];
        rimFixed++;
      }
      if(rimFixed) sx.putImageData(sI,0,0);
    }catch(e){ console.warn("white rim skipped:", e); }
    if(!any){
      if(!rimFixed) return halves;
      const out=mk(W,H); out.getContext("2d").putImageData(src,0,0); return out;
    }
    const NEAR=3;   // 0.25mm at 300dpi: a rim up to ~5px wide still has both neighbours in reach, a glow does not
    px.globalCompositeOperation="destination-in";
    px.drawImage(dilateCanvas(solid,NEAR),0,0);
    px.drawImage(dilateCanvas(clear,NEAR),0,0);
    px.globalCompositeOperation="source-over";
    const ink=autoBleedAssembled(solid, part, NEAR+1).getContext("2d").getImageData(0,0,W,H).data;
    for(let i=0;i<d.length;i+=4){
      if(ink[i+3]>0 && d[i+3]>8 && d[i+3]<250){
        /* A FRINGE, NOT LINE ART (Thomas, 20 Oct 2026, order 9933 dragon: "the sticker was fine... so why is the
           bookmark not"). 85% of that file's black linework is semi-transparent ink beside the cream horns, so
           this pass painted the outlines cream. A matte fringe can only sit as far from the ink as its uncovered
           share allows (a 90% opaque pixel is at most ~10% of the way to the matte); drawn ink at partial alpha is
           much further. Only a pixel inside that limit is recoloured; line art keeps its own colour. */
        const dist=Math.hypot(d[i]-ink[i], d[i+1]-ink[i+1], d[i+2]-ink[i+2]);
        if(dist > (1-d[i+3]/255)*441.7+30) continue;
        d[i]=ink[i]; d[i+1]=ink[i+1]; d[i+2]=ink[i+2];
      }
    }
    const out=mk(W,H); out.getContext("2d").putImageData(src,0,0);
    return out;
  }catch(e){ console.warn("defringe skipped:", e); return halves; }
}
function recolourBg(maskCanvas){
  if(opts.bgMode!=="gradient") return recolour(maskCanvas,opts.bg);
  const c=mk(maskCanvas.width,maskCanvas.height), x=c.getContext("2d");
  x.drawImage(maskCanvas,0,0);
  x.globalCompositeOperation="source-in";
  x.fillStyle=bmBgFill(x,maskBBox(maskCanvas));
  x.fillRect(0,0,c.width,c.height);
  return c;
}
function syncBmDial(){
  const dot=$("bmGradDialDot"); if(!dot) return;
  const a=((opts.bgAngle||135)-90)*Math.PI/180;
  dot.style.left=(50+Math.cos(a)*38.9)+"%";
  dot.style.top=(50+Math.sin(a)*38.9)+"%";
  $("bmGradAngleVal").textContent=Math.round(opts.bgAngle||135)+"\u00b0";
}
function bmHasBridge(){ return !opts.finished && opts.bridgeOn!==false && (opts.bridgeMm||0)>0; }
function renderSwatches(){
  /* AUTO IS NOT OFFERED ON TRANSPARENT ARTWORK (Thomas, 17 Sep 2026: "auto border
     on a transparent image just looks broken"). Auto grows the border from the
     artwork's own outer pixels; on a cut-out drawing those are its black outline,
     so the whole border comes out as a black smear. Greyed out and labelled
     rather than hidden, and a file already on Auto drops back to Solid. */
  let _transp=false;
  try{
    const a=main&&main.art;
    if(a){ if(a.__hasAlpha===undefined) a.__hasAlpha=!!bmArtHasAlpha(a); _transp=a.__hasAlpha; }
  }catch(e){}
  const _seg=$("bmBgModeSeg");
  if(_seg){
    /* 30 Sep 2026: nor with a bridge - Auto grows the edges a few mm and the
       bridge is 10mm+ between the halves, so it printed nothing there. */
    const _bridge=bmHasBridge(), _noAuto=_transp||_bridge;
    const _auto=[..._seg.children].find(b=>b.dataset.v==="auto");
    if(_auto){
      _auto.disabled=_noAuto;
      _auto.style.opacity=_noAuto?".4":"";
      _auto.style.cursor=_noAuto?"not-allowed":"";
      _auto.title=_transp?stkT("stk.labs.bookmark.design.auto_unavailable","Not available: this artwork has a transparent background, so Auto would grow the border out of its outline. Use Solid or Gradient."):_bridge?stkT("stk.labs.bookmark.design.auto_unavailable_bridge","Not available with a bridge: Auto cannot fill the bridge between the halves. Use Solid or Gradient, or turn the bridge off."):stkT("stk.labs.bookmark.design.auto_title","The border and bleed grow from your artwork's own edges");
    }
    if(_noAuto && opts.bgMode==="auto"){ opts.bgMode="solid"; if(!opts.bg) opts.bg="#ffffff"; }
    /* the lit button always says what the mode IS - it used to stay on Auto from
       the markup while a transparent file had quietly been put on Solid */
    [..._seg.children].forEach(b=>b.classList.toggle("on", b.dataset.v===(opts.bgMode||"solid")));
  }
  const bmSolid=opts.bgMode!=="gradient"&&opts.bgMode!=="auto";
  const swp=$("bmSolidWrap"), gwp=$("bmGradWrap");
  if(swp) swp.style.display=bmSolid?"":"none";
  if(gwp) gwp.style.display=opts.bgMode==="gradient"?"":"none";
  const bah=$("bmAutoHint"); if(bah) bah.style.display=opts.bgMode==="auto"?"":"none";
  if(bmSolid) buildSwatchHost($("swatchHost"), opts.bg, c=>{ opts.bg=c; renderSwatches(); buildAndRender(); }, true);
  else {
    buildSwatchHost($("bmGradFromHost"), opts.bgFrom, c=>{ opts.bgFrom=c; renderSwatches(); buildAndRender(); }, true);
    buildSwatchHost($("bmGradToHost"), opts.bgTo, c=>{ opts.bgTo=c; renderSwatches(); buildAndRender(); }, true);
  }
  buildSwatchHost($("foldSwatchHost"), opts.foldColour, c=>{ opts.foldColour=c; renderSwatches(); render(); }, true);
  /* Auto reads the card artwork's own outer ring, so the bleed continues the
     design instead of a flat white edge. Solid is there to override it. */
  const cAuto=opts.cardBgMode==="auto";
  const cSeg=$("cardBgModeSeg");
  if(cSeg) for(const b of cSeg.children) b.classList.toggle("on", b.dataset.v===(opts.cardBgMode||"auto"));
  const cHost=$("cardSwatchHost");
  if(cHost) cHost.style.display=cAuto?"none":"";
  if(!cAuto) buildSwatchHost(cHost, opts.cardBg, c=>{ opts.cardBg=c; renderSwatches(); buildAndRender(); }, true);
}
/* ---------- UI: slots ---------- */
function thumbFor(rec){
  const c=mk(46,46), x=c.getContext("2d");
  const a=bmInk(rec)||rec.art; const sc=Math.min(46/a.width,46/a.height);
  const dw=a.width*sc, dh=a.height*sc;
  x.drawImage(a,(46-dw)/2,(46-dh)/2,dw,dh);
  return c.toDataURL("image/png");
}
function setSlot(slot, rec, defaultTitle, defaultSub, removable){
  slot.innerHTML="";
  if(rec){
    const img=document.createElement("img"); img.className="upslot__thumb"; img.src=thumbFor(rec);
    const t=document.createElement("div"); t.className="upslot__t"; t.textContent=defaultTitle;
    const s=document.createElement("div"); s.className="upslot__s"; s.textContent=stkT("stk.labs.bookmark.slot.tap_to_replace","Tap to replace");
    slot.appendChild(img); slot.appendChild(t); slot.appendChild(s);
    slot.classList.add("filled");
  } else {
    const t=document.createElement("div"); t.className="upslot__t"; t.textContent=defaultTitle;
    const s=document.createElement("div"); s.className="upslot__s"; s.textContent=defaultSub;
    slot.appendChild(t); slot.appendChild(s);
    slot.classList.remove("filled");
  }
  if(removable){
    const xb=document.createElement("div");
    xb.id=slot.id+"X";
    xb.style.cssText="position:absolute;top:6px;right:8px;font-family:var(--bm-display);font-size:15px;color:var(--muted);cursor:pointer;line-height:1";
    xb.textContent="\u00d7";
    xb.style.display = rec ? "block" : "none";
    xb.addEventListener("click",e=>{ e.stopPropagation(); top=null; refreshSlots(); buildAndRender(); });
    slot.style.position="relative";
    slot.appendChild(xb);
  }
}
function refreshSlots(){
  setSlot($("slotMain"), main, stkT("stk.labs.bookmark.slot.main_title","Main design"), stkT("stk.labs.bookmark.slot.main_sub","Used for both halves"), false);
  setSlot($("slotTop"), top, stkT("stk.labs.bookmark.slot.top_title","Top half design"), stkT("stk.labs.bookmark.slot.top_sub","Tap to upload"), true);
}
function refreshCardSlot(){
  setSlot($("slotCard"), card, stkT("stk.labs.bookmark.slot.card_title","Card design"), stkT("stk.labs.bookmark.slot.card_sub","Optional \u00b7 8.7 \u00d7 6.7cm"), false);
}
/* ---------- UI: misc ---------- */
function enableDownloads(){
  const has=!!main;
  const hasCard = !!card || opts.cardPreset==="grid" || opts.cardPreset==="design";
  ["dlPrint","dlCut"].forEach(id=>$(id).disabled=!has);
  $("dlCardPrint").disabled = !(has || hasCard);
  $("dlCardCut").disabled = !(has || hasCard);
  // card proof shows the bookmark on the card, so it needs the bookmark
  $("dlCardProof").disabled = !has;
  // ZIP: anything to bundle
  $("dlZip").disabled = !(has || hasCard);
}
function updateDpi(){
  const el=$("dpi"); if(!main){ el.textContent=""; el.className=""; return; }
  const L=layoutMm(); if(!L){ el.textContent=""; return; }
  // dpi of the bottom half art across its printed width
  const natW=main.srcW*main.trimRatio;
  const dpi=Math.round(natW/(L.halfWmm/25.4));
  let cls="ok", word=stkT("stk.labs.bookmark.dpi.print_ready","Print ready");
  if(dpi<150){ cls="bad"; word=stkT("stk.labs.bookmark.dpi.low_quality","Low quality"); } else if(dpi<300){ cls="mid"; word=stkT("stk.labs.bookmark.dpi.acceptable","Acceptable"); }
  /* i18n: one sentence per case (vector or not) so a translation never glues a suffix on */
  el.textContent=main.isVector?stkF(stkT("stk.labs.bookmark.dpi.readout_vector","[dpi] DPI \u00b7 [quality] (vector)"),{dpi:dpi,quality:word}):stkF(stkT("stk.labs.bookmark.dpi.readout","[dpi] DPI \u00b7 [quality]"),{dpi:dpi,quality:word});
  el.className=cls;
}
/* show the customer the real size of their bookmark, for ordering notes */
function updateDims(){
  const dimsEl=$("canvasDims"), txt=$("dimText");
  if(!main || !sceneMm){ dimsEl.classList.remove("show"); return; }
  const bb=sceneMm.cutBB, ppm=sceneMm.ppm;
  // the preview cut excludes bleed; the finished/exported cut includes it,
  // so report the true cut edge (preview cut + bleed each side)
  const wcm=(bb.w/ppm/10).toFixed(1);
  const hcm=(bb.h/ppm/10).toFixed(1);
  txt.textContent=stkF(stkT("stk.labs.bookmark.dims.bookmark","[w]cm \u00d7 [h]cm \u00b7 files add 1.5mm bleed"),{w:wcm,h:hcm});
  dimsEl.querySelector("b").textContent=stkT("stk.labs.bookmark.dims.bookmark_size","BOOKMARK SIZE");
  dimsEl.classList.add("show");
  /* The size boxes must never disagree with this readout. Border width, cut
     smoothing and bridge length all change the finished piece, so restate them
     on every build - but never while one of them has focus, or a value would be
     rewritten out from under someone mid-type. */
  const ae=root.activeElement;
  if(ae!==$("bmW") && ae!==$("bmH")) syncBmSize();
}
function toggleEl(id,key,after){
  $(id).addEventListener("click",()=>{
    $(id).classList.toggle("on");
    opts[key]=$(id).classList.contains("on");
    if(after) after();
  });
}
function segGroup(id,key,after){
  $(id).addEventListener("click",e=>{
    const b=e.target.closest("button"); if(!b) return;
    [...$(id).children].forEach(c=>c.classList.remove("on"));
    b.classList.add("on");
    opts[key]=b.dataset.v;
    if(after) after();
  });
}
function syncTolVisibility(){ $("gTol").classList.toggle("hidden", !opts.removeWhite); }
function syncBorderVisibility(){ /* border always on; no-op kept for call sites */ }
function syncFoldVisibility(){ $("foldColourWrap").style.display = opts.fold ? "" : "none"; }
function syncOrientHint(){
  const el=$("orientHint"); if(!el) return;
  el.textContent = opts.orient==="portrait"
    ? "Portrait card: bookmark up to 5.5 \u00d7 15cm unfolded."
    : "Landscape card: bookmark up to 6.5 \u00d7 13cm unfolded.";
}
function syncFlipHint(){
  $("flipHint").textContent = opts.flip==="mirror"
    ? stkT("stk.labs.bookmark.flip.hint_mirror","Mirror: best for designs without text, the fold lines up exactly. Switch to Rotate if your design has words.")
    : stkT("stk.labs.bookmark.flip.hint_rotate","Rotate 180\u00b0: keeps text readable on both halves. The halves are point-symmetric, not mirror-aligned.");
}
function switchView(v){
  opts.view=v;
  $("tabBookmark").classList.toggle("on", v==="bookmark");
  $("tabCard").classList.toggle("on", v==="card");
  const th=$("viewThumb");
  if(th) th.style.transform = v==="card" ? "translateX(calc(100% + 4px))" : "translateX(0)";
  $("viewBookmark").classList.toggle("hidden", v!=="bookmark");
  $("viewCard").classList.toggle("hidden", v!=="card");
  fitted=false;                 // canvas size differs between views, re-fit
  buildAndRender();
  requestAnimationFrame(()=>{ buildTicks("bridgeTicksRow","bridge"); paintAllRanges(); });
}
function syncPresetSeg(){
  const seg=$("cardPresetSeg"); if(!seg) return;
  [...seg.children].forEach(b=>b.classList.toggle("on", b.dataset.v===opts.cardPreset));
}

/* ---------- wiring ---------- */
$("tabBookmark").addEventListener("click",()=>switchView("bookmark"));
$("tabCard").addEventListener("click",()=>switchView("card"));

$("slotMain").addEventListener("click",()=>{ activeTarget="main"; $("fileMain").click(); });
// the big canvas overlay ("Build your magnetic bookmark") is the obvious tap
// target on mobile, so make it open the file picker too.
(function(){ const dz=$("drop"); if(dz){ dz.style.cursor="pointer"; dz.addEventListener("click",()=>{ activeTarget="main"; $("fileMain").click(); }); } })();
// floating live preview (mobile): show when the canvas scrolls out of view
(function(){
  const fpClose=$("floatClose"), fpRe=$("floatReopen");
  if(fpClose) fpClose.addEventListener("click",()=>{ floatDismissed=true; updateFloatPreviewVisibility(); });
  if(fpRe) fpRe.addEventListener("click",()=>{ floatDismissed=false; updateFloatPreviewVisibility(); });
  let tk=false;
  const onScroll=()=>{ if(tk) return; tk=true; requestAnimationFrame(()=>{ updateFloatPreviewVisibility(); tk=false; }); };
  window.addEventListener("scroll", onScroll, {passive:true});
  window.addEventListener("resize", onScroll, {passive:true});
})();
$("slotTop").addEventListener("click",e=>{ if(e.target.id==="slotTopX") return; activeTarget="top"; $("fileTop").click(); });
$("slotCard").addEventListener("click",()=>{ activeTarget="card"; $("fileCard").click(); });
$("fileMain").addEventListener("change",e=>{ loadFile(e.target.files[0],"main"); e.target.value=""; });
$("fileTop").addEventListener("change",e=>{ loadFile(e.target.files[0],"top"); e.target.value=""; });
$("fileCard").addEventListener("change",e=>{ loadFile(e.target.files[0],"card"); e.target.value=""; });
toggleEl("twoSidedToggle","_twoSided",()=>{
  $("topSlotWrap").style.display = $("twoSidedToggle").classList.contains("on") ? "" : "none";
  if(!$("twoSidedToggle").classList.contains("on") && top){ top=null; refreshSlots(); buildAndRender(); }
});

/* Orientation is offered in two places - with the artwork and with the backing
   card - because it decides both the bookmark box and the card size. One value,
   so whichever control is used, both repaint. */
function syncOrientSegs(){
  ["orientSeg","orientSegCard"].forEach(id=>{
    const seg=$(id); if(!seg) return;
    [...seg.querySelectorAll("button")].forEach(b=>b.classList.toggle("on", b.dataset.v===opts.orient));
  });
}
function afterOrientChange(){
  syncOrientSegs(); syncOrientHint(); syncBmSize();
  opts.cardWidthMm=null; syncCardWidthRange();
  if(opts.cardPreset==="grid") loadDefaultCard(opts.orient);
  fitted=false; buildAndRender(); updateDpi();
}
segGroup("orientSeg","orient",afterOrientChange);
segGroup("orientSegCard","orient",afterOrientChange);
segGroup("flipSeg","flip",()=>{ syncFlipHint(); buildAndRender(); });

/* Build snap ticks positioned to match the slider thumb's actual travel.
   A range thumb centre runs from thumbW/2 to trackW-thumbW/2, so a value's
   pixel position is thumbW/2 + (v/max)*(trackW-thumbW). Positioning ticks
   this way makes them line up exactly with where the thumb lands. */
const BRIDGE_SNAPS=[0,10,20];
const THUMB_W=18;
function buildTicks(rowId, sliderId){
  const row=$(rowId), sl=$(sliderId);
  if(!row||!sl) return;
  const trackW=sl.getBoundingClientRect().width;
  if(!trackW){ return; }   // hidden (collapsed section); rebuilt on expand
  const max=+sl.max;
  row.innerHTML="";
  // ticks sit relative to the row; row has no padding so use px lefts
  row.style.padding="0";
  BRIDGE_SNAPS.forEach(v=>{
    const px=THUMB_W/2 + (v/max)*(trackW-THUMB_W);
    const t=document.createElement("div");
    t.className="tick"; t.dataset.v=v;
    t.style.left=px+"px";
    t.innerHTML="<i></i>";
    row.appendChild(t);
  });
}
function snapBridge(v){
  for(const s of BRIDGE_SNAPS){ if(Math.abs(v-s)<=2){ return s; } }
  return v;
}
function setBridge(v, fromCard){
  v=Math.max(0,Math.min(50,Math.round(v)));
  opts.bridgeMm=v;
  $("bridge").value=v; $("bridgeVal").textContent=v+"mm";
  if($("bridgeCard")){ $("bridgeCard").value=v; $("bridgeCardVal").textContent=v+"mm"; }
  paintAllRanges();
  buildAndRender(); updateDpi();
}
$("bridge").addEventListener("input",e=>{ $("bridgeVal").textContent=e.target.value+"mm"; });
$("bridge").addEventListener("change",e=>{ setBridge(snapBridge(+e.target.value)); });
$("bridgeTicksRow").addEventListener("click",e=>{ const t=e.target.closest(".tick"); if(t) setBridge(+t.dataset.v); });
$("bridgeW2").addEventListener("input",e=>{ $("bridgeWVal").textContent=e.target.value+"mm"; });
toggleEl("bridgeToggle","bridgeOn",()=>{ syncBridgeUI(); renderSwatches(); buildAndRender(); });
/* The bridge is what gives, not the corner: its slider cannot go below the
   length that leaves room for two floor-radius fillets. Switch the bridge off
   and the halves join directly, so there are no inner fillets to fit. */
function syncBridgeUI(){
  const on=opts.bridgeOn!==false;
  const gb=$("gBridge"), gw=$("gBridgeW");
  if(gb) gb.style.display=on?"":"none";
  if(gw) gw.style.display=on?"":"none";
  if(!on) return;
  const minMm=Math.ceil(bridgeMinMm()*2)/2;
  const r=$("bridge");
  r.min=String(minMm);
  if(+r.value < minMm){ r.value=String(minMm); opts.bridgeMm=minMm; }
  $("bridgeVal").textContent=(+r.value)+"mm";
  const meta=r.parentElement && r.parentElement.querySelector(".range-meta span");
  if(meta) meta.textContent=minMm+"mm";
  try{ paintRange(r); }catch(e){}
}
$("cornerR").addEventListener("input",e=>{ $("cornerVal").textContent=(+e.target.value).toFixed(1)+"mm"; });
$("cornerR").addEventListener("change",e=>{
  opts.cornerAuto=false;                      // a hand-set radius is never overwritten by the measured one
  opts.cornerMm=Math.max(BM_CORNER_MIN_MM, Math.min(BM_CORNER_MAX_MM, +e.target.value));
  buildAndRender();
});
/* the slider only exists for rectangular artwork, and its ceiling is whatever
   the bridge and border actually leave room for - stated, not silently applied */
function syncCornerUI(){
  const g=$("gCorner"); if(!g) return;
  const on=!!bmCutSegs;
  g.style.display = on ? "" : "none";
  if(!on) return;
  const capRaw=bmCornerCapMm||BM_CORNER_MAX_MM;
  const cap=Math.max(BM_CORNER_MIN_MM, Math.min(BM_CORNER_MAX_MM, capRaw));
  const r=$("cornerR");
  r.max=cap.toFixed(2);
  $("cornerMaxLbl").textContent=cap.toFixed(1)+"mm";
  const want=(opts.cornerMm==null?BM_CORNER_MM:opts.cornerMm);
  r.value=Math.min(want,cap);
  const used=bmCornerUsedMm||want;
  $("cornerVal").textContent=used.toFixed(1)+"mm";
  const h=$("cornerHint");
  if(false){
    /* The four inner fillets are limited by the gap between the halves, and
       the border eats that gap from both sides: usable gap = bridge length
       minus twice the border. Below the laminate floor the answer is not to
       shrink the corner silently, it is to say what to change. */
    const needMm = 2*BM_CORNER_MIN_MM + 2*Math.max(opts.borderMm,0);
    h.textContent = "Only "+capRaw.toFixed(1)+"mm fits here, under the "
      + BM_CORNER_MIN_MM.toFixed(2)+"mm the laminate needs. Lengthen the bridge to "
      + (Math.ceil(needMm*2)/2).toFixed(1)+"mm, or narrow the border.";
    h.style.color="var(--bad,#e0484f)";
  } else if(want>cap+0.05){
    h.textContent = stkF(stkT("stk.labs.bookmark.corner.held_at","Held at [mm]mm: a longer bridge or a narrower border makes room for more."),{mm:cap.toFixed(1)});
    h.style.color="";
  } else {
    h.textContent = stkT("stk.labs.bookmark.corner.rectangle_hint","Your artwork is a rectangle, so it is cut as one: straight edges, and the same radius on all twelve corners. Remove the background instead to cut around the artwork itself.");
    h.style.color="";
  }
  try{ paintRange(r); }catch(e){}
}
$("bridgeW2").addEventListener("change",e=>{ opts.bridgeWmm=+e.target.value; $("bridgeWVal").textContent=opts.bridgeWmm+"mm"; buildAndRender(); });
/* Artwork centre. The tool measures where the design's mass actually sits and
   folds there; this is the override for when the customer disagrees, which is a
   judgement call no measurement settles. Two sources can set this value, so the
   rule is explicit: null means the measurement owns it, a number means the
   customer does, and clicking the readout hands it back to the measurement. */
function syncArtCentre(){
  const el=$("artCentre"), lab=$("artCentreVal"), btn=$("artCentreReset");
  if(!el||!lab) return;
  const auto=(opts.artCentre==null);
  const v=Math.round(centreFrac()*100);
  el.value=Math.min(80, Math.max(20, v));
  lab.textContent = auto ? stkT("stk.labs.bookmark.ui.auto","Auto") : (v+"%");
  // the button only exists when there is something to undo, so "Auto" is never
  // offered as an action while it is already what you have
  if(btn) btn.style.display = auto ? "none" : "";
}
function resetArtCentre(){
  if(opts.artCentre==null) return;
  opts.artCentre=null; syncArtCentre(); buildAndRender();
}
/* Snap back to Auto. Clicking the readout was the only way back, which is not
   discoverable while your hand is on the slider - Thomas, 25 Aug. Within 2% of
   the measured centre the slider gives up the override and returns to it, so
   dragging past and back is a complete round trip. */
const AUTO_SNAP_PCT = 2;
function autoPct(){ return Math.round(inkCentreFrac(main && main.art)*100); }
function nearAuto(v){ return Math.abs(v - autoPct()) <= AUTO_SNAP_PCT; }
$("artCentre").addEventListener("input",e=>{
  const v=+e.target.value;
  $("artCentreVal").textContent = nearAuto(v) ? stkT("stk.labs.bookmark.ui.auto","Auto") : (v+"%");
});
$("artCentre").addEventListener("change",e=>{
  const v=+e.target.value;
  opts.artCentre = nearAuto(v) ? null : v/100;
  syncArtCentre(); buildAndRender();
});
$("artCentreReset").addEventListener("click", resetArtCentre);
$("smooth").addEventListener("input",e=>{ $("smoothVal").textContent=(+e.target.value).toFixed(1)+"mm"; });
$("smooth").addEventListener("change",e=>{ opts.smoothMm=+e.target.value; $("smoothVal").textContent=opts.smoothMm.toFixed(1)+"mm"; buildAndRender(); });
$("borderW").addEventListener("input",e=>{ $("borderVal").textContent=(+e.target.value).toFixed(1)+"mm"; });
$("borderW").addEventListener("change",e=>{ opts.borderMm=+e.target.value; $("borderVal").textContent=opts.borderMm.toFixed(1)+"mm"; buildAndRender(); });
$("tol").addEventListener("input",e=>{ $("tolVal").textContent=(+e.target.value)+"%"; });
$("tol").addEventListener("change",e=>{ opts.removeTol=+e.target.value; $("tolVal").textContent=opts.removeTol+"%"; if(opts.removeWhite) reprocessAll(); });
function syncKeySwatch(){ const k=$("keySwatch"); if(k) k.style.background=opts.removeKey; }
function setRemoveKey(hex){ opts.removeKey=hex; syncKeySwatch(); if(opts.removeWhite) reprocessAll(); }
$("keyPick").addEventListener("click",()=>{
  if(window.EyeDropper){ new EyeDropper().open().then(r=>setRemoveKey(r.sRGBHex)).catch(()=>{}); }
  else $("keyNative").click();
});
$("keyNative").addEventListener("input",e=>setRemoveKey(e.target.value));
$("keyReset").addEventListener("click",()=>setRemoveKey("#ffffff"));

toggleEl("rmWhite","removeWhite",()=>{ syncTolVisibility(); reprocessAll(); });
function syncFinishedUI(){
  const f=opts.finished;
  const hideGroup=el=>{ const g=el && el.closest(".group"); if(g) g.style.display=f?"none":""; };
  hideGroup($("flipSeg")); hideGroup($("bridge")); hideGroup($("bridgeW2")); hideGroup($("bridgeCard"));
  // a finished bookmark has no fold, so there is no centre to place it on
  hideGroup($("artCentre"));
  const tsRow=$("twoSidedToggle") && $("twoSidedToggle").closest(".row");
  if(tsRow) tsRow.style.display=f?"none":"";
  if(f){ $("topSlotWrap").style.display="none"; }
  else { $("topSlotWrap").style.display = $("twoSidedToggle").classList.contains("on") ? "" : "none"; }
  const hint=$("finishedHint"); if(hint) hint.style.display=f?"":"none";
}
toggleEl("finishedToggle","finished",()=>{
  if(opts.finished){
    // ready-made designs usually carry their own border already
    opts.borderMm=0; $("borderW").value=0; $("borderVal").textContent="0.0mm"; paintAllRanges();
  }
  syncFinishedUI(); renderSwatches(); fitted=false; buildAndRender(); updateDpi();
});
toggleEl("showOnCard","showOnCard",()=>{ render(); });
/* The magnet guide is one setting shown in two places - the card Preview and
   the bookmark Preview. Two controls over one value is exactly where UIs drift,
   so neither owns it: both read opts.showMagnet through syncMagnetToggles(). */
function syncMagnetToggles(){
  ["magnetToggle","magnetToggleBm"].forEach(id=>{
    const el=$(id); if(el) el.classList.toggle("on", !!opts.showMagnet);
  });
}
toggleEl("magnetToggle","showMagnet",()=>{ syncMagnetToggles(); render(); });
$("magnetToggleBm").addEventListener("click",()=>{
  opts.showMagnet=!opts.showMagnet; syncMagnetToggles(); render();
});

/* load Stickiply's default grid backing card (per orientation), cache it */
function loadDefaultCard(orient, cb){
  if(defaultCardImg[orient]){ cb&&cb(); return; }
  const im=new Image();
  im.crossOrigin="anonymous";
  im.onload=()=>{ defaultCardImg[orient]=im; cb&&cb(); };
  im.onerror=()=>{ cb&&cb(); };
  im.src=DEFAULT_CARDS[orient];
}
function applyCardPreset(){
  const p=opts.cardPreset;
  // the upload slot stays visible; dropping a card file switches to "upload"
  // grid + design have their own background, so hide the plain bg colour control
  $("cardBgGroup").style.display = (p==="grid"||p==="design") ? "none" : "";
  // the design controls live in their own section, shown only for "design"
  const ds=$("designSection");
  if(ds) ds.style.display = p==="design" ? "" : "none";
  const hint=$("cardPresetHint");
  if(hint){
    hint.textContent = p==="design"
      ? stkT("stk.labs.bookmark.card.preset_hint_design","Design your card in the section below: background, grid, text, logo or QR code.")
      : stkT("stk.labs.bookmark.card.preset_hint","Use our default unbranded card, upload your own, or design one right here. 8.7 \u00d7 6.7cm, 6.5mm rounded corners.");
  }
  if(p==="grid"){
    loadDefaultCard(opts.orient, ()=>{ buildAndRender(); });
  }
  if(p==="design"){ invalidateCardDesign(); renderLayerList(); renderEditorPanel(); }
  enableDownloads();
}
segGroup("cardPresetSeg","cardPreset",()=>{ applyCardPreset(); fitted=false; buildAndRender(); });

/* ---------- card editor ---------- */
const GOOGLE_FONTS=[
  {name:stkT("stk.labs.bookmark.editor.font_sans","Sans (default)"), css:"sans-serif", google:false},
  {name:stkT("stk.labs.bookmark.editor.font_serif","Serif"), css:"serif", google:false},
  {name:"Poppins", css:"'Poppins'", google:true, family:"Poppins"},
  {name:"Montserrat", css:"'Montserrat'", google:true, family:"Montserrat"},
  {name:"Playfair Display", css:"'Playfair Display'", google:true, family:"Playfair Display"},
  {name:"Lobster", css:"'Lobster'", google:true, family:"Lobster"},
  {name:"Pacifico", css:"'Pacifico'", google:true, family:"Pacifico"},
  {name:"Bebas Neue", css:"'Bebas Neue'", google:true, family:"Bebas Neue"},
  {name:"Caveat", css:"'Caveat'", google:true, family:"Caveat"},
  {name:"Dancing Script", css:"'Dancing Script'", google:true, family:"Dancing Script"},
  {name:"Oswald", css:"'Oswald'", google:true, family:"Oswald"},
  {name:"Anton", css:"'Anton'", google:true, family:"Anton"},
  {name:"Righteous", css:"'Righteous'", google:true, family:"Righteous"},
  {name:"Abril Fatface", css:"'Abril Fatface'", google:true, family:"Abril Fatface"}
];
const loadedFonts=new Set();
function loadGoogleFont(f, onready){
  if(!f.google){ onready&&onready(); return; }
  if(loadedFonts.has(f.family)){ onready&&onready(); return; }
  loadedFonts.add(f.family);
  // inject the stylesheet into the MAIN document head so canvas can use the font
  const href="https://fonts.googleapis.com/css2?family="+encodeURIComponent(f.family).replace(/%20/g,"+")+":wght@400;600;700&display=swap";
  const link=document.createElement("link"); link.rel="stylesheet"; link.href=href;
  document.head.appendChild(link);
  // wait for the actual font to be ready, then redraw
  const fam=f.family;
  const tryReady=()=>{
    if(document.fonts && document.fonts.load){
      Promise.all([document.fonts.load("16px '"+fam+"'"), document.fonts.load("700 16px '"+fam+"'")])
        .then(()=>{ onready&&onready(); })
        .catch(()=>{ setTimeout(()=>onready&&onready(), 600); });
    } else { setTimeout(()=>onready&&onready(), 600); }
  };
  // give the stylesheet a tick to register the @font-face, then load
  setTimeout(tryReady, 60);
}
function refreshDesign(){ invalidateCardDesign(); buildAndRender(); }

// background type
(function wireEditor(){
  const seg=$("edBgType");
  if(seg) seg.addEventListener("click",e=>{
    const b=e.target.closest("button"); if(!b) return;
    [...seg.children].forEach(c=>c.classList.toggle("on",c===b));
    opts.cardDesign.bg.type=b.dataset.v;
    $("edSolidWrap").style.display = b.dataset.v==="solid" ? "" : "none";
    $("edGradWrap").style.display  = b.dataset.v==="gradient" ? "" : "none";
    refreshDesign();
  });
  const ang=$("edGradAngle");
  if(ang){
    ang.addEventListener("input",e=>{ $("edGradAngleVal").textContent=e.target.value+"\u00b0"; opts.cardDesign.bg.angle=+e.target.value; refreshDesign(); });
  }
  const gt=$("edGridToggle");
  if(gt) gt.addEventListener("click",()=>{
    gt.classList.toggle("on");
    opts.cardDesign.grid.on=gt.classList.contains("on");
    $("edGridOpts").style.display = opts.cardDesign.grid.on ? "" : "none";
    refreshDesign();
  });
  // grid config sliders
  const gsp=$("edGridSpacing");
  if(gsp) gsp.addEventListener("input",e=>{ opts.cardDesign.grid.spacingMm=+e.target.value; $("edGridSpacingVal").textContent=(+e.target.value)+"mm"; refreshDesign(); });
  const gth=$("edGridThick");
  if(gth) gth.addEventListener("input",e=>{ opts.cardDesign.grid.thicknessMm=+e.target.value; $("edGridThickVal").textContent=(+e.target.value).toFixed(2)+"mm"; refreshDesign(); });
  const gin=$("edGridInset");
  if(gin) gin.addEventListener("input",e=>{ opts.cardDesign.grid.insetMm=+e.target.value; $("edGridInsetVal").textContent=(+e.target.value)+"mm"; refreshDesign(); });
  const gtop=$("edGridTop");
  if(gtop) gtop.addEventListener("input",e=>{ opts.cardDesign.grid.topMm=+e.target.value; $("edGridTopVal").textContent=(+e.target.value)+"mm"; refreshDesign(); });
  const gbot=$("edGridBottom");
  if(gbot) gbot.addEventListener("input",e=>{ opts.cardDesign.grid.bottomMm=+e.target.value; $("edGridBottomVal").textContent=(+e.target.value)+"mm"; refreshDesign(); });
  const gch=$("edGridColourHost");
  if(gch) gch.appendChild(colourPicker(opts.cardDesign.grid.colour, c=>{ opts.cardDesign.grid.colour=c; refreshDesign(); }));
  $("edAddText") && $("edAddText").addEventListener("click",()=>addDesignLayer("text"));
  $("edAddLogo") && $("edAddLogo").addEventListener("click",()=>{ designLogoTarget=true; $("edLogoFile").click(); });
  $("edAddQR") && $("edAddQR").addEventListener("click",()=>addDesignLayer("qr"));
  $("edAddShape") && $("edAddShape").addEventListener("click",()=>addDesignLayer("shape"));
  $("edLogoFile") && $("edLogoFile").addEventListener("change",e=>{ const f=e.target.files[0]; if(f) loadDesignLogo(f); e.target.value=""; });
  // background colour pickers
  const bgHost=$("edBgHost");
  if(bgHost) bgHost.appendChild(colourPicker(opts.cardDesign.bg.colour, c=>{ opts.cardDesign.bg.colour=c; refreshDesign(); }));
  const gf=$("edGradFromHost");
  if(gf) gf.appendChild(colourPicker(opts.cardDesign.bg.from, c=>{ opts.cardDesign.bg.from=c; refreshDesign(); }));
  const gto=$("edGradToHost");
  if(gto) gto.appendChild(colourPicker(opts.cardDesign.bg.to, c=>{ opts.cardDesign.bg.to=c; refreshDesign(); }));
})();

let designLogoTarget=false;
function newId(){ return "L"+Math.random().toString(36).slice(2,8); }
function cardCentreMm(){ const t=TEMPLATES[opts.orient]; return { x:t.cardW/2, y:t.cardH/2 }; }
function addDesignLayer(type){
  const t=TEMPLATES[opts.orient]; const ctr=cardCentreMm();
  let L;
  if(type==="text"){
    L={ id:newId(), type:"text", text:stkT("stk.labs.bookmark.editor.default_text","Your text"), x:ctr.x, y:ctr.y, sizeMm:6, colour:"#1a1a20", font:"sans-serif", weight:"600", align:"center", rot:0, opacity:1 };
  } else if(type==="qr"){
    L={ id:newId(), type:"qr", data:"https://stickiply.com", x:ctr.x, y:ctr.y, sizeMm:20, fg:"#1a1a20", bg:"#ffffff", eye:"#1a1a20", dotStyle:"square", matrix:null, rot:0, opacity:1 };
    L.matrix=qrMatrix(L.data);
  } else if(type==="shape"){
    L={ id:newId(), type:"shape", shape:"rect", x:ctr.x, y:ctr.y, wMm:30, hMm:18, fill:"#5f4c9f", stroke:"none", strokeMm:0, rot:0, opacity:1, radiusMm:2 };
  }
  if(!L) return;
  opts.cardDesign.layers.push(L);
  opts.selLayer=L.id;
  renderEditorPanel(); renderLayerList(); refreshDesign();
}
function loadDesignLogo(file){
  const url=URL.createObjectURL(file);
  const im=new Image();
  im.onload=()=>{
    const t=TEMPLATES[opts.orient]; const ctr=cardCentreMm();
    const L={ id:newId(), type:"logo", img:im, x:ctr.x, y:ctr.y, wMm:Math.min(40,t.cardW*0.5), rot:0, opacity:1 };
    opts.cardDesign.layers.push(L); opts.selLayer=L.id;
    renderEditorPanel(); renderLayerList(); refreshDesign();
    URL.revokeObjectURL(url);
  };
  im.src=url;
}
function selectedLayer(){ return opts.cardDesign.layers.find(l=>l.id===opts.selLayer)||null; }
function deleteLayer(id){
  opts.cardDesign.layers=opts.cardDesign.layers.filter(l=>l.id!==id);
  if(opts.selLayer===id) opts.selLayer=null;
  renderEditorPanel(); renderLayerList(); refreshDesign();
}
/* Photoshop-like layer list (Layers tab in the editor) */
function layerLabel(L){
  if(L.name) return L.name;
  if(L.type==="text") return stkF(stkT("stk.labs.bookmark.layers.label_text","Text \u2014 [text]"),{text:((L.text||"").split("\n")[0].slice(0,18)||stkT("stk.labs.bookmark.layers.label_text_empty","empty"))});
  if(L.type==="logo") return stkT("stk.labs.bookmark.layers.label_logo","Logo");
  if(L.type==="qr") return stkF(stkT("stk.labs.bookmark.layers.label_qr","QR \u2014 [data]"),{data:(L.data||"").slice(0,18)});
  if(L.type==="shape") return stkF(stkT("stk.labs.bookmark.layers.label_shape","Shape \u2014 [shape]"),{shape:(L.shape||"rect")});
  return stkT("stk.labs.bookmark.layers.label_layer","Layer");
}
function moveLayer(id, dir){
  const a=opts.cardDesign.layers; const i=a.findIndex(l=>l.id===id);
  if(i<0) return; const j=i+dir;
  if(j<0||j>=a.length) return;
  const tmp=a[i]; a[i]=a[j]; a[j]=tmp;
  renderLayerList(); invalidateCardDesign(); buildAndRender();
}
function duplicateLayer(id){
  const a=opts.cardDesign.layers; const i=a.findIndex(l=>l.id===id);
  if(i<0) return;
  const src=a[i];
  const copy=Object.assign({}, src);   // shallow clone (img ref shared, matrix shared = fine)
  copy.id=newId();
  copy.x=(src.x||0)+3; copy.y=(src.y||0)+3;   // offset so it's visible
  const t=TEMPLATES[opts.orient];
  copy.x=Math.max(0,Math.min(t.cardW,copy.x)); copy.y=Math.max(0,Math.min(t.cardH,copy.y));
  a.splice(i+1,0,copy);
  opts.selLayer=copy.id;
  renderEditorPanel(); renderLayerList(); refreshDesign();
}
function nudgeLayer(id, dxMm, dyMm){
  const L=opts.cardDesign.layers.find(l=>l.id===id); if(!L) return;
  const t=TEMPLATES[opts.orient];
  L.x=Math.max(0,Math.min(t.cardW,(L.x||0)+dxMm));
  L.y=Math.max(0,Math.min(t.cardH,(L.y||0)+dyMm));
  invalidateCardDesign(); buildAndRender();
}
function renderLayerList(){
  const host=$("edLayerList"); if(!host) return;
  const layers=opts.cardDesign.layers;
  $("edLayerEmpty").style.display = layers.length ? "none" : "";
  host.innerHTML="";
  // top of the visual stack = end of array; show top-first
  for(let i=layers.length-1;i>=0;i--){
    const L=layers[i];
    const row=document.createElement("div");
    row.className="layeritem"+(L.id===opts.selLayer?" on":"");
    const name=document.createElement("span"); name.className="layeritem__name"; name.textContent=layerLabel(L);
    name.onclick=()=>{ opts.selLayer=L.id; renderEditorPanel(); renderLayerList(); render(); };
    const startRename=()=>{
      const inp=document.createElement("input"); inp.type="text"; inp.value=L.name||layerLabel(L);
      inp.className="layeritem__rename";
      inp.onclick=e=>e.stopPropagation();
      const commit=()=>{ const v=inp.value.trim(); L.name = v || null; renderLayerList(); };
      inp.onkeydown=e=>{ if(e.key==="Enter"){ commit(); } else if(e.key==="Escape"){ renderLayerList(); } };
      inp.onblur=commit;
      name.replaceWith(inp); inp.focus(); inp.select();
    };
    name.ondblclick=e=>{ e.stopPropagation(); startRename(); };
    const ctr=document.createElement("div"); ctr.className="layeritem__ctr";
    const ren=document.createElement("button"); ren.title=stkT("stk.labs.bookmark.layers.rename","Rename"); ren.className="ren";
    ren.innerHTML='<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
    ren.onclick=e=>{ e.stopPropagation(); startRename(); };
    const up=document.createElement("button"); up.title=stkT("stk.labs.bookmark.layers.bring_forward","Bring forward"); up.textContent="\u2191";
    up.disabled = i===layers.length-1; up.onclick=()=>moveLayer(L.id,+1);
    const dn=document.createElement("button"); dn.title=stkT("stk.labs.bookmark.layers.send_backward","Send backward"); dn.textContent="\u2193";
    dn.disabled = i===0; dn.onclick=()=>moveLayer(L.id,-1);
    const del=document.createElement("button"); del.title=stkT("stk.labs.bookmark.ui.delete","Delete"); del.textContent="\u00d7"; del.className="del";
    del.onclick=()=>{ deleteLayer(L.id); renderLayerList(); };
    ctr.appendChild(ren); ctr.appendChild(up); ctr.appendChild(dn); ctr.appendChild(del);
    row.appendChild(name); row.appendChild(ctr);
    host.appendChild(row);
  }
}
function renderEditorPanel(){
  const host=$("edLayerPanel"); if(!host) return;
  const L=selectedLayer();
  if(!L){ host.style.display="none"; host.innerHTML=""; return; }
  host.style.display="";
  host.innerHTML="";
  const wrap=document.createElement("div"); wrap.className="group"; wrap.style.marginTop="16px";
  const head=document.createElement("label"); head.className="lbl-sub";
  head.textContent = L.type==="text"?stkT("stk.labs.bookmark.editor.selected_text","Selected text"):L.type==="logo"?stkT("stk.labs.bookmark.editor.selected_logo","Selected logo"):L.type==="shape"?stkT("stk.labs.bookmark.editor.selected_shape","Selected shape"):stkT("stk.labs.bookmark.editor.selected_qr","Selected QR code");
  wrap.appendChild(head);

  const mkRange=(label,min,max,step,val,on)=>{
    const g=document.createElement("div"); g.style.margin="8px 0";
    const l=document.createElement("div"); l.className="lbl-sub"; l.textContent=label; g.appendChild(l);
    const r=document.createElement("input"); r.type="range"; r.min=min; r.max=max; r.step=step; r.value=val;
    r.addEventListener("input",e=>on(+e.target.value)); g.appendChild(r); return g;
  };
  if(L.type==="text"){
    const ta=document.createElement("textarea"); ta.value=L.text; ta.rows=2;
    ta.style.cssText="width:100%;border:1.5px solid var(--line);border-radius:10px;padding:8px;font-family:inherit;font-size:13px;resize:vertical";
    ta.addEventListener("input",e=>{ L.text=e.target.value; refreshDesign(); });
    wrap.appendChild(ta);
    // font picker (Google Fonts, loaded on demand)
    const fl=document.createElement("div"); fl.className="lbl-sub"; fl.style.marginTop="10px"; fl.textContent=stkT("stk.labs.bookmark.editor.font","Font"); wrap.appendChild(fl);
    const sel=document.createElement("select");
    sel.style.cssText="width:100%;border:1.5px solid var(--line);border-radius:10px;padding:8px;font-family:inherit;font-size:13px;background:var(--bg);color:var(--ink)";
    GOOGLE_FONTS.forEach(f=>{ const o=document.createElement("option"); o.value=f.css; o.textContent=f.name; if((L.font||"")===f.css) o.selected=true; sel.appendChild(o); });
    sel.addEventListener("change",e=>{
      const f=GOOGLE_FONTS.find(g=>g.css===e.target.value);
      L.font=f.css;
      if(f.google) loadGoogleFont(f, ()=>{ invalidateCardDesign(); buildAndRender(); });
      refreshDesign();
    });
    wrap.appendChild(sel);
    // weight
    wrap.appendChild((()=>{ const g=document.createElement("div"); g.style.margin="8px 0";
      const l=document.createElement("div"); l.className="lbl-sub"; l.textContent=stkT("stk.labs.bookmark.editor.weight","Weight"); g.appendChild(l);
      const seg=document.createElement("div"); seg.className="seg";
      [["400",stkT("stk.labs.bookmark.editor.weight_regular","Regular")],["600",stkT("stk.labs.bookmark.editor.weight_medium","Medium")],["700",stkT("stk.labs.bookmark.editor.weight_bold","Bold")]].forEach(([w,lab])=>{ const btn=document.createElement("button"); btn.textContent=lab;
        if((L.weight||"600")===w) btn.classList.add("on");
        btn.onclick=()=>{ L.weight=w; [...seg.children].forEach(c=>c.classList.remove("on")); btn.classList.add("on"); refreshDesign(); };
        seg.appendChild(btn); });
      g.appendChild(seg); return g; })());
    wrap.appendChild(mkRange(stkT("stk.labs.bookmark.editor.size","Size"),3,20,0.5,L.sizeMm,v=>{ L.sizeMm=v; refreshDesign(); }));
    wrap.appendChild(mkRange(stkT("stk.labs.bookmark.editor.letter_spacing","Letter spacing"),0,3,0.1,L.spacingMm||0,v=>{ L.spacingMm=v; refreshDesign(); }));
    const ch=document.createElement("div"); ch.className="lbl-sub"; ch.textContent=stkT("stk.labs.bookmark.ui.colour","Colour"); wrap.appendChild(ch);
    wrap.appendChild(colourPicker(L.colour,c=>{ L.colour=c; refreshDesign(); }));
  } else if(L.type==="logo"){
    wrap.appendChild(mkRange(stkT("stk.labs.bookmark.editor.size","Size"),10,80,1,L.wMm,v=>{ L.wMm=v; refreshDesign(); }));
    wrap.appendChild(mkRange(stkT("stk.labs.bookmark.editor.rotation","Rotation"),-180,180,5,L.rot,v=>{ L.rot=v; refreshDesign(); }));
  } else if(L.type==="qr"){
    const inp=document.createElement("input"); inp.type="text"; inp.value=L.data;
    inp.style.cssText="width:100%;border:1.5px solid var(--line);border-radius:10px;padding:8px;font-family:inherit;font-size:13px";
    inp.addEventListener("change",e=>{ L.data=e.target.value; L.matrix=qrMatrix(L.data); refreshDesign(); });
    const il=document.createElement("div"); il.className="lbl-sub"; il.textContent=stkT("stk.labs.bookmark.editor.link_or_text","Link or text"); wrap.appendChild(il); wrap.appendChild(inp);
    wrap.appendChild(mkRange(stkT("stk.labs.bookmark.editor.size","Size"),12,40,1,L.sizeMm,v=>{ L.sizeMm=v; refreshDesign(); }));
    // dot style
    const ds=document.createElement("div"); ds.className="lbl-sub"; ds.style.marginTop="10px"; ds.textContent=stkT("stk.labs.bookmark.editor.dot_style","Dot style"); wrap.appendChild(ds);
    const seg=document.createElement("div"); seg.className="seg";
    [["square",stkT("stk.labs.bookmark.editor.dot_square","Square")],["rounded",stkT("stk.labs.bookmark.editor.dot_rounded","Rounded")],["dots",stkT("stk.labs.bookmark.editor.dot_dots","Dots")]].forEach(([v,lab])=>{
      const btn=document.createElement("button"); btn.textContent=lab;
      if((L.dotStyle||"square")===v) btn.classList.add("on");
      btn.onclick=()=>{ L.dotStyle=v; [...seg.children].forEach(c=>c.classList.remove("on")); btn.classList.add("on"); refreshDesign(); };
      seg.appendChild(btn);
    });
    wrap.appendChild(seg);
    // colours: dots, background, eyes
    const cl1=document.createElement("div"); cl1.className="lbl-sub"; cl1.style.marginTop="10px"; cl1.textContent=stkT("stk.labs.bookmark.editor.dot_colour","Dot colour"); wrap.appendChild(cl1);
    wrap.appendChild(colourPicker(L.fg,c=>{ L.fg=c; refreshDesign(); }));
    const cl2=document.createElement("div"); cl2.className="lbl-sub"; cl2.style.marginTop="8px"; cl2.textContent=stkT("stk.labs.bookmark.editor.eye_colour","Eye colour"); wrap.appendChild(cl2);
    wrap.appendChild(colourPicker(L.eye,c=>{ L.eye=c; refreshDesign(); }));
    const cl3=document.createElement("div"); cl3.className="lbl-sub"; cl3.style.marginTop="8px"; cl3.textContent=stkT("stk.labs.bookmark.ui.background","Background"); wrap.appendChild(cl3);
    const bgRow=document.createElement("div"); bgRow.className="row"; bgRow.style.marginBottom="8px";
    const bgLbl=document.createElement("span"); bgLbl.className="lbl"; bgLbl.textContent=stkT("stk.labs.bookmark.editor.transparent_background","Transparent background");
    const bgTog=document.createElement("div"); bgTog.className="toggle"+(L.bg==="transparent"?" on":"");
    bgTog.onclick=()=>{ if(L.bg==="transparent"){ L.bg="#ffffff"; } else { L._bgPrev=L.bg; L.bg="transparent"; } renderEditorPanel(); refreshDesign(); };
    bgRow.appendChild(bgLbl); bgRow.appendChild(bgTog); wrap.appendChild(bgRow);
    if(L.bg!=="transparent"){
      wrap.appendChild(colourPicker(L.bg,c=>{ L.bg=c; refreshDesign(); }));
    }
    const warn=document.createElement("div"); warn.className="hint"; warn.style.marginTop="9px";
    warn.textContent = L.bg==="transparent"
      ? stkT("stk.labs.bookmark.editor.qr_warn_transparent","Transparent: make sure the card behind has enough contrast with the dots, or it won't scan.")
      : stkT("stk.labs.bookmark.editor.qr_warn_contrast","Keep good contrast between dots and background, or the code may not scan.");
    wrap.appendChild(warn);
  } else if(L.type==="shape"){
    // shape type
    const sl=document.createElement("div"); sl.className="lbl-sub"; sl.textContent=stkT("stk.labs.bookmark.ui.shape","Shape"); wrap.appendChild(sl);
    const sseg=document.createElement("div"); sseg.className="seg";
    const SHAPE_ICONS={
      rect:'<rect x="4" y="6" width="16" height="12" rx="2"/>',
      circle:'<ellipse cx="12" cy="12" rx="8" ry="6.5"/>',
      star:'<path d="m12 3 2.6 5.6 6 .7-4.5 4.1 1.2 5.9L12 16.3 6.7 19.3l1.2-5.9L3.4 9.3l6-.7Z"/>',
      heart:'<path d="M12 20C6.5 15.7 4 12.5 4 9.6 4 7.1 5.9 5.2 8.2 5.2c1.5 0 2.9.8 3.8 2.1.9-1.3 2.3-2.1 3.8-2.1 2.3 0 4.2 1.9 4.2 4.4 0 2.9-2.5 6.1-8 10.4Z"/>',
      line:'<path d="M4 18 20 6"/>'
    };
    [["rect",stkT("stk.labs.bookmark.editor.shape_rectangle","Rectangle")],["circle",stkT("stk.labs.bookmark.editor.shape_ellipse","Ellipse")],["star",stkT("stk.labs.bookmark.editor.shape_star","Star")],["heart",stkT("stk.labs.bookmark.editor.shape_heart","Heart")],["line",stkT("stk.labs.bookmark.editor.shape_line","Line")]].forEach(([v,lab])=>{
      const btn=document.createElement("button"); btn.title=lab;
      btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round" style="width:18px;height:18px;display:block;margin:0 auto">'+SHAPE_ICONS[v]+'</svg>';
      if((L.shape||"rect")===v) btn.classList.add("on");
      btn.onclick=()=>{ L.shape=v; [...sseg.children].forEach(c=>c.classList.remove("on")); btn.classList.add("on"); renderEditorPanel(); refreshDesign(); };
      sseg.appendChild(btn);
    });
    wrap.appendChild(sseg);
    wrap.appendChild(mkRange(stkT("stk.labs.bookmark.editor.width","Width"),2,80,1,L.wMm,v=>{ L.wMm=v; refreshDesign(); }));
    if(L.shape!=="line") wrap.appendChild(mkRange(stkT("stk.labs.bookmark.editor.height","Height"),2,80,1,L.hMm,v=>{ L.hMm=v; refreshDesign(); }));
    if(L.shape==="rect") wrap.appendChild(mkRange(stkT("stk.labs.bookmark.ui.corner_radius","Corner radius"),0,20,0.5,L.radiusMm,v=>{ L.radiusMm=v; refreshDesign(); }));
    if(L.shape!=="line"){
      const fl=document.createElement("div"); fl.className="lbl-sub"; fl.style.marginTop="8px"; fl.textContent=stkT("stk.labs.bookmark.editor.fill","Fill"); wrap.appendChild(fl);
      wrap.appendChild(colourPicker(L.fill==="none"?"#ffffff":L.fill,c=>{ L.fill=c; refreshDesign(); }));
      const noFill=document.createElement("button"); noFill.className="ghost"; noFill.style.marginTop="8px";
      noFill.textContent = L.fill==="none" ? stkT("stk.labs.bookmark.editor.add_fill","Add fill") : stkT("stk.labs.bookmark.editor.no_fill","No fill");
      noFill.onclick=()=>{ L.fill = L.fill==="none" ? "#5f4c9f" : "none"; renderEditorPanel(); refreshDesign(); };
      wrap.appendChild(noFill);
    }
    const stl=document.createElement("div"); stl.className="lbl-sub"; stl.style.marginTop="8px"; stl.textContent = L.shape==="line"?stkT("stk.labs.bookmark.ui.line_colour","Line colour"):stkT("stk.labs.bookmark.editor.outline","Outline"); wrap.appendChild(stl);
    wrap.appendChild(colourPicker(L.stroke==="none"?"#1a1a20":L.stroke,c=>{ L.stroke=c; if(!L.strokeMm) L.strokeMm=L.shape==="line"?1:0.6; refreshDesign(); }));
    wrap.appendChild(mkRange(L.shape==="line"?stkT("stk.labs.bookmark.editor.thickness","Thickness"):stkT("stk.labs.bookmark.editor.outline_width","Outline width"),0,6,0.2,L.strokeMm||0,v=>{ L.strokeMm=v; if(v>0 && (!L.stroke||L.stroke==="none")) L.stroke="#1a1a20"; refreshDesign(); }));
  }

  /* ---- common controls for every layer: opacity, rotation, duplicate, nudge ---- */
  const common=document.createElement("div"); common.style.marginTop="14px"; common.style.paddingTop="14px"; common.style.borderTop="1px solid var(--line)";
  // opacity
  common.appendChild(mkRange(stkT("stk.labs.bookmark.editor.opacity","Opacity"),0,100,1, Math.round((L.opacity==null?1:L.opacity)*100), v=>{ L.opacity=v/100; refreshDesign(); }));
  // rotation (text, logo, qr, shape all support rot)
  common.appendChild(mkRange(stkT("stk.labs.bookmark.editor.rotation","Rotation"),-180,180,5, L.rot||0, v=>{ L.rot=v; refreshDesign(); }));
  // nudge pad + duplicate
  const nrow=document.createElement("div"); nrow.style.cssText="display:flex;gap:8px;align-items:center;margin-top:6px";
  const nl=document.createElement("div"); nl.className="lbl-sub"; nl.style.margin="0"; nl.style.flex="1"; nl.textContent=stkT("stk.labs.bookmark.editor.nudge","Nudge"); nrow.appendChild(nl);
  const mkNudge=(label,dx,dy)=>{ const b=document.createElement("button"); b.className="nudgebtn"; b.textContent=label; b.onclick=()=>nudgeLayer(L.id,dx,dy); return b; };
  nrow.appendChild(mkNudge("\u2190",-1,0)); nrow.appendChild(mkNudge("\u2192",1,0));
  nrow.appendChild(mkNudge("\u2191",0,-1)); nrow.appendChild(mkNudge("\u2193",0,1));
  common.appendChild(nrow);
  const dup=document.createElement("button"); dup.className="ghost"; dup.style.marginTop="10px"; dup.textContent=stkT("stk.labs.bookmark.editor.duplicate","Duplicate");
  dup.onclick=()=>duplicateLayer(L.id);
  common.appendChild(dup);
  wrap.appendChild(common);

  const del=document.createElement("button"); del.className="ghost"; del.textContent=stkT("stk.labs.bookmark.ui.delete","Delete");
  del.style.marginTop="8px"; del.addEventListener("click",()=>deleteLayer(L.id));
  wrap.appendChild(del);
  host.appendChild(wrap);
  paintAllRanges();
}
/* tiny colour picker: brand swatches + native input */
function colourPicker(current, onpick){
  const rawpick=onpick; onpick=c=>rawpick(printSafe(c));
  const wrap=document.createElement("div");
  const row=document.createElement("div"); row.className="swatches";
  ["#1a1a20","#ffffff","#f0513c","#f78d28","#ffc707","#5dba68","#4b8dc8","#5f4c9f"].forEach(col=>{
    const s=document.createElement("div"); s.className="sw"+(col.toLowerCase()===(current||"").toLowerCase()?" on":"");
    s.style.background=col; s.onclick=()=>{ onpick(col); [...row.children].forEach(c=>c.classList.remove("on")); s.classList.add("on"); };
    row.appendChild(s);
  });
  const wheelWrap=document.createElement("div"); wheelWrap.className="wheelwrap"; wheelWrap.style.display="none";
  wheelWrap.appendChild(buildColourWheel(onpick));
  const cust=document.createElement("div"); cust.className="sw custom"; cust.title=stkT("stk.labs.bookmark.colour.wheel","Colour wheel");
  cust.onclick=()=>{ wheelWrap.style.display = wheelWrap.style.display==="none" ? "" : "none"; };
  row.appendChild(cust);
  const eye=eyedropSwatch(onpick); if(eye) row.appendChild(eye);
  wrap.appendChild(row); wrap.appendChild(wheelWrap);
  return wrap;
}

/* bookmark width on the card: max = template width, min 30mm, default = max */
function syncCardWidthRange(){
  const sl=$("cardWidth"); if(!sl) return;
  const maxMm=TEMPLATES[opts.orient].w;            // 55 portrait, 65 landscape
  sl.max=maxMm; sl.min=30;
  // default (or clamp) to max when unset
  const cur = opts.cardWidthMm==null ? maxMm : Math.min(opts.cardWidthMm, maxMm);
  sl.value=cur;
  $("cardWidthVal").textContent=(cur/10).toFixed(1)+"cm";
  $("cardWidthMax").textContent=(maxMm/10).toFixed(1)+"cm";
  $("cardWidthMin").textContent="3.0cm";
  paintAllRanges();
}
segGroup("bmBgModeSeg","bgMode",()=>{ renderSwatches(); buildAndRender(); });
segGroup("cardBgModeSeg","cardBgMode",()=>{ renderSwatches(); buildAndRender(); });
(()=>{
  const dial=$("bmGradDial"); if(!dial) return;
  let turning=false, raf=0;
  const setFromEvent=e=>{
    const r=dial.getBoundingClientRect();
    const dx=e.clientX-(r.left+r.width/2), dy=e.clientY-(r.top+r.height/2);
    if(!dx && !dy) return;
    let deg=Math.atan2(dy,dx)*180/Math.PI+90;
    deg=((Math.round(deg/5)*5)%360+360)%360;
    if(deg===opts.bgAngle) return;
    opts.bgAngle=deg;
    syncBmDial();
    if(!raf) raf=requestAnimationFrame(()=>{ raf=0; buildAndRender(); });
  };
  dial.addEventListener("pointerdown",e=>{ turning=true; try{dial.setPointerCapture(e.pointerId);}catch(_){} setFromEvent(e); });
  dial.addEventListener("pointermove",e=>{ if(turning) setFromEvent(e); });
  ["pointerup","pointercancel"].forEach(ev=>dial.addEventListener(ev,()=>{ turning=false; buildAndRender(); }));
})();
/* test hook (harmless in production) - lets a check compare what the preview
   frames against what the export writes, instead of trusting they match. */
try{ root.host.__bm={ get o(){return opts;}, buildCardExport, cardDesignArtBleed,
  buildCardDesignArt, get cardScene(){return cardScene;}, buildAndRender }; }catch(e){}
syncBmDial();
/* ---------- type-in bookmark size ----------
   TEMPLATES holds the maximum finished piece per orientation (55x150mm
   portrait, 65x130mm landscape). A number bigger than that snaps back to the
   maximum and the box shows the value actually used, rather than being
   silently ignored. Blank = automatic, the previous behaviour. */
/* One degree of freedom. The finished piece keeps the artwork's proportions,
   so only the width is stored; the length is whatever that width produces, and
   the boxes are filled from the measured result after each build. */
function sizeCaps(){
  const t=TEMPLATES[opts.orient];
  return { w: Math.min(opts.sizeWmm || t.w, t.w), h: t.h };
}
/* the real finished cut, in mm, as the BOOKMARK SIZE readout reports it */
function bmActualMm(){
  if(!sceneMm || !sceneMm.cutBB || !sceneMm.ppm) return null;
  return { w: sceneMm.cutBB.w/sceneMm.ppm, h: sceneMm.cutBB.h/sceneMm.ppm };
}
function syncBmSize(){
  const t=TEMPLATES[opts.orient];
  const w=$("bmW"), h=$("bmH");
  if(opts.sizeWmm) opts.sizeWmm=Math.min(opts.sizeWmm,t.w);
  const cur=bmActualMm();
  /* Once a size is set, BOTH boxes show the measured result - so when a value
     bounces off a maximum the pair immediately reads the size actually used
     rather than the number that was typed. Blank stays blank = automatic. */
  const show = opts.sizeWmm && cur;
  const dp=bmDp(), fmt=mm=>String(+bmFromMm(mm).toFixed(dp));
  if(w){ w.min=fmt(10); w.max=fmt(t.w); w.value = show ? fmt(cur.w) : (opts.sizeWmm?fmt(opts.sizeWmm):""); }
  if(h){ h.min=fmt(10); h.max=fmt(t.h); h.value = show ? fmt(cur.h) : ""; }
  /* i18n: translated unit label for display only; logic keeps bmUnit */
  const uLbl=bmUnit==="in"?stkT("stk.labs.bookmark.units.inch","in"):bmUnit==="cm"?stkT("stk.labs.bookmark.units.cm","cm"):bmUnit;
  if($("bmWCap")) $("bmWCap").textContent=stkF(stkT("stk.labs.bookmark.size.width_caption","Width ([unit])"),{unit:uLbl});
  if($("bmHCap")) $("bmHCap").textContent=stkF(stkT("stk.labs.bookmark.size.length_caption","Length ([unit])"),{unit:uLbl});
  if($("bmUnitSeg")) [...$("bmUnitSeg").querySelectorAll("button")].forEach(b=>b.classList.toggle("on",b.dataset.u===bmUnit));
  const hint=$("bmSizeHint");
  if(hint) hint.textContent=stkF(stkT("stk.labs.bookmark.size.max_hint","Max [w] x [h][unit]. The two stay in your artwork's proportions, so changing one moves the other. Blank = automatic."),{w:fmt(t.w),h:fmt(t.h),unit:uLbl});
}
/* `which` says which box was edited. The other one is derived, never read -
   the piece is one shape at one ratio, so there is only ever one number to set. */
function commitBmSize(which){
  const t=TEMPLATES[opts.orient];
  const cur=bmActualMm();
  const ratio = (cur && cur.w>0) ? cur.h/cur.w : null;   // length per unit of width
  const num=el=>{ const raw=el.value.trim(); if(raw==="") return null;
                  const v=+raw; return (isFinite(v)&&v>0) ? v : null; };
  let W=null;
  if(which==="h"){
    const H=num($("bmH"));
    if(H!=null && ratio) W=bmToMm(H)/ratio;    // typed a length: back-solve the width, in mm
  } else {
    const v=num($("bmW"));
    if(v!=null) W=bmToMm(v);
  }
  if(W==null){
    opts.sizeWmm=null;                          // cleared = back to automatic
  } else {
    W=Math.max(10, Math.min(t.w, W));           // width's own ceiling
    /* ...and the length's. Whichever limit bites first, both step back together
       so the limiting dimension lands exactly on the guide size. */
    if(ratio && W*ratio > t.h) W=Math.max(10, t.h/ratio);
    opts.sizeWmm=W;
  }
  fitted=false;
  buildAndRender();       // synchronous: sceneMm is fresh on the next line
  syncBmSize();           // fill both boxes from what actually came out
}
/* hidden by default: the explanation matters the first time and is noise every
   time after, so it lives behind the dot rather than sitting under the boxes. */
$("bmSizeInfo").addEventListener("click",()=>{
  const hint=$("bmSizeHint"), open=hint.classList.toggle("show");
  $("bmSizeInfo").classList.toggle("on",open);
  $("bmSizeInfo").setAttribute("aria-expanded",String(open));
});
$("bmUnitSeg").addEventListener("click",e=>{
  const b=e.target.closest("button"); if(!b) return;
  bmUnit=b.dataset.u;
  syncBmSize();                 // rewrites the boxes; the bookmark is untouched
});
[["bmW","w"],["bmH","h"]].forEach(([id,which])=>{
  $(id).addEventListener("change",()=>commitBmSize(which));
  $(id).addEventListener("keydown",e=>{ if(e.key==="Enter"){ e.preventDefault(); commitBmSize(which); } });
});
syncBmSize();
$("cardWidth").addEventListener("input",e=>{
  $("cardWidthVal").textContent=(+e.target.value/10).toFixed(1)+"cm";
  // live update placement without rebuilding the bookmark or card (cheap, smooth)
  const maxMm=TEMPLATES[opts.orient].w;
  const v=+e.target.value;
  opts.cardWidthMm = v>=maxMm ? null : v;
  if(opts.view==="card"){ render(); updateCardDims(); }
});
$("cardWidth").addEventListener("change",e=>{
  const maxMm=TEMPLATES[opts.orient].w;
  const v=+e.target.value;
  opts.cardWidthMm = v>=maxMm ? null : v;
  if(opts.view==="card"){ render(); updateCardDims(); }
});
/* bridge length is adjustable from the card view too; setBridge keeps both sliders in sync */
$("bridgeCard").addEventListener("input",e=>{ $("bridgeCardVal").textContent=e.target.value+"mm"; });
$("bridgeCard").addEventListener("change",e=>{ setBridge(snapBridge(+e.target.value), true); });
/* canvas tool buttons (top-left of stage) */
$("ctoolRuler").addEventListener("click",()=>{
  opts.rulers=!opts.rulers;
  $("ctoolRuler").classList.toggle("on",opts.rulers);
  syncRulers();
});
$("ctoolFlip").addEventListener("click",()=>{
  opts.previewFlip=!opts.previewFlip;
  $("ctoolFlip").classList.toggle("on",opts.previewFlip);
  render();
});
$("ctoolFold").addEventListener("click",()=>{
  opts.fold=!opts.fold;
  $("ctoolFold").classList.toggle("on",opts.fold);
  syncFoldVisibility(); render();
});
$("ctoolCut").addEventListener("click",()=>{
  opts.cut=!opts.cut;
  $("ctoolCut").classList.toggle("on",opts.cut);
  render();
});
/* dark mode: one switch, themes the entire tool including downloads */
let darkMode=false;
$("ctoolStage").addEventListener("click",()=>{
  darkMode=!darkMode;
  root.querySelector(".app").classList.toggle("dark", darkMode);
  $("ctoolStage").classList.toggle("on", darkMode);
  syncRulers();
});
segGroup("cardViewSeg","cardView",()=>{
  const h=$("cardViewHint");
  if(h) h.textContent = opts.cardView==="full"
    ? "Full length: the whole bookmark, fold pinned to the card's top edge, top half hanging above."
    : "Folded: shows the front half wrapping the top edge, how it sits in the cello bag.";
  fitted=false;            // canvas size differs between folded/full
  buildCard(); render();
});
segGroup("cardSideSeg","cardSide",()=>{ fitted=false; buildCard(); render(); });
segGroup("bmViewSeg","bmView",()=>{ fitted=false; render(); });

/* collapsible sections: tap a header to fold or unfold it */
root.querySelectorAll(".step__head").forEach(h=>{
  h.addEventListener("click",()=>{
    const sec=h.parentElement;
    sec.classList.toggle("collapsed");
    if(!sec.classList.contains("collapsed")){
      // rebuild ticks for any slider that just became visible
      requestAnimationFrame(()=>{ buildTicks("bridgeTicksRow","bridge"); paintAllRanges(); });
    }
  });
});

/* the full empty-tool reset, shared by Clear All and by closing the last tab */
function clearAllBm(){
  docs=[]; activeIdx=-1;
  main=null; top=null; card=null; palette=[]; paletteLight=[];
  opts.artCentre=null;   // back to the measurement for whatever comes next
  baseScene=null; cutPath=null; foldPath=null; cardScene=null; outBase="stickiply-bookmark";
  if(animRaf){ cancelAnimationFrame(animRaf); animRaf=0; }
  $("preview").classList.add("hidden");
  $("drop").classList.remove("hidden");
  $("canvasTools").style.display="none";
  $("canvasDims").classList.remove("show");
  $("rulerTop").classList.add("hidden"); $("rulerLeft").classList.add("hidden");
  $("zoomctl").style.display="none";
  zoom=1; panX=0; panY=0; fitted=false;
  opts.magnetOffX=0; opts.magnetOffY=null; opts.cardWidthMm=null; magnetCircle=null;
  ["dlPrint","dlCut","dlCardPrint","dlCardCut","dlCardProof","dlZip"].forEach(id=>$(id).disabled=true);
  $("note").classList.remove("show");
  $("dpi").textContent=""; $("dpi").className="";
  refreshSlots(); refreshCardSlot(); renderSwatches();
  /* derived and transient state, the same set a tab switch drops */
  invalidateCardDesign(); lastGeo=null; lastTrimOff={x:0,y:0};
  curErase=null; if(erasing) setEraseMode(false);
  draggingLayer=null; activeGuides={v:false,h:false};
  renderDocTabs();
}
$("resetBtn").addEventListener("click",clearAllBm);

/* ---------- saved designs: IndexedDB now, cloud adapter later ----------
   Keyed to the Shopify customer id when logged in (data-cust-id from Liquid),
   "guest" otherwise. Swapping dbTx for a fetch() to the Uploads backend is the
   upgrade path to true cross-device storage. */
const CUST_ID=(root.host && root.host.dataset.custId) || "guest";
const CUST_NAME=(root.host && root.host.dataset.custName) || "";
function dbTx(mode,fn){
  return new Promise((res,rej)=>{
    const q=indexedDB.open("stickiply-bookmark-lab",1);
    q.onupgradeneeded=()=>{ q.result.createObjectStore("designs",{keyPath:"id"}); };
    q.onerror=()=>rej(q.error);
    q.onsuccess=()=>{
      const tx=q.result.transaction("designs",mode), st=tx.objectStore("designs");
      const out=fn(st);
      tx.oncomplete=()=>res(out ? out.result : undefined);
      tx.onerror=()=>rej(tx.error);
    };
  });
}
function serializeLayers(){
  return opts.cardDesign.layers.map(L=>{
    const c=Object.assign({},L);
    if(L.img){ const cv=mk(L.img.width,L.img.height); cv.getContext("2d").drawImage(L.img,0,0); c.imgData=cv.toDataURL("image/png"); delete c.img; }
    return c;
  });
}
function designThumb(){
  if(!baseScene) return null;
  const t=mk(64,80), tc=t.getContext("2d");
  const sc=Math.min(64/baseScene.width,80/baseScene.height);
  tc.drawImage(baseScene,(64-baseScene.width*sc)/2,(80-baseScene.height*sc)/2,baseScene.width*sc,baseScene.height*sc);
  return t.toDataURL("image/png");
}
async function saveDesign(){
  if(!main){ showError(stkT("stk.labs.bookmark.saved.upload_first","Upload a design first, then save it.")); return; }
  const rec=t=>t?{data:t.raw.toDataURL("image/png"), srcW:t.srcW, isVector:t.isVector}:null;
  const o=Object.assign({},opts,{cardDesign:Object.assign({},opts.cardDesign,{layers:null})});
  const snap={ id:CUST_ID+"-"+Date.now(), owner:CUST_ID, name:outBase, savedAt:new Date().toISOString(),
               o, layers:serializeLayers(), main:rec(main), top:rec(top), card:rec(card),
               outBase, thumb:designThumb() };
  await dbTx("readwrite",st=>st.put(snap));
  renderSavedList(true);
}
function loadImageEl(src){ return new Promise((res,rej)=>{ const im=new Image(); im.onload=()=>res(im); im.onerror=rej; im.src=src; }); }
function syncControlsFromOpts(){
  $("bridge").value=opts.bridgeMm; $("bridgeVal").textContent=opts.bridgeMm+"mm";
  $("bridgeW2").value=opts.bridgeWmm; $("bridgeWVal").textContent=opts.bridgeWmm+"mm";
  syncArtCentre();
  $("borderW").value=opts.borderMm; $("borderVal").textContent=opts.borderMm.toFixed(1)+"mm";
  $("smooth").value=opts.smoothMm; $("smoothVal").textContent=opts.smoothMm.toFixed(1)+"mm";
  $("tol").value=opts.removeTol; $("tolVal").textContent=opts.removeTol+"%";
  $("rmWhite").classList.toggle("on",opts.removeWhite); syncTolVisibility(); syncKeySwatch();
  $("twoSidedToggle").classList.toggle("on",!!top); $("topSlotWrap").style.display = top ? "" : "none";
  syncOrientSegs();
  [...$("flipSeg").children].forEach(b=>b.classList.toggle("on",b.dataset.v===opts.flip));
  $("showOnCard").classList.toggle("on",opts.showOnCard);
  $("ctoolFold").classList.toggle("on",opts.fold);
  $("ctoolCut").classList.toggle("on",opts.cut);
  $("finishedToggle").classList.toggle("on",!!opts.finished);
  syncFinishedUI();
  [...$("bmBgModeSeg").children].forEach(b=>b.classList.toggle("on",b.dataset.v===(opts.bgMode||"solid")));
  syncBmDial();
  $("cornerR").value=(opts.cornerMm==null?BM_CORNER_MM:opts.cornerMm);
  $("bridgeToggle").classList.toggle("on",opts.bridgeOn!==false);
  try{ syncBridgeUI(); }catch(e){}
  syncFlipHint(); syncOrientHint(); syncCardWidthRange(); syncFoldVisibility();
  paintAllRanges();
}
async function restoreDesign(snap){
  $("spin").classList.add("show");
  try{
    Object.assign(opts, snap.o, {cardDesign:Object.assign({},snap.o.cardDesign,{layers:[]})});
    opts.removeInner=false;   /* the Remove inner white switch is gone (21 Oct 2026): that white opens kept; the magic wand takes each piece */
    outBase=snap.outBase||"stickiply-bookmark";
    main=null; top=null; card=null;
    for(const [t,recd] of [["main",snap.main],["top",snap.top],["card",snap.card]]){
      if(!recd) continue;
      const im=await loadImageEl(recd.data);
      const cv=mk(im.width,im.height); cv.getContext("2d").drawImage(im,0,0);
      activeTarget=t;
      finishIngest(cv, recd.srcW, recd.isVector);
    }
    const ls=[];
    for(const L of (snap.layers||[])){
      const c=Object.assign({},L);
      if(c.imgData){ c.img=await loadImageEl(c.imgData); delete c.imgData; }
      ls.push(c);
    }
    opts.cardDesign.layers=ls;
    opts.cardPreset=snap.o.cardPreset;
    syncPresetSeg(); applyCardPreset();
    syncControlsFromOpts();
    renderSwatches(); refreshSlots(); refreshCardSlot();
    invalidateCardDesign(); fitted=false;
    switchView("bookmark");
    updateDpi();
  }catch(e){ showError(stkF(stkT("stk.labs.bookmark.saved.load_error","Couldn't load that design: [error]"),{error:(e.message||e)})); }
  $("spin").classList.remove("show");
}
async function renderSavedList(show){
  const host=$("savedList"); if(!host) return;
  let all=[];
  try{ all=await dbTx("readonly",st=>st.getAll())||[]; }catch(e){}
  const mine=all.filter(d=>d.owner===CUST_ID).sort((a,b)=>b.savedAt.localeCompare(a.savedAt));
  host.innerHTML="";
  mine.forEach(d=>{
    const row=document.createElement("div"); row.className="layeritem";
    if(d.thumb){ const im=document.createElement("img"); im.src=d.thumb; im.style.cssText="width:26px;height:32px;object-fit:contain;border-radius:4px;flex-shrink:0"; row.appendChild(im); }
    const nm=document.createElement("span"); nm.className="layeritem__name";
    nm.textContent=d.name+" \u00b7 "+(function(dt){ var l=document.documentElement.lang; try{ return dt.toLocaleDateString(l&&!/^en\b/i.test(l)?l:undefined); }catch(e){ return dt.toLocaleDateString(); } })(new Date(d.savedAt))  /* P172 (2 Oct 2026): page language; English keeps the browser locale */;
    row.appendChild(nm);
    const ctr=document.createElement("div"); ctr.className="layeritem__ctr";
    const load=document.createElement("button"); load.textContent="\u2192"; load.title=stkT("stk.labs.bookmark.saved.load_title","Load this design");
    load.onclick=()=>restoreDesign(d);
    const del=document.createElement("button"); del.textContent="\u00d7"; del.className="del"; del.title=stkT("stk.labs.bookmark.ui.delete","Delete");
    del.onclick=async()=>{ await dbTx("readwrite",st=>st.delete(d.id)); renderSavedList(true); };
    ctr.appendChild(load); ctr.appendChild(del);
    row.appendChild(ctr);
    host.appendChild(row);
  });
  if(show) host.style.display="";
  const hint=$("savedHint");
  if(hint){
    hint.textContent = CUST_NAME
      ? stkF(stkT("stk.labs.bookmark.saved.signed_in_as","Signed in as [name]"),{name:CUST_NAME})
      : (mine.length ? stkT("stk.labs.bookmark.saved.hint_device","Designs are saved in this browser, on this device.") : stkT("stk.labs.bookmark.saved.hint_empty","Save a design to come back to it later."));
  }
}
$("saveDesignBtn").addEventListener("click",saveDesign);
$("showDesignsBtn").addEventListener("click",()=>{
  const l=$("savedList");
  l.style.display = l.style.display==="none" ? "" : "none";
  renderSavedList();
});
renderSavedList();

$("dlPrint").addEventListener("click",dlPrint);
$("dlCut").addEventListener("click",dlCut);
$("dlCardPrint").addEventListener("click",dlCardPrint);
$("dlCardCut").addEventListener("click",dlCardCut);
$("dlCardProof").addEventListener("click",dlCardProof);
$("dlZip").addEventListener("click",dlZip);

/* reprocess main + top from retained raw sources (card excluded) */
function reprocessAll(){
  const prevTarget=activeTarget;
  const todo=[];
  if(main) todo.push(["main",main.raw,main.isVector]);
  if(top)  todo.push(["top",top.raw,top.isVector]);
  if(!todo.length){ buildAndRender(); return; }
  $("spin").classList.add("show");
  setTimeout(()=>{
    todo.forEach(([tgt,raw,vec])=>{ activeTarget=tgt; finishIngest(raw, (tgt==="main"?main:top).srcW, vec, true); });
    activeTarget=prevTarget;
    $("spin").classList.remove("show");
  },20);
}

/* drag-drop onto the stage feeds the main slot */
const stage=$("stage");
["dragover","dragenter"].forEach(ev=>stage.addEventListener(ev,e=>{e.preventDefault();$("drop").classList.add("over");}));
["dragleave","drop"].forEach(ev=>stage.addEventListener(ev,e=>{e.preventDefault();$("drop").classList.remove("over");}));
stage.addEventListener("drop",e=>{ const f=e.dataTransfer.files[0]; loadFile(f, opts.view==="card"?"card":"main"); });

/* ---------- zoom + pan controls ---------- */
$("zoomIn").addEventListener("click",()=>zoomBy(1.25));
$("zoomOut").addEventListener("click",()=>zoomBy(0.8));
$("zoomFit").addEventListener("click",()=>{ zoom=1; panX=0; panY=0; applyTransform(); });

const inner=$("stageInner");
inner.addEventListener("wheel",e=>{
  if($("preview").classList.contains("hidden")) return;
  e.preventDefault();
  zoomBy(e.deltaY<0?1.12:0.89, e.clientX, e.clientY);
},{passive:false});

/* map a screen point to composed-canvas coordinates of #preview */
function screenToCanvas(clientX, clientY){
  const cv=$("preview"); const r=cv.getBoundingClientRect();
  if(!r.width) return null;
  const sx=cv.width/r.width, sy=cv.height/r.height;
  return { x:(clientX-r.left)*sx, y:(clientY-r.top)*sy };
}
/* is the pointer over the magnet guide? (card view, magnet shown) */
function hitMagnet(clientX, clientY){
  const draggable = (opts.view==="card") || (opts.view==="bookmark" && opts.bmView==="folded");
  if(!draggable || !opts.showMagnet || !magnetCircle) return false;
  const p=screenToCanvas(clientX,clientY); if(!p) return false;
  const cy=magnetCircle.cy + (magnetCircle.headroom||0);
  const dx=p.x-magnetCircle.cx, dy=p.y-cy;
  // generous grab radius: the magnet disc plus a bit
  const grab=magnetCircle.r*1.3;
  return dx*dx+dy*dy <= grab*grab;
}
let draggingMagnet=false;
let draggingBmOnCard=false;
let draggingLayer=null;   // layer id being dragged
let activeGuides={v:false,h:false};   // centre alignment guides shown while dragging

/* map a design layer's card-mm position to composed-canvas coords */
function layerCanvasPos(L){
  const ppm=cardScene.ppm, bleedPx=cardScene.bleedPx;
  const head=(magnetCircle&&magnetCircle.headroom)||0;
  return { x:bleedPx + L.x*ppm, y:head + bleedPx + L.y*ppm };
}
/* approximate on-canvas size (radius) of a layer for hit-testing, in canvas px */
function layerHitRadius(L){
  const ppm=cardScene.ppm;
  if(L.type==="text"){ const w=Math.max(2,(L.text||"").length)* (L.sizeMm*ppm)*0.32; return Math.max(L.sizeMm*ppm*0.7, w*0.5); }
  if(L.type==="logo" && L.img){ const w=L.wMm*ppm; return Math.max(w,w*(L.img.height/L.img.width))/2; }
  if(L.type==="shape"){ return Math.max(L.wMm, L.hMm||L.wMm)*ppm/2; }
  if(L.type==="qr"){ return (L.sizeMm*ppm)/2; }
  return 12;
}
/* topmost design layer under the pointer, or null */
function hitDesignLayer(clientX, clientY){
  const inDesign = (opts.view==="editor") || (opts.view==="card" && opts.cardPreset==="design");
  if(!inDesign) return null;
  const p=screenToCanvas(clientX,clientY); if(!p) return null;
  const layers=opts.cardDesign.layers;
  for(let i=layers.length-1;i>=0;i--){
    const L=layers[i]; const pos=layerCanvasPos(L); const rad=layerHitRadius(L);
    const dx=p.x-pos.x, dy=p.y-pos.y;
    if(Math.abs(dx)<=rad && Math.abs(dy)<=rad) return L;
  }
  return null;
}


/* ================= clean-up eraser =================
   Third port of the same tool (Sticker Sheet Lab -> Proof Lab -> here). The
   bookmark preview is a COMPOSITE - artwork scaled into a half box, and the
   other half the same artwork turned 180 (or mirrored) - so a brush point has
   to be mapped back through that placement before it can touch source pixels.
   Erasing the upright half cleans the folded half automatically: both halves
   are drawn from the one `art` canvas. */
function punch(cnv,x,y,r){
  const c2=cnv.getContext("2d");
  c2.save(); c2.globalCompositeOperation="destination-out";
  c2.beginPath(); c2.arc(x,y,r,0,Math.PI*2); c2.fill(); c2.restore();
}
function setEraseMode(on){
  erasing=!!on && !!main && opts.view==="bookmark";
  $("preview").classList.toggle("erasing",erasing);
  const b=$("ctoolErase");
  if(b){ b.classList.toggle("on",erasing); b.setAttribute("aria-pressed",String(erasing)); }
  const bar=$("eraseBar"); if(bar) bar.classList.toggle("show",erasing);
  bmSyncTool();
}
function syncEraseBar(){
  const n=(main&&main.eraseStrokes?main.eraseStrokes.length:0)+(top&&top.eraseStrokes?top.eraseStrokes.length:0);
  if($("eraseUndo")) $("eraseUndo").disabled=!(n || (bmHist && bmHist.length));
  if($("eraseRedo")) $("eraseRedo").disabled=!(bmRedo && bmRedo.length);
  if($("eraseClear")) $("eraseClear").disabled=!n;
}
/* preview-canvas pixel -> {rec, x, y, sc} in that slot's own art space */
function sceneToSlot(sx,sy){
  const g=lastGeo; if(!g||!main) return null;
  /* previewFlip rotates the CONTENT as it is drawn (not the element), so undo
     that first or the brush lands 180 degrees away from the cursor. */
  if(opts.previewFlip && baseScene){ sx=baseScene.width-sx; sy=baseScene.height-sy; }
  const fit=(a,w,h)=>{ const sc=Math.min(w/a.width,h/a.height);
    return {sc, ox:(w-a.width*sc)/2, oy:(h-a.height*sc)/2}; };
  const inBox=(x0,y0,w,h)=> sx>=x0 && sx<=x0+w && sy>=y0 && sy<=y0+h;
  if(opts.finished){
    if(!inBox(g.pad,g.topY,g.halfW,g.fullH)) return null;
    const f=fit(main.art,g.halfW,g.fullH);
    return {rec:main, x:(sx-g.pad-f.ox)/f.sc, y:(sy-g.topY-f.oy)/f.sc, sc:f.sc};
  }
  if(inBox(g.pad,g.bottomY,g.halfW,g.halfH)){
    const f=fit(main.art,g.halfW,g.halfH);
    return {rec:main, x:(sx-g.pad-f.ox)/f.sc, y:(sy-g.bottomY-f.oy)/f.sc, sc:f.sc};
  }
  if(inBox(g.pad,g.topY,g.halfW,g.halfH)){
    const rec = top ? top : main;
    const f=fit(rec.art,g.halfW,g.halfH);      // makeTopArt keeps the source size
    let x=(sx-g.pad-f.ox)/f.sc, y=(sy-g.topY-f.oy)/f.sc;
    /* invert makeTopArt: rotate(PI) alone maps (u,v)->(W-u,H-v); with the
       mirror it collapses to a vertical flip, (u,v)->(u,H-v). */
    const W=rec.art.width, H=rec.art.height;
    if(opts.flip==="mirror"){ y=H-y; } else { x=W-x; y=H-y; }
    return {rec, x, y, sc:f.sc};
  }
  return null;
}
/* One stamp mid-drag. baseScene is punched too so pixels vanish under the brush
   at once; the cut line is re-traced on release, not per stamp. */
function eraseStampAt(sx,sy){
  if(!curErase) return;
  const hit=sceneToSlot(sx,sy); if(!hit) return;
  const ppm = sceneMm ? sceneMm.ppm : 1;
  const mm = +($("eraseSize") ? $("eraseSize").value : 2) || 2;
  const r = Math.max(1, (mm*ppm)/hit.sc);
  if(curErase.rec && curErase.rec!==hit.rec) return;    // one slot per stroke
  curErase.rec=hit.rec;
  const fill=bmStampEdit(hit,r);
  const off=hit.rec.trimOff||{x:0,y:0};
  curErase.pts.push(fill ? {x:hit.x+off.x, y:hit.y+off.y, r, f:1} : {x:hit.x+off.x, y:hit.y+off.y, r});
  if(baseScene){
    /* sx,sy are PREVIEW-CANVAS pixels; baseScene is the un-flipped scene, so
       invert exactly once when previewFlip is on. */
    (fill ? (c,x,y,rr)=>bmDisc(c,x,y,rr,opts.bg||"#ffffff") : punch)(baseScene,
      opts.previewFlip ? baseScene.width-sx  : sx,
      opts.previewFlip ? baseScene.height-sy : sy,
      r*hit.sc);
    _trim.v=null;
  }
  render();
}
function finishErase(){
  const cur=curErase; curErase=null;
  if(!cur || !cur.pts.length || !cur.rec) return;
  const L=(cur.rec.eraseStrokes = cur.rec.eraseStrokes || []);
  bmDo({t:"add", L, g:cur.pts, i:L.length});
  syncEraseBar();
  if(cur.pts[0] && cur.pts[0].f) reprocessAll();   /* a fill: the drawn copy is rebuilt so the colour is the background's own (gradient, auto) */
  else buildAndRender();          // cut line re-traces against the erased silhouette
}
/* Undo/Reset rebuild each slot from `raw` and replay whatever strokes remain -
   the live stamps above were destructive, so this is the cheap correct path. */
function replayErase(){ syncEraseBar(); reprocessAll(); }
$("ctoolErase").addEventListener("click",()=>bmToolPick("erase"));
$("ctoolFill").addEventListener("click",()=>bmToolPick("fill"));
$("ctoolWand").addEventListener("click",()=>bmToolPick("wand"));
$("eraseSize").addEventListener("input",e=>{ $("eraseSizeVal").textContent=(+e.target.value).toFixed(1)+"mm"; });
$("eraseUndo").addEventListener("click",()=>{ if(bmUndo()) replayErase(); });
$("eraseRedo").addEventListener("click",()=>{ if(bmRedoOne()) replayErase(); });
$("eraseClear").addEventListener("click",()=>{
  const prev=[main,top].filter(r=>r&&r.eraseStrokes&&r.eraseStrokes.length).map(r=>({L:r.eraseStrokes, list:r.eraseStrokes.slice()}));
  if(prev.length){ bmDo({t:"reset", prev}); replayErase(); }
});
/* three buttons and a longer tool name no longer fit the bar in words: icons (the words stay as title + aria-label) */
try{ const ICO={eraseUndo:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:block"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>',eraseRedo:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:block"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"/></svg>',eraseClear:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:block"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>'}; Object.keys(ICO).forEach(id=>{ const b=$(id); if(!b) return; const t=b.textContent.trim(); b.setAttribute("aria-label",t); b.title=t; b.innerHTML=ICO[id]; }); }catch(e){}

/* pointer drag to pan; two-pointer pinch to zoom; drag the magnet guide */
const ptrs=new Map(); let pinchDist=0;
const bmScenePt=e=>{
  const cv=$("preview"), rect=cv.getBoundingClientRect();
  return {x:(e.clientX-rect.left)*cv.width/rect.width, y:(e.clientY-rect.top)*cv.height/rect.height};
};
let bmBrushing=false;
inner.addEventListener("pointerdown",e=>{
  if($("preview").classList.contains("hidden")) return;
  if(erasing && bmTool==="wand" && ptrs.size===0){ bmWandTap(bmScenePt(e)); return; }   /* MAGIC WAND: a tap, not a stroke */
  if(erasing && ptrs.size===0){
    const pt=bmScenePt(e);
    bmBrushing=true; curErase={rec:null, pts:[]};
    inner.setPointerCapture(e.pointerId);
    eraseStampAt(pt.x,pt.y);
    return;
  }
  // dragging a design layer takes top priority
  if(ptrs.size===0){
    const L=hitDesignLayer(e.clientX,e.clientY);
    if(L){
      draggingLayer=L.id; opts.selLayer=L.id; renderEditorPanel();
      inner.setPointerCapture(e.pointerId);
      ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
      render();
      return;
    }
  }
  // magnet drag next
  if(ptrs.size===0 && hitMagnet(e.clientX,e.clientY)){
    draggingMagnet=true;
    inner.setPointerCapture(e.pointerId);
    ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
    return;
  }
  // then the bookmark sitting on the card
  if(ptrs.size===0 && hitBookmarkOnCard(e.clientX,e.clientY)){
    draggingBmOnCard=true;
    inner.setPointerCapture(e.pointerId);
    ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
    return;
  }
  inner.setPointerCapture(e.pointerId);
  ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
  if(ptrs.size===1) inner.classList.add("panning");
  if(ptrs.size===2){ const p=[...ptrs.values()]; pinchDist=Math.hypot(p[0].x-p[1].x,p[0].y-p[1].y); }
});
inner.addEventListener("pointermove",e=>{
  if(bmBrushing){ const pt=bmScenePt(e); eraseStampAt(pt.x,pt.y); return; }
  if(draggingLayer){
    const prev=ptrs.get(e.pointerId); if(!prev) return;
    const cv=$("preview"); const r=cv.getBoundingClientRect();
    const sx=cv.width/r.width;
    const ppm=cardScene?cardScene.ppm:8;
    const L=opts.cardDesign.layers.find(l=>l.id===draggingLayer);
    if(L){
      L.x += ((e.clientX-prev.x)*sx)/ppm;
      L.y += ((e.clientY-prev.y)*sx)/ppm;
      const t=TEMPLATES[opts.orient];
      // snap to card centre lines and edges (within ~1.2mm), unless Alt held
      activeGuides={v:false,h:false};
      if(!e.altKey){
        const snapMm=1.2;
        const xs=[t.cardW/2], ys=[t.cardH/2];
        for(const gx of xs){ if(Math.abs(L.x-gx)<snapMm){ L.x=gx; activeGuides.v=true; } }
        for(const gy of ys){ if(Math.abs(L.y-gy)<snapMm){ L.y=gy; activeGuides.h=true; } }
      }
      L.x=Math.max(0,Math.min(t.cardW,L.x)); L.y=Math.max(0,Math.min(t.cardH,L.y));
      invalidateCardDesign(); buildAndRender();
    }
    ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
    return;
  }
  if(draggingBmOnCard){
    const prev=ptrs.get(e.pointerId); if(!prev) return;
    const cv=$("preview"); const r=cv.getBoundingClientRect();
    const sx=cv.width/r.width;
    const ppm=cardScene?cardScene.ppm:8;
    opts.cardBmOffXmm=(opts.cardBmOffXmm||0)+((e.clientX-prev.x)*sx)/ppm;
    clampBookmarkOnCard();
    ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
    render(); updateCardDims();
    return;
  }
  if(draggingMagnet){
    const prev=ptrs.get(e.pointerId); if(!prev) return;
    const cv=$("preview"); const r=cv.getBoundingClientRect();
    const sx=cv.width/r.width;                       // canvas px per screen px
    /* The folded bookmark view is drawn in baseScene pixels with no card scale;
       the card view is drawn at the card's ppm and scaled by the width slider.
       Using the card numbers on the folded canvas made the magnet crawl. */
    const foldedView=(opts.view==="bookmark" && opts.bmView==="folded");
    const ppm=foldedView ? (sceneMm?sceneMm.ppm:8) : (cardScene?cardScene.ppm:8);
    const f=foldedView ? 1 : cardScaleFactor();
    // convert screen delta -> mm of artwork (divide out the on-card scale f)
    const dmmX=((e.clientX-prev.x)*sx)/(ppm*f);
    const dmmY=((e.clientY-prev.y)*sx)/(ppm*f);
    opts.magnetOffX=(opts.magnetOffX||0)+dmmX;
    opts.magnetOffY=(opts.magnetOffY==null?0:opts.magnetOffY)+dmmY;
    clampMagnet();
    ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
    render(); updateCardDims();
    return;
  }
  if(!ptrs.has(e.pointerId)) return;
  const prev=ptrs.get(e.pointerId);
  if(ptrs.size===2){
    ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
    const p=[...ptrs.values()]; const d=Math.hypot(p[0].x-p[1].x,p[0].y-p[1].y);
    if(pinchDist>0){ const cx=(p[0].x+p[1].x)/2, cy=(p[0].y+p[1].y)/2; zoomBy(d/pinchDist, cx, cy); }
    pinchDist=d; return;
  }
  panX+=e.clientX-prev.x; panY+=e.clientY-prev.y;
  ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
  applyTransform();
});
["pointerup","pointercancel","pointerleave"].forEach(ev=>inner.addEventListener(ev,e=>{
  if(bmBrushing){ bmBrushing=false; finishErase(); return; }
  ptrs.delete(e.pointerId);
  draggingMagnet=false; draggingBmOnCard=false;
  if(draggingLayer){ draggingLayer=null; activeGuides={v:false,h:false}; invalidateCardDesign(); buildAndRender(); }
  if(ptrs.size<2) pinchDist=0;
  if(ptrs.size===0) inner.classList.remove("panning");
}));
/* cursor hint: show a move cursor when hovering the magnet guide */
inner.addEventListener("pointermove",e=>{
  if(draggingMagnet || draggingBmOnCard || ptrs.size>0) return;
  inner.style.cursor = (hitDesignLayer(e.clientX,e.clientY)||hitMagnet(e.clientX,e.clientY)||hitBookmarkOnCard(e.clientX,e.clientY)) ? "move" : "";
});
/* The bookmark drawn on the card: its box in screen coordinates, for dragging. */
function bookmarkOnCardBox(){
  if(!(opts.showOnCard && baseScene && sceneMm && cardScene)) return null;
  if(opts.view!=="card") return null;
  const cv=$("preview"); if(!cv) return null;
  const r=cv.getBoundingClientRect();
  const sx=r.width/cv.width;                       // screen px per canvas px
  const ppm=cardScene.ppm, f=cardScaleFactor();
  const drawW=baseScene.width*f;
  const bx=(cardScene.cardW-drawW)/2 + (opts.cardBmOffXmm||0)*ppm;
  const drawH=baseScene.height*f;
  const top=(cardScene.headroom||0)
          + Math.max(0,(cardScene.cardTopPx||0)-Math.round(FOLD_RISE_MM*ppm));
  return { l:r.left+bx*sx, t:r.top+top*sx, w:drawW*sx, h:drawH*sx };
}
function hitBookmarkOnCard(cx,cy){
  const b=bookmarkOnCardBox(); if(!b) return false;
  return cx>=b.l && cx<=b.l+b.w && cy>=b.t && cy<=b.t+b.h;
}
/* Travel stops when the bookmark's edge reaches the card's edge - that IS the
   fit the customer is checking, so it must be reachable, and no further. */
function clampBookmarkOnCard(){
  if(!(baseScene && cardScene)) return;
  const ppm=cardScene.ppm;
  const bmWmm=(baseScene.width*cardScaleFactor())/ppm;
  const cardWmm=cardScene.cardW/ppm;
  const lim=Math.abs(cardWmm-bmWmm)/2;
  opts.cardBmOffXmm=Math.max(-lim, Math.min(lim, opts.cardBmOffXmm||0));
}
/* keep the magnet centre within the bookmark's front half artwork */
function clampMagnet(){
  if(!sceneMm || !baseScene) return;
  const ppm=sceneMm.ppm;
  const halfWmm=(sceneMm.cutBB.w/ppm)/2;
  const rMm=MAGNET_DIA_MM/2;
  // X: keep the magnet within the half width
  const limX=Math.max(0, halfWmm - rMm);
  opts.magnetOffX=Math.max(-limX, Math.min(limX, opts.magnetOffX||0));
  // Y: from just below the fold down to the bottom of the front half
  const frontHmm=((baseScene.height - sceneMm.foldYpx)/ppm);
  const defaultBelow=(MAGNET_SAFE_MM/2)+2;        // mm below fold (matches guide)
  const minY=-(defaultBelow - rMm - MAGNET_FOLD_CLEAR_MM);   // 6mm clear of the fold
  const maxY=Math.max(minY, frontHmm - defaultBelow - rMm);
  opts.magnetOffY=Math.max(minY, Math.min(maxY, opts.magnetOffY==null?0:opts.magnetOffY));
}

/* size the tool to fill exactly from its top edge to the bottom of the
   viewport, minus a small margin. self-corrects to any theme header height
   so the tool never runs taller than the visible window. */
function fitToolHeight(){
  const tool=root.querySelector(".tool"); if(!tool) return;
  /* mobile: never pin a height - the page grows as long as the options need */
  if(window.matchMedia("(max-width:900px)").matches){ tool.style.height="auto"; return; }
  const top=tool.getBoundingClientRect().top;   // distance from viewport top
  const margin=24;                              // breathing room at the bottom
  let h=window.innerHeight - top - margin;
  h=Math.max(520, Math.min(h, 900));            // sane bounds
  tool.style.height=h+"px";
  if(!$("preview").classList.contains("hidden")){ applyTransform(); }
}
window.addEventListener("resize",()=>{
  fitToolHeight();
  if(!$("preview").classList.contains("hidden")){ applyTransform(); buildTicks("bridgeTicksRow","bridge"); }
});
window.addEventListener("scroll",()=>{ /* top can shift as sticky headers collapse */ }, {passive:true});

/* On a phone the stage only reaches its real height after the first paint: the
   panel below it settles, the view tabs appear, the webfont lands. baseFitScale()
   reads the stage box, so a fit computed before that leaves the bookmark a few
   pixels tall and only a device rotation puts it right.
   Measured 9 Sep 2026 on a 375x812 viewport: stage 28px, preview 5x25.
   Watch the stage itself rather than the window. */
try{
  const _stageEl=$("stageInner");
  if(_stageEl && window.ResizeObserver){
    let _lastH=0;
    new ResizeObserver(entries=>{
      const h=Math.round(entries[0].contentRect.height);
      if(h===_lastH) return;
      _lastH=h;
      if(!$("preview").classList.contains("hidden")) applyTransform();
    }).observe(_stageEl);
  }
}catch(e){ /* never let a layout observer stop the tool loading */ }

/* sliders: paint the filled portion of every range track */
/* segmented pill sliders: a value circle at the left, six pills that light
   up in the pastel logo colours. The native input sits invisibly on top so
   dragging, keyboard and touch all keep working. */
function segmentizeRange(r){
  if(r._segfill) return;
  const metaSpan=r.parentNode ? r.parentNode.querySelector(".range-meta span:nth-child(2)") : null;
  const wrap=document.createElement("div"); wrap.className="segslider";
  r.parentNode.insertBefore(wrap,r);
  const badge=document.createElement("div"); badge.className="segslider__val";
  const track=document.createElement("div"); track.className="segslider__track";
  const bar=document.createElement("div"); bar.className="segbar";
  const fill=document.createElement("div"); fill.className="segbar__fill";
  bar.appendChild(fill); track.appendChild(bar);
  wrap.appendChild(badge); wrap.appendChild(track);
  /* the title sits above the bar, right-aligned, so the bar keeps full width */
  const lbl=r.parentNode.querySelector("label.lbl-sub,.lbl-sub");
  if(lbl) lbl.classList.add("segslider__lbl");
  track.appendChild(r);
  r._segfill=fill; r._segbadge=badge; r._segmeta=metaSpan;
}
function updateSeg(r){
  if(!r._segfill) return;
  const min=+r.min||0, max=+r.max||100, v=+r.value;
  const pct=Math.max(0,Math.min(1,(v-min)/(max-min)));
  r._segfill.style.width=(pct*100).toFixed(1)+"%";
  r._segbadge.textContent = r._segmeta ? r._segmeta.textContent : r.value;
}
function paintRange(r){ segmentizeRange(r); updateSeg(r); }
function paintAllRanges(){ root.querySelectorAll('input[type=range]').forEach(paintRange); }
root.addEventListener("input",e=>{ const t=e.target; if(t && t.type==="range") requestAnimationFrame(()=>updateSeg(t)); });

/* init */
syncTolVisibility(); syncBorderVisibility(); syncFoldVisibility();
syncOrientHint(); syncFlipHint(); syncCardWidthRange(); applyCardPreset(); renderSwatches();
refreshSlots(); refreshCardSlot();
/* mobile: open every section on load so no option hides behind a chevron */
if(window.matchMedia("(max-width:900px)").matches){
  root.querySelectorAll(".step.collapsed").forEach(sec=>sec.classList.remove("collapsed"));
}
requestAnimationFrame(()=>{ fitToolHeight(); buildTicks("bridgeTicksRow","bridge"); paintAllRanges(); });

/* ---------- compact QR encoder (byte mode, ECC level M, versions 1-10) ----------
   Returns a 2D array of 0/1 (the module matrix) for the given text, or null. */
function qrMatrix(text){
  try{ return QR.encode(text); }catch(e){ return null; }
}
/* QR encoder: qrcode-generator by Kazuhiko Arase, MIT licensed. Inlined, byte mode, ECC M. */
const QR=(function(){
//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------

var qrcode = function() {

  //---------------------------------------------------------------------
  // qrcode
  //---------------------------------------------------------------------

  /**
   * qrcode
   * @param typeNumber 1 to 40
   * @param errorCorrectionLevel 'L','M','Q','H'
   */
  var qrcode = function(typeNumber, errorCorrectionLevel) {

    var PAD0 = 0xEC;
    var PAD1 = 0x11;

    var _typeNumber = typeNumber;
    var _errorCorrectionLevel = QRErrorCorrectionLevel[errorCorrectionLevel];
    var _modules = null;
    var _moduleCount = 0;
    var _dataCache = null;
    var _dataList = [];

    var _this = {};

    var makeImpl = function(test, maskPattern) {

      _moduleCount = _typeNumber * 4 + 17;
      _modules = function(moduleCount) {
        var modules = new Array(moduleCount);
        for (var row = 0; row < moduleCount; row += 1) {
          modules[row] = new Array(moduleCount);
          for (var col = 0; col < moduleCount; col += 1) {
            modules[row][col] = null;
          }
        }
        return modules;
      }(_moduleCount);

      setupPositionProbePattern(0, 0);
      setupPositionProbePattern(_moduleCount - 7, 0);
      setupPositionProbePattern(0, _moduleCount - 7);
      setupPositionAdjustPattern();
      setupTimingPattern();
      setupTypeInfo(test, maskPattern);

      if (_typeNumber >= 7) {
        setupTypeNumber(test);
      }

      if (_dataCache == null) {
        _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
      }

      mapData(_dataCache, maskPattern);
    };

    var setupPositionProbePattern = function(row, col) {

      for (var r = -1; r <= 7; r += 1) {

        if (row + r <= -1 || _moduleCount <= row + r) continue;

        for (var c = -1; c <= 7; c += 1) {

          if (col + c <= -1 || _moduleCount <= col + c) continue;

          if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
              || (0 <= c && c <= 6 && (r == 0 || r == 6) )
              || (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
            _modules[row + r][col + c] = true;
          } else {
            _modules[row + r][col + c] = false;
          }
        }
      }
    };

    var getBestMaskPattern = function() {

      var minLostPoint = 0;
      var pattern = 0;

      for (var i = 0; i < 8; i += 1) {

        makeImpl(true, i);

        var lostPoint = QRUtil.getLostPoint(_this);

        if (i == 0 || minLostPoint > lostPoint) {
          minLostPoint = lostPoint;
          pattern = i;
        }
      }

      return pattern;
    };

    var setupTimingPattern = function() {

      for (var r = 8; r < _moduleCount - 8; r += 1) {
        if (_modules[r][6] != null) {
          continue;
        }
        _modules[r][6] = (r % 2 == 0);
      }

      for (var c = 8; c < _moduleCount - 8; c += 1) {
        if (_modules[6][c] != null) {
          continue;
        }
        _modules[6][c] = (c % 2 == 0);
      }
    };

    var setupPositionAdjustPattern = function() {

      var pos = QRUtil.getPatternPosition(_typeNumber);

      for (var i = 0; i < pos.length; i += 1) {

        for (var j = 0; j < pos.length; j += 1) {

          var row = pos[i];
          var col = pos[j];

          if (_modules[row][col] != null) {
            continue;
          }

          for (var r = -2; r <= 2; r += 1) {

            for (var c = -2; c <= 2; c += 1) {

              if (r == -2 || r == 2 || c == -2 || c == 2
                  || (r == 0 && c == 0) ) {
                _modules[row + r][col + c] = true;
              } else {
                _modules[row + r][col + c] = false;
              }
            }
          }
        }
      }
    };

    var setupTypeNumber = function(test) {

      var bits = QRUtil.getBCHTypeNumber(_typeNumber);

      for (var i = 0; i < 18; i += 1) {
        var mod = (!test && ( (bits >> i) & 1) == 1);
        _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
      }

      for (var i = 0; i < 18; i += 1) {
        var mod = (!test && ( (bits >> i) & 1) == 1);
        _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
      }
    };

    var setupTypeInfo = function(test, maskPattern) {

      var data = (_errorCorrectionLevel << 3) | maskPattern;
      var bits = QRUtil.getBCHTypeInfo(data);

      // vertical
      for (var i = 0; i < 15; i += 1) {

        var mod = (!test && ( (bits >> i) & 1) == 1);

        if (i < 6) {
          _modules[i][8] = mod;
        } else if (i < 8) {
          _modules[i + 1][8] = mod;
        } else {
          _modules[_moduleCount - 15 + i][8] = mod;
        }
      }

      // horizontal
      for (var i = 0; i < 15; i += 1) {

        var mod = (!test && ( (bits >> i) & 1) == 1);

        if (i < 8) {
          _modules[8][_moduleCount - i - 1] = mod;
        } else if (i < 9) {
          _modules[8][15 - i - 1 + 1] = mod;
        } else {
          _modules[8][15 - i - 1] = mod;
        }
      }

      // fixed module
      _modules[_moduleCount - 8][8] = (!test);
    };

    var mapData = function(data, maskPattern) {

      var inc = -1;
      var row = _moduleCount - 1;
      var bitIndex = 7;
      var byteIndex = 0;
      var maskFunc = QRUtil.getMaskFunction(maskPattern);

      for (var col = _moduleCount - 1; col > 0; col -= 2) {

        if (col == 6) col -= 1;

        while (true) {

          for (var c = 0; c < 2; c += 1) {

            if (_modules[row][col - c] == null) {

              var dark = false;

              if (byteIndex < data.length) {
                dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
              }

              var mask = maskFunc(row, col - c);

              if (mask) {
                dark = !dark;
              }

              _modules[row][col - c] = dark;
              bitIndex -= 1;

              if (bitIndex == -1) {
                byteIndex += 1;
                bitIndex = 7;
              }
            }
          }

          row += inc;

          if (row < 0 || _moduleCount <= row) {
            row -= inc;
            inc = -inc;
            break;
          }
        }
      }
    };

    var createBytes = function(buffer, rsBlocks) {

      var offset = 0;

      var maxDcCount = 0;
      var maxEcCount = 0;

      var dcdata = new Array(rsBlocks.length);
      var ecdata = new Array(rsBlocks.length);

      for (var r = 0; r < rsBlocks.length; r += 1) {

        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;

        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);

        dcdata[r] = new Array(dcCount);

        for (var i = 0; i < dcdata[r].length; i += 1) {
          dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
        }
        offset += dcCount;

        var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
        var rawPoly = qrPolynomial(dcdata[r], rsPoly.getLength() - 1);

        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for (var i = 0; i < ecdata[r].length; i += 1) {
          var modIndex = i + modPoly.getLength() - ecdata[r].length;
          ecdata[r][i] = (modIndex >= 0)? modPoly.getAt(modIndex) : 0;
        }
      }

      var totalCodeCount = 0;
      for (var i = 0; i < rsBlocks.length; i += 1) {
        totalCodeCount += rsBlocks[i].totalCount;
      }

      var data = new Array(totalCodeCount);
      var index = 0;

      for (var i = 0; i < maxDcCount; i += 1) {
        for (var r = 0; r < rsBlocks.length; r += 1) {
          if (i < dcdata[r].length) {
            data[index] = dcdata[r][i];
            index += 1;
          }
        }
      }

      for (var i = 0; i < maxEcCount; i += 1) {
        for (var r = 0; r < rsBlocks.length; r += 1) {
          if (i < ecdata[r].length) {
            data[index] = ecdata[r][i];
            index += 1;
          }
        }
      }

      return data;
    };

    var createData = function(typeNumber, errorCorrectionLevel, dataList) {

      var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);

      var buffer = qrBitBuffer();

      for (var i = 0; i < dataList.length; i += 1) {
        var data = dataList[i];
        buffer.put(data.getMode(), 4);
        buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber) );
        data.write(buffer);
      }

      // calc num max data.
      var totalDataCount = 0;
      for (var i = 0; i < rsBlocks.length; i += 1) {
        totalDataCount += rsBlocks[i].dataCount;
      }

      if (buffer.getLengthInBits() > totalDataCount * 8) {
        throw 'code length overflow. ('
          + buffer.getLengthInBits()
          + '>'
          + totalDataCount * 8
          + ')';
      }

      // end code
      if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
        buffer.put(0, 4);
      }

      // padding
      while (buffer.getLengthInBits() % 8 != 0) {
        buffer.putBit(false);
      }

      // padding
      while (true) {

        if (buffer.getLengthInBits() >= totalDataCount * 8) {
          break;
        }
        buffer.put(PAD0, 8);

        if (buffer.getLengthInBits() >= totalDataCount * 8) {
          break;
        }
        buffer.put(PAD1, 8);
      }

      return createBytes(buffer, rsBlocks);
    };

    _this.addData = function(data, mode) {

      mode = mode || 'Byte';

      var newData = null;

      switch(mode) {
      case 'Numeric' :
        newData = qrNumber(data);
        break;
      case 'Alphanumeric' :
        newData = qrAlphaNum(data);
        break;
      case 'Byte' :
        newData = qr8BitByte(data);
        break;
      default :
        throw 'mode:' + mode;
      }

      _dataList.push(newData);
      _dataCache = null;
    };

    _this.isDark = function(row, col) {
      if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) {
        throw row + ',' + col;
      }
      return _modules[row][col];
    };

    _this.getModuleCount = function() {
      return _moduleCount;
    };

    _this.make = function() {
      if (_typeNumber < 1) {
        var typeNumber = 1;

        for (; typeNumber < 40; typeNumber++) {
          var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
          var buffer = qrBitBuffer();

          for (var i = 0; i < _dataList.length; i++) {
            var data = _dataList[i];
            buffer.put(data.getMode(), 4);
            buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber) );
            data.write(buffer);
          }

          var totalDataCount = 0;
          for (var i = 0; i < rsBlocks.length; i++) {
            totalDataCount += rsBlocks[i].dataCount;
          }

          if (buffer.getLengthInBits() <= totalDataCount * 8) {
            break;
          }
        }

        _typeNumber = typeNumber;
      }

      makeImpl(false, getBestMaskPattern() );
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // qrcode.stringToBytes
  //---------------------------------------------------------------------

  qrcode.stringToBytesFuncs = {
    'default' : function(s) {
      var bytes = [];
      for (var i = 0; i < s.length; i += 1) {
        var c = s.charCodeAt(i);
        bytes.push(c & 0xff);
      }
      return bytes;
    }
  };

  qrcode.stringToBytes = qrcode.stringToBytesFuncs['default'];

  //---------------------------------------------------------------------
  // qrcode.createStringToBytes
  //---------------------------------------------------------------------

  /**
   * @param unicodeData base64 string of byte array.
   * [16bit Unicode],[16bit Bytes], ...
   * @param numChars
   */
  //---------------------------------------------------------------------
  // QRMode
  //---------------------------------------------------------------------

  var QRMode = {
    MODE_NUMBER :    1 << 0,
    MODE_ALPHA_NUM : 1 << 1,
    MODE_8BIT_BYTE : 1 << 2,
    MODE_KANJI :     1 << 3
  };

  //---------------------------------------------------------------------
  // QRErrorCorrectionLevel
  //---------------------------------------------------------------------

  var QRErrorCorrectionLevel = {
    L : 1,
    M : 0,
    Q : 3,
    H : 2
  };

  //---------------------------------------------------------------------
  // QRMaskPattern
  //---------------------------------------------------------------------

  var QRMaskPattern = {
    PATTERN000 : 0,
    PATTERN001 : 1,
    PATTERN010 : 2,
    PATTERN011 : 3,
    PATTERN100 : 4,
    PATTERN101 : 5,
    PATTERN110 : 6,
    PATTERN111 : 7
  };

  //---------------------------------------------------------------------
  // QRUtil
  //---------------------------------------------------------------------

  var QRUtil = function() {

    var PATTERN_POSITION_TABLE = [
      [],
      [6, 18],
      [6, 22],
      [6, 26],
      [6, 30],
      [6, 34],
      [6, 22, 38],
      [6, 24, 42],
      [6, 26, 46],
      [6, 28, 50],
      [6, 30, 54],
      [6, 32, 58],
      [6, 34, 62],
      [6, 26, 46, 66],
      [6, 26, 48, 70],
      [6, 26, 50, 74],
      [6, 30, 54, 78],
      [6, 30, 56, 82],
      [6, 30, 58, 86],
      [6, 34, 62, 90],
      [6, 28, 50, 72, 94],
      [6, 26, 50, 74, 98],
      [6, 30, 54, 78, 102],
      [6, 28, 54, 80, 106],
      [6, 32, 58, 84, 110],
      [6, 30, 58, 86, 114],
      [6, 34, 62, 90, 118],
      [6, 26, 50, 74, 98, 122],
      [6, 30, 54, 78, 102, 126],
      [6, 26, 52, 78, 104, 130],
      [6, 30, 56, 82, 108, 134],
      [6, 34, 60, 86, 112, 138],
      [6, 30, 58, 86, 114, 142],
      [6, 34, 62, 90, 118, 146],
      [6, 30, 54, 78, 102, 126, 150],
      [6, 24, 50, 76, 102, 128, 154],
      [6, 28, 54, 80, 106, 132, 158],
      [6, 32, 58, 84, 110, 136, 162],
      [6, 26, 54, 82, 110, 138, 166],
      [6, 30, 58, 86, 114, 142, 170]
    ];
    var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
    var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0);
    var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);

    var _this = {};

    var getBCHDigit = function(data) {
      var digit = 0;
      while (data != 0) {
        digit += 1;
        data >>>= 1;
      }
      return digit;
    };

    _this.getBCHTypeInfo = function(data) {
      var d = data << 10;
      while (getBCHDigit(d) - getBCHDigit(G15) >= 0) {
        d ^= (G15 << (getBCHDigit(d) - getBCHDigit(G15) ) );
      }
      return ( (data << 10) | d) ^ G15_MASK;
    };

    _this.getBCHTypeNumber = function(data) {
      var d = data << 12;
      while (getBCHDigit(d) - getBCHDigit(G18) >= 0) {
        d ^= (G18 << (getBCHDigit(d) - getBCHDigit(G18) ) );
      }
      return (data << 12) | d;
    };

    _this.getPatternPosition = function(typeNumber) {
      return PATTERN_POSITION_TABLE[typeNumber - 1];
    };

    _this.getMaskFunction = function(maskPattern) {

      switch (maskPattern) {

      case QRMaskPattern.PATTERN000 :
        return function(i, j) { return (i + j) % 2 == 0; };
      case QRMaskPattern.PATTERN001 :
        return function(i, j) { return i % 2 == 0; };
      case QRMaskPattern.PATTERN010 :
        return function(i, j) { return j % 3 == 0; };
      case QRMaskPattern.PATTERN011 :
        return function(i, j) { return (i + j) % 3 == 0; };
      case QRMaskPattern.PATTERN100 :
        return function(i, j) { return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0; };
      case QRMaskPattern.PATTERN101 :
        return function(i, j) { return (i * j) % 2 + (i * j) % 3 == 0; };
      case QRMaskPattern.PATTERN110 :
        return function(i, j) { return ( (i * j) % 2 + (i * j) % 3) % 2 == 0; };
      case QRMaskPattern.PATTERN111 :
        return function(i, j) { return ( (i * j) % 3 + (i + j) % 2) % 2 == 0; };

      default :
        throw 'bad maskPattern:' + maskPattern;
      }
    };

    _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
      var a = qrPolynomial([1], 0);
      for (var i = 0; i < errorCorrectLength; i += 1) {
        a = a.multiply(qrPolynomial([1, QRMath.gexp(i)], 0) );
      }
      return a;
    };

    _this.getLengthInBits = function(mode, type) {

      if (1 <= type && type < 10) {

        // 1 - 9

        switch(mode) {
        case QRMode.MODE_NUMBER    : return 10;
        case QRMode.MODE_ALPHA_NUM : return 9;
        case QRMode.MODE_8BIT_BYTE : return 8;
        case QRMode.MODE_KANJI     : return 8;
        default :
          throw 'mode:' + mode;
        }

      } else if (type < 27) {

        // 10 - 26

        switch(mode) {
        case QRMode.MODE_NUMBER    : return 12;
        case QRMode.MODE_ALPHA_NUM : return 11;
        case QRMode.MODE_8BIT_BYTE : return 16;
        case QRMode.MODE_KANJI     : return 10;
        default :
          throw 'mode:' + mode;
        }

      } else if (type < 41) {

        // 27 - 40

        switch(mode) {
        case QRMode.MODE_NUMBER    : return 14;
        case QRMode.MODE_ALPHA_NUM : return 13;
        case QRMode.MODE_8BIT_BYTE : return 16;
        case QRMode.MODE_KANJI     : return 12;
        default :
          throw 'mode:' + mode;
        }

      } else {
        throw 'type:' + type;
      }
    };

    _this.getLostPoint = function(qrcode) {

      var moduleCount = qrcode.getModuleCount();

      var lostPoint = 0;

      // LEVEL1

      for (var row = 0; row < moduleCount; row += 1) {
        for (var col = 0; col < moduleCount; col += 1) {

          var sameCount = 0;
          var dark = qrcode.isDark(row, col);

          for (var r = -1; r <= 1; r += 1) {

            if (row + r < 0 || moduleCount <= row + r) {
              continue;
            }

            for (var c = -1; c <= 1; c += 1) {

              if (col + c < 0 || moduleCount <= col + c) {
                continue;
              }

              if (r == 0 && c == 0) {
                continue;
              }

              if (dark == qrcode.isDark(row + r, col + c) ) {
                sameCount += 1;
              }
            }
          }

          if (sameCount > 5) {
            lostPoint += (3 + sameCount - 5);
          }
        }
      };

      // LEVEL2

      for (var row = 0; row < moduleCount - 1; row += 1) {
        for (var col = 0; col < moduleCount - 1; col += 1) {
          var count = 0;
          if (qrcode.isDark(row, col) ) count += 1;
          if (qrcode.isDark(row + 1, col) ) count += 1;
          if (qrcode.isDark(row, col + 1) ) count += 1;
          if (qrcode.isDark(row + 1, col + 1) ) count += 1;
          if (count == 0 || count == 4) {
            lostPoint += 3;
          }
        }
      }

      // LEVEL3

      for (var row = 0; row < moduleCount; row += 1) {
        for (var col = 0; col < moduleCount - 6; col += 1) {
          if (qrcode.isDark(row, col)
              && !qrcode.isDark(row, col + 1)
              &&  qrcode.isDark(row, col + 2)
              &&  qrcode.isDark(row, col + 3)
              &&  qrcode.isDark(row, col + 4)
              && !qrcode.isDark(row, col + 5)
              &&  qrcode.isDark(row, col + 6) ) {
            lostPoint += 40;
          }
        }
      }

      for (var col = 0; col < moduleCount; col += 1) {
        for (var row = 0; row < moduleCount - 6; row += 1) {
          if (qrcode.isDark(row, col)
              && !qrcode.isDark(row + 1, col)
              &&  qrcode.isDark(row + 2, col)
              &&  qrcode.isDark(row + 3, col)
              &&  qrcode.isDark(row + 4, col)
              && !qrcode.isDark(row + 5, col)
              &&  qrcode.isDark(row + 6, col) ) {
            lostPoint += 40;
          }
        }
      }

      // LEVEL4

      var darkCount = 0;

      for (var col = 0; col < moduleCount; col += 1) {
        for (var row = 0; row < moduleCount; row += 1) {
          if (qrcode.isDark(row, col) ) {
            darkCount += 1;
          }
        }
      }

      var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
      lostPoint += ratio * 10;

      return lostPoint;
    };

    return _this;
  }();

  //---------------------------------------------------------------------
  // QRMath
  //---------------------------------------------------------------------

  var QRMath = function() {

    var EXP_TABLE = new Array(256);
    var LOG_TABLE = new Array(256);

    // initialize tables
    for (var i = 0; i < 8; i += 1) {
      EXP_TABLE[i] = 1 << i;
    }
    for (var i = 8; i < 256; i += 1) {
      EXP_TABLE[i] = EXP_TABLE[i - 4]
        ^ EXP_TABLE[i - 5]
        ^ EXP_TABLE[i - 6]
        ^ EXP_TABLE[i - 8];
    }
    for (var i = 0; i < 255; i += 1) {
      LOG_TABLE[EXP_TABLE[i] ] = i;
    }

    var _this = {};

    _this.glog = function(n) {

      if (n < 1) {
        throw 'glog(' + n + ')';
      }

      return LOG_TABLE[n];
    };

    _this.gexp = function(n) {

      while (n < 0) {
        n += 255;
      }

      while (n >= 256) {
        n -= 255;
      }

      return EXP_TABLE[n];
    };

    return _this;
  }();

  //---------------------------------------------------------------------
  // qrPolynomial
  //---------------------------------------------------------------------

  function qrPolynomial(num, shift) {

    if (typeof num.length == 'undefined') {
      throw num.length + '/' + shift;
    }

    var _num = function() {
      var offset = 0;
      while (offset < num.length && num[offset] == 0) {
        offset += 1;
      }
      var _num = new Array(num.length - offset + shift);
      for (var i = 0; i < num.length - offset; i += 1) {
        _num[i] = num[i + offset];
      }
      return _num;
    }();

    var _this = {};

    _this.getAt = function(index) {
      return _num[index];
    };

    _this.getLength = function() {
      return _num.length;
    };

    _this.multiply = function(e) {

      var num = new Array(_this.getLength() + e.getLength() - 1);

      for (var i = 0; i < _this.getLength(); i += 1) {
        for (var j = 0; j < e.getLength(); j += 1) {
          num[i + j] ^= QRMath.gexp(QRMath.glog(_this.getAt(i) ) + QRMath.glog(e.getAt(j) ) );
        }
      }

      return qrPolynomial(num, 0);
    };

    _this.mod = function(e) {

      if (_this.getLength() - e.getLength() < 0) {
        return _this;
      }

      var ratio = QRMath.glog(_this.getAt(0) ) - QRMath.glog(e.getAt(0) );

      var num = new Array(_this.getLength() );
      for (var i = 0; i < _this.getLength(); i += 1) {
        num[i] = _this.getAt(i);
      }

      for (var i = 0; i < e.getLength(); i += 1) {
        num[i] ^= QRMath.gexp(QRMath.glog(e.getAt(i) ) + ratio);
      }

      // recursive call
      return qrPolynomial(num, 0).mod(e);
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // QRRSBlock
  //---------------------------------------------------------------------

  var QRRSBlock = function() {

    var RS_BLOCK_TABLE = [

      // L
      // M
      // Q
      // H

      // 1
      [1, 26, 19],
      [1, 26, 16],
      [1, 26, 13],
      [1, 26, 9],

      // 2
      [1, 44, 34],
      [1, 44, 28],
      [1, 44, 22],
      [1, 44, 16],

      // 3
      [1, 70, 55],
      [1, 70, 44],
      [2, 35, 17],
      [2, 35, 13],

      // 4
      [1, 100, 80],
      [2, 50, 32],
      [2, 50, 24],
      [4, 25, 9],

      // 5
      [1, 134, 108],
      [2, 67, 43],
      [2, 33, 15, 2, 34, 16],
      [2, 33, 11, 2, 34, 12],

      // 6
      [2, 86, 68],
      [4, 43, 27],
      [4, 43, 19],
      [4, 43, 15],

      // 7
      [2, 98, 78],
      [4, 49, 31],
      [2, 32, 14, 4, 33, 15],
      [4, 39, 13, 1, 40, 14],

      // 8
      [2, 121, 97],
      [2, 60, 38, 2, 61, 39],
      [4, 40, 18, 2, 41, 19],
      [4, 40, 14, 2, 41, 15],

      // 9
      [2, 146, 116],
      [3, 58, 36, 2, 59, 37],
      [4, 36, 16, 4, 37, 17],
      [4, 36, 12, 4, 37, 13],

      // 10
      [2, 86, 68, 2, 87, 69],
      [4, 69, 43, 1, 70, 44],
      [6, 43, 19, 2, 44, 20],
      [6, 43, 15, 2, 44, 16],

      // 11
      [4, 101, 81],
      [1, 80, 50, 4, 81, 51],
      [4, 50, 22, 4, 51, 23],
      [3, 36, 12, 8, 37, 13],

      // 12
      [2, 116, 92, 2, 117, 93],
      [6, 58, 36, 2, 59, 37],
      [4, 46, 20, 6, 47, 21],
      [7, 42, 14, 4, 43, 15],

      // 13
      [4, 133, 107],
      [8, 59, 37, 1, 60, 38],
      [8, 44, 20, 4, 45, 21],
      [12, 33, 11, 4, 34, 12],

      // 14
      [3, 145, 115, 1, 146, 116],
      [4, 64, 40, 5, 65, 41],
      [11, 36, 16, 5, 37, 17],
      [11, 36, 12, 5, 37, 13],

      // 15
      [5, 109, 87, 1, 110, 88],
      [5, 65, 41, 5, 66, 42],
      [5, 54, 24, 7, 55, 25],
      [11, 36, 12, 7, 37, 13],

      // 16
      [5, 122, 98, 1, 123, 99],
      [7, 73, 45, 3, 74, 46],
      [15, 43, 19, 2, 44, 20],
      [3, 45, 15, 13, 46, 16],

      // 17
      [1, 135, 107, 5, 136, 108],
      [10, 74, 46, 1, 75, 47],
      [1, 50, 22, 15, 51, 23],
      [2, 42, 14, 17, 43, 15],

      // 18
      [5, 150, 120, 1, 151, 121],
      [9, 69, 43, 4, 70, 44],
      [17, 50, 22, 1, 51, 23],
      [2, 42, 14, 19, 43, 15],

      // 19
      [3, 141, 113, 4, 142, 114],
      [3, 70, 44, 11, 71, 45],
      [17, 47, 21, 4, 48, 22],
      [9, 39, 13, 16, 40, 14],

      // 20
      [3, 135, 107, 5, 136, 108],
      [3, 67, 41, 13, 68, 42],
      [15, 54, 24, 5, 55, 25],
      [15, 43, 15, 10, 44, 16],

      // 21
      [4, 144, 116, 4, 145, 117],
      [17, 68, 42],
      [17, 50, 22, 6, 51, 23],
      [19, 46, 16, 6, 47, 17],

      // 22
      [2, 139, 111, 7, 140, 112],
      [17, 74, 46],
      [7, 54, 24, 16, 55, 25],
      [34, 37, 13],

      // 23
      [4, 151, 121, 5, 152, 122],
      [4, 75, 47, 14, 76, 48],
      [11, 54, 24, 14, 55, 25],
      [16, 45, 15, 14, 46, 16],

      // 24
      [6, 147, 117, 4, 148, 118],
      [6, 73, 45, 14, 74, 46],
      [11, 54, 24, 16, 55, 25],
      [30, 46, 16, 2, 47, 17],

      // 25
      [8, 132, 106, 4, 133, 107],
      [8, 75, 47, 13, 76, 48],
      [7, 54, 24, 22, 55, 25],
      [22, 45, 15, 13, 46, 16],

      // 26
      [10, 142, 114, 2, 143, 115],
      [19, 74, 46, 4, 75, 47],
      [28, 50, 22, 6, 51, 23],
      [33, 46, 16, 4, 47, 17],

      // 27
      [8, 152, 122, 4, 153, 123],
      [22, 73, 45, 3, 74, 46],
      [8, 53, 23, 26, 54, 24],
      [12, 45, 15, 28, 46, 16],

      // 28
      [3, 147, 117, 10, 148, 118],
      [3, 73, 45, 23, 74, 46],
      [4, 54, 24, 31, 55, 25],
      [11, 45, 15, 31, 46, 16],

      // 29
      [7, 146, 116, 7, 147, 117],
      [21, 73, 45, 7, 74, 46],
      [1, 53, 23, 37, 54, 24],
      [19, 45, 15, 26, 46, 16],

      // 30
      [5, 145, 115, 10, 146, 116],
      [19, 75, 47, 10, 76, 48],
      [15, 54, 24, 25, 55, 25],
      [23, 45, 15, 25, 46, 16],

      // 31
      [13, 145, 115, 3, 146, 116],
      [2, 74, 46, 29, 75, 47],
      [42, 54, 24, 1, 55, 25],
      [23, 45, 15, 28, 46, 16],

      // 32
      [17, 145, 115],
      [10, 74, 46, 23, 75, 47],
      [10, 54, 24, 35, 55, 25],
      [19, 45, 15, 35, 46, 16],

      // 33
      [17, 145, 115, 1, 146, 116],
      [14, 74, 46, 21, 75, 47],
      [29, 54, 24, 19, 55, 25],
      [11, 45, 15, 46, 46, 16],

      // 34
      [13, 145, 115, 6, 146, 116],
      [14, 74, 46, 23, 75, 47],
      [44, 54, 24, 7, 55, 25],
      [59, 46, 16, 1, 47, 17],

      // 35
      [12, 151, 121, 7, 152, 122],
      [12, 75, 47, 26, 76, 48],
      [39, 54, 24, 14, 55, 25],
      [22, 45, 15, 41, 46, 16],

      // 36
      [6, 151, 121, 14, 152, 122],
      [6, 75, 47, 34, 76, 48],
      [46, 54, 24, 10, 55, 25],
      [2, 45, 15, 64, 46, 16],

      // 37
      [17, 152, 122, 4, 153, 123],
      [29, 74, 46, 14, 75, 47],
      [49, 54, 24, 10, 55, 25],
      [24, 45, 15, 46, 46, 16],

      // 38
      [4, 152, 122, 18, 153, 123],
      [13, 74, 46, 32, 75, 47],
      [48, 54, 24, 14, 55, 25],
      [42, 45, 15, 32, 46, 16],

      // 39
      [20, 147, 117, 4, 148, 118],
      [40, 75, 47, 7, 76, 48],
      [43, 54, 24, 22, 55, 25],
      [10, 45, 15, 67, 46, 16],

      // 40
      [19, 148, 118, 6, 149, 119],
      [18, 75, 47, 31, 76, 48],
      [34, 54, 24, 34, 55, 25],
      [20, 45, 15, 61, 46, 16]
    ];

    var qrRSBlock = function(totalCount, dataCount) {
      var _this = {};
      _this.totalCount = totalCount;
      _this.dataCount = dataCount;
      return _this;
    };

    var _this = {};

    var getRsBlockTable = function(typeNumber, errorCorrectionLevel) {

      switch(errorCorrectionLevel) {
      case QRErrorCorrectionLevel.L :
        return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
      case QRErrorCorrectionLevel.M :
        return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
      case QRErrorCorrectionLevel.Q :
        return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
      case QRErrorCorrectionLevel.H :
        return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
      default :
        return undefined;
      }
    };

    _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {

      var rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);

      if (typeof rsBlock == 'undefined') {
        throw 'bad rs block @ typeNumber:' + typeNumber +
            '/errorCorrectionLevel:' + errorCorrectionLevel;
      }

      var length = rsBlock.length / 3;

      var list = [];

      for (var i = 0; i < length; i += 1) {

        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];

        for (var j = 0; j < count; j += 1) {
          list.push(qrRSBlock(totalCount, dataCount) );
        }
      }

      return list;
    };

    return _this;
  }();

  //---------------------------------------------------------------------
  // qrBitBuffer
  //---------------------------------------------------------------------

  var qrBitBuffer = function() {

    var _buffer = [];
    var _length = 0;

    var _this = {};

    _this.getBuffer = function() {
      return _buffer;
    };

    _this.getAt = function(index) {
      var bufIndex = Math.floor(index / 8);
      return ( (_buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
    };

    _this.put = function(num, length) {
      for (var i = 0; i < length; i += 1) {
        _this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
      }
    };

    _this.getLengthInBits = function() {
      return _length;
    };

    _this.putBit = function(bit) {

      var bufIndex = Math.floor(_length / 8);
      if (_buffer.length <= bufIndex) {
        _buffer.push(0);
      }

      if (bit) {
        _buffer[bufIndex] |= (0x80 >>> (_length % 8) );
      }

      _length += 1;
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // qrNumber
  //---------------------------------------------------------------------

  var qrNumber = function(data) {

    var _mode = QRMode.MODE_NUMBER;
    var _data = data;

    var _this = {};

    _this.getMode = function() {
      return _mode;
    };

    _this.getLength = function(buffer) {
      return _data.length;
    };

    _this.write = function(buffer) {

      var data = _data;

      var i = 0;

      while (i + 2 < data.length) {
        buffer.put(strToNum(data.substring(i, i + 3) ), 10);
        i += 3;
      }

      if (i < data.length) {
        if (data.length - i == 1) {
          buffer.put(strToNum(data.substring(i, i + 1) ), 4);
        } else if (data.length - i == 2) {
          buffer.put(strToNum(data.substring(i, i + 2) ), 7);
        }
      }
    };

    var strToNum = function(s) {
      var num = 0;
      for (var i = 0; i < s.length; i += 1) {
        num = num * 10 + chatToNum(s.charAt(i) );
      }
      return num;
    };

    var chatToNum = function(c) {
      if ('0' <= c && c <= '9') {
        return c.charCodeAt(0) - '0'.charCodeAt(0);
      }
      throw 'illegal char :' + c;
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // qrAlphaNum
  //---------------------------------------------------------------------

  var qrAlphaNum = function(data) {

    var _mode = QRMode.MODE_ALPHA_NUM;
    var _data = data;

    var _this = {};

    _this.getMode = function() {
      return _mode;
    };

    _this.getLength = function(buffer) {
      return _data.length;
    };

    _this.write = function(buffer) {

      var s = _data;

      var i = 0;

      while (i + 1 < s.length) {
        buffer.put(
          getCode(s.charAt(i) ) * 45 +
          getCode(s.charAt(i + 1) ), 11);
        i += 2;
      }

      if (i < s.length) {
        buffer.put(getCode(s.charAt(i) ), 6);
      }
    };

    var getCode = function(c) {

      if ('0' <= c && c <= '9') {
        return c.charCodeAt(0) - '0'.charCodeAt(0);
      } else if ('A' <= c && c <= 'Z') {
        return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
      } else {
        switch (c) {
        case ' ' : return 36;
        case '$' : return 37;
        case '%' : return 38;
        case '*' : return 39;
        case '+' : return 40;
        case '-' : return 41;
        case '.' : return 42;
        case '/' : return 43;
        case ':' : return 44;
        default :
          throw 'illegal char :' + c;
        }
      }
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // qr8BitByte
  //---------------------------------------------------------------------

  var qr8BitByte = function(data) {

    var _mode = QRMode.MODE_8BIT_BYTE;
    var _data = data;
    var _bytes = qrcode.stringToBytes(data);

    var _this = {};

    _this.getMode = function() {
      return _mode;
    };

    _this.getLength = function(buffer) {
      return _bytes.length;
    };

    _this.write = function(buffer) {
      for (var i = 0; i < _bytes.length; i += 1) {
        buffer.put(_bytes[i], 8);
      }
    };

    return _this;
  };

  //---------------------------------------------------------------------
  // qrKanji
  //---------------------------------------------------------------------

  //---------------------------------------------------------------------
  // returns qrcode function.

  return qrcode;
}();

// multibyte support
!function() {

  qrcode.stringToBytesFuncs['UTF-8'] = function(s) {
    // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
    function toUTF8Array(str) {
      var utf8 = [];
      for (var i=0; i < str.length; i++) {
        var charcode = str.charCodeAt(i);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) {
          utf8.push(0xc0 | (charcode >> 6),
              0x80 | (charcode & 0x3f));
        }
        else if (charcode < 0xd800 || charcode >= 0xe000) {
          utf8.push(0xe0 | (charcode >> 12),
              0x80 | ((charcode>>6) & 0x3f),
              0x80 | (charcode & 0x3f));
        }
        // surrogate pair
        else {
          i++;
          // UTF-16 encodes 0x10000-0x10FFFF by
          // subtracting 0x10000 and splitting the
          // 20 bits of 0x0-0xFFFFF into two halves
          charcode = 0x10000 + (((charcode & 0x3ff)<<10)
            | (str.charCodeAt(i) & 0x3ff));
          utf8.push(0xf0 | (charcode >>18),
              0x80 | ((charcode>>12) & 0x3f),
              0x80 | ((charcode>>6) & 0x3f),
              0x80 | (charcode & 0x3f));
        }
      }
      return utf8;
    }
    return toUTF8Array(s);
  };

}();
  return { encode:function(text){ var qr=qrcode(0,"M"); qr.addData(text); qr.make(); var n=qr.getModuleCount(); var m=[]; for(var r=0;r<n;r++){ var row=[]; for(var c=0;c<n;c++) row.push(qr.isDark(r,c)?1:0); m.push(row);} return m; } };
})();

} /* end bmInit */

class BookmarkLabTool extends HTMLElement {
  connectedCallback(){
    if(this.shadowRoot) return;
    const r=this.attachShadow({mode:"open"});
    r.innerHTML="<style>"+BM_CSS+"</style>"+BM_HTML;
    bmInit(r);
  }
}
customElements.define("bookmark-lab-tool", BookmarkLabTool);
})();
